// Range filter - used in table pagination
filters.filter('rangeBottom', function () {
  return function (input, bottom) {
    if (typeof input === 'undefined') return;
    bottom = parseInt(bottom);
    var output = [];
    angular.forEach(input, function (data, index) {
      if (index >= bottom) {
        output.push(data);
      }
    });
    return output;
  };
});
filters.filter('rangeTop', function () {
  return function (input, top) {
    if (typeof input === 'undefined') return;
    top = parseInt(top);
    var output = [];
    angular.forEach(input, function (data, index) {
      if (index <= top) {
        output.push(data);
      }
    });
    return output;
  };
});

// Excludes inactive if showInactive is false.
filters.filter('inactive', function () {
  return function (input, showInactive, propName) {
    if (typeof input === 'undefined' || input.length === 0) return;
    if (typeof propName === 'undefined') propName = 'is_active';
    if (typeof input[0].is_active === 'undefined') propName = 'IsActive';
    var output = [];
    for (var i = 0; i < input.length; i++) {
      var is_active = input[i][propName];
      if (is_active || !is_active && showInactive) {
        output.push(input[i]);
      }
    }
    return output;
  };
});
filters.filter('toDateTime', function () {
  return function (input) {
    if (typeof input === 'undefined' || input === null) return;
    var split = input.split('T');
    var date = split[0];
    var time = split[1].substring(0, 5);
    return date + ' ' + time;
  };
});
filters.filter('toTime', function () {
  return function (input) {
    if (typeof input === 'undefined' || input === null) return;
    var split = input.split('T');
    var time;
    if (split.length === 1) {
      time = split[0].substring(0, 5);
    } else time = split[1].substring(0, 5);
    return time;
  };
});
filters.filter('toDate', function () {
  return function (input) {
    if (typeof input === 'undefined' || input === null) return;
    var split = input.split('T');
    var date = split[0];
    return date;
  };
});
filters.filter('capitalize', function () {
  return function (input) {
    return !!input ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
  };
});
filters.filter('shortstring', function () {
  return function (input) {
    if (typeof input === 'undefined' || input === null) return;
    var output = '';
    if (input.length > 8) {
      output = input.slice(0, 7);
    } else output = input;
    return output;
  };
});
filters.filter('phoneFilter', function () {
  return function (input) {
    if (!input) {
      return '';
    }
    var output = '';
    var pattern = /^\+?[\d-\s]*$/;
    if (!pattern.test(input)) {
      output = input.substring(0, input.length - 1);
    } else output = input;
    return output;
  };
});
filters.filter('limit', function () {
  return function (input, limit) {
    return input <= limit ? input : limit;
  };
});
filters.filter('removeTemplateRoutesIfTemplated', function () {
  return function (input) {
    var output = [];
    angular.forEach(input, function (route) {
      if (typeof route !== 'undefined') {
        if (!route.is_template) {
          output.push(route);
        } else {
          var usedForTemplating = false;
          angular.forEach(input, function (compareRoute) {
            if (typeof compareRoute !== 'undefined' && route.route_id === compareRoute.source_template_id) {
              // route is template
              usedForTemplating = true;
            }
          });
          if (!usedForTemplating) {
            output.push(route);
          }
        }
      }
    });
    return output;
  };
});
filters.filter('filterDestinationLocationPath', function () {
  return function (destinationLocations, parent) {
    var output = [];
    if (typeof parent === 'undefined') {
      angular.forEach(destinationLocations, function (loc) {
        if (loc.Level === 2) {
          output.push(loc);
        }
      });
    } else {
      angular.forEach(destinationLocations, function (loc) {
        if (loc.ParentLocationId === parent.location_id) {
          output.push(loc);
        }
      });
    }
    return output;
  };
});
filters.filter('filterSubProjectByDropLocationParent', function () {
  return function (destinationLocations, dropLocationParentId) {
    var output = [];

    // If drop location is not set, nothing should be shown.
    if (!dropLocationParentId || dropLocationParentId < 0) {
      return output;
    }

    // If parent is not in list if available drop locations, no filter should be applied.
    var dropLocationParent = destinationLocations.find(function (l) {
      return l.LocationId === dropLocationParentId;
    });
    if (!dropLocationParent) {
      output = destinationLocations;
      return output;
    }

    // If parent is one of the available drop locations, only that location should be return.
    // However, this only applies for SubProject.
    // For other levels, no filter should be applied.
    destinationLocations.forEach(function (l) {
      if (l.LocationTypeName === "SubProject") {
        if (l.LocationId == dropLocationParentId) {
          output.push(l);
        }
      } else {
        output.push(l);
      }
    });
    return output;
  };
});
filters.filter('filterLocationTypeEq', function () {
  return function (destinationLocations, locationTypeName) {
    var output = [];
    angular.forEach(destinationLocations, function (loc) {
      if (loc.LocationTypeName === locationTypeName) {
        output.push(loc);
      }
    });
    return output;
  };
});
filters.filter('filterLocationTypeNeq', function () {
  return function (destinationLocations, locationTypeName) {
    var output = [];
    angular.forEach(destinationLocations, function (loc) {
      if (loc.LocationTypeName != locationTypeName) {
        output.push(loc);
      }
    });
    return output;
  };
});
filters.filter('toOrderPrefix', function () {
  return function (orderNumber) {
    return orderNumber ? orderNumber.slice(0, 2) : "";
  };
});
filters.filter('cleanNumberInput', function () {
  return function (number) {
    if (typeof number === 'undefined') return;
    var splitComma = number.toString().split('.');
    var out = splitComma[0];
    var splitE = out.split('e');
    out = splitE[0];
    return parseInt(out);
  };
});
filters.filter('orderVehicleDropLocationId', function () {
  return function (inputArray, id) {
    if (id === null || id === undefined) {
      return inputArray;
    }
    var filteredArray = [];
    angular.forEach(inputArray, function (order) {
      if (order.vehicle_drop_location_id === id) {
        filteredArray.push(order);
      }
    });
    return filteredArray;
  };
});
filters.filter('reverse', function () {
  return function (inputArray) {
    return inputArray.slice().reverse();
  };
});
'use strict';

directives.directive('dateTimeFilter', [function () {
  return {
    restrict: 'EA',
    scope: {
      dateTimeFilterParent: '=',
      dates: '='
    },
    templateUrl: 'assets/js/directives/dateTimeFilter/date_time_filter.html',
    link: function link(scope) {
      scope.$watch('dates', function (newValue, oldValue) {
        scope.dates = newValue;
      }, true);
    },
    controller: ['$scope', function ($scope) {
      var format = "YYYY-MM-DD HH:mm";
      function setDateTime(newFrom, newTo) {
        if (newFrom) {
          $scope.dates.from = document.getElementById('inputFrom').value = newFrom;
        }
        if (newTo) {
          $scope.dates.to = document.getElementById('inputTo').value = newTo;
        }
      }
      ;
      $scope.dates ? setDateTime($scope.dates.from, $scope.dates.to) : setDateTime(null, null);
      $scope.initDateTimeEvents = function () {
        var fromMoment = null,
          toMoment = null;

        // FUTURE: Refactor dateTimeFilter, or wrap it, to avoid jQuery bugs
        $('#' + $scope.dateTimeFilterParent).find('#dateTimeFilterFrom').datetimepicker({
          format: 'YYYY-MM-DD HH:mm',
          locale: 'sv'
        });
        $('#' + $scope.dateTimeFilterParent).find('#dateTimeFilterFrom').data().DateTimePicker.stepping(15);
        $('#' + $scope.dateTimeFilterParent).find('#dateTimeFilterTo').datetimepicker({
          format: 'YYYY-MM-DD HH:mm',
          locale: 'sv'
        });
        $('#' + $scope.dateTimeFilterParent).find('#dateTimeFilterTo').data().DateTimePicker.stepping(15);

        // Date time picker events
        $('#' + $scope.dateTimeFilterParent).find('#dateTimeFilterFrom').on('dp.change', function (ev) {
          if (!ev.date) {
            setDateTime(null, null);
          } else if (!toMoment || toMoment && ev.date.isSameOrBefore(toMoment)) {
            setDateTime(ev.date.format(format), null);
            fromMoment = moment(ev.date);
          } else {
            setDateTime(toMoment.format(format), null);
            fromMoment = moment(toMoment);
          }
          if (!$scope.$$phase) {
            $scope.$apply(); //$digest or $apply
          }
        });

        $('#' + $scope.dateTimeFilterParent).find('#dateTimeFilterTo').on('dp.change', function (ev) {
          if (!ev.date) {
            setDateTime(null, null);
          } else if (!fromMoment || fromMoment && ev.date.isSameOrAfter(fromMoment)) {
            setDateTime(null, ev.date.format(format));
            toMoment = moment(ev.date);
          } else {
            setDateTime(null, fromMoment.format(format));
            toMoment = moment(fromMoment);
          }
          if (!$scope.$$phase) {
            $scope.$apply(); //$digest or $apply
          }
        });
      };
    }]
  };
}]);
'use strict';

angular.module('sp.directives').directive('gateBooking', ['$uibModal', '$rootScope', 'orderFormModalService', function ($uibModal, $rootScope, orderFormModalService) {
  return {
    restrict: 'A',
    scope: {
      orderId: "=orderId",
      formType: "=formType"
    },
    link: function link(scope, element, attrs) {
      element.bind('click', function () {
        var openModalInstance = function openModalInstance(formType, orderId, cpy, openModalInstanceForCpy) {
          var orderFormPromise;
          if (formType === 'create_order') {
            orderFormPromise = orderFormModalService.openCreate(OrderTypeEnum.GATE_BOOKING);
          } else if (formType === 'view_order') {
            orderFormPromise = orderFormModalService.openView(orderId, OrderTypeEnum.GATE_BOOKING, cpy);
          }
          orderFormPromise.then(function (results) {
            $rootScope.$broadcast('bookingOrderCreated'); // Refreshes BookingOrderTable
            if (results.copy) {
              openModalInstanceForCpy(formType, orderId, true, openModalInstanceForCpy);
            }
          });
        };
        openModalInstance(scope.formType, scope.orderId, false, openModalInstance);
      });
    }
  };
}]);
'use strict';

directives.directive('notificationConfiguration', [function () {
  return {
    restrict: 'EA',
    scope: {
      notifications: "=",
      formLocked: "="
    },
    templateUrl: 'assets/js/directives/notificationConfiguration/notification_configuration.html'
  };
}]);
directives.directive('orderHoverInfo', ['$translate', '$compile', function ($translate, $compile) {
  return {
    restrict: 'A',
    scope: {
      orderHoverInfo: '='
    },
    link: function link(scope, element, attrs) {
      if (!scope.orderHoverInfo) return;
      scope.creator = {};
      scope.receivers = [];
      angular.forEach(scope.orderHoverInfo.contacts, function (contact) {
        if (contact.ContactRoleId === ContactRoleEnum.ORDER_CREATOR) {
          scope.creator = contact;
        } else if (contact.ContactRoleId === ContactRoleEnum.DELIVERY_RECEIVER) {
          scope.receivers.push(contact);
        }
      });
      function createReceiverTemplate(index) {
        if (!scope.receivers[index].Name && !scope.receivers[index].Phone && !scope.receivers[index].Email) {
          return '';
        } else {
          // User input shall be written as {{userinput}} or ng-bind="userinput" to prevent risk of XSS attacks.
          return '<div>' + '<div class="hr-dashed"></div>' + (!!scope.receivers[index].Name ? '<p>' + '<b>' + $translate.instant('RECEIVER') + ' ' + (index + 1) + ': </b>' + '<span> {{receivers[' + index + '].Name}} </span>' + '</p>' : '') + (!!scope.receivers[index].Phone ? '<p>' + '<b>' + $translate.instant('PHONE_NUMBER') + ': </b>' + '<span> {{receivers[' + index + '].Phone}}</span>' + '</p>' : '') + (!!scope.receivers[index].Email ? '<p>' + '<b>' + $translate.instant('EMAIL') + ': </b>' + '<a href="mailto: {{receivers[' + index + '].Email}} "> {{receivers[' + index + '].Email}} </span>' + '</p>' : '') + '</div>';
        }
      }
      var receiverTemplate = '';
      angular.forEach(scope.receivers, function (receiver, index) {
        receiverTemplate += createReceiverTemplate(index);
      });

      // User input shall be written as {{userinput}} or ng-bind="userinput" to prevent risk of XSS attacks.
      var template = '<div class="OrderHoverInfoWrapper">' + '<div class="OrderHoverInfo">' + '<div class="OrderHoverInfo_Arrow"></div>' + '<div class="OrderHoverInfo_headerWrapper flex-row flex-center-items">' + '<div class="OrderHoverInfoBtn btn flex-row-center" ng-click="hoverInfoExpanded = !hoverInfoExpanded; stopEventPropagation($event);">' + '<i class="fa fa-info-circle" aria-hidden="true"></i>' + '</div>' + '<h5 class="OrderHoverInfo_header" ng-if="hoverInfoExpanded"> {{orderHoverInfo.work_order_company_name}} </h5>' + '</div>' + '<div class="auto-scroll-vert" ng-if="hoverInfoExpanded">' + (!!scope.creator.Name ? '<p class="OrderHoverInfo_OrderCreator">' + '<b>' + $translate.instant('CONTACT_PERSON') + ': </b>' + '<span>{{creator.Name}}</span></p>' + '</p>' : '') + (!!scope.creator.Phone ? '<p>' + '<b>' + $translate.instant('PHONE_NUMBER') + ': </b>' + '<span>{{creator.Phone}}</span></p>' + '</p>' : '') + (!!scope.creator.Email ? '<p>' + '<b>' + $translate.instant('EMAIL') + ': </b>' + '<a href="mailto: {{creator.Email}}">{{creator.Email}}</a>' + '</p>' : '') + receiverTemplate + '</div>' + '</div>' + '</div>';

      // Important! Using $compile together with user input introduces a risk for XSS attacks, see https://docs.angularjs.org/guide/security.
      // To avoid user input to be complied to html, the user input must be evaluated AFTER the template has been complied.
      // Always make sure that the user input is displayed as string and not html, when making changes to the code. 
      element.bind('mouseenter', function () {
        if (scope.orderHoverInfo.order_id === -1) return;
        element.append($compile(template)(scope));
      });
      element.bind('mouseleave', function () {
        scope.hoverInfoExpanded = false;
        element.find('.OrderHoverInfoWrapper').remove();
      });
      scope.stopEventPropagation = function (event) {
        event.stopPropagation();
      };
      scope.hoverInfoExpanded = false;
    }
  };
}]);
services.service('quickGuideService', ['$uibModal', function ($uibModal) {
  this.openQuickGuide = function () {
    sessionStorage.hideQuickGuideThisSession = true;
    $uibModal.open({
      size: 'lg',
      templateUrl: "assets/js/directives/quickGuide/quick_guide.html",
      controller: ['$scope', '$uibModalInstance', '$localStorage', 'userFactory', 'errorService', 'languageFactory', function ($scope, $uibModalInstance, $localStorage, userFactory, errorService, languageFactory) {
        $scope.atPage = 0;
        var initialHideQuickGuideForUser = $scope.hideQuickGuideForUser = $localStorage.user.hideQuickGuideForUser,
          // checkbox
          sessionDivision = languageFactory.getLanguageDivision();
        $scope.sessionMainProject = $localStorage.user.session_main_project;
        var guides = [{
          url: 'assets/js/directives/quickGuide/guides/guide_start.html',
          divisions: ['bl', 'pl']
        }, {
          url: 'assets/js/directives/quickGuide/guides/guide_booking_and_deliveries.html',
          divisions: ['bl']
        }, {
          url: 'assets/js/directives/quickGuide/guides/guide_administrate.html',
          divisions: ['bl', 'pl']
        }, {
          url: 'assets/js/directives/quickGuide/guides/guide_archive.html',
          divisions: ['bl']
        }];
        $scope.allowedGuides = [];
        $scope.allowedGuide = function (divisions) {
          var allow = false;
          angular.forEach(divisions, function (division) {
            if (division === sessionDivision) {
              allow = true;
            }
          });
          return allow;
        };
        (function populateAllowedGuides() {
          angular.forEach(guides, function (guide) {
            if ($scope.allowedGuide(guide.divisions)) {
              $scope.allowedGuides.push(guide);
            }
          });
        })();
        $scope.incrementPage = function () {
          if ($scope.atPage < $scope.allowedGuides.length - 1) {
            $scope.atPage++;
          }
        };
        $scope.decrementPage = function () {
          if ($scope.atPage > 0) {
            $scope.atPage--;
          }
        };
        $scope.cancel = function () {
          if (initialHideQuickGuideForUser !== $scope.hideQuickGuideForUser) {
            userFactory.changeQuickGuideShown($scope.hideQuickGuideForUser).then(function () {
              $localStorage.user.hideQuickGuideForUser = $scope.hideQuickGuideForUser;
            });
          }
          $uibModalInstance.close();
        };
      }]
    });
  };
}]);
'use strict';

directives.directive('quickGuide', ['quickGuideService', '$localStorage', function (quickGuideService, $localStorage) {
  return {
    restrict: 'A',
    scope: {},
    link: function link(scope, element, attrs, ctrl) {
      element.click(quickGuideService.openQuickGuide);
    }
  };
}]);
directives.directive("additionalServiceIcons", function () {
  return {
    restrict: "A",
    scope: {
      additionalServiceTypeId: "="
    },
    link: function link(scope, elem, attrs) {
      var className = '';
      if (scope.additionalServiceTypeId === AdditionalServiceTypeEnum.CARRYING) className = 'sp-AdditionalService-carry';
      if (scope.additionalServiceTypeId === AdditionalServiceTypeEnum.GUIDING) className = 'sp-AdditionalService-guide';
      if (scope.additionalServiceTypeId === AdditionalServiceTypeEnum.UNLOADING_HELP) className = 'sp-AdditionalService-unloading';
      if (scope.additionalServiceTypeId === AdditionalServiceTypeEnum.EXPRESS_DELIVERY) className = 'sp-AdditionalService-express';
      if (scope.additionalServiceTypeId === AdditionalServiceTypeEnum.QUITTANCE) className = 'sp-AdditionalService-quittance';
      if (scope.additionalServiceTypeId === AdditionalServiceTypeEnum.TIMING) className = 'sp-AdditionalService-timing';
      if (scope.additionalServiceTypeId === AdditionalServiceTypeEnum.UNPACKING) className = 'sp-AdditionalService-unpacking';
      if (scope.additionalServiceTypeId === AdditionalServiceTypeEnum.ARRIVAL_CONTROL) className = 'sp-AdditionalService-arrivalControl';
      elem.addClass(className);
    }
  };
});
directives.directive('sidemenu', function () {
  return {
    restrict: 'A',
    replace: true,
    templateUrl: "app/shared/admin_side_menu.html",
    controller: ['$rootScope', '$scope', '$uibModal', '$localStorage', 'roleService', function ($rootScope, $scope, $uibModal, $localStorage, roleService) {
      $scope.adminSideMenu = $localStorage.adminSideMenu;
      $scope.adminSideMenuVisible = function (bool) {
        $scope.adminSideMenu.visible = bool;
        $localStorage.adminSideMenu.visible = bool;
      };
      $scope.registerUser = function () {
        var modalInstance = $uibModal.open({
          animation: true,
          backdrop: 'static',
          ariaLabelledBy: 'modal-title',
          ariaDescribedBy: 'modal-body',
          templateUrl: 'app/components/customers/users/user_form.html',
          controller: 'UserInstanceController',
          size: 'lg',
          windowClass: 'sp-modal-window'
        });
        modalInstance.result.then(function (results) {
          console.log("modal exit" + results);
        });
      };
      function identifyRoles() {
        $scope.isAdmin = roleService.isAdmin();
        $scope.isServicenter = roleService.isServicenter();
        $scope.isProjectOwner = roleService.isProjectOwner();
        $scope.isWarehousePlanner = roleService.isWarehousePlanner();
        $scope.isWarehouseOperator = roleService.isWarehouseOperator();
        $scope.isInternal = roleService.isInternal();
        $scope.isCustomer = roleService.isCustomer();
      }
      ;
      identifyRoles();
      $scope.$on('updatedUserData', function (event) {
        identifyRoles();
      });
    }]
  };
});
'use strict';

directives.directive('dateTimePicker', function () {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var modelName = attrs['dateTimePicker'];
      $(element).on('change paste keyup', function (ev) {
        scope.$parent.slot[modelName] = $(element).val();
      });
    }
  };
});
directives.directive('downloadFileLink', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      filePath: '@',
      titleText: '@',
      fileName: '@',
      mimeType: '@?',
      showIcon: '<?'
    },
    template: '<a href ng-click="downloadFile(filePath)">{{titleText}}' + '<i ng-show="showIcon" class="fa fa-arrow-circle-down" aria-hidden="true"></i>' + '</a>',
    controller: ['$scope', '$http', function ($scope, $http) {
      $scope.downloadFile = function (filePath) {
        $http({
          url: filePath,
          method: 'GET',
          data: '',
          responseType: 'blob'
        }).then(function (result) {
          var blob = new Blob([result.data]);
          var url = window.URL || window.webkitURL;
          var fileURL = url.createObjectURL(blob);
          var downloadLink = angular.element('<a></a>'); // Creating a new link that can have compiled url as href
          downloadLink.css({
            display: 'none'
          }); // Make sure it's not visible
          angular.element(document.body).append(downloadLink); // Required for (at least) FireFox https://stackoverflow.com/questions/32225904/programmatical-click-on-a-tag-not-working-in-firefox

          var link = downloadLink[0]; // Recover the <a> tag from directive
          link.href = fileURL;
          link.download = $scope.fileName;
          link.target = '_self';
          link.click(); // Call click function
        });
      };
    }]
  };
});
directives.directive('fileModel', ['$parse', function ($parse) {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var model = $parse(attrs.fileModel);
      var isMultiple = attrs.multiple;
      var modelSetter = model.assign;
      element.bind('change', function () {
        var values = [];
        angular.forEach(element[0].files, function (item) {
          var value = {
            // File Name 
            name: item.name,
            //File Size 
            size: item.size,
            //File URL to view 
            url: URL.createObjectURL(item),
            // File Input Value 
            _file: item
          };
          values.push(value);
        });
        scope.$apply(function () {
          if (isMultiple) {
            modelSetter(scope, values);
          } else {
            modelSetter(scope, values[0]);
          }
        });
      });
    }
  };
}]);
directives.directive('footer', function () {
  return {
    restrict: 'E',
    replace: true,
    controllerAs: 'vm',
    templateUrl: "app/shared/footer.html",
    controller: ['$uibModal', '$rootScope', '$scope', 'authFactory', '$localStorage', 'languageFactory', 'roleService', function ($uibModal, $rootScope, $scope, authFactory, $localStorage, languageFactory, roleService) {
      var vm = this;
      function setMainProjectData() {
        vm.hasSessionMainProject = !!$localStorage.user.session_main_project;
        vm.isInternal = roleService.isInternal();
        if (vm.hasSessionMainProject) {
          vm.external_support_email = $localStorage.user.session_main_project.external_support_email;
          vm.external_support_phone_number = $localStorage.user.session_main_project.external_support_phone_number;
          vm.internal_support_email = $localStorage.user.session_main_project.internal_support_email;
          vm.internal_support_phone_number = $localStorage.user.session_main_project.internal_support_phone_number;
        }
      }
      setMainProjectData();
      $scope.$on('updatedUserData', function (event) {
        setMainProjectData();
      });
    }]
  };
});
'use strict';

directives.directive('limitTo', ['$filter', function ($filter) {
  return {
    restrict: "A",
    link: function link(scope, elem, attrs) {
      var limit = parseInt(attrs.limitTo);
      angular.element(elem).on("keyup", function (e) {
        var value = parseInt(this.value);
        if (value < 0 || value > limit || isNaN(value)) {
          this.value = 0;
          e.preventDefault();
        }
      });
    }
  };
}]);
'use strict';

directives.directive('onFinishRender', ['$timeout', function ($timeout) {
  return {
    restrict: 'A',
    link: function link(scope, element, attr) {
      if (scope.$last === true) {
        $timeout(function () {
          var week_day = -1;
          if (scope.day) week_day = scope.day.week_day;
          scope.$emit(attr.onFinishRender, scope.$index, week_day); // index of last added slot, which day
        }, 0);
      }
    }
  };
}]);
'use strict';

directives.directive('orderList', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/components/orders/order_list.html'
  };
});
'use strict';

directives.directive('orderListMobile', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/components/orders/order_list_mobile.html'
  };
});
'use strict';

directives.directive('orderPackageList', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/components/orders/order_package_list.html'
  };
});
'use strict';

directives.directive('packageCollectionPackages', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/components/package_collection/package_collection_packages.html'
  };
});
directives.directive('passCodeStatusColor', function () {
  return {
    scope: {
      passCodeStatusColor: "="
    },
    link: function link(scope, element, attributes) {
      switch (scope.passCodeStatusColor) {
        case PassCodeStatusEnum.REQUEST_SENT_HAS_ERROR:
          element.addClass("sp-red");
          break;
        case PassCodeStatusEnum.PASSCODE_RECEIVED:
          element.addClass("sp-green");
          break;
        case PassCodeStatusEnum.REQUEST_SENT:
          element.addClass("sp-blue");
          break;
        case PassCodeStatusEnum.NO_REQUEST_SENT:
          element.addClass("sp-grey");
          break;
        default:
        // Might not be a direct delivery
      }
    }
  };
});
directives.directive('phoneFilterDirective', ['$filter', function ($filter) {
  return {
    require: 'ngModel',
    link: function link(scope, element, attrs, modelController) {
      modelController.$parsers.push(function (input) {
        var transformedInput = $filter('phoneFilter')(input);
        if (transformedInput !== input) {
          modelController.$setViewValue(transformedInput);
          modelController.$render();
        }
        return transformedInput;
      });
    }
  };
}]);
directives.directive('strictNumberInputDirective', ['$filter', function ($filter) {
  return {
    require: 'ngModel',
    link: function link(scope, element, attrs, modelController) {
      modelController.$parsers.push(function (input) {
        var transformedInput = $filter('cleanNumberInput')(input);
        if (transformedInput !== input) {
          modelController.$setViewValue(transformedInput);
          modelController.$render();
        }
        return transformedInput;
      });
    }
  };
}]);
directives.directive('stringToNumber', function () {
  return {
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function (value) {
        return '' + value;
      });
      ngModel.$formatters.push(function (value) {
        return parseFloat(value);
      });
    }
  };
});
'use strict';

factories.factory('authFactory', ['$http', 'ENV', '$httpParamSerializer', '$cookies', '$rootScope', '$localStorage', function ($http, ENV, $httpParamSerializer, $cookies, $rootScope, $localStorage) {
  var endPoint = ENV.apiEndpoint;
  var authFactory = {};
  authFactory.validateCaptcha = function (captchaToken) {
    var urlBase = '/validateCaptcha';
    var url = endPoint + urlBase;
    var data = {
      "captchaToken": captchaToken
    };
    var req = {
      method: 'POST',
      url: url,
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
      },
      data: $httpParamSerializer(data)
    };
    return $http(req);
  };
  authFactory.login = function (username, password, captchaToken) {
    var urlBase = '/token';
    var url = endPoint + urlBase;
    var data = {
      "grant_type": "password",
      "username": username,
      "password": password,
      "captchaToken": captchaToken
    };
    var req = {
      method: 'POST',
      url: url,
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
      },
      data: $httpParamSerializer(data)
    };
    return $http(req);
  };
  authFactory.getMe = function () {
    return $http.get(endPoint + '/api/Users/Me');
  };
  authFactory.logout = function () {
    $cookies.remove('access_token');
    $cookies.remove("user_role_id");
    $cookies.remove("user_role_name");
    $http.defaults.headers.common.Authorization = '';
    $localStorage.user = {
      isLoggedIn: false
    };
    delete sessionStorage.hideQuickGuideThisSession;
    $localStorage.adminSideMenu.visible = false;
    var isLoginPage = window.location.href.indexOf("/login") !== -1;
    if (!isLoginPage) {
      window.location.href = "/login";
    }
  };
  authFactory.isLoggedIn = function () {
    if ($localStorage.user.isLoggedIn) {
      return true;
    } else return false;
  };
  authFactory.setAuthTokenAndRedirect = function () {
    var isLoginPage = window.location.href.indexOf("/login") !== -1;
    var isActivatePage = window.location.href.indexOf("/activate") !== -1;
    var isResetPage = window.location.href.indexOf("/reset") !== -1;
    if (isLoginPage) {
      if ($localStorage.user.isLoggedIn) {
        $http.defaults.headers.common.Authorization = 'Bearer ' + $cookies.get("access_token");
        window.location.href = "/";
      }
    } else if (isActivatePage) {
      if ($localStorage.user.isLoggedIn) {
        $http.defaults.headers.common.Authorization = 'Bearer ' + $cookies.get("access_token");
        window.location.href = "/";
      }
    } else if (isResetPage) {
      if ($localStorage.user.isLoggedIn) {
        $http.defaults.headers.common.Authorization = 'Bearer ' + $cookies.get("access_token");
        window.location.href = "/";
      }
    } else {
      if ($localStorage.user.isLoggedIn) {
        $http.defaults.headers.common.Authorization = 'Bearer ' + $cookies.get("access_token");
      } else window.location.href = "/login";
    }
  };
  return authFactory;
}]);
'use strict';

angular.module('sp.factories').factory('companyFactory', ['$http', 'ENV', '$httpParamSerializer', 'workOrderFactory', 'generalHelperService', 'notificationTemplateFactory', function ($http, ENV, $httpParamSerializer, workOrderFactory, generalHelperService, notificationTemplateFactory) {
  var urlBase = '/api/companies';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var divisionsUrlBase = '/api/Divisions';
  var divisionsUrl = endPoint + divisionsUrlBase;
  var companyFactory = {};

  /**
   * Retrieves an array of CompanyDTO instances from backend
   */
  companyFactory.getCompanies = function (includeInactive, divisionId) {
    var params = {
      includeInactive: includeInactive
    };
    return $http.get(divisionsUrl + '/' + divisionId + '/Companies' + '?' + $httpParamSerializer(params));
  };
  companyFactory.getCompany = function (id) {
    return $http.get(url + '/' + id);
  };
  companyFactory.createCompany = function (comp) {
    var out = JSON.stringify(comp);
    return $http.post(url, out);
  };
  companyFactory.updateCompany = function (id, comp) {
    var out = JSON.stringify(comp);
    return $http.put(url + '/' + id, out);
  };
  companyFactory.activateCompany = function (id) {
    return $http.put(url + '/' + id + '/activate');
  };
  companyFactory.deactivateCompany = function (id) {
    return $http.put(url + '/' + id + '/deactivate');
  };
  companyFactory.deleteCompany = function (id) {
    return $http.delete(url + '/' + id);
  };

  /**
   * Retrieves an array of ErpCompanyDTO instances from backend.
   */
  companyFactory.getErpCompanies = function (divisionId) {
    return $http.get(divisionsUrl + '/' + divisionId + '/ErpCompanies');
  };

  /**
  * Retrieves an array of ErpWorkOrderDTO instances from backend.
  */
  companyFactory.getErpWorkOrders = function (companyId) {
    return $http.get(url + '/' + companyId + '/ErpWorkOrders');
  };
  companyFactory.getFilterableCompanies = function (mainProjectId, includeDeleted, includeInactive) {
    var params = {
      mainProjectId: mainProjectId,
      includeDeleted: includeDeleted,
      includeInactive: includeInactive
    };
    return $http.get(url + '/FilterableCompanies?' + $httpParamSerializer(params));
  };
  companyFactory.repackageCompanyDTOArray = function (companyDTOArray) {
    var companyArray = [];
    if (!companyDTOArray) {
      return [];
    }
    angular.forEach(companyDTOArray, function (companyDTO) {
      companyArray.push(companyFactory.repackageCompanyDTO(companyDTO));
    });
    companyArray.sort(compareCompanies);
    return companyArray;
  };
  companyFactory.repackageErpCompanyDTOArray = function (erpCompanyDTOArray) {
    if (!erpCompanyDTOArray) return [];
    var erpCompanyArray = [];
    angular.forEach(erpCompanyDTOArray, function (erpCompanyDTO) {
      erpCompanyArray.push(repackageErpCompanyDTO(erpCompanyDTO));
    });
    erpCompanyArray.sort(compareCompanies);
    return erpCompanyArray;
  };
  companyFactory.repackageCompanyDTO = function (companyDTO) {
    var company = {
      work_orders: workOrderFactory.repackageWorkOrderDTOArray(companyDTO.WorkOrders),
      // FUTURE performance: Is this used? Could it be avoided to read the WorkOrders in some cases for performance?
      company_id: companyDTO.CompanyId,
      company_name: companyDTO.Name,
      company_display_name: companyDTO.Name,
      // FUTURE (SPL112): Should really be companyDisplayName(companyDTO.Name, companyDTO.ErpSystemCompanyNo), but this is currently done by BE
      organization_number: companyDTO.OrganizationNumber,
      street_address: companyDTO.StreetAddress,
      zip_code: companyDTO.ZipCode,
      city: companyDTO.City,
      contact: companyDTO.Contact,
      phone: companyDTO.Phone,
      sms: companyDTO.Sms,
      email: companyDTO.Email,
      erp_system_company_no: companyDTO.ErpSystemCompanyNo,
      is_active: companyDTO.IsActive,
      comments: companyDTO.Comments,
      notification_configuration: notificationTemplateFactory.extendTemplatesWithNames(companyDTO.NotificationTemplates)
    };
    return company;
  };
  companyFactory.packageCompany = function (company, divisionId) {
    var companyDTO = {
      "CompanyId": company.company_id,
      "Name": company.company_name,
      "OrganizationNumber": company.organization_number,
      "StreetAddress": company.street_address,
      "ZipCode": company.zip_code,
      "City": company.city,
      "Contact": company.contact,
      "Phone": company.phone,
      "Sms": company.sms,
      "Email": company.email,
      "ErpSystemCompanyNo": company.erp_system_company_no,
      "IsActive": company.is_active,
      "Comments": company.comments,
      "NotificationTemplates": company.notification_configuration,
      "DivisionId": divisionId
    };
    return companyDTO;
  };
  function repackageErpCompanyDTO(erpCompanyDto) {
    var erpCompany = {
      erp_system_company_no: erpCompanyDto.CompanyNo,
      company_name: erpCompanyDto.Name,
      company_display_name: companyDisplayName(erpCompanyDto.Name, erpCompanyDto.CompanyNo),
      organization_number: erpCompanyDto.OrganizationNumber
    };
    return erpCompany;
  }
  function companyDisplayName(name, erpCompanyNo) {
    return name + (erpCompanyNo ? " (" + erpCompanyNo + ")" : "");
  }

  /**
   * Define a sort order for companies.
   * Must work both for companies and erpCompanies
   */
  function compareCompanies(company1, company2) {
    return company1.company_display_name.localeCompare(company2.company_display_name);
  }
  return companyFactory;
}]);
'use strict';

factories.factory('contactFactory', ['$http', 'ENV', '$httpParamSerializer', function ($http, ENV, $httpParamSerializer) {
  var urlBase = '/api/contacts';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var contactFactory = {};
  contactFactory.getContacts = function (mainProjectId, includeInactive) {
    var params = {
      mainProjectId: mainProjectId,
      includeInactive: includeInactive
    };
    return $http.get(url + '?' + $httpParamSerializer(params));
  };
  contactFactory.getContact = function (id) {
    return $http.get(url + '/' + id);
  };
  contactFactory.createContact = function (type) {
    var out = JSON.stringify(type);
    return $http.post(url, out);
  };
  contactFactory.updateContact = function (id, type) {
    var out = JSON.stringify(type);
    return $http.put(url + '/' + id, out);
  };
  contactFactory.activateContacts = function (ids) {
    var out = JSON.stringify(ids);
    return $http.put(url + '/activate', out);
  };
  contactFactory.deactivateContacts = function (ids) {
    var out = JSON.stringify(ids);
    return $http.put(url + '/deactivate', out);
  };
  contactFactory.deleteContact = function (id) {
    return $http.delete(url + '/' + id);
  };
  contactFactory.repackageDTO = function (DTO) {
    return {
      contact_id: DTO.ContactId,
      name: DTO.Name,
      phone: DTO.Phone,
      email: DTO.Email,
      company: DTO.Company,
      company_and_name: DTO.Company ? "(" + DTO.Company + ") " + DTO.Name : DTO.Name,
      description: DTO.Description,
      main_project_id: DTO.MainProjectId,
      is_active: DTO.IsActive
    };
  };
  contactFactory.repackageDTOArray = function (DTOArray) {
    var repackagedDTOArray = [];
    if (!DTOArray) {
      return [];
    }
    angular.forEach(DTOArray, function (DTO) {
      repackagedDTOArray.push(contactFactory.repackageDTO(DTO));
    });
    return repackagedDTOArray;
  };
  return contactFactory;
}]);
'use strict';

factories.factory("deliveryFactory", ['$http', 'ENV', '$filter', '$translate', function ($http, ENV, $filter, $translate) {
  var urlBase = '/api/deliveries';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var deliveryFactory = {};
  deliveryFactory.getDeliveriesByDate = function (date, mainProjectId) {
    return $http.get(url + '/ByDate/' + date + '?mainProjectId=' + mainProjectId);
  };
  deliveryFactory.getDelivery = function (id) {
    return $http.get(url + '/' + id);
  };
  deliveryFactory.updateDelivery = function (id, deliveryDTO) {
    var out = JSON.stringify(deliveryDTO);
    return $http.put(url + '/' + id, out);
  };
  deliveryFactory.confirmDelivery = function (id) {
    return $http.put(url + '/' + id + '/confirm');
  };
  deliveryFactory.deliverDelivery = function (id) {
    return $http.put(url + '/' + id + '/deliver');
  };
  deliveryFactory.deleteDelivery = function (id) {
    return $http.delete(url + '/' + id);
  };
  deliveryFactory.assignOrdersToNewRoute = function (assignOrdersToNewRouteDeliveryDTO) {
    var jsonDto = JSON.stringify(assignOrdersToNewRouteDeliveryDTO);
    return $http.put(url + '/AssignOrdersToNewRouteDelivery', jsonDto);
  };
  deliveryFactory.assignOrdersToRoute = function (outObj) {
    var out = JSON.stringify(outObj);
    return $http.put(url + '/AssignOrdersToRouteDelivery', out);
  };
  deliveryFactory.assignOrdersToNewInternalTransport = function (outObj) {
    var out = JSON.stringify(outObj);
    return $http.put(url + '/AssignOrdersToNewInternalTransportDelivery', out);
  };
  deliveryFactory.assignOrdersToNewExternalTransport = function (outObj) {
    var out = JSON.stringify(outObj);
    return $http.put(url + '/AssignOrdersToNewExternalTransportDelivery', out);
  };
  deliveryFactory.assignOrdersTransport = function (outObj) {
    var out = JSON.stringify(outObj);
    return $http.put(url + '/AssignOrdersToTransportDelivery', out);
  };
  function loadOrders(orders, destinationMappingIndex) {
    var newOrders = [];
    angular.forEach(orders, function (order) {
      newOrders.push({
        order_id: order.OrderId,
        task_id: order.TaskId,
        order_number: order.OrderNumber,
        order_type: order.OrderType,
        task_status: order.TaskStatus,
        destination: destinationMappingIndex,
        package_count: order.SpecifiedPackageCount,
        package_weight: order.SpecifiedPackageWeight,
        pallet_count: order.SpecifiedPalletCount,
        pallet_weight: order.SpecifiedPalletWeight,
        other_count: order.SpecifiedOtherCount,
        other_weight: order.SpecifiedOtherWeight,
        content: order.Content,
        work_order_name: order.WorkOrderName,
        receiver_name: order.OrderReceiverName,
        receiver_phone: order.OrderReceiverPhone,
        erp_system_reference: order.ErpSystemReference,
        total_count: order.SpecifiedPackageCount + order.SpecifiedPalletCount + order.SpecifiedOtherCount,
        total_weight: order.SpecifiedPackageWeight + order.SpecifiedPalletWeight + order.SpecifiedOtherWeight,
        additional_services: order.AdditionalServices
      });
    });
    return newOrders;
  }
  function loadDeliveryLocations(deliveryLocationDTOArray) {
    var newDeliveryLocations = [];
    var locationMappingIndex = 0;
    angular.forEach(deliveryLocationDTOArray, function (location) {
      newDeliveryLocations.push({
        drop_location_id: location.DropLocationId,
        drop_location_name: location.DropLocationName,
        destination_location_path: location.DestinationLocationPath,
        address: location.Address,
        zip_code: location.ZipCode,
        city: location.City,
        orders: loadOrders(location.Orders, locationMappingIndex)
      });
      locationMappingIndex++;
    });
    return newDeliveryLocations;
  }
  deliveryFactory.createDTO = function (delivery) {
    return {
      "DeliveryId": delivery.delivery_id,
      "DeliveryTypeId": delivery.delivery_type_id,
      "DeliveryStatusTypeId": delivery.delivery_status_type_id,
      "DeliveryDate": delivery.delivery_date,
      "ShippingId": delivery.shipping_id,
      "Capacity": delivery.capacity,
      "CurrentWeight": delivery.current_weight,
      "Time": delivery.time,
      "VehicleId": delivery.vehicle_id,
      "DeliveryLocations": delivery.original_delivery_locations
    };
  };
  deliveryFactory.repackageDTO = function (deliveryDTO) {
    var delivery = {
      delivery_id: deliveryDTO.DeliveryId,
      delivery_type_id: deliveryDTO.DeliveryTypeId,
      delivery_status_type_id: deliveryDTO.DeliveryStatusTypeId,
      shipping_id: deliveryDTO.ShippingId,
      shipping_name: deliveryDTO.ShippingName,
      delivery_date: deliveryDTO.DeliveryDate,
      time: deliveryDTO.Time ? $filter('toTime')(deliveryDTO.Time) : '',
      vehicle_id: deliveryDTO.VehicleId,
      vehicle_name: deliveryDTO.VehicleName,
      capacity: deliveryDTO.Capacity,
      current_weight: deliveryDTO.CurrentWeight,
      current_weight_include_specified: deliveryDTO.CurrentWeightIncludeSpecified,
      delivery_locations: loadDeliveryLocations(deliveryDTO.DeliveryLocations),
      original_delivery_locations: deliveryDTO.DeliveryLocations
    };
    if (deliveryDTO.DeliveryTypeId === DeliveryTypeEnum.ROUTE_DELIVERY) {
      delivery.full_name = deliveryDTO.RouteName;
      delivery.route_name = deliveryDTO.RouteName;
      delivery.route_id = deliveryDTO.RouteId;
      delivery.is_template = deliveryDTO.RouteIsTemplate;
      delivery.source_template_id = deliveryDTO.RouteSourceTemplateId;
      if (deliveryDTO.RouteDeliveryTimeTypeId === DeliveryTimeTypeEnum.SPECIFIC) {
        delivery.full_name += ' ' + delivery.time;
      } else if (deliveryDTO.RouteDeliveryTimeTypeId === DeliveryTimeTypeEnum.FORENOON) {
        delivery.full_name += ' ' + $translate.instant('FORENOON_SHORT');
      } else if (deliveryDTO.RouteDeliveryTimeTypeId === DeliveryTimeTypeEnum.AFTERNOON) {
        delivery.full_name += ' ' + $translate.instant('AFTERNOON_SHORT');
      }
    } else {
      var timeString = delivery.time ? " " + delivery.time : "";
      if (typeof delivery.vehicle_name !== 'undefined' && delivery.vehicle_name !== null) {
        delivery.transport_name = delivery.vehicle_name + timeString;
      } else if (typeof delivery.shipping_name !== 'undefined' && delivery.shipping_name !== null) {
        delivery.transport_name = delivery.shipping_name + timeString;
      } else {
        delivery.transport_name = "- No name -" + timeString;
      }
    }
    return delivery;
  };
  deliveryFactory.repackageDTOArray = function (deliveryDtoArray) {
    if (!deliveryDtoArray) {
      return [];
    }
    var deliveryArray = [];
    angular.forEach(deliveryDtoArray, function (deliveryDTO) {
      deliveryArray.push(deliveryFactory.repackageDTO(deliveryDTO));
    });
    return deliveryArray;
  };
  return deliveryFactory;
}]);
'use strict';

factories.factory('deviationCodeFactory', ['$http', 'ENV', function ($http, ENV) {
  var urlBase = '/api/deviationcodes';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var deviationCodeFactory = {};
  deviationCodeFactory.getDeviationCodes = function () {
    return $http.get(url);
  };
  deviationCodeFactory.getDeviationCode = function (id) {
    return $http.get(url + '/' + id);
  };
  deviationCodeFactory.createDeviationCode = function (comp) {
    var out = JSON.stringify(comp);
    return $http.post(url, out);
  };
  deviationCodeFactory.updateDeviationCode = function (id, comp) {
    var out = JSON.stringify(comp);
    return $http.put(url + '/' + id, out);
  };
  deviationCodeFactory.activateDeviationCode = function (id) {
    return $http.put(url + '/' + id + '/activate');
  };
  deviationCodeFactory.deactivateDeviationCode = function (id) {
    return $http.put(url + '/' + id + '/deactivate');
  };
  deviationCodeFactory.deleteDeviationCode = function (id) {
    return $http.delete(url + '/' + id);
  };
  deviationCodeFactory.repackageDTO = function (DTO) {
    return {
      deviation_code_id: DTO.DeviationCodeId,
      deviation_code_name: DTO.Name,
      is_active: DTO.IsActive
    };
  };
  deviationCodeFactory.repackageDTOArray = function (DTOArray) {
    var repackagedDTOArray = [];
    if (!DTOArray) {
      return [];
    }
    angular.forEach(DTOArray, function (DTO) {
      repackagedDTOArray.push(deviationCodeFactory.repackageDTO(DTO));
    });
    return repackagedDTOArray;
  };
  return deviationCodeFactory;
}]);
'use strict';

factories.factory('divisionFactory', ['$http', 'ENV', function ($http, ENV) {
  var urlBase = '/api/divisions';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var divisionFactory = {};
  divisionFactory.getDivisions = function () {
    return $http.get(url);
  };
  divisionFactory.getDivision = function (id) {
    return $http.get(url + '/' + id);
  };
  divisionFactory.updateDivision = function (id, division) {
    var out = JSON.stringify(division);
    return $http.put(url + '/' + id, out);
  };
  divisionFactory.createDTO = function (division) {
    return {
      "DivisionId": division.division_id,
      "Name": division.division_name
    };
  };
  divisionFactory.repackageDTO = function (DTO) {
    return {
      division_id: DTO.DivisionId,
      division_name: DTO.Name
    };
  };
  divisionFactory.repackageDTOArray = function (DTOArray) {
    var repackagedDTOArray = [];
    if (!DTOArray) {
      return [];
    }
    angular.forEach(DTOArray, function (DTO) {
      repackagedDTOArray.push(divisionFactory.repackageDTO(DTO));
    });
    return repackagedDTOArray;
  };
  return divisionFactory;
}]);
'use strict';

factories.factory('gateFactory', ['$http', '$q', 'ENV', function ($http, $q, ENV) {
  var urlBase = '/api/gates';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var gateFactory = {};
  gateFactory.getGates = function () {
    return $http.get(url);
  };
  gateFactory.getGatesByMainProjectId = function (mainProjectId) {
    return $http.get(url, {
      params: {
        mainProjectId: mainProjectId
      }
    });
  };
  gateFactory.getSystemGates = function (mainProjectId) {
    return $http.get(url + '/lambertsson-online/', {
      params: {
        mainProjectId: mainProjectId
      }
    });
  };
  gateFactory.getGate = function (id) {
    return $http.get(url + '/' + id);
  };
  gateFactory.createGate = function (gate) {
    var out = JSON.stringify(gate);
    return $http.post(url, out);
  };
  gateFactory.updateGate = function (id, gate) {
    var out = JSON.stringify(gate);
    return $http.put(url + '/' + id, out);
  };
  gateFactory.activateGate = function (id) {
    return $http.put(url + '/' + id + '/activate');
  };
  gateFactory.deactivateGate = function (id) {
    return $http.put(url + '/' + id + '/deactivate');
  };
  gateFactory.deleteGate = function (id) {
    return $http.delete(url + '/' + id);
  };
  gateFactory.repackageDTO = function (DTO) {
    return {
      gate_id: DTO.GateId,
      gate_name: DTO.Name,
      system_gate_name: DTO.SystemName,
      gate_location: DTO.Location,
      project_id: DTO.ProjectId,
      project_name: DTO.ProjectName,
      main_project_id: DTO.MainProjectId,
      is_active: DTO.IsActive,
      comments: DTO.Comments
    };
  };
  gateFactory.repackageDTOArray = function (DTOArray) {
    var repackagedDTOArray = [];
    if (!DTOArray) {
      return [];
    }
    angular.forEach(DTOArray, function (DTO) {
      repackagedDTOArray.push(gateFactory.repackageDTO(DTO));
    });
    return repackagedDTOArray;
  };
  gateFactory.repackageSystemGateDTO = function (DTO) {
    return {
      id: DTO.id,
      name: DTO.name
    };
  };
  gateFactory.repackageSystemGateDTOArray = function (DTOArray) {
    var repackagedDTOArray = [];
    if (!DTOArray) {
      return [];
    }
    angular.forEach(DTOArray, function (DTO) {
      repackagedDTOArray.push(gateFactory.repackageSystemGateDTO(DTO));
    });
    return repackagedDTOArray;
  };
  return gateFactory;
}]);
'use strict';

factories.factory('gatePassFactory', ['$http', '$q', 'ENV', function ($http, $q, ENV) {
  var urlBase = '/api/gatePasses';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var gatePassFactory = {};
  gatePassFactory.getAllGatePasses = function () {
    return $http.get(url);
  };
  return gatePassFactory;
}]);
'use strict';

factories.factory('languageFactory', ['$translate', '$rootScope', function ($translate, $rootScope) {
  var languageFactory = {};
  languageFactory.supportedLanguages = ['sv', 'en'];
  languageFactory.setLanguageIfNone = function () {
    if (typeof localStorage.NG_TRANSLATE_LANG_KEY === 'undefined') {
      localStorage.NG_TRANSLATE_LANG_KEY = 'sv_bl';
      $translate.use('sv_bl');
    }
    if ($rootScope.lang_prefix === '' || typeof $rootScope.lang_prefix === 'undefined') {
      languageFactory.changeLanguage(localStorage.NG_TRANSLATE_LANG_KEY);
    }
  };
  languageFactory.changeLanguage = function (langKey) {
    var keySplit = langKey.split('_');
    var langPrefix = keySplit[0];
    var langSuffix = '_' + keySplit[1];
    $rootScope.lang_prefix = langPrefix;
    $rootScope.lang_suffix = '_' + langSuffix;
    $translate.use(langKey);
  };
  languageFactory.changeBaseLanguage = function (baseLang) {
    var oldLang = localStorage.NG_TRANSLATE_LANG_KEY;
    var newLang = baseLang + '_' + oldLang.split('_')[1];
    $rootScope.lang_prefix = baseLang;
    $translate.use(newLang);
  };
  languageFactory.changeLanguageDivision = function (langDivision) {
    var oldLang = localStorage.NG_TRANSLATE_LANG_KEY;
    var newLang = oldLang.split('_')[0] + '_' + langDivision;
    $rootScope.lang_suffix = '_' + langDivision;
    $translate.use(newLang);
  };
  languageFactory.getLanguageDivision = function () {
    var langKey = localStorage.NG_TRANSLATE_LANG_KEY;
    return divisionKey = langKey.split('_')[1] || '';
  };
  languageFactory.changeLanguageByDivisionId = function (divisionId) {
    switch (divisionId) {
      case DivisionTypeEnum.CONSTRUCTION:
        languageFactory.changeLanguageDivision('bl');
        break;
      case DivisionTypeEnum.PRODUCTION:
        languageFactory.changeLanguageDivision('pl');
        break;
      default:
        languageFactory.changeLanguageDivision('bl');
    }
  };
  return languageFactory;
}]);
'use strict';

angular.module('sp.factories').factory('locationFactory', ['$http', '$httpParamSerializer', 'ENV', function ($http, $httpParamSerializer, ENV) {
  var urlBase = '/api/locations';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var locationFactory = {};
  locationFactory.getLocations = function (mainProjectId) {
    var params = {
      mainProjectId: mainProjectId
    };
    return $http.get(url + '?' + $httpParamSerializer(params));
  };
  locationFactory.getLocation = function (id) {
    return $http.get(url + '/' + id);
  };
  locationFactory.createLocation = function (loc) {
    var out = JSON.stringify(loc);
    return $http.post(url, out);
  };
  locationFactory.updateLocation = function (id, loc) {
    var out = JSON.stringify(loc);
    return $http.put(url + '/' + id, out);
  };
  locationFactory.activateLocation = function (id) {
    return $http.put(url + '/' + id + '/activate');
  };
  locationFactory.deactivateLocation = function (id) {
    return $http.put(url + '/' + id + '/deactivate');
  };
  locationFactory.deleteLocation = function (id) {
    return $http.delete(url + '/' + id);
  };
  locationFactory.getLocationTreeRules = function (divisionId) {
    return $http.get(url + '/typetree/' + divisionId);
  };
  locationFactory.getFilterableVehicleDropLocations = function (mainProjectId, includeDeleted, includeInactive) {
    console.log("getFilterableVehicleDropLocations includeDeleted=" + includeDeleted + " includeInactive=" + includeInactive);
    var params = {
      mainProjectId: mainProjectId,
      includeDeleted: includeDeleted,
      includeInactive: includeInactive
    };
    return $http.get(url + '/FilterableVehicleDropLocations?' + $httpParamSerializer(params));
  };
  locationFactory.getFilterableResourceLocations = function (mainProjectId, includeDeleted, includeInactive) {
    var params = {
      mainProjectId: mainProjectId,
      includeDeleted: includeDeleted,
      includeInactive: includeInactive
    };
    return $http.get(url + '/FilterableResourceLocations?' + $httpParamSerializer(params));
  };
  locationFactory.getDestinationLocations = function (mainProjectId) {
    var params = {
      mainProjectId: mainProjectId
    };
    return $http.get(url + '/DestinationLocations?' + $httpParamSerializer(params));
  };
  locationFactory.createDTO = function (location) {
    return {
      "Name": location.location_name,
      "LocationId": location.location_id,
      "ParentLocationId": location.parent_location_id,
      "LocationTypeId": location.location_type_id,
      "Level": location.level,
      "SortOrder": location.sort_order,
      "IsActive": true,
      "IsScannable": location.is_scannable,
      "Comments": location.comments,
      "RootMainProjectId": location.root_main_project_id
    };
  };
  locationFactory.repackageDTO = function (DTO) {
    var out = {
      location_id: DTO.LocationId,
      location_type_id: DTO.LocationTypeId,
      location_type_name: DTO.LocationTypeAlias,
      location_name: DTO.Name,
      parent_location_id: DTO.ParentLocationId,
      child_location_type_ids: DTO.ChildLocationTypeIds,
      root_main_project_id: DTO.RootMainProjectId,
      is_scannable: DTO.IsScannable,
      is_active: DTO.IsActive,
      comments: DTO.Comments,
      level: DTO.Level,
      sort_order: DTO.SortOrder,
      collapsed: true,
      show: false
    };
    switch (DTO.LocationTypeId) {
      case LocationTypeEnum.MAIN_PROJECT:
        out.main_project_id = DTO.MainProjectId;
        break;
      case LocationTypeEnum.PROJECT:
        out.project_id = DTO.ProjectId;
        break;
      case LocationTypeEnum.SUB_PROJECT:
        out.sub_project_id = DTO.SubProjectId;
        break;
      default:
      // Other cases needs not to have an extra variable as the projects do.
    }

    return out;
  };
  locationFactory.repackageDTOArray = function (DTOArray) {
    var repackagedDTOArray = [];
    if (!DTOArray) {
      return [];
    }
    angular.forEach(DTOArray, function (DTO) {
      repackagedDTOArray.push(locationFactory.repackageDTO(DTO));
    });
    return repackagedDTOArray;
  };
  return locationFactory;
}]);
'use strict';

factories.factory('mainProjectFactory', ['$http', 'ENV', '$translate', 'generalHelperService', function ($http, ENV, $translate, generalHelperService) {
  var urlBase = '/api/mainprojects';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var mainProjectFactory = {};
  mainProjectFactory.getMainProjects = function () {
    return $http.get(url);
  };
  mainProjectFactory.getMainProject = function (id) {
    return $http.get(url + '/' + id);
  };
  mainProjectFactory.createMainProject = function (project) {
    var out = JSON.stringify(project);
    return $http.post(url, out);
  };
  mainProjectFactory.updateMainProject = function (id, project) {
    var out = JSON.stringify(project);
    return $http.put(url + '/' + id, out);
  };
  mainProjectFactory.activateMainProject = function (id) {
    return $http.put(url + '/' + id + '/activate');
  };
  mainProjectFactory.deactivateMainProject = function (id) {
    return $http.put(url + '/' + id + '/deactivate');
  };
  mainProjectFactory.deleteMainProject = function (id) {
    return $http.delete(url + '/' + id);
  };
  mainProjectFactory.createLesDTO = function (les) {
    return {
      "LesParameterId": les.LesParameterId ? les.LesParameterId : null,
      "LesParameterTypeId": les.LesParameterTypeId,
      "LesParameterTypeName": les.LesParameterTypeName,
      "MainProjectId": les.MainProjectId,
      "Value": les.Value
    };
  };
  mainProjectFactory.createDTO = function (mainProject) {
    return {
      "Name": mainProject.main_project_name,
      "MainProjectId": mainProject.main_project_id,
      "GroupageAreaName": mainProject.groupage_area_name,
      "ShortName": mainProject.main_project_short_name,
      "City": mainProject.city,
      "ArticleNumber": mainProject.main_project_article_number,
      "DivisionId": mainProject.division_id,
      "IsActive": mainProject.is_active,
      "Comments": mainProject.comments,
      "Phone": mainProject.external_support_phone_number,
      "Email": mainProject.external_support_email,
      "PhoneInternal": mainProject.internal_support_phone_number,
      "EmailInternal": mainProject.internal_support_email,
      "HoursToMinOrderDate": mainProject.main_project_hours_to_min_order_date,
      "IsFinalDestinationRequired": mainProject.is_final_destination_required,
      "IsBillable": mainProject.is_billable,
      "SendSmsNotificationsByDefault": mainProject.send_sms_notifications_by_default,
      "IsDirectDeliveryFunctionEnabled": mainProject.is_direct_delivery_function_enabled,
      "IsTransshipmentFunctionEnabled": mainProject.is_transshipment_function_enabled,
      "IsStoringFunctionEnabled": mainProject.is_storing_function_enabled,
      "IsMaterialOrderFunctionEnabled": mainProject.is_material_order_function_enabled,
      "IsResourceBookingFunctionEnabled": mainProject.is_resource_booking_function_enabled,
      "IsWarehouseBalanceFunctionEnabled": mainProject.is_warehouse_balance_function_enabled,
      "IsPlanTransportFunctionEnabled": mainProject.is_plan_transport_function_enabled,
      "IsGateManagementFunctionEnabled": mainProject.is_gate_management_function_enabled,
      "LesParameters": mainProject.les_parameters
    };
  };
  mainProjectFactory.repackageDTO = function (DTO) {
    return {
      main_project_name: DTO.Name,
      main_project_id: DTO.MainProjectId,
      main_project_short_name: DTO.ShortName,
      groupage_area_name: DTO.GroupageAreaName,
      city: DTO.City,
      main_project_article_number: DTO.ArticleNumber,
      division_id: DTO.DivisionId,
      division_name: $translate.instant(generalHelperService.getKeyByValue(DivisionTypeEnum, DTO.DivisionId)),
      is_active: DTO.IsActive,
      comments: DTO.Comments,
      external_support_phone_number: DTO.Phone,
      external_support_email: DTO.Email,
      internal_support_phone_number: DTO.PhoneInternal ? DTO.PhoneInternal : '---',
      internal_support_email: DTO.EmailInternal ? DTO.EmailInternal : '---',
      main_project_hours_to_min_order_date: DTO.HoursToMinOrderDate,
      is_final_destination_required: DTO.IsFinalDestinationRequired,
      is_billable: DTO.IsBillable,
      send_sms_notifications_by_default: DTO.SendSmsNotificationsByDefault,
      is_direct_delivery_function_enabled: DTO.IsDirectDeliveryFunctionEnabled,
      is_transshipment_function_enabled: DTO.IsTransshipmentFunctionEnabled,
      is_storing_function_enabled: DTO.IsStoringFunctionEnabled,
      is_material_order_function_enabled: DTO.IsMaterialOrderFunctionEnabled,
      is_resource_booking_function_enabled: DTO.IsResourceBookingFunctionEnabled,
      is_warehouse_balance_function_enabled: DTO.IsWarehouseBalanceFunctionEnabled,
      is_plan_transport_function_enabled: DTO.IsPlanTransportFunctionEnabled,
      is_gate_management_function_enabled: DTO.IsGateManagementFunctionEnabled,
      les_parameters_dto: DTO.LesParameters
    };
  };
  mainProjectFactory.repackageDTOArray = function (DTOArray) {
    var repackagedDTOArray = [];
    if (!DTOArray) {
      return [];
    }
    angular.forEach(DTOArray, function (DTO) {
      repackagedDTOArray.push(mainProjectFactory.repackageDTO(DTO));
    });
    return repackagedDTOArray;
  };
  return mainProjectFactory;
}]);
'use strict';

angular.module('sp.factories').factory('mainProjectFileFactory', ['$http', '$filter', 'ENV', '$httpParamSerializer', 'errorService', 'ngToast', function ($http, $filter, ENV, $httpParamSerializer, errorService, ngToast) {
  var urlBase = '/api/mainProjectFiles';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var mainProjectFileFactory = {};
  mainProjectFileFactory.saveFile = function (file, mainProjectFileId) {
    var formData = new FormData();
    formData.append('file', file._file);

    // Shall send content type 'multipart/form-data'.
    // This is needed to overwrite default value 'application/json', see https://stackoverflow.com/questions/41607656/purpose-of-content-type-undefined-in-angularjs-fileupload
    var config = {
      headers: {
        'Content-Type': undefined
      }
    };
    var resultPromise = $http.post(url + "/" + mainProjectFileId + "/file", formData, config);
    resultPromise.catch(function () {
      ngToast.danger("Filuppladdning av '" + file._file.name + "' misslyckades.");
    });
    return resultPromise;
  };
  mainProjectFileFactory.getMainProjectFileUrl = function (mainProjectFileId) {
    return url + "/" + mainProjectFileId + "/file";
  };
  mainProjectFileFactory.createMainProjectFile = function (mainProjectFile, file) {
    var json = JSON.stringify(mainProjectFile);
    return $http.post(url, json).then(function (response) {
      return mainProjectFileFactory.saveFile(file, response.data);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  mainProjectFileFactory.getMainProjectFiles = function (mainProjectId) {
    var params = {
      mainProjectId: mainProjectId
    };
    return $http.get(url + '/?' + $httpParamSerializer(params));
  };
  mainProjectFileFactory.getMainProjectFile = function (mainProjectFileId) {
    return $http.get(url + '/' + mainProjectFileId);
  };
  mainProjectFileFactory.updateMainProjectFile = function (id, mainProjectFile, file) {
    var json = JSON.stringify(mainProjectFile);
    if (!file) return $http.put(url + "/" + id, json);
    return $http.put(url + "/" + id, json).then(function (response) {
      return mainProjectFileFactory.saveFile(file, id);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  mainProjectFileFactory.deleteMainProjectFile = function (mainProjectFileId) {
    return $http.delete(url + "/" + mainProjectFileId);
  };
  mainProjectFileFactory.repackageDTO = function (DTO) {
    var repackagedDTO = {
      mainProjectFileId: DTO.MainProjectFileId,
      header: DTO.Header,
      fileName: DTO.File != null ? DTO.File.FileName : "",
      fileUploaded: $filter('toDateTime')(DTO.FileUploaded),
      file: DTO.File != null ? DTO.File : {},
      comments: DTO.Comments
    };
    repackagedDTO.file.FileUrl = mainProjectFileFactory.getMainProjectFileUrl(DTO.MainProjectFileId);
    return repackagedDTO;
  };
  mainProjectFileFactory.repackageDTOArray = function (DTOArray) {
    if (!DTOArray) {
      return [];
    }
    var repackagedDTOArray = [];
    angular.forEach(DTOArray, function (DTO) {
      repackagedDTOArray.push(mainProjectFileFactory.repackageDTO(DTO));
    });
    return repackagedDTOArray;
  };
  return mainProjectFileFactory;
}]);
'use strict';

factories.factory('notificationTemplateFactory', ['$http', 'ENV', 'generalHelperService', function ($http, ENV, generalHelperService) {
  var urlBase = '/api/NotificationTemplates';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var notificationTemplateFactory = {};
  notificationTemplateFactory.getNotificationTemplates = function () {
    return $http.get(url);
  };
  notificationTemplateFactory.getNotificationTemplate = function (id) {
    return $http.get(url + '/' + id);
  };
  notificationTemplateFactory.updateNotificationTemplate = function (id, notificationTemplate) {
    var out = JSON.stringify(notificationTemplate);
    return $http.put(url + '/' + id, out);
  };
  notificationTemplateFactory.getConfigurableTemplates = function () {
    return $http.get(url + '/ConfigurableTemplates');
  };
  notificationTemplateFactory.extendTemplatesWithNames = function (notificationConfiguration) {
    return notificationConfiguration.reduce(function (acc, conf) {
      acc.push({
        NotificationType: conf.NotificationType,
        NotificationTemplateName: generalHelperService.getKeyByValue(NotificationTypeEnum, conf.NotificationType),
        IsSelected: conf.IsSelected
      });
      return acc;
    }, []);
  };
  return notificationTemplateFactory;
}]);
'use strict';

factories.factory('notificationsFactory', ['$http', 'ENV', function ($http, ENV) {
  var urlBase = '/api/notifications';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var notificationsFactory = {};
  notificationsFactory.getNotifications = function () {
    return $http.get(url);
  };
  return notificationsFactory;
}]);
'use strict';

factories.factory('orderDirectDeliveryFactory', ['$http', 'ENV', function ($http, ENV) {
  var orderDirectDeliveryFactory = {};
  orderDirectDeliveryFactory.createOrderDTO = function (order, orderStatus) {
    var out = {
      "OrderId": order.order_id,
      "TaskStatus": order.task_status,
      "DeliveryReceiver1ContactId": order.dr.receiver1.contact_id,
      "DeliveryReceiver1ContactName": order.dr.receiver1.contact_name,
      "DeliveryReceiver1ContactPhone": order.dr.receiver1.phone_nr,
      "DeliveryReceiver1ContactEmail": order.dr.receiver1.email,
      "DeliveryReceiver1ContactWantEmail": order.dr.receiver1.email_notif,
      "DeliveryReceiver1ContactWantSms": order.dr.receiver1.sms_notif,
      "DeliveryReceiver2ContactId": order.dr.receiver2.contact_id,
      "DeliveryReceiver2ContactName": order.dr.receiver2.contact_name,
      "DeliveryReceiver2ContactPhone": order.dr.receiver2.phone_nr,
      "DeliveryReceiver2ContactEmail": order.dr.receiver2.email,
      "DeliveryReceiver2ContactWantEmail": order.dr.receiver2.email_notif,
      "DeliveryReceiver2ContactWantSms": order.dr.receiver2.sms_notif,
      "DeliveryReceiver3ContactId": order.dr.receiver3.contact_id,
      "DeliveryReceiver3ContactName": order.dr.receiver3.contact_name,
      "DeliveryReceiver3ContactPhone": order.dr.receiver3.phone_nr,
      "DeliveryReceiver3ContactEmail": order.dr.receiver3.email,
      "DeliveryReceiver3ContactWantEmail": order.dr.receiver3.email_notif,
      "DeliveryReceiver3ContactWantSms": order.dr.receiver3.sms_notif,
      'Supplier': order.di.supplier,
      'HasAdditionalServiceGuiding': !!order.bc.guiding_help,
      'HasAdditionalServiceUnloadingHelp': !!order.bc.unloading_help,
      'IsUnannouncedGoods': !!order.bc.is_unannounced_goods,
      'IsUnreachable': !!order.bc.is_unreachable,
      'IsUnusedResource': !!order.bc.is_unused_resource,
      "AdditionalServiceGuidingStatusId": order.dto ? order.dto.AdditionalServiceGuidingStatusId : null,
      "AdditionalServiceUnloadingHelpStatusTypeId": order.dto ? order.dto.AdditionalServiceUnloadingHelpStatusTypeId : null,
      'VehicleTypeId': order.di.vehicle_type_id,
      'VehicleTypeCode': order.di.vehicle_type_name,
      'VehicleDropLocationId': order.bc.vehicle_drop_location_id,
      'VehicleDropLocationName': order.bc.vehicle_drop_location_name,
      'DestinationLocationId': order.bc.destination_location_id,
      'DestinationLocationName': order.bc.destination_location_name,
      'StaircaseLocationId': order.bc.staircase_location_id,
      'SlotTimeMin': order.bc.timeslots.time_i,
      'SlotTimeMax': order.bc.timeslots.time_f,
      'InGateId': order.bc.gate_in_id,
      'InGateName': order.bc.gate_in_name,
      'OutGateId': order.bc.gate_out_id,
      'OutGateName': order.bc.gate_out_name,
      'ExtraInGateId': order.bc.extra_gate_in_id,
      'ExtraInGateName': order.bc.extra_gate_in_name,
      'ExtraOutGateId': order.bc.extra_gate_out_id,
      'ExtraOutGateName': order.bc.extra_gate_out_name,
      'NumTransports': order.bc.n_transports,
      'NumUnbookedTransports': order.bc.n_unbooked_transports,
      'Comments': order.bc.comments,
      'Files': ['nothing'],
      'GatePassCode': order.br.gate_code,
      'OrderNumber': order.br.order_number,
      'Content': order.di.material,
      'Quantity': order.di.n_materials ? order.di.n_materials : '',
      'OrderType': OrderTypeEnum.DIRECT_DELIVERY,
      'OrderStatus': orderStatus,
      'WorkOrderId': order.proj.work_order_id,
      'WorkOrderName': order.proj.work_order_name,
      'WorkOrderCompanyId': order.proj.company_id === -1 ? null : order.proj.company_id,
      // -1 used for filtering purpose and should not reach backend.
      'WorkOrderCompanyName': order.proj.company_name,
      "OrderCreatorContactId": order.proj.contact_person.contact_id,
      "OrderCreatorContactName": order.proj.contact_person.contact_name,
      "OrderCreatorContactPhone": order.proj.contact_person.phone_nr,
      "OrderCreatorContactEmail": order.proj.contact_person.email,
      "OrderCreatorContactWantSms": order.proj.contact_person.sms_notif,
      "OrderCreatorContactWantEmail": order.proj.contact_person.email_notif,
      "AllowedPassages": 0
    };
    return out;
  };
  orderDirectDeliveryFactory.loadRecurringWeek = function (recurringWeekTemplate, recurringTimes) {
    angular.forEach(recurringTimes, function (time) {
      if (time.DayOfWeek === 0) {
        recurringWeekTemplate[6].slots.push({
          recurring_time_id: time.RecurringTimeId,
          week_day: time.DayOfWeek,
          time_i: time.SlotTimeMin,
          time_f: time.SlotTimeMax
        });
      } else {
        recurringWeekTemplate[time.DayOfWeek - 1].slots.push({
          recurring_time_id: time.RecurringTimeId,
          week_day: time.DayOfWeek,
          time_i: time.SlotTimeMin,
          time_f: time.SlotTimeMax
        });
      }
    });
    return recurringWeekTemplate;
  };
  function createRecurringTimes(recurringWeek) {
    var recurringTimes = [];
    for (var i = 0; i < 7; i++) {
      angular.forEach(recurringWeek[i].slots, function (recurringSlot) {
        recurringTimes.push({
          'RecurringTimeId': recurringSlot.recurring_time_id,
          'DayOfWeek': recurringSlot.week_day,
          'SlotTimeMin': recurringSlot.time_i,
          'SlotTimeMax': recurringSlot.time_f
        });
      });
    }
    return recurringTimes;
  }
  orderDirectDeliveryFactory.createRecurringOrderDTO = function (order, orderStatus) {
    var orderDTO = orderDirectDeliveryFactory.createOrderDTO(order, orderStatus);
    orderDTO['OrderType'] = OrderTypeEnum.RECURRING_DIRECT_DELIVERY;
    orderDTO["RecurringStart"] = new Date(order.bc.timeslots.recurring_start);
    orderDTO["RecurringEnd"] = new Date(order.bc.timeslots.recurring_end);
    orderDTO["WeekTypeId"] = order.bc.timeslots.week_frequency;
    orderDTO['RecurringTimes'] = createRecurringTimes(order.bc.timeslots.recurring_week);

    // Values must be set since recurring and normal direct delivery shares params but not all are needed.
    orderDTO['SlotTimeMin'] = new Date();
    orderDTO['SlotTimeMax'] = new Date();
    orderDTO['NumTransports'] = 0;

    // Override regular direct delivery allowedPassages with one calculated by recurring order.
    orderDTO["AllowedPassages"] = order.bc.timeslots.allowed_passages;
    return orderDTO;
  };
  return orderDirectDeliveryFactory;
}]);
'use strict';

angular.module('sp.factories').factory('orderFactory', ['$http', '$q', 'ENV', '$httpParamSerializer', 'generalHelperService', '$translate', '$filter', '$rootScope', 'errorService', 'megaFilterService', 'ngToast', function ($http, $q, ENV, $httpParamSerializer, generalHelperService, $translate, $filter, $rootScope, errorService, megaFilterService, ngToast) {
  var urlBase = '/api/orders';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var orderFactory = {};
  function dateMax(date1, date2) {
    if (!date1) {
      return date2;
    }
    if (!date2) {
      return date1;
    }
    return date1 > date2 ? date1 : date2;
  }
  function dateMin(date1, date2) {
    if (!date1) {
      return date2;
    }
    if (!date2) {
      return date1;
    }
    return date1 > date2 ? date1 : date2;
  }
  function PackageApiPaginationIfSet(pagination) {
    if (pagination.skip != null && pagination.take != null) {
      return {
        Skip: pagination.skip,
        Take: pagination.take
      };
    }
    return null;
  }
  function combineFilterAndPagination(filter, pagination, mainProjectId, searchString) {
    var combined = {
      Filter: megaFilterService.copyFilter(filter),
      Pagination: PackageApiPaginationIfSet(pagination)
    };
    combined.Filter.MainProjectId = mainProjectId;
    combined.Filter.SearchString = searchString;
    combined.Filter.deliveryTimeFrom = dateMax(filter.deliveryTimeFrom, pagination.from);
    combined.Filter.deliveryTimeTo = dateMin(filter.deliveryTimeTo, pagination.to);
    return combined;
  }

  //Files
  orderFactory.saveFile = function (orderId, file, fileAttachmentTypeId) {
    var formData = new FormData();
    formData.append('file', file._file);

    // Shall send content type 'multipart/form-data'.
    // This is needed to overwrite default value 'application/json', see https://stackoverflow.com/questions/41607656/purpose-of-content-type-undefined-in-angularjs-fileupload
    var config = {
      headers: {
        'Content-Type': undefined
      }
    };
    var resultPromise = $http.post(url + "/" + orderId + "/" + fileAttachmentTypeId + "/Files", formData, config);
    resultPromise.catch(function () {
      ngToast.danger("Filuppladdning av '" + file._file.name + "' misslyckades.");
    });
    return resultPromise;
  };
  orderFactory.createFileLink = function (orderId, fileName) {
    return url + '/' + orderId + '/Files/' + fileName;
  };

  // -- General orders --
  orderFactory.getOrders = function (mainProjectId, filter, pagination, searchString) {
    var data = combineFilterAndPagination(filter, pagination, mainProjectId, searchString);
    var json = JSON.stringify(data);
    return $http.post(url + '/FilteredOrders', json).then(function (response) {
      return orderFactory.RepackageDTOSlice(response.data);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  orderFactory.getOrdersFromExtendedSet = function (mainProjectId, filter, pagination, searchString) {
    var data = combineFilterAndPagination(filter, pagination, mainProjectId, searchString);
    var json = JSON.stringify(data);
    return $http.post(url + '/ExtendedSet', json).then(function (response) {
      return orderFactory.RepackageDTOSlice(response.data);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  orderFactory.getOrdersWithPackages = function (mainProjectId, filter, pagination, searchString) {
    var data = combineFilterAndPagination(filter, pagination, mainProjectId, searchString);
    var json = JSON.stringify(data);
    return $http.post(url + '/WithPackages', json).then(function (response) {
      return orderFactory.RepackageDTOSliceWithPackages(response.data);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  orderFactory.getPackageCollections = function (mainProjectId, searchString, dates, chosenTimeValueType) {
    var params = {
      mainProjectId: mainProjectId,
      searchString: searchString ? searchString : "",
      dateTimeFrom: dates.dateTimeFrom,
      dateTimeTo: dates.dateTimeTo,
      chosenTimeValueType: chosenTimeValueType
    };
    return $http.get(url + '/PackageCollection?' + $httpParamSerializer(params));
  };
  orderFactory.getGateBookings = function (mainProjectId) {
    return $http.get(url + '/GateBookings?mainProjectId=' + mainProjectId);
  };
  orderFactory.getArchived = function (mainProjectId, filter, pagination, searchString) {
    var data = combineFilterAndPagination(filter, pagination, mainProjectId, searchString);
    var json = JSON.stringify(data);
    return $http.post(url + '/Archived', json).then(function (response) {
      return orderFactory.RepackageDTOSlice(response.data);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  orderFactory.getArchivedWithPackages = function (mainProjectId, filter, pagination, searchString) {
    var data = combineFilterAndPagination(filter, pagination, mainProjectId, searchString);
    var json = JSON.stringify(data);
    return $http.post(url + '/Archived/WithPackages', json).then(function (response) {
      return orderFactory.RepackageDTOSliceWithPackages(response.data);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  orderFactory.getUndeliveredOrders = function (mainProjectId, includeAllStatuses) {
    var params = {
      mainProjectId: mainProjectId,
      includeAllStatuses: includeAllStatuses
    };
    return $http.get(url + '/undelivered?' + $httpParamSerializer(params));
  };
  orderFactory.getOrder = function (id) {
    return $http.get(url + '/' + id);
  };
  function saveFiles(orderId, files, fileAttachmentTypeEnum) {
    var filePromises = [];
    angular.forEach(files, function (file) {
      filePromises.push(orderFactory.saveFile(orderId, file, fileAttachmentTypeEnum));
    });
    return Promise.all(filePromises);
  }
  orderFactory.createOrder = function (order, files, formGuid) {
    if (!formGuid) {
      formGuid = null;
    }
    var params = {
      formGuid: formGuid
    };
    var out = JSON.stringify(order);
    return $http.post(url + '?' + $httpParamSerializer(params), out).then(function (response) {
      if (files) {
        saveFiles(response.data, files, FileAttachmentTypeEnum.DOCUMENT);
      }
      return response;
    });
  };
  orderFactory.getGuid = function () {
    return $http.get(url + '/getguid');
  };
  orderFactory.confirmOrder = function (id, order, options) {
    var out = JSON.stringify(order);
    return $http.put(url + '/' + id + '/updateandconfirmorder', out).then(function (response) {
      if (options && options.fileAttachments) {
        saveFiles(id, options.fileAttachments, FileAttachmentTypeEnum.DOCUMENT);
      }
    });
  };
  orderFactory.updateOrder = function (id, order, options) {
    var out = JSON.stringify(order);
    return $http.put(url + '/' + id, out).then(function (response) {
      if (options && options.fileAttachments) {
        saveFiles(id, options.fileAttachments, FileAttachmentTypeEnum.DOCUMENT);
      }
    });
  };
  orderFactory.cancelOrder = function (id, order) {
    var out = JSON.stringify(order);
    return $http.put(url + '/' + id + '/cancelorder', out);
  };
  orderFactory.reactivatePackageCollectionOrder = function (id, order) {
    var out = JSON.stringify(order);
    return $http.put(url + '/' + id + '/reactivatePackageCollectionOrder', out);
  };
  orderFactory.renotifyOrderStatus = function (id) {
    return $http.put(url + '/' + id + '/RenotifyOrderStatus');
  };

  // -- Direct Delivery --
  orderFactory.getDirectDeliveryFormBase = function (id) {
    return $http.get(endPoint + '/api/workorders/' + id + '/directdeliveryorderformbase');
  };
  orderFactory.renotifyDirectDeliveryOrder = function (id) {
    return $http.put(url + '/' + id + '/sendgatepasscode');
  };
  orderFactory.isTimeSlotAvailable = function (from, to, vehicleDropLocationId, orderId) {
    var params = {
      from: from,
      to: to,
      vehicleDropLocationId: vehicleDropLocationId,
      orderId: orderId
    };
    return $http.get(url + '/IsTimeSlotAvailable?' + $httpParamSerializer(params));
  };
  orderFactory.isResourceAvailable = function (from, to, resourceLocationId, resourceBookingId) {
    var params = {
      from: from,
      to: to,
      resourceLocationId: resourceLocationId,
      resourceBookingId: resourceBookingId
    };
    return $http.get(url + '/IsResourceAvailable?' + $httpParamSerializer(params));
  };
  orderFactory.passCodeTryAgain = function (orderId) {
    return $http.put(url + '/' + orderId + '/PassCodeTryAgain');
  };

  // -- Storing --
  orderFactory.getStoringFormBase = function (workOrderId) {
    return $http.get(endPoint + '/api/workorders/' + workOrderId + '/storingorderformbase');
  };

  // -- Transshipment --
  orderFactory.getTransshipmentFormBase = function (workOrderId) {
    return $http.get(endPoint + '/api/workorders/' + workOrderId + '/transshipmentorderformbase');
  };

  /**
   * Retrieves a MaterialOrderFormBaseDTO. Including current article balance from WMS (Epix)
   */
  orderFactory.getMaterialFormBase = function (workOrderId) {
    return $http.get(endPoint + '/api/workorders/' + workOrderId + '/materialorderformbase');
  };

  // -- Resource Booking --
  orderFactory.getResourceBookingOrderBase = function (workOrderId) {
    return $http.get(endPoint + '/api/workorders/' + workOrderId + '/resourcebookingorderformbase');
  };

  //---- Changing task statuses
  //"NextStatus/{orderType}/{taskStatusId}"
  orderFactory.getNextStatus = function (orderType, taskStatusId) {
    return $http.get(url + "/NextStatus/" + orderType + "/" + taskStatusId);
  };
  orderFactory.setNextStatus = function (orderId) {
    return orderFactory.setNextStatusMultiple([orderId]);
  };
  orderFactory.setNextStatusMultiple = function (orderIds) {
    return $http.post(url + '/NextStatus', orderIds).finally(function () {
      $rootScope.$broadcast('orderStatusChanged');
    });
  };
  //---- Task Status end ------

  orderFactory.removeOrderFromDelivery = function (orderId) {
    return $http.put(url + '/' + orderId + '/RemoveFromDelivery');
  };
  orderFactory.repackageDTO = function (DTO) {
    //first, map common properties
    var order = {
      order_id: DTO.OrderId,
      order_number: DTO.OrderNumber,
      order_type: DTO.OrderType,
      order_type_name: $translate.instant(generalHelperService.getKeyByValue(OrderTypeEnum, DTO.OrderType)),
      order_status_type_id: DTO.OrderStatus,
      order_status_type_name: $translate.instant(generalHelperService.getKeyByValue(OrderStatusTypeEnum, DTO.OrderStatus)),
      task_status: DTO.TaskStatus,
      task_status_name: $translate.instant(generalHelperService.getKeyByValue(TaskStatusTypeEnum, DTO.TaskStatus)),
      project_id: null,
      project_name: '',
      work_order_id: DTO.WorkOrderId,
      work_order_name: DTO.WorkOrderName,
      work_order_company_id: DTO.WorkOrderCompanyId,
      work_order_company_name: DTO.WorkOrderCompanyName,
      erp_system_reference: DTO.ErpSystemReference,
      packages: DTO.Packages,
      supplier: DTO.Supplier,
      content: DTO.Content,
      additional_services: DTO.AdditionalServices,
      contacts: DTO.Contacts,
      is_accessible_to_user: DTO.IsAccessibleToUser,
      originalDTO: DTO
    };

    // Selects Project based on DropLocation.
    angular.forEach(DTO.WOProjects, function (project) {
      if (DTO.DropLocationProjectId === project.ProjectId) {
        order.project_id = project.ProjectId;
        order.project_name = project.Name;
      }
    });

    //then map order type specific properties
    switch (DTO.OrderType) {
      case OrderTypeEnum.DIRECT_DELIVERY:
        order.time_i = $filter('toTime')(DTO.SlotTimeMin);
        order.time_f = $filter('toTime')(DTO.SlotTimeMax);
        order.vehicle_drop_location_id = DTO.VehicleDropLocationId;
        order.vehicle_drop_location_name = DTO.VehicleDropLocationName;
        order.time_span = $filter('toTime')(DTO.SlotTimeMin) + '-' + $filter('toTime')(DTO.SlotTimeMax);
        order.date_i = $filter('toDate')(DTO.SlotTimeMin);
        order.date_f = $filter('toDate')(DTO.SlotTimeMax);
        order.gate_pass_code = DTO.PassCode;
        order.is_part = DTO.IsPart;
        order.parts_count = DTO.PartsCount;
        order.part_number = DTO.PartNumber;
        order.well_sec_error_code = DTO.WellSecErrorCode;
        order.pass_code_status_id = DTO.PassCodeRequestStatusId;
        break;
      case OrderTypeEnum.RECURRING_DIRECT_DELIVERY:
        // If SlottimeMin/Max is available then i means that it is not archived and has been split. Archived orders aren't split
        order.time_i = DTO.SlotTimeMin ? $filter('toTime')(DTO.SlotTimeMin) : $filter('toTime')(DTO.RecurringStart);
        order.time_f = DTO.SlotTimeMax ? $filter('toTime')(DTO.SlotTimeMax) : $filter('toTime')(DTO.RecurringEnd);
        order.vehicle_drop_location_id = DTO.VehicleDropLocationId;
        order.vehicle_drop_location_name = DTO.VehicleDropLocationName;
        order.time_span = $filter('toTime')(DTO.SlotTimeMin) + '-' + $filter('toTime')(DTO.SlotTimeMax);
        order.date_i = DTO.SlotTimeMin ? $filter('toDate')(DTO.SlotTimeMin) : $filter('toDate')(DTO.RecurringStart);
        order.date_f = DTO.SlotTimeMax ? $filter('toDate')(DTO.SlotTimeMax) : $filter('toDate')(DTO.RecurringEnd);
        order.gate_pass_code = DTO.PassCode;
        order.is_part = DTO.IsPart;
        order.parts_count = DTO.PartsCount;
        order.part_number = DTO.PartNumber;
        order.well_sec_error_code = DTO.WellSecErrorCode;
        break;
      case OrderTypeEnum.STORING:
        order.time_i = $filter('toTime')(DTO.OrderDate);
        order.date_i = $filter('toDate')(DTO.OrderDate);
        break;
      case OrderTypeEnum.TRANSSHIPMENT:
        order.time_i = $filter('toTime')(DTO.OrderDate);
        order.date_i = $filter('toDate')(DTO.OrderDate);
        order.arrival_at_warehouse = $filter('toDateTime')(DTO.OrderDate);
        order.arrival_time = $filter('toTime')(DTO.OrderDate);
        order.vehicle_drop_location_id = DTO.VehicleDropLocationId;
        order.vehicle_drop_location_name = DTO.VehicleDropLocationName;
        order.shipping_id = DTO.ShippingId;
        order.shipping_name = DTO.ShippingName;
        order.timing_due_date = DTO.TimingDueDate ? $filter('toDateTime')(DTO.TimingDueDate) : '';
        order.package_count = DTO.PackageCount;
        order.package_weight = DTO.PackageWeight;
        break;
      case OrderTypeEnum.MATERIAL:
        order.time_i = $filter('toTime')(DTO.OrderDate);
        order.date_i = $filter('toDate')(DTO.OrderDate);
        order.wished_delivery_time = $filter('toTime')(DTO.OrderDate);
        order.wished_delivery_date = $filter('toDate')(DTO.OrderDate);
        order.vehicle_drop_location_id = DTO.VehicleDropLocationId;
        order.vehicle_drop_location_name = DTO.VehicleDropLocationName;
        order.shipping_id = DTO.ShippingId;
        order.shipping_name = DTO.ShippingName;
        order.timing_due_date = DTO.TimingDueDate ? $filter('toDateTime')(DTO.TimingDueDate) : '';
        order.package_count = DTO.PackageCount;
        order.package_weight = DTO.PackageWeight;
        break;
      case OrderTypeEnum.RESOURCE_BOOKING:
        order.time_i = $filter('toTime')(DTO.SlotTimeMin);
        order.date_i = $filter('toDate')(DTO.SlotTimeMin);
        order.time_f = $filter('toTime')(DTO.SlotTimeMax);
        order.time_f = $filter('toTime')(DTO.SlotTimeMax);
        order.resource_location_name = DTO.ResourceLocationName;
        order.resource_location_id = DTO.ResourceLocationId;
        break;
      default:
        console.log("Error: Trying to repackage invalid order type: " + DTO.OrderType);
        return;
    }
    return order;
  };
  orderFactory.repackageOrderWithPackagesDTO = function (DTO) {
    return {
      order_id: DTO.OrderId,
      order_type: DTO.OrderType,
      order_type_name: $translate.instant(generalHelperService.getKeyByValue(OrderTypeEnum, DTO.OrderType)),
      package_id: DTO.PackageId,
      package_status_type_name: $translate.instant(generalHelperService.getKeyByValue(PackageStatusTypeEnum, DTO.PackageStatusType)),
      delivery_number: DTO.OrderNumber,
      package_number: DTO.ExternalPackageId,
      // SendSuit
      tracking_number: DTO.TrackingNumber,
      // DHL etc..
      destination: DTO.Destination,
      current_location: DTO.LocationName,
      current_location_date_time: $filter('toDateTime')(DTO.Updated),
      time_i: $filter('toTime')(DTO.DeliveryDate),
      date_i: $filter('toDate')(DTO.DeliveryDate)
    };
  };
  orderFactory.repackageDTOArray = function (DTOArray) {
    var repackagedDTOArray = [];
    if (!DTOArray) {
      return [];
    }
    angular.forEach(DTOArray, function (DTO) {
      var repackagedDTO = orderFactory.repackageDTO(DTO);
      if (repackagedDTO) {
        repackagedDTOArray.push(repackagedDTO);
      }
    });
    return repackagedDTOArray;
  };
  orderFactory.RepackageDTOSlice = function (slice) {
    return {
      items: orderFactory.repackageDTOArray(slice.Items),
      totalCount: slice.TotalCount
    };
  };
  orderFactory.repackageOrderWithPackagesDTOArray = function (DTOArray) {
    var repackagedDTOArray = [];
    if (!DTOArray) {
      return [];
    }
    angular.forEach(DTOArray, function (DTO) {
      var repackagedDTO = orderFactory.repackageOrderWithPackagesDTO(DTO);
      if (repackagedDTO) {
        repackagedDTOArray.push(repackagedDTO);
      }
    });
    return repackagedDTOArray;
  };
  orderFactory.RepackageDTOSliceWithPackages = function (slice) {
    return {
      items: orderFactory.repackageOrderWithPackagesDTOArray(slice.Items),
      totalCount: slice.TotalCount
    };
  };
  orderFactory.printShippingsNote = function (orderId, printerId, printLabel, printNotice) {
    var params = {
      orderId: orderId,
      printerId: printerId,
      printLabel: !!printLabel,
      printNotice: !!printNotice
    };
    return $http.put(url + '/' + orderId + '/PrintShippingsNotes?' + $httpParamSerializer(params));
  };
  orderFactory.updateAdditionalService = function (orderId, serviceTypeId, serviceStatusTypeId) {
    var out = {
      "AdditionalServiceTypeId": serviceTypeId,
      "AdditionalServiceStatusTypeId": serviceStatusTypeId
    };
    return $http.put(url + '/' + orderId + '/updateadditionalservice', out);
  };
  orderFactory.repackageResourceBookingDTOArray = function (DTOArray) {
    if (!DTOArray) {
      return [];
    }
    var repackagedDTOArray = [];
    angular.forEach(DTOArray, function (DTO) {
      repackagedDTOArray.push({
        "resource_booking_id": DTO.ResourceBookingId,
        "resource_location_id": DTO.ResourceLocationId,
        "resource_location_name": DTO.ResourceLocationName,
        "slot_time_start": $filter('toDateTime')(DTO.SlotTimeStart),
        "slot_time_end": $filter('toDateTime')(DTO.SlotTimeEnd)
      });
    });
    return repackagedDTOArray;
  };
  orderFactory.createResourceBookingDTOArray = function (resourceBookings) {
    if (!resourceBookings) {
      return [];
    }
    var DTOArray = [];
    angular.forEach(resourceBookings, function (resourceBooking) {
      DTOArray.push({
        "ResourceBookingId": resourceBooking.resource_booking_id,
        "ResourceLocationId": resourceBooking.resource_location_id,
        "SlotTimeStart": resourceBooking.slot_time_start,
        "SlotTimeEnd": resourceBooking.slot_time_end
      });
    });
    return DTOArray;
  };
  return orderFactory;
}]);
'use strict';

factories.factory('orderGateBookingFactory', ['$http', 'ENV', function ($http, ENV) {
  var orderGateBookingFactory = {};
  orderGateBookingFactory.createOrderDTO = function (order, orderStatus) {
    return {
      "OrderId": order.order_id,
      "TaskStatus": order.task_status,
      "DeliveryReceiver1ContactId": order.dr.receiver1.contact_id,
      "DeliveryReceiver1ContactName": order.dr.receiver1.contact_name,
      "DeliveryReceiver1ContactPhone": order.dr.receiver1.phone_nr,
      "DeliveryReceiver1ContactEmail": order.dr.receiver1.email,
      "DeliveryReceiver1ContactWantEmail": order.dr.receiver1.email_notif,
      "DeliveryReceiver1ContactWantSms": order.dr.receiver1.sms_notif,
      "DeliveryReceiver2ContactId": order.dr.receiver2.contact_id,
      "DeliveryReceiver2ContactName": order.dr.receiver2.contact_name,
      "DeliveryReceiver2ContactPhone": order.dr.receiver2.phone_nr,
      "DeliveryReceiver2ContactEmail": order.dr.receiver2.email,
      "DeliveryReceiver2ContactWantEmail": order.dr.receiver2.email_notif,
      "DeliveryReceiver2ContactWantSms": order.dr.receiver2.sms_notif,
      "DeliveryReceiver3ContactId": order.dr.receiver3.contact_id,
      "DeliveryReceiver3ContactName": order.dr.receiver3.contact_name,
      "DeliveryReceiver3ContactPhone": order.dr.receiver3.phone_nr,
      "DeliveryReceiver3ContactEmail": order.dr.receiver3.email,
      "DeliveryReceiver3ContactWantEmail": order.dr.receiver3.email_notif,
      "DeliveryReceiver3ContactWantSms": order.dr.receiver3.sms_notif,
      'Supplier': order.di.supplier,
      'SlotTimeMin': order.bc.time_i,
      'SlotTimeMax': order.bc.time_f,
      "AllowedPassages": order.bc.allowed_passages,
      'InGateId': order.bc.gate_in_id,
      'InGateName': order.bc.gate_in_name,
      'OutGateId': order.bc.gate_out_id,
      'OutGateName': order.bc.gate_out_name,
      'Comments': order.bc.comments,
      'GatePassCode': '',
      'OrderNumber': '',
      'OrderType': OrderTypeEnum.GATE_BOOKING,
      'OrderStatus': orderStatus,
      'WorkOrderId': order.proj.work_order_id,
      'WorkOrderName': order.proj.work_order_name,
      'WorkOrderCompanyId': order.proj.company_id,
      'WorkOrderCompanyName': order.proj.company_name,
      "Quantity": ''
    };
  };
  return orderGateBookingFactory;
}]);
"use strict";

factories.factory("orderMaterialFactory", function () {
  var orderMaterialFactory = {};
  function articlesBatchEquals(article1, article2) {
    return article1.article_id === article2.article_id && article1.batch === article2.batch && article1.storage_location === article2.storage_location;
  }
  function insertSorted(array, element, compareFunction) {
    var insertIndex = _.findIndex(array, function (a) {
      return compareArticles(a, element) >= 0;
    });
    if (insertIndex === -1) insertIndex = array.length;
    return array.splice(insertIndex, 0, element);
  }

  /**
  * Returns an array of ArticleOrderLineDTO instances, intended to be part of an OrderDTO to send to BE.
   *
   * Is visible in the factory for test.
   * @param {} articles
   * @param {} storageLocation 
   * @returns {} 
   */
  orderMaterialFactory.packageArticles = function (articles, storageLocation) {
    var articleOrderLineDtoArray = [];
    for (var i = 0; i < articles.length; i++) {
      var articleToAdd = articles[i];

      // Handle that article_quantity is mangled by UI-binding if larger than availability.
      // This may happen if an order is updated or confirmed after the WMS stock har diminished
      var articleQuantity = articleToAdd.article_quantity;
      if (articleQuantity === undefined) {
        articleQuantity = articleToAdd.original_article_quantity;
      }
      if (articleQuantity > 0 && articleToAdd.storage_location === storageLocation) {
        var orderLineDto = _.find(articleOrderLineDtoArray, function (dto) {
          return dto.ArticleId === articleToAdd.article_id && dto.ProductionBatchId === articleToAdd.batch;
        });
        if (orderLineDto) {
          orderLineDto.OrderedQuantity += articleQuantity;
        } else {
          articleOrderLineDtoArray.push({
            "ArticleId": articleToAdd.article_id,
            "ProductionBatchId": articleToAdd.batch,
            "StorageLocation": articleToAdd.storage_location,
            "OrderedQuantity": articleQuantity,
            "Name": articleToAdd.article_name,
            "Unit": articleToAdd.unit,
            "Weight": articleToAdd.weight
          });
        }
      }
    }
    return articleOrderLineDtoArray;
  };
  function repackageArticleOrderLineDTO(articleOrderLineDTO) {
    return {
      article_id: articleOrderLineDTO.ArticleId,
      batch: articleOrderLineDTO.ProductionBatchId ? articleOrderLineDTO.ProductionBatchId : "",
      storage_location: articleOrderLineDTO.StorageLocation ? articleOrderLineDTO.StorageLocation : "",
      article_quantity: articleOrderLineDTO.OrderedQuantity,
      article_name: articleOrderLineDTO.Name ? articleOrderLineDTO.Name : "",
      unit: articleOrderLineDTO.Unit ? articleOrderLineDTO.Unit : "",
      weight: articleOrderLineDTO.Weight
    };
  }
  ;

  /**
   * Returns the ordered articles, with each article as a single line, regardless of the stock situation in WMS.
   * @param {} articleOrderLineDTOArray - Articles ordered by the user.
   * @returns {} ArticleOrderLine array, to be used in the UI
   */
  orderMaterialFactory.repackageArticleOrderLineDTOArray = function (articleOrderLineDTOArray) {
    var articles = [];
    angular.forEach(articleOrderLineDTOArray, function (articleOrderLineDTO) {
      var article = repackageArticleOrderLineDTO(articleOrderLineDTO);
      articles.push(article);
    });
    articles.sort(compareArticles);
    return articles;
  };
  function repackageArticleDTOAsArticleOrderLine(articleDTO) {
    var article = {
      article_id: articleDTO.Id,
      batch: articleDTO.ProductionBatchId ? articleDTO.ProductionBatchId : "",
      storage_location: articleDTO.StorageLocation ? articleDTO.StorageLocation : "",
      article_name: articleDTO.Name ? articleDTO.Name : "",
      unit: articleDTO.Unit ? articleDTO.Unit : "",
      weight: articleDTO.Weight,
      availability: articleDTO.Availability,
      article_quantity: 0,
      original_article_quantity: 0
    };
    return article;
  }
  ;
  function compareArticles(article1, article2) {
    var compare;
    compare = article1.storage_location.localeCompare(article2.storage_location);
    if (compare !== 0) return compare;
    compare = article1.article_id.localeCompare(article2.article_id);
    if (compare !== 0) return compare;
    compare = article1.article_name.localeCompare(article2.article_name);
    if (compare !== 0) return compare;
    compare = article1.batch.localeCompare(article2.batch);
    if (compare !== 0) return compare;
    if (article1.availability !== undefined && article2.availability !== undefined) {
      return article1.availability - article2.availability;
    }
    return 0;
  }

  /**
   * Return a list of the existing WMS articles in stock including what the user has ordered.
   * Intended to be called to populate the order form with data from the BE.
   * 
   * Distributes the ordered articles over the available articles in stock when there is more than one
   * WMS article (pallet) in stock for a specific article.
   * @param {ArticleDTO} articleDTOArray - Articles in stock from WMS-system (Epix).
   * @param {} orderedArticles - Articles ordered by the user.
   * @returns {} ArticleOrderLine array, to be used in the UI
   */
  orderMaterialFactory.repackageArticleDTOsAsArticleOrderLineArray = function (articleDTOArray, orderedArticles) {
    var articles = [];
    angular.forEach(articleDTOArray, function (articleDTO) {
      articles.push(repackageArticleDTOAsArticleOrderLine(articleDTO));
    });

    // Sort articles on availability, so the ordered quantity is distributed on the pallets with least availability first
    articles.sort(compareArticles);

    // For each ordered article, go through the articles in stock and distribute the quantity.
    angular.forEach(orderedArticles, function (orderedArticle) {
      var orderedQuantity = orderedArticle.article_quantity;
      if (orderedQuantity <= 0) return;
      var lastArticle = null;
      var articleIx = _.findIndex(articles, function (article) {
        return articlesBatchEquals(article, orderedArticle);
      });
      while (articleIx !== -1) {
        lastArticle = articles[articleIx];
        var quantityToTakeFromThisArticle = Math.min(orderedQuantity, lastArticle.availability);
        lastArticle.article_quantity = quantityToTakeFromThisArticle;
        lastArticle.original_article_quantity = lastArticle.article_quantity;
        orderedQuantity -= quantityToTakeFromThisArticle;
        if (orderedQuantity === 0) break;
        articleIx = _.findIndex(articles, function (article) {
          return articlesBatchEquals(article, orderedArticle);
        }, articleIx + 1);
      }

      // If ordered article not in stock, show and order it anyway
      if (lastArticle === null) {
        var outOfStockArticle = _.clone(orderedArticle);
        outOfStockArticle.availability = 0;
        outOfStockArticle.original_article_quantity = outOfStockArticle.article_quantity;
        insertSorted(articles, outOfStockArticle, compareArticles);
      }

      // If there was not enough articles in stock to fulfill the ordered quantity, over-order
      // This can happen if the stock has been diminished between notification and confirmation of the material task order.
      if (orderedQuantity > 0 && lastArticle) {
        lastArticle.article_quantity += orderedQuantity;
        lastArticle.original_article_quantity = lastArticle.article_quantity;
      }
    });
    return articles;
  };
  orderMaterialFactory.createOrderDTO = function (order, orderStatus) {
    return {
      "OrderId": order.order_id,
      "TaskStatus": order.task_status,
      "DeliveryReceiver1ContactId": order.dr.receiver1.contact_id,
      "DeliveryReceiver1ContactName": order.dr.receiver1.contact_name,
      "DeliveryReceiver1ContactPhone": order.dr.receiver1.phone_nr,
      "DeliveryReceiver1ContactEmail": order.dr.receiver1.email,
      "DeliveryReceiver1ContactWantEmail": order.dr.receiver1.email_notif,
      "DeliveryReceiver1ContactWantSms": order.dr.receiver1.sms_notif,
      "DeliveryReceiver2ContactId": order.dr.receiver2.contact_id,
      "DeliveryReceiver2ContactName": order.dr.receiver2.contact_name,
      "DeliveryReceiver2ContactPhone": order.dr.receiver2.phone_nr,
      "DeliveryReceiver2ContactEmail": order.dr.receiver2.email,
      "DeliveryReceiver2ContactWantEmail": order.dr.receiver2.email_notif,
      "DeliveryReceiver2ContactWantSms": order.dr.receiver2.sms_notif,
      "DeliveryReceiver3ContactId": order.dr.receiver3.contact_id,
      "DeliveryReceiver3ContactName": order.dr.receiver3.contact_name,
      "DeliveryReceiver3ContactPhone": order.dr.receiver3.phone_nr,
      "DeliveryReceiver3ContactEmail": order.dr.receiver3.email,
      "DeliveryReceiver3ContactWantEmail": order.dr.receiver3.email_notif,
      "DeliveryReceiver3ContactWantSms": order.dr.receiver3.sms_notif,
      // --
      "DestinationAddress": order.bc.address,
      "DestinationZipCode": order.bc.zip_code,
      "DestinationCity": order.bc.city,
      "VehicleDropLocationId": order.bc.vehicle_drop_location_id,
      "VehicleDropLocationName": order.bc.vehicle_drop_location_name,
      "DestinationLocationId": order.bc.destination_location_id,
      "DestinationLocationName": order.bc.destination_location_name,
      "StaircaseLocationId": order.bc.staircase_location_id,
      "WishedDeliveryDate": order.bc.arrival_time,
      "NumTransports": order.bc.n_transports,
      "Comments": order.bc.comments,
      "IsUnannouncedGoods": !!order.bc.is_unannounced_goods,
      "IsUnreachable": !!order.bc.is_unreachable,
      "IsUnusedResource": !!order.bc.is_unused_resource,
      // --
      "OrderType": OrderTypeEnum.MATERIAL,
      "OrderStatus": orderStatus,
      // --
      "WorkOrderId": order.proj.work_order_id,
      "WorkOrderName": order.proj.work_order_name,
      // TODO: Possible to remove?
      "WmsSystemReference": order.proj.epix_owner_number,
      "WorkOrderCompanyId": order.proj.company_id,
      "WorkOrderCompanyName": order.proj.company_name,
      // TODO: Possible to remove?
      "OrderCreatorContactId": order.proj.contact_person.contact_id,
      "OrderCreatorContactName": order.proj.contact_person.contact_name,
      "OrderCreatorContactPhone": order.proj.contact_person.phone_nr,
      "OrderCreatorContactEmail": order.proj.contact_person.email,
      "OrderCreatorContactWantSms": order.proj.contact_person.sms_notif,
      "OrderCreatorContactWantEmail": order.proj.contact_person.email_notif,
      // --
      "ArticleOrderLines": this.packageArticles(order.wb.articles, order.wb.storage_location),
      //Admin sections
      "SpecifiedPackageCount": order.si.package_count,
      "SpecifiedPackageWeight": order.si.package_weight,
      "SpecifiedPalletCount": order.si.pallet_count,
      "SpecifiedPalletWeight": order.si.pallet_weight,
      "SpecifiedOtherCount": order.si.other_count,
      "SpecifiedOtherWeight": order.si.other_weight,
      "HasAdditionalServiceExpressDelivery": !!order.si.has_express,
      "HasAdditionalServiceTiming": !!order.si.has_timing,
      "AdditionalServiceTimingDueDate": order.si.timing,
      "ShippingId": order.si.shipping_id,
      // --
      "IsReturn": !!order.ar.is_return,
      "AdditionalServiceTimingStatusTypeId": order.dto ? order.dto.AdditionalServiceTimingStatusTypeId : null,
      "AdditionalServiceExpressDeliveryStatusTypeId": order.dto ? order.dto.AdditionalServiceExpressDeliveryStatusTypeId : null
    };
  };
  return orderMaterialFactory;
});
'use strict';

factories.factory('orderPackageCollectionFactory', ['$filter', 'packageFactory', 'workOrderFactory', function ($filter, packageFactory, workOrderFactory) {
  var orderPackageCollectionFactory = {};
  orderPackageCollectionFactory.createOrderDTO = function (order) {
    return {
      "OrderId": order.order_id,
      "TaskStatus": order.task_status,
      "WorkOrderId": order.work_order_id,
      "CustomName": order.package_collection_name,
      "ValidFrom": order.valid_from + ' 00:00:00',
      "ValidTo": order.valid_to + ' 23:59:59',
      "OrderType": OrderTypeEnum.PACKAGE_COLLECTION,
      "Comments": order.comments,
      'VehicleDropLocationId': order.vehicle_drop_location_id,
      'VehicleDropLocationName': order.vehicle_drop_location_name,
      'DestinationLocationId': order.location_id,
      'DestinationLocationName': order.location_name,
      "DestinationAddress": order.address,
      "DestinationZipCode": order.zip_code,
      "DestinationCity": order.city,
      "Quantity": 0
    };
  };
  function repackageDTO(packageCollectionOrderDTO) {
    return {
      order_id: packageCollectionOrderDTO.OrderId,
      order_number: packageCollectionOrderDTO.OrderNumber,
      task_status: packageCollectionOrderDTO.TaskStatus,
      task_status_name: $filter('translate')(packageCollectionOrderDTO.TaskStatusTypeAlias),
      work_order_id: packageCollectionOrderDTO.WorkOrderId,
      work_order_name: packageCollectionOrderDTO.WorkOrderName,
      work_order_display_name: workOrderFactory.workOrderDisplayName(packageCollectionOrderDTO.WorkOrderName, packageCollectionOrderDTO.ErpSystemReference),
      company_id: packageCollectionOrderDTO.WorkOrderCompanyId,
      company_name: packageCollectionOrderDTO.WorkOrderCompanyName,
      package_collection_id: packageCollectionOrderDTO.CustomId,
      package_collection_name: packageCollectionOrderDTO.CustomName,
      packages: packageFactory.repackageDTOArray(packageCollectionOrderDTO.Packages),
      valid_from: $filter('toDate')(packageCollectionOrderDTO.ValidFrom),
      valid_to: $filter('toDate')(packageCollectionOrderDTO.ValidTo),
      comments: packageCollectionOrderDTO.Comments,
      vehicle_drop_location_id: packageCollectionOrderDTO.VehicleDropLocationId,
      vehicle_drop_location_name: packageCollectionOrderDTO.VehicleDropLocationName,
      location_id: packageCollectionOrderDTO.DestinationLocationId,
      location_name: packageCollectionOrderDTO.DestinationLocationName,
      address: packageCollectionOrderDTO.DestinationAddress,
      zip_code: packageCollectionOrderDTO.DestinationZipCode,
      city: packageCollectionOrderDTO.DestinationCity
    };
  }
  ;
  orderPackageCollectionFactory.repackageDTOArray = function (DTOArray) {
    if (!DTOArray) {
      return [];
    }
    var packageCollectionOrders = [];
    angular.forEach(DTOArray, function (packageCollectionOrderDTO) {
      packageCollectionOrders.push(repackageDTO(packageCollectionOrderDTO));
    });
    return packageCollectionOrders;
  };
  return orderPackageCollectionFactory;
}]);
'use strict';

factories.factory('orderResourceBookingFactory', ['orderFactory', function (orderFactory) {
  var orderResourceBookingFactory = {};
  orderResourceBookingFactory.createOrderDTO = function (order, orderStatus) {
    return {
      "OrderId": order.order_id,
      "TaskStatus": order.task_status,
      "OrderType": OrderTypeEnum.RESOURCE_BOOKING,
      "OrderStatus": orderStatus,
      "WorkOrderId": order.proj.work_order_id,
      "WorkOrderName": order.proj.work_order_name,
      "WorkOrderCompanyId": order.proj.company_id,
      "WorkOrderCompanyName": order.proj.company_name,
      "OrderCreatorContactId": order.proj.contact_person.contact_id,
      "OrderCreatorContactName": order.proj.contact_person.contact_name,
      "OrderCreatorContactPhone": order.proj.contact_person.phone_nr,
      "OrderCreatorContactEmail": order.proj.contact_person.email,
      "OrderCreatorContactWantSms": order.proj.contact_person.sms_notif,
      "OrderCreatorContactWantEmail": order.proj.contact_person.email_notif,
      "DeliveryReceiver1ContactId": order.dr.receiver1.contact_id,
      "DeliveryReceiver1ContactName": order.dr.receiver1.contact_name,
      "DeliveryReceiver1ContactPhone": order.dr.receiver1.phone_nr,
      "DeliveryReceiver1ContactEmail": order.dr.receiver1.email,
      "DeliveryReceiver1ContactWantEmail": order.dr.receiver1.email_notif,
      "DeliveryReceiver1ContactWantSms": order.dr.receiver1.sms_notif,
      "DeliveryReceiver2ContactId": order.dr.receiver2.contact_id,
      "DeliveryReceiver2ContactName": order.dr.receiver2.contact_name,
      "DeliveryReceiver2ContactPhone": order.dr.receiver2.phone_nr,
      "DeliveryReceiver2ContactEmail": order.dr.receiver2.email,
      "DeliveryReceiver2ContactWantEmail": order.dr.receiver2.email_notif,
      "DeliveryReceiver2ContactWantSms": order.dr.receiver2.sms_notif,
      "DeliveryReceiver3ContactId": order.dr.receiver3.contact_id,
      "DeliveryReceiver3ContactName": order.dr.receiver3.contact_name,
      "DeliveryReceiver3ContactPhone": order.dr.receiver3.phone_nr,
      "DeliveryReceiver3ContactEmail": order.dr.receiver3.email,
      "DeliveryReceiver3ContactWantEmail": order.dr.receiver3.email_notif,
      "DeliveryReceiver3ContactWantSms": order.dr.receiver3.sms_notif,
      "VehicleDropLocationId": order.bc.vehicle_drop_location_id,
      "VehicleDropLocationName": order.bc.vehicle_drop_location_name,
      "DestinationLocationId": order.bc.destination_location_id,
      "DestinationLocationName": order.bc.destination_location_name,
      "StaircaseLocationId": order.bc.staircase_location_id,
      "ResourceBookings": orderFactory.createResourceBookingDTOArray(order.bc.resource_bookings),
      "Comments": order.bc.comments,
      "ParentOrderId": order.br.parent_order_id,
      "NumTransports": 0,
      "Content": "",
      "Quantity": ""
    };
  };
  return orderResourceBookingFactory;
}]);
'use strict';

factories.factory('orderStoringFactory', function () {
  var orderStoringFactory = {};
  orderStoringFactory.createOrderDTO = function (order, orderStatus) {
    return {
      "OrderId": order.order_id,
      "TaskStatus": order.task_status,
      "Supplier": order.di.supplier,
      "Content": order.di.material,
      "Quantity": order.di.n_materials,
      "ExternalOrderReference": order.bc.ext_order_reference,
      "Comments": order.bc.comments,
      "NumTransports": order.bc.n_transports,
      "Arrival": order.bc.arrival_time,
      "HasAdditionalServiceArrivalControl": true,
      // Has always additional service Arrival Control
      "OrderType": OrderTypeEnum.STORING,
      "OrderStatus": orderStatus,
      "WorkOrderId": order.proj.work_order_id,
      "WorkOrderName": order.proj.work_order_name,
      "WorkOrderCompanyId": order.proj.company_id,
      "WorkOrderCompanyName": order.proj.company_name,
      "OrderCreatorContactId": order.proj.contact_person.contact_id,
      "OrderCreatorContactName": order.proj.contact_person.contact_name,
      "OrderCreatorContactPhone": order.proj.contact_person.phone_nr,
      "OrderCreatorContactEmail": order.proj.contact_person.email,
      "OrderCreatorContactWantSms": order.proj.contact_person.sms_notif,
      "OrderCreatorContactWantEmail": order.proj.contact_person.email_notif,
      //Admin section
      "IsUnannouncedGoods": !!order.bc.is_unannounced_goods,
      "IsUnreachable": !!order.bc.is_unreachable,
      "IsUnusedResource": !!order.bc.is_unused_resource,
      "HasInadequateLabeling": !!order.ar.has_inadequate_labeling,
      "OtherReference": order.ar.other_reference
    };
  };
  return orderStoringFactory;
});
'use strict';

factories.factory('orderTransshipmentFactory', function () {
  var orderTransshipmentFactory = {};
  orderTransshipmentFactory.createOrderDTO = function (order, orderStatus) {
    return {
      "OrderId": order.order_id,
      "TaskStatus": order.task_status,
      "DeliveryReceiver1ContactId": order.dr.receiver1.contact_id,
      "DeliveryReceiver1ContactName": order.dr.receiver1.contact_name,
      "DeliveryReceiver1ContactPhone": order.dr.receiver1.phone_nr,
      "DeliveryReceiver1ContactEmail": order.dr.receiver1.email,
      "DeliveryReceiver1ContactWantEmail": order.dr.receiver1.email_notif,
      "DeliveryReceiver1ContactWantSms": order.dr.receiver1.sms_notif,
      "DeliveryReceiver2ContactId": order.dr.receiver2.contact_id,
      "DeliveryReceiver2ContactName": order.dr.receiver2.contact_name,
      "DeliveryReceiver2ContactPhone": order.dr.receiver2.phone_nr,
      "DeliveryReceiver2ContactEmail": order.dr.receiver2.email,
      "DeliveryReceiver2ContactWantEmail": order.dr.receiver2.email_notif,
      "DeliveryReceiver2ContactWantSms": order.dr.receiver2.sms_notif,
      "DeliveryReceiver3ContactId": order.dr.receiver3.contact_id,
      "DeliveryReceiver3ContactName": order.dr.receiver3.contact_name,
      "DeliveryReceiver3ContactPhone": order.dr.receiver3.phone_nr,
      "DeliveryReceiver3ContactEmail": order.dr.receiver3.email,
      "DeliveryReceiver3ContactWantEmail": order.dr.receiver3.email_notif,
      "DeliveryReceiver3ContactWantSms": order.dr.receiver3.sms_notif,
      "Supplier": order.di.supplier,
      // --
      "AdditionalServiceExpressDeliveryStatusTypeId": order.dto ? order.dto.AdditionalServiceExpressDeliveryStatusTypeId : null,
      "AdditionalServiceTimingStatusTypeId": order.dto ? order.dto.AdditionalServiceTimingStatusTypeId : null,
      "VehicleDropLocationId": order.bc.vehicle_drop_location_id,
      "VehicleDropLocationName": order.bc.vehicle_drop_location_name,
      "DestinationLocationId": order.bc.destination_location_id,
      "DestinationLocationName": order.bc.destination_location_name,
      "StaircaseLocationId": order.bc.staircase_location_id,
      "ArrivalAtWarehouse": order.bc.arrival_time,
      "NumTransports": order.bc.n_transports,
      "Comments": order.bc.comments,
      // --
      "Content": order.di.material,
      "Quantity": order.di.n_materials,
      // --
      "OrderType": OrderTypeEnum.TRANSSHIPMENT,
      "OrderStatus": orderStatus,
      "WorkOrderId": order.proj.work_order_id,
      "WorkOrderName": order.proj.work_order_name,
      "WorkOrderCompanyId": order.proj.company_id,
      "WorkOrderCompanyName": order.proj.company_name,
      "OrderCreatorContactId": order.proj.contact_person.contact_id,
      "OrderCreatorContactName": order.proj.contact_person.contact_name,
      "OrderCreatorContactPhone": order.proj.contact_person.phone_nr,
      "OrderCreatorContactEmail": order.proj.contact_person.email,
      "OrderCreatorContactWantSms": order.proj.contact_person.sms_notif,
      "OrderCreatorContactWantEmail": order.proj.contact_person.email_notif,
      //Admin sections
      "IsUnannouncedGoods": !!order.bc.is_unannounced_goods,
      "IsUnreachable": !!order.bc.is_unreachable,
      "IsUnusedResource": !!order.bc.is_unused_resource,
      "HasInadequateLabeling": !!order.ar.has_inadequate_labeling,
      "IsReturn": !!order.ar.is_return,
      "OtherReference": order.ar.other_reference,
      // --
      "SpecifiedPackageCount": order.si.package_count,
      "SpecifiedPackageWeight": order.si.package_weight,
      "SpecifiedPalletCount": order.si.pallet_count,
      "SpecifiedPalletWeight": order.si.pallet_weight,
      "SpecifiedOtherCount": order.si.other_count,
      "SpecifiedOtherWeight": order.si.other_weight,
      "HasAdditionalServiceTiming": !!order.si.has_timing,
      "AdditionalServiceTimingDueDate": order.si.timing,
      "HasAdditionalServiceExpressDelivery": !!order.si.has_express,
      "HasAdditionalServiceArrivalControl": true,
      // Has always additional service Arrival Control
      "ShippingId": order.si.shipping_id
    };
  };
  return orderTransshipmentFactory;
});
'use strict';

factories.factory('packageFactory', ['$http', 'ENV', '$filter', '$translate', 'generalHelperService', '$httpParamSerializer', function ($http, ENV, $filter, $translate, generalHelperService, $httpParamSerializer) {
  var urlBase = '/api/packages';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var packageFactory = {};
  packageFactory.getPackages = function () {
    return $http.get(url);
  };
  packageFactory.getPackagesWithFilter = function (dates, chosenTimeValueType, searchString, packageCollectionOrderId) {
    var params = {
      dateTimeFrom: dates.dateTimeFrom,
      dateTimeTo: dates.dateTimeTo,
      chosenTimeValueType: chosenTimeValueType,
      searchString: searchString ? searchString : "",
      packageCollectionOrderId: packageCollectionOrderId
    };
    return $http.get(url + '/PackagesWithFilter?' + $httpParamSerializer(params));
  };
  packageFactory.getPackage = function (id) {
    return $http.get(url + '/' + id);
  };
  packageFactory.createPackage = function (pack) {
    var out = JSON.stringify(pack);
    return $http.post(url, out);
  };
  packageFactory.updatePackage = function (id, pack) {
    var out = JSON.stringify(pack);
    return $http.put(url + '/' + id, out);
  };
  packageFactory.deliverPackage = function (id, pack) {
    var out = JSON.stringify(pack);
    return $http.put(url + '/' + id + '/Deliver', out);
  };
  packageFactory.buildImageLinks = function (packageID, image) {
    var links = {
      link: url + '/' + packageID + '/Files/' + image,
      dl_link: url + '/' + packageID + '/Files/' + image + '?download=true'
    };
    return links;
  };
  packageFactory.getPackageHistory = function (id) {
    return $http.get(url + '/' + id + '/history');
  };
  packageFactory.repackageDTO = function (DTO) {
    var out = {
      package_id: DTO.PackageId,
      delivery_number: DTO.OrderNumber,
      package_number: DTO.ExternalPackageId,
      tracking_number: DTO.TrackingNumber,
      delivery_time: '---',
      order_type: $translate.instant(DTO.OrderTypeAlias),
      package_status_type: DTO.PackageStatusType,
      package_status_name: $translate.instant(generalHelperService.getKeyByValue(PackageStatusTypeEnum, DTO.PackageStatusType)),
      package_type: $translate.instant(generalHelperService.getKeyByValue(PackageTypeEnum, DTO.PackageType)),
      receiver: DTO.Receiver,
      package_address: DTO.Address,
      package_location_id: DTO.LocationId,
      package_location_name: DTO.LocationName,
      package_end_address: DTO.EndAddress,
      package_end_city: DTO.EndCity,
      package_end_location_id: DTO.EndLocationId,
      package_end_location_name: DTO.EndLocationName,
      package_end_postal_code: DTO.EndPostalCode,
      package_created: $filter('toDateTime')(DTO.PackageCreated),
      package_updated: $filter('toDateTime')(DTO.PackageUpdated),
      package_delivered: $filter('toDateTime')(DTO.PackageDelivered),
      is_active: DTO.IsActive,
      comments: DTO.Comment,
      carrier: DTO.Carrier,
      deviation: DTO.DeviationCodeName,
      deviation_code: DTO.DeviationCodeId,
      weight: DTO.Weight,
      image1: DTO.Image1,
      image1_link: packageFactory.buildImageLinks(DTO.PackageId, DTO.Image1).link,
      image2: DTO.Image2,
      image2_link: packageFactory.buildImageLinks(DTO.PackageId, DTO.Image2).link,
      image3: DTO.Image3,
      image3_link: packageFactory.buildImageLinks(DTO.PackageId, DTO.Image3).link,
      image4: DTO.Image4,
      image4_link: packageFactory.buildImageLinks(DTO.PackageId, DTO.Image4).link,
      has_images: DTO.Image1 || DTO.Image2 || DTO.Image3 || DTO.Image4,
      signature_image: DTO.SignatureImage,
      signature_image_link: packageFactory.buildImageLinks(DTO.PackageId, DTO.SignatureImage).link,
      signature_clarification: DTO.SignatureClarification,
      currentPlace: DTO.LocationName ? DTO.LocationName : DTO.Address,
      endPlace: DTO.EndLocationName ? DTO.EndLocationName : ""
    };
    out.packageTime = function (chosenTimeType) {
      switch (chosenTimeType) {
        case PackageTimeValueTypeEnum.DELIVERED:
          return this.package_delivered;
        case PackageTimeValueTypeEnum.UPDATED:
          return this.package_updated;
        default:
          return this.package_created;
      }
    };
    if (!out.endPlace && DTO.EndAddress) {
      out.endPlace = DTO.EndAddress;
      out.endPlace += DTO.EndPostalCode ? " " + DTO.EndPostalCode : "";
      out.endPlace += DTO.EndCity ? " " + DTO.EndCity : "";
    }
    return out;
  };
  packageFactory.repackageDTOArray = function (DTOArray) {
    var repackagedDTOArray = [];
    if (!DTOArray) {
      return [];
    }
    angular.forEach(DTOArray, function (DTO) {
      repackagedDTOArray.push(packageFactory.repackageDTO(DTO));
    });
    return repackagedDTOArray;
  };
  return packageFactory;
}]);
'use strict';

factories.factory('printerFactory', ['$http', 'ENV', '$httpParamSerializer', function ($http, ENV, $httpParamSerializer) {
  var urlBase = '/api/printers';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var printerFactory = {};
  printerFactory.getAllPrinters = function () {
    return $http.get(url);
  };
  printerFactory.getPrintersByMainProjectId = function (mainProjectId) {
    return $http.get(url + '?' + $httpParamSerializer({
      mainProjectId: mainProjectId
    }));
  };
  printerFactory.getPrinter = function (id) {
    return $http.get(url + '/' + id);
  };
  printerFactory.createPrinter = function (type) {
    var out = JSON.stringify(type);
    return $http.post(url, out);
  };
  printerFactory.updatePrinter = function (id, type) {
    var out = JSON.stringify(type);
    return $http.put(url + '/' + id, out);
  };
  printerFactory.activatePrinter = function (id) {
    return $http.put(url + '/' + id + '/activate');
  };
  printerFactory.deactivatePrinter = function (id) {
    return $http.put(url + '/' + id + '/deactivate');
  };
  printerFactory.deletePrinter = function (id) {
    return $http.delete(url + '/' + id);
  };
  printerFactory.repackageDTO = function (DTO) {
    return {
      printer_id: DTO.PrinterId,
      main_project_id: DTO.MainProjectId,
      main_project_name: DTO.MainProjectName,
      printer_name: DTO.Name,
      printer_location: DTO.Location,
      printer_partition: DTO.Partition,
      company: DTO.Company,
      street_address: DTO.StreetAddress,
      zip_code: DTO.ZipCode,
      city: DTO.City,
      phone: DTO.Phone,
      email: DTO.Email,
      is_active: DTO.IsActive
    };
  };
  printerFactory.repackageDTOArray = function (DTOArray) {
    var repackagedDTOArray = [];
    if (!DTOArray) {
      return [];
    }
    angular.forEach(DTOArray, function (DTO) {
      repackagedDTOArray.push(printerFactory.repackageDTO(DTO));
    });
    return repackagedDTOArray;
  };
  return printerFactory;
}]);
'use strict';

angular.module('sp.factories').factory('projectFactory', ['$http', 'ENV', '$httpParamSerializer', function ($http, ENV, $httpParamSerializer) {
  var urlBase = '/api/projects';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var projectFactory = {};
  projectFactory.getProjects = function (mainProjectId, includeInactive) {
    var params = {
      mainProjectId: mainProjectId,
      includeInactive: includeInactive
    };
    return $http.get(url + '?' + $httpParamSerializer(params));
  };
  projectFactory.getProject = function (id) {
    return $http.get(url + '/' + id);
  };
  projectFactory.createProject = function (proj) {
    var out = JSON.stringify(proj);
    return $http.post(url, out);
  };
  projectFactory.updateProject = function (id, proj) {
    var out = JSON.stringify(proj);
    return $http.put(url + '/' + id, out);
  };
  projectFactory.activateProject = function (id) {
    return $http.put(url + '/' + id + '/activate');
  };
  projectFactory.deactivateProject = function (id) {
    return $http.put(url + '/' + id + '/deactivate');
  };
  projectFactory.deleteProject = function (id) {
    return $http.delete(url + '/' + id);
  };
  projectFactory.getFilterableProjects = function (mainProjectId, includeDeleted, includeInactive) {
    var params = {
      mainProjectId: mainProjectId,
      includeDeleted: includeDeleted,
      includeInactive: includeInactive
    };
    return $http.get(url + '/FilterableProjects?' + $httpParamSerializer(params));
  };
  projectFactory.repackageDTO = function (projectDTO) {
    return {
      project_name: projectDTO.Name,
      project_id: projectDTO.ProjectId,
      project_short_name: projectDTO.ShortName,
      main_project_name: projectDTO.MainProjectName,
      main_project_id: projectDTO.MainProjectId,
      gate_in_id: projectDTO.DefaultInGateId,
      gate_in_name: projectDTO.DefaultInGateName,
      gate_out_id: projectDTO.DefaultOutGateId,
      gate_out_name: projectDTO.DefaultOutGateName,
      city: projectDTO.City,
      is_active: projectDTO.IsActive,
      comments: projectDTO.Comments
    };
  };
  projectFactory.repackageDTOArray = function (projectDTOArray) {
    if (!projectDTOArray) {
      return [];
    }
    var projectArray = [];
    angular.forEach(projectDTOArray, function (projectDTO) {
      projectArray.push(projectFactory.repackageDTO(projectDTO));
    });
    return projectArray;
  };
  return projectFactory;
}]);
'use strict';

factories.factory('routeFactory', ['$http', '$httpParamSerializer', 'ENV', '$translate', '$filter', function ($http, $httpParamSerializer, ENV, $translate, $filter) {
  var urlBase = '/api/routes';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var routeFactory = {};
  routeFactory.getRouteTemplates = function (includeInactive) {
    var params = {
      includeInactive: includeInactive
    };
    return $http.get(url + '/RouteTemplates?' + $httpParamSerializer(params));
  };
  routeFactory.getRouteTemplatesByMainProjectId = function (includeInactive, mainProjectId) {
    var params = {
      includeInactive: includeInactive,
      mainProjectId: mainProjectId
    };
    return $http.get(url + '/RouteTemplates?' + $httpParamSerializer(params));
  };
  routeFactory.getRoute = function (id) {
    return $http.get(url + '/' + id);
  };
  routeFactory.createRoute = function (route) {
    var out = JSON.stringify(route);
    return $http.post(url, out);
  };
  routeFactory.updateRoute = function (id, route) {
    var out = JSON.stringify(route);
    return $http.put(url + '/' + id, out);
  };
  routeFactory.activateRoute = function (id) {
    return $http.put(url + '/' + id + '/activate');
  };
  routeFactory.deactivateRoute = function (id) {
    return $http.put(url + '/' + id + '/deactivate');
  };
  routeFactory.deleteRoute = function (id) {
    return $http.delete(url + '/' + id);
  };
  routeFactory.createDTO = function (route, isTemplate) {
    var timeType = -1;
    if (route.is_afternoon) timeType = DeliveryTimeTypeEnum.AFTERNOON;else if (route.is_forenoon) timeType = DeliveryTimeTypeEnum.FORENOON;else timeType = DeliveryTimeTypeEnum.SPECIFIC;
    var isActive = route.is_active;
    if (typeof route.is_active === 'undefined') isActive = true;

    // RouteDTO
    return {
      "RouteId": route.route_id,
      "Name": route.route_name,
      "MainProjectId": route.main_project_id,
      "VehicleId": route.vehicle_id,
      "Time": route.time,
      "DeliveryTimeTypeId": timeType,
      "IsTemplate": isTemplate,
      "SourceTemplateId": route.source_template_id,
      "IsActive": isActive,
      "Comments": route.comments
    };
  };
  function repackageDTO(routeDTO) {
    var displayTime = null;
    switch (routeDTO.DeliveryTimeTypeId) {
      case DeliveryTimeTypeEnum.SPECIFIC:
        displayTime = $filter('toTime')(routeDTO.Time);
        break;
      case DeliveryTimeTypeEnum.AFTERNOON:
        displayTime = $translate.instant('AFTERNOON_SHORT');
        break;
      case DeliveryTimeTypeEnum.FORENOON:
        displayTime = $translate.instant('FORENOON_SHORT');
        break;
    }
    var repackagedDTO = {
      route_id: routeDTO.RouteId,
      route_name: routeDTO.Name,
      full_name: routeDTO.Name + ' ' + displayTime,
      main_project_id: routeDTO.MainProjectId,
      main_project_name: routeDTO.MainProjectName,
      display_time: displayTime,
      delivery_time_type_id: routeDTO.DeliveryTimeTypeId,
      time: $filter('toTime')(routeDTO.Time),
      is_afternoon: routeDTO.DeliveryTimeTypeId === DeliveryTimeTypeEnum.AFTERNOON,
      is_forenoon: routeDTO.DeliveryTimeTypeId === DeliveryTimeTypeEnum.FORENOON,
      vehicle_id: routeDTO.VehicleId,
      vehicle_name: routeDTO.VehicleName,
      is_template: routeDTO.IsTemplate,
      source_template_id: routeDTO.SourceTemplateId,
      is_active: routeDTO.IsActive,
      comments: routeDTO.Comments
    };
    return repackagedDTO;
  }
  ;
  routeFactory.repackageDTOArray = function (routeDTOArray) {
    var repackagedDTOArray = [];
    if (!routeDTOArray) {
      return [];
    }
    angular.forEach(routeDTOArray, function (routeDTO) {
      repackagedDTOArray.push(repackageDTO(routeDTO));
    });
    return repackagedDTOArray;
  };
  return routeFactory;
}]);
'use strict';

factories.factory('shippingFactory', ['$http', '$httpParamSerializer', 'ENV', function ($http, $httpParamSerializer, ENV) {
  var urlBase = '/api/shippings';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var shippingFactory = {};
  shippingFactory.getShippings = function (includeInactive) {
    var params = {
      includeInactive: includeInactive
    };
    return $http.get(url + '?' + $httpParamSerializer(params));
  };
  shippingFactory.getShippingsByMainProjectId = function (includeInactive, mainProjectId) {
    var params = {
      includeInactive: includeInactive,
      mainProjectId: mainProjectId
    };
    return $http.get(url + '?' + $httpParamSerializer(params));
  };
  shippingFactory.getShipping = function (id) {
    return $http.get(url + '/' + id);
  };
  shippingFactory.createShipping = function (shipping) {
    var out = JSON.stringify(shipping);
    return $http.post(url, out);
  };
  shippingFactory.updateShipping = function (id, shipping) {
    var out = JSON.stringify(shipping);
    return $http.put(url + '/' + id, out);
  };
  shippingFactory.activateShipping = function (id) {
    return $http.put(url + '/' + id + '/activate');
  };
  shippingFactory.deactivateShipping = function (id) {
    return $http.put(url + '/' + id + '/deactivate');
  };
  shippingFactory.deleteShipping = function (id) {
    return $http.delete(url + '/' + id);
  };
  shippingFactory.createDTO = function (shipping) {
    var isActive = true;
    if (typeof shipping.is_active !== 'undefined') isActive = shipping.is_active;
    return {
      "ShippingId": shipping.shipping_id,
      "Name": shipping.shipping_name,
      "MainProjectId": shipping.main_project_id,
      "IsExpress": !!shipping.is_express,
      "IsNonWorkHours": !!shipping.is_non_work_hours,
      "UnifaunReference": shipping.unifaun_reference,
      "IsActive": isActive,
      "Comments": shipping.comments
    };
  };
  shippingFactory.repackageDTO = function (DTO) {
    return {
      shipping_id: DTO.ShippingId,
      shipping_name: DTO.Name,
      main_project_id: DTO.MainProjectId,
      main_project_name: DTO.MainProjectName,
      is_express: DTO.IsExpress,
      is_non_work_hours: DTO.IsNonWorkHours,
      unifaun_reference: DTO.UnifaunReference,
      is_active: DTO.IsActive
    };
  };
  shippingFactory.repackageDTOArray = function (DTOArray) {
    var repackagedDTOArray = [];
    if (!DTOArray) {
      return [];
    }
    angular.forEach(DTOArray, function (DTO) {
      repackagedDTOArray.push(shippingFactory.repackageDTO(DTO));
    });
    return repackagedDTOArray;
  };
  return shippingFactory;
}]);
'use strict';

factories.factory('statisticsReportFactory', ['$http', '$httpParamSerializer', 'ENV', function ($http, $httpParamSerializer, ENV) {
  var urlBase = '/api/statistics';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var statisticsReportFactory = {};
  statisticsReportFactory.getDeliveryReport = function (subProjectIDs, fromDate, toDate) {
    var params = {
      subProjectIDs: subProjectIDs,
      fromDate: fromDate,
      toDate: toDate
    };
    return $http.get(url + '/Delivery?' + $httpParamSerializer(params));
  };
  statisticsReportFactory.getPlanningReport = function (mainProjectId, fromDate, toDate) {
    var params = {
      mainProjectId: mainProjectId,
      fromDate: fromDate,
      toDate: toDate
    };
    return $http.get(url + '/Planning?' + $httpParamSerializer(params));
  };
  statisticsReportFactory.repackageDTO = function (DTO) {
    var excelBinaryString = atob(DTO.ExcelData);
    var excelBytes = new Uint8Array(excelBinaryString.length);
    for (var i = 0; i < excelBytes.length; i++) {
      excelBytes[i] = excelBinaryString.charCodeAt(i);
    }
    return {
      totalRecordCount: DTO.TotalRecordCount,
      recordCount: DTO.RetrievedRecordCount,
      excelArrayBuffer: excelBytes.buffer
    };
  };
  return statisticsReportFactory;
}]);
'use strict';

angular.module('sp.factories').factory('subProjectFactory', ['$http', '$httpParamSerializer', 'ENV', function ($http, $httpParamSerializer, ENV) {
  var urlBase = '/api/subprojects';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var subProjectFactory = {};
  subProjectFactory.getSubProjects = function (mainProjectId, includeInactive) {
    var params = {
      mainProjectId: mainProjectId,
      includeInactive: includeInactive
    };
    return $http.get(url + '?' + $httpParamSerializer(params));
  };
  subProjectFactory.getSubProject = function (id) {
    return $http.get(url + '/' + id);
  };
  subProjectFactory.createSubProject = function (project) {
    var out = JSON.stringify(project);
    return $http.post(url, out);
  };
  subProjectFactory.updateSubProject = function (id, project) {
    var out = JSON.stringify(project);
    return $http.put(url + '/' + id, out);
  };
  subProjectFactory.activateSubProject = function (id) {
    return $http.put(url + '/' + id + '/activate');
  };
  subProjectFactory.deactivateSubProject = function (id) {
    return $http.put(url + '/' + id + '/deactivate');
  };
  subProjectFactory.deleteSubProject = function (id) {
    return $http.delete(url + '/' + id);
  };
  subProjectFactory.createDTO = function (DTO) {
    return {
      "Name": DTO.sub_project_name,
      "SubProjectId": DTO.sub_project_id,
      "ProjectId": DTO.project_id,
      "IsActive": true,
      "Comments": DTO.comments
    };
  };
  subProjectFactory.getFilterableSubProjects = function (mainProjectId, includeDeleted, includeInactive) {
    var params = {
      mainProjectId: mainProjectId,
      includeDeleted: includeDeleted,
      includeInactive: includeInactive
    };
    return $http.get(url + '/FilterableSubProjects?' + $httpParamSerializer(params));
  };
  subProjectFactory.repackageDTO = function (DTO) {
    return {
      sub_project_name: DTO.Name,
      sub_project_id: DTO.SubProjectId,
      sub_project_short_name: DTO.ShortName,
      project_id: DTO.ProjectId,
      project_name: DTO.ProjectName,
      main_project_id: DTO.MainProjectId,
      main_project_name: DTO.MainProjectName,
      is_active: DTO.IsActive,
      comments: DTO.Comments
    };
  };
  subProjectFactory.repackageDTOArray = function (DTOArray) {
    var repackagedDTOArray = [];
    if (!DTOArray) {
      return [];
    }
    angular.forEach(DTOArray, function (DTO) {
      repackagedDTOArray.push(subProjectFactory.repackageDTO(DTO));
    });
    return repackagedDTOArray;
  };
  return subProjectFactory;
}]);
'use strict';

factories.factory('supplierFactory', ['$http', 'ENV', function ($http, ENV) {
  var urlBase = '/api/suppliers';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var supplierFactory = {};
  supplierFactory.getSuppliers = function () {
    return $http.get(url);
  };
  supplierFactory.getSupplier = function (id) {
    return $http.get(url + '/' + id);
  };
  supplierFactory.createSupplier = function (supplier) {
    var out = JSON.stringify(supplier);
    return $http.post(url, out);
  };
  supplierFactory.updateSupplier = function (id, supplier) {
    var out = JSON.stringify(supplier);
    return $http.put(url + '/' + id, out);
  };
  supplierFactory.activateSupplier = function (id) {
    return $http.put(url + '/' + id + '/activate');
  };
  supplierFactory.deactivateSupplier = function (id) {
    return $http.put(url + '/' + id + '/deactivate');
  };
  supplierFactory.deleteSupplier = function (id) {
    return $http.delete(url + '/' + id);
  };
  return supplierFactory;
}]);
'use strict';

factories.factory('userFactory', ['$http', '$uibModal', 'ENV', 'authFactory', '$localStorage', 'errorService', 'mainProjectFactory', 'workOrderFactory', '$rootScope', 'languageFactory', 'companyFactory', 'projectFactory', 'quickGuideService', function ($http, $uibModal, ENV, authFactory, $localStorage, errorService, mainProjectFactory, workOrderFactory, $rootScope, languageFactory, companyFactory, projectFactory, quickGuideService) {
  var urlBase = '/api/users';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var userFactory = {};
  userFactory.createUser = function (user, role) {
    var out = JSON.stringify(user);
    return $http.post(url + '/' + 'register?role=' + role, out);
  };
  userFactory.updateUser = function (user) {
    var out = JSON.stringify(user);
    return $http.put(url + '/' + user.UserId, out);
  };
  userFactory.activateUser = function (activateAccount) {
    var out = JSON.stringify(activateAccount);
    return $http.post(url + '/Activate', out);
  };
  userFactory.changeQuickGuideShown = function (hideQuickGuide) {
    return $http.put(url + '/ChangeQuickGuideShown?hideQuickGuide=' + hideQuickGuide);
  };
  userFactory.requestPasswordReset = function (passwordResetRequestDTO) {
    var out = JSON.stringify(passwordResetRequestDTO);
    return $http.post(url + '/RequestPasswordReset', out);
  };
  userFactory.resendActivationLink = function (userDTO) {
    var out = JSON.stringify(userDTO);
    return $http.post(url + '/ResendActivationLink', out);
  };
  userFactory.resetPassword = function (passwordResetDTO) {
    var out = JSON.stringify(passwordResetDTO);
    return $http.post(url + '/ResetPassword', out);
  };
  userFactory.changePassword = function (changePasswordDTO) {
    var out = JSON.stringify(changePasswordDTO);
    return $http.post(url + '/ChangePassword', out);
  };
  userFactory.getUser = function (id) {
    return $http.get(endPoint + '/api/users/' + id);
  };
  userFactory.reActivateUsers = function (ids) {
    var out = JSON.stringify(ids);
    return $http.post(url + '/ReActivate', out);
  };
  userFactory.deactivateUsers = function (ids) {
    var out = JSON.stringify(ids);
    return $http.post(url + '/Deactivate', out);
  };
  userFactory.getUsers = function (filterAndPagination) {
    var out = JSON.stringify(filterAndPagination);
    return $http.post(endPoint + '/api/users/GetUsers', out);
  };
  userFactory.getMe = function () {
    return $http.get(endPoint + '/api/users/me');
  };
  userFactory.updateMe = function (user) {
    var out = JSON.stringify(user);
    return $http.put(endPoint + '/api/users/me', user);
  };
  userFactory.isUserDataSet = function () {
    return $localStorage.user.companies && $localStorage.user.email && $localStorage.user.user_name && $localStorage.user.phone_number && $localStorage.user.role_id && $localStorage.user.user_id && $localStorage.user.work_orders && $localStorage.user.login && $localStorage.user.user_role_name && $localStorage.user.hideQuickGuideForUser;
  };
  userFactory.setUserData = function (forceRefresh) {
    if ($localStorage.user.isLoggedIn && (!userFactory.isUserDataSet() || forceRefresh)) {
      authFactory.getMe().then(function (response) {
        var data = response.data;
        $localStorage.user.companies = companyFactory.repackageCompanyDTOArray(data.Companies);
        $localStorage.user.email = data.Email;
        $localStorage.user.login = data.Login;
        $localStorage.user.user_name = data.Name;
        $localStorage.user.phone_number = data.PhoneNumber;
        $localStorage.user.role_id = data.RoleId;
        $localStorage.user.user_role_name = data.RoleName.toUpperCase();
        $localStorage.user.user_id = data.UserId;
        $localStorage.user.work_orders = workOrderFactory.repackageWorkOrderDTOArray(data.WorkOrders);
        $localStorage.user.main_projects = mainProjectFactory.repackageDTOArray(data.MainProjects);
        $localStorage.user.projects = projectFactory.repackageDTOArray(data.Projects);
        $localStorage.user.sub_projects = projectFactory.repackageDTOArray(data.SubProjects);
        $localStorage.user.hideQuickGuideForUser = data.HideQuickGuide;

        // Set session main project if none
        if (!$localStorage.user.session_main_project && $localStorage.user.main_projects.length > 0) {
          $localStorage.user.session_main_project = $localStorage.user.main_projects[0];
          var divisionId = $localStorage.user.main_projects[0].division_id;
          languageFactory.changeLanguageByDivisionId(divisionId);
        } else if ($localStorage.user.session_main_project && $localStorage.user.main_projects) {
          // Refresh session data

          angular.forEach($localStorage.user.main_projects, function (mainProject) {
            if (mainProject.main_project_id === $localStorage.user.session_main_project.main_project_id) {
              $localStorage.user.session_main_project = mainProject;
            }
          });
        }
        if (data.IsPasswordChangeRequired) {
          $uibModal.open({
            animation: false,
            backdrop: 'static',
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'app/components/user/settings/settings_form.html',
            controller: 'SettingsController',
            size: 'md',
            windowClass: 'sp-modal-window',
            resolve: {
              isPasswordChangeRequired: function isPasswordChangeRequired() {
                return true;
              }
            }
          });
        }
        if (!$localStorage.user.hideQuickGuideForUser && !sessionStorage.hideQuickGuideThisSession) {
          quickGuideService.openQuickGuide();
        }
        $rootScope.$broadcast('updatedUserData');
      }, function (error) {
        errorService.handleError(error);
      });
    }
  };
  return userFactory;
}]);
'use strict';

factories.factory('vehicleFactory', ['$http', 'ENV', '$httpParamSerializer', function ($http, ENV, $httpParamSerializer) {
  var urlBase = '/api/vehicles';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var vehicleFactory = {};
  vehicleFactory.getVehicles = function (includeInactive) {
    var params = {
      includeInactive: includeInactive
    };
    return $http.get(url + '?' + $httpParamSerializer(params));
  };
  vehicleFactory.getVehiclesByMainProjectId = function (includeInactive, mainProjectId) {
    var params = {
      includeInactive: includeInactive,
      mainProjectId: mainProjectId
    };
    return $http.get(url + '?' + $httpParamSerializer(params));
  };
  vehicleFactory.getVehicle = function (id) {
    return $http.get(url + '/' + id);
  };
  vehicleFactory.createVehicle = function (vehicle) {
    var out = JSON.stringify(vehicle);
    return $http.post(url, out);
  };
  vehicleFactory.updateVehicle = function (id, vehicle) {
    var out = JSON.stringify(vehicle);
    return $http.put(url + '/' + id, out);
  };
  vehicleFactory.activateVehicle = function (id) {
    return $http.put(url + '/' + id + '/activate');
  };
  vehicleFactory.deactivateVehicle = function (id) {
    return $http.put(url + '/' + id + '/deactivate');
  };
  vehicleFactory.deleteVehicle = function (id) {
    return $http.delete(url + '/' + id);
  };
  vehicleFactory.repackageDTO = function (DTO) {
    var repackagedDTO = {
      vehicle_id: DTO.VehicleId,
      vehicle_name: DTO.Name,
      vehicle_type_id: DTO.VehicleTypeId,
      vehicle_type_code: DTO.VehicleTypeCode,
      main_project_id: DTO.MainProjectId,
      main_project_name: DTO.MainProjectName,
      is_active: DTO.IsActive
    };
    return repackagedDTO;
  };
  vehicleFactory.repackageDTOArray = function (DTOArray) {
    var repackagedDTOArray = [];
    if (!DTOArray) {
      return [];
    }
    angular.forEach(DTOArray, function (DTO) {
      repackagedDTOArray.push(vehicleFactory.repackageDTO(DTO));
    });
    return repackagedDTOArray;
  };
  return vehicleFactory;
}]);
'use strict';

factories.factory('vehicleTypeFactory', ['$http', 'ENV', '$httpParamSerializer', function ($http, ENV, $httpParamSerializer) {
  var urlBase = '/api/vehicletypes';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var vehicleTypeFactory = {};
  vehicleTypeFactory.getVehicleTypes = function (mainProjectId, includeInactive) {
    var params = {
      mainProjectId: mainProjectId,
      includeInactive: includeInactive
    };
    return $http.get(url + '?' + $httpParamSerializer(params));
  };
  vehicleTypeFactory.getVehicleType = function (id) {
    return $http.get(url + '/' + id);
  };
  vehicleTypeFactory.createVehicleType = function (type) {
    var out = JSON.stringify(type);
    return $http.post(url, out);
  };
  vehicleTypeFactory.updateVehicleType = function (id, type) {
    var out = JSON.stringify(type);
    return $http.put(url + '/' + id, out);
  };
  vehicleTypeFactory.activateVehicleType = function (id) {
    return $http.put(url + '/' + id + '/activate');
  };
  vehicleTypeFactory.deactivateVehicleType = function (id) {
    return $http.put(url + '/' + id + '/deactivate');
  };
  vehicleTypeFactory.deleteVehicleType = function (id) {
    return $http.delete(url + '/' + id);
  };
  vehicleTypeFactory.repackageDTO = function (DTO) {
    return {
      vehicle_type_id: DTO.VehicleTypeId,
      vehicle_type_code: DTO.Code,
      vehicle_capacity: DTO.Capacity,
      main_project_id: DTO.MainProjectId,
      main_project_name: DTO.MainProjectName,
      is_active: DTO.IsActive
    };
  };
  vehicleTypeFactory.repackageDTOArray = function (DTOArray) {
    var repackagedDTOArray = [];
    if (!DTOArray) {
      return [];
    }
    angular.forEach(DTOArray, function (DTO) {
      repackagedDTOArray.push(vehicleTypeFactory.repackageDTO(DTO));
    });
    return repackagedDTOArray;
  };
  return vehicleTypeFactory;
}]);
'use strict';

angular.module('sp.factories').factory('workOrderFactory', ['$http', 'ENV', 'subProjectFactory', '$httpParamSerializer', 'generalHelperService', function ($http, ENV, subProjectFactory, $httpParamSerializer, generalHelperService) {
  var urlBase = '/api/workorders';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var workOrderFactory = {};
  workOrderFactory.getWorkOrders = function (mainProjectId, includeInactive) {
    var params = {
      mainProjectId: mainProjectId,
      includeInactive: includeInactive
    };
    return $http.get(url + '?' + $httpParamSerializer(params));
  };

  /**
   * Retrieve a WorkOrderDTO from backend.
   */
  workOrderFactory.getWorkOrder = function (id) {
    return $http.get(url + '/' + id);
  };
  workOrderFactory.getAllWorkOrdersByCompanyId = function (id) {
    return $http.get(endPoint + '/api/companies/' + id + '/workorders');
  };
  workOrderFactory.getWorkOrdersByCompanyId = function (id, mainProjectId) {
    var params = {
      mainProjectId: mainProjectId
    };
    return $http.get(endPoint + '/api/companies/' + id + '/workorders' + '?' + $httpParamSerializer(params));
  };
  workOrderFactory.createWorkOrder = function (workOrderDTO) {
    var out = JSON.stringify(workOrderDTO);
    return $http.post(url, out);
  };
  workOrderFactory.updateWorkOrder = function (id, workOrderDTO) {
    var out = JSON.stringify(workOrderDTO);
    return $http.put(url + '/' + id, out);
  };
  workOrderFactory.activateWorkOrder = function (id) {
    return $http.put(url + '/' + id + '/activate');
  };
  workOrderFactory.deactivateWorkOrder = function (id) {
    return $http.put(url + '/' + id + '/deactivate');
  };
  workOrderFactory.deleteWorkOrder = function (id) {
    return $http.delete(url + '/' + id);
  };
  workOrderFactory.createEpixXML = function (id) {
    return $http.post(url + '/epix/' + id);
  };
  workOrderFactory.getFilterableWorkorders = function (mainProjectId, includeDeleted, includeInactive) {
    var params = {
      mainProjectId: mainProjectId,
      includeDeleted: includeDeleted,
      includeInactive: includeInactive
    };
    return $http.get(url + '/FilterableWorkOrders?' + $httpParamSerializer(params));
  };

  /**
   * Convert a js workOrder to a WorkOrderDTO, to send to backend
   */
  workOrderFactory.packageWorkOrder = function (workOrder) {
    return {
      "Name": workOrder.work_order_name,
      "WorkOrderId": workOrder.work_order_id,
      "ShortName": workOrder.work_order_short_name,
      "WorkOrderType": workOrder.work_order_type,
      "WorkOrderGroup": workOrder.work_order_group,
      "ContactName": workOrder.contact_name,
      "ContactEmail": workOrder.contact_email,
      "ContactPhone": workOrder.contact_phone,
      "SubProjects": workOrder.subProjectsOut,
      "CompanyId": workOrder.company_id,
      "CompanyName": workOrder.company_name,
      "CompanyRoleId": 1,
      "HasGateIntegration": workOrder.has_gate_integration,
      "ErpSystemReference": workOrder.erp_system_reference,
      "IsActive": workOrder.is_active,
      "Comments": workOrder.comments,
      "ErpSystemShortName": workOrder.erp_system_short_name,
      "ErpGroup": workOrder.work_order_group,
      "ErpType": workOrder.work_order_type,
      "NotificationTemplates": workOrder.notificationConfiguration
    };
  };
  workOrderFactory.workOrderDisplayName = function (name, erpSystemReference) {
    return name + ' (' + erpSystemReference + ')';
  };
  workOrderFactory.repackageWorkOrderDTO = function (workOrderDTO) {
    var workOrder = {
      main_project_id: workOrderDTO.SubProjects.length > 0 ? workOrderDTO.SubProjects[0].MainProjectId : null,
      work_order_id: workOrderDTO.WorkOrderId,
      work_order_name: workOrderDTO.Name,
      work_order_short_name: workOrderDTO.ShortName,
      sub_projects: subProjectFactory.repackageDTOArray(workOrderDTO.SubProjects),
      wo_projects: workOrderDTO.WOProjects,
      project_id: workOrderDTO.WOProjects.length ? workOrderDTO.WOProjects[0].ProjectId : null,
      project_name: workOrderDTO.WOProjects.length ? workOrderDTO.WOProjects[0].Name : '',
      contact_name: workOrderDTO.ContactName,
      contact_email: workOrderDTO.ContactEmail,
      contact_phone: workOrderDTO.ContactPhone,
      company_id: workOrderDTO.CompanyId,
      company_name: workOrderDTO.CompanyName,
      company_role_id: workOrderDTO.CompanyRoleId,
      company_role_name: workOrderDTO.CompanyRoleName,
      erp_system_reference: workOrderDTO.ErpSystemReference,
      erp_system_short_name: workOrderDTO.ErpSystemShortName,
      erp_display_name: workOrderFactory.workOrderDisplayName(workOrderDTO.ErpSystemShortName, workOrderDTO.ErpSystemReference),
      work_order_display_name: workOrderFactory.workOrderDisplayName(workOrderDTO.Name, workOrderDTO.ErpSystemReference),
      pyramid_order_number: workOrderDTO.ErpSystemReference,
      work_order_group: workOrderDTO.ErpGroup,
      work_order_type: workOrderDTO.ErpType,
      has_gate_integration: workOrderDTO.HasGateIntegration,
      is_active: workOrderDTO.IsActive,
      comments: workOrderDTO.Comments
    };
    workOrder.notificationConfiguration = workOrderDTO.NotificationTemplates.reduce(function (acc, conf) {
      acc.push({
        NotificationType: conf.NotificationType,
        NotificationTemplateName: generalHelperService.getKeyByValue(NotificationTypeEnum, conf.NotificationType),
        IsSelected: conf.IsSelected
      });
      return acc;
    }, []);
    return workOrder;
  };
  workOrderFactory.repackageWorkOrderDTOArray = function (workOrderDTOArray) {
    if (!workOrderDTOArray) {
      return [];
    }
    var workOrderArray = [];
    angular.forEach(workOrderDTOArray, function (workOrderDTO) {
      workOrderArray.push(workOrderFactory.repackageWorkOrderDTO(workOrderDTO));
    });
    workOrderArray.sort(function (wo1, wo2) {
      return wo1.work_order_display_name.localeCompare(wo2.work_order_display_name);
    });
    return workOrderArray;
  };
  workOrderFactory.extractUniqueCompaniesFromWorkOrders = function (workOrders) {
    var uniqueCompanies = [];
    angular.forEach(workOrders, function (workOrder) {
      if (generalHelperService.isUnique(uniqueCompanies, 'company_id', workOrder.company_id)) {
        uniqueCompanies.push({
          company_id: workOrder.company_id,
          company_name: workOrder.company_name
        });
      }
    });
    uniqueCompanies.sort(function (company1, company2) {
      return company1.company_name.localeCompare(company2.company_name);
    });

    // TODO: rename company_name to company_display_name?
    return uniqueCompanies;
  };
  workOrderFactory.getSuppliers = function (workOrderId) {
    return $http.get(url + '/' + workOrderId + '/suppliers');
  };
  workOrderFactory.deleteSupplier = function (workOrderId, supplierId) {
    return $http.delete(url + '/' + workOrderId + '/supplier/' + supplierId);
  };
  return workOrderFactory;
}]);
'use strict';

angular.module('sp.factories').factory('materialFactory', ['$http', '$httpParamSerializer', 'ENV', 'errorService', function ($http, $httpParamSerializer, ENV, errorService) {
  var urlBase = '/api/Materials';
  var endPoint = ENV.apiEndpoint;
  var url = endPoint + urlBase;
  var materialFactory = {};
  materialFactory.getMaterials = function (mainProjectId) {
    var params = {
      mainProjectId: mainProjectId
    };
    return $http.get(url + '/balance?' + $httpParamSerializer(params)).then(function (response) {
      return repackageDTOArray(response.data);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  function repackageDTOArray(articleOrderLineDTOArray) {
    var articles = [];
    angular.forEach(articleOrderLineDTOArray, function (articleOrderLineDTO) {
      var article = repackageDTO(articleOrderLineDTO);
      articles.push(article);
    });
    return articles;
  }
  ;
  function repackageDTO(articleDTO) {
    var article = {
      article_id: articleDTO.Id,
      batch: articleDTO.ProductionBatchId ? articleDTO.ProductionBatchId : "",
      storage_location: articleDTO.StorageLocation ? articleDTO.StorageLocation : "",
      article_name: articleDTO.Name ? articleDTO.Name : "",
      unit: articleDTO.Unit ? articleDTO.Unit : "",
      weight: articleDTO.Weight,
      availability: articleDTO.Availability,
      company_name: articleDTO.CompanyName,
      work_order_name: articleDTO.WorkOrderName
    };
    return article;
  }
  materialFactory.getMaterialsExport = function (mainProjectId) {
    var params = {
      mainProjectId: mainProjectId
    };
    return $http.get(url + '/balance/export?' + $httpParamSerializer(params)).then(function (response) {
      var excelBinaryString = atob(response.data.ExcelData);
      var excelBytes = new Uint8Array(excelBinaryString.length);
      for (var i = 0; i < excelBytes.length; i++) {
        excelBytes[i] = excelBinaryString.charCodeAt(i);
      }
      return new Blob([excelBytes.buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
    });
  };
  return materialFactory;
}]);
angular.module('serviplan').factory('versionInterceptor', ['$rootScope', '$q', 'spVersion', function ($rootScope, $q, spVersion) {
  function isOutdatedSite(response) {
    var versionHeader = response.headers('SP-Version');
    return versionHeader && versionHeader !== spVersion;
  }
  return {
    response: function response(_response) {
      if (isOutdatedSite(_response)) {
        $rootScope.$broadcast('siteOutdated');
      }
      return _response;
    },
    responseError: function responseError(response) {
      if (isOutdatedSite(response)) {
        $rootScope.$broadcast('siteOutdatedError');
      }
      return $q.reject(response);
    }
  };
}]);
'use strict';

angular.module('sp.services').service('generalHelperService', [function () {
  this.isUnique = function (array, idKey, value) {
    var unique = true;
    array.forEach(function (entry, index) {
      if (entry[idKey] === value) {
        unique = false;
      }
    });
    return unique;
  };
  this.getKeyByValue = function (collection, findValue) {
    var keyFound = null;
    angular.forEach(collection, function (value, key) {
      if (value === findValue) {
        keyFound = key;
      }
    });
    return keyFound;
  };

  // Color utility functions
  // Pin color-id mapper
  this.generateFirstColorClass = function (id) {
    return 'pin-color-' + id % 10;
  };
  this.generateSecondColorClass = function (id) {
    return 'pin-bg-color-' + Math.floor(id % 100 / 10);
  };

  // Order helpers
  this.calculateOrderWeight = function (order) {
    var weightSum = 0;
    angular.forEach(order.packages, function (pack, index) {
      weightSum += pack.Weight;
    });
    if (order.order_type === OrderTypeEnum.TRANSSHIPMENT) {
      weightSum += order.other_weight;
      weightSum += order.pallet_weight;
      weightSum += order.package_weight;
    }
    return weightSum;
  };

  // PrinterHelper
  this.printDiv = function (divId) {
    var printContents = document.getElementById(divId).cloneNode(true);
    $(".sp-close-wrapper", printContents).remove();
    $("#PrintBtn", printContents).remove();
    var printContentsInner = printContents.innerHTML;
    var popupWin = window.open('', '_blank', 'width=800,height=600');
    popupWin.document.open();
    popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="assets/css/core.min.css" /></head><body onload="window.print()">' + printContentsInner + '</body></html>');
    popupWin.document.close();
  };

  // Time helpers

  /**
   * Parse a datetime or date string in format "YYYY-MM-DD HH:mm" or "YYYY-MM-DD" to a moment object.
   *
   * The 
   * @param {string} dateTimeString 
   * @returns {moment} 
   */
  this.dateTimeStringToMoment = function (dateTimeString) {
    return moment(dateTimeString, ["YYYY-MM-DD HH:mm", "YYYY-MM-DD", "HH:mm"], true);
  };
  this.parseDate = function (timeDate) {
    if (timeDate === null) return '';
    var split = timeDate.split('T');
    return split[0];
  };
  this.parseTime = function (timeDate) {
    if (timeDate === null) return '';
    var split = timeDate.slice(0, -3).split('T');
    return split[1];
  };
  this.parseDateSpan = function (timeDateI, timeDateF) {
    if (timeDateI === null || timeDateF === null) return '';
    var splitI = timeDateI.split('T');
    var splitF = timeDateF.split('T');
    return splitI[0] + '-' + splitF[0];
  };
  this.parseTimeSpan = function (timeDateI, timeDateF) {
    if (timeDateI === null || timeDateF === null) return '';
    var splitI = timeDateI.slice(0, -3).split('T');
    var splitF = timeDateF.slice(0, -3).split('T');
    return splitI[1] + '-' + splitF[1];
  };

  /**
   * Method used to ensure that a time interval is valid, i.e., that the initial time is not later than the final time.
   *
   * The method returns the final string if it represents a later time than initial.
   * In all other cases, the method returns the initial string.
   *
   * @param {string} initial - The initial time as a datetime string, format "YYYY-MM-DD HH:mm" or "YYYY-MM-DD"
   * @param {string} final - The final (end) time as a datetime string, format "YYYY-MM-DD HH:mm", "YYYY-MM-DD" or undefined
   * @returns {string} - 
   */
  this.getValidInitialDateTime = function (initial, final) {
    if (!final) return initial;
    var initialDate = this.dateTimeStringToMoment(initial);
    var finalDate = this.dateTimeStringToMoment(final);
    if (!initialDate.isValid() || !finalDate.isValid()) return initial;
    return initialDate.isBefore(finalDate) ? initial : final;
  };

  /** See getValidInitialDateTime.
   */
  this.getValidFinalDateTime = function (initial, final) {
    if (!initial) return final;
    var initialDate = this.dateTimeStringToMoment(initial);
    var finalDate = this.dateTimeStringToMoment(final);
    if (!initialDate.isValid() || !finalDate.isValid()) return final;
    return initialDate.isBefore(finalDate) ? final : initial;
  };

  /**
   * Method to ensure that the given date-time is not in the past.
   * @param {string} dateTimeString - Date time string in the format "YYYY-MM-DD HH:mm".
   * @returns {string} - The given string, or a date time string representing the current time.
   */
  this.limitDateTimeToCurrent = function (dateTimeString) {
    var dateTime = moment(dateTimeString, "YYYY-MM-DD HH:mm", true);
    if (!dateTime.isValid()) return dateTimeString;
    var currentDateTime = moment();
    return dateTime.isAfter(currentDateTime) ? dateTimeString : this.dateToDateTimeString(currentDateTime);
  };
  this.limitDateTimeSpan = function (dateTimeFrom, dateTimeTo, minDuration, maxDuration, excludeTime) {
    var toDate = moment(dateTimeTo);
    var minDate = minDuration ? moment(dateTimeFrom).add(minDuration) : moment(dateTimeTo);
    var maxDate = moment(dateTimeFrom).add(maxDuration);
    if (toDate.isBefore(minDate)) {
      toDate = minDate;
    }
    if (toDate.isAfter(maxDate)) {
      toDate = maxDate;
    }
    return excludeTime ? this.dateToDateString(toDate) : this.dateToDateTimeString(toDate);
  };
  this.limitTimespan = function (startTime, endTime, minDuration, maxHour) {
    var end = this.dateTimeStringToMoment(endTime);
    var minTime = minDuration ? this.dateTimeStringToMoment(startTime).add(minDuration) : this.dateTimeStringToMoment(startTime);
    var maxTime = this.dateTimeStringToMoment(maxHour);
    if (end.isBefore(minTime)) {
      end = minTime;
    }
    if (end.isAfter(maxTime)) {
      end = maxTime;
    }
    return this.dateToTimeString(end);
  };
  this.addTimespanToDateTime = function (initialDateTime, timespan) {
    var newDate = moment(initialDateTime).add(timespan);
    return this.dateToDateTimeString(newDate);
  };
  this.addTimespanToTime = function (initialTime, timespan) {
    var newTime = this.dateTimeStringToMoment(initialTime).add(timespan);
    return this.dateToTimeString(newTime);
  };
  this.dateToDateTimeString = function (date) {
    return moment(date).format("YYYY-MM-DD HH:mm");
  };
  this.dateToDateString = function (date) {
    return moment(date).format("YYYY-MM-DD");
  };
  this.dateToTimeString = function (date) {
    return moment(date).format("HH:mm");
  };
  this.generateNameMapFromEnum = function (enumCollection) {
    var map = {};
    for (var c in enumCollection) {
      map[enumCollection[c]] = c;
    }
    return map;
  };
  this.getEnumIds = function (enumCollection) {
    var array = [];
    for (var c in enumCollection) {
      array.push(enumCollection[c]);
    }
    return array;
  };
  this.areEquivalentArrays = function (array1, array2) {
    if (array1 === array2) return true;
    if (!array1 || !array2) return false;
    if (array1.length !== array2.length) return false;
    var sorted1 = array1.slice().sort();
    var sorted2 = array2.slice().sort();
    for (var i = 0; i < sorted1.length; ++i) {
      if (sorted1[i] !== sorted2[i]) return false;
    }
    return true;
  };
}]);
(function () {
  'use strict';

  angular.module('sp.services').service('loadRecaptchaService', ['ENV', loadRecaptchaService]);
  function loadRecaptchaService(ENV) {
    console.log("cap", ENV.recaptchaSiteKey);
    this.loadApi = function () {
      console.log("loadApi cap", ENV.recaptchaSiteKey);
      $.getScript("https://www.google.com/recaptcha/api.js?render=" + ENV.recaptchaSiteKey);
    };
  }
})();
'use strict';

services.service('recurringDirectDeliveryHelper', ['inputValidationService', function (inputValidationService) {
  (function () {
    var days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
    Date.prototype.getConvertedDay = function () {
      var dayIndex = this.getDay() - 1;
      if (dayIndex === -1) dayIndex = 6;
      return dayIndex;
    };

    // Returns the ISO week of the date.
    Date.prototype.getWeek = function () {
      var date = new Date(this.getTime());
      date.setHours(0, 0, 0, 0);
      // Thursday in current week decides the year.
      date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
      // January 4 is always in week 1.
      var week1 = new Date(date.getFullYear(), 0, 4);
      // Adjust to Thursday in week 1 and count number of weeks from date to week1.
      return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    };
  })();
  function createTimeLine(recurringWeek, validFrom, validTo) {
    var refDate = new Date(validFrom);
    var endDate = new Date(validTo);
    var timeLine = [];
    timeLine.push({
      date: new Date(refDate.getTime()),
      recurringDay: recurringWeek[refDate.getConvertedDay()]
    });
    refDate.setDate(refDate.getDate() + 1);
    do {
      timeLine.push({
        date: new Date(refDate.getTime()),
        recurringDay: recurringWeek[refDate.getConvertedDay()]
      });
      refDate.setDate(refDate.getDate() + 1);
    } while (refDate.getTime() <= endDate.getTime());
    return timeLine;
  }
  this.calculateAllowedPassages = function (recurringWeek, validFrom, validTo, weekFrequency) {
    var allowedPassages = 0;
    if (!inputValidationService.isValidDate(validFrom) || !inputValidationService.isValidDate(validTo)) {
      return allowedPassages;
    }
    var timeLine = createTimeLine(recurringWeek, validFrom, validTo);
    if (weekFrequency == 1) {
      // all weeks
      angular.forEach(timeLine, function (data) {
        allowedPassages += data.recurringDay.slots.length * 2;
      });
    } else if (weekFrequency == 2) {
      // even weeks
      angular.forEach(timeLine, function (data) {
        if (data.date.getWeek() % 2 === 0) {
          allowedPassages += data.recurringDay.slots.length * 2;
        }
      });
    } else if (weekFrequency == 3) {
      // odd weeks
      angular.forEach(timeLine, function (data) {
        if (data.date.getWeek() % 2 !== 0) {
          allowedPassages += data.recurringDay.slots.length * 2;
        }
      });
    }
    return allowedPassages;
  };
}]);
'use strict';

services.service('additionalServiceStatusService', function () {
  // AdditionalServiceStatusTypeEnum = Object.freeze({"ORDERED": 1, "CONFIRMED": 2, "COMPLETED": 3, "NOT_COMPLETED": 4});
  this.isOrdered = function (statusTypeId) {
    return AdditionalServiceStatusTypeEnum.ORDERED === statusTypeId;
  };
  this.isConfirmed = function (statusTypeId) {
    return AdditionalServiceStatusTypeEnum.CONFIRMED === statusTypeId;
  };
  this.isCompleted = function (statusTypeId) {
    return AdditionalServiceStatusTypeEnum.COMPLETED === statusTypeId;
  };
  this.isNotCompleted = function (statusTypeId) {
    return AdditionalServiceStatusTypeEnum.NOT_COMPLETED === statusTypeId;
  };
});
'use strict';

services.service('dropdownService', function () {
  this.openDropdown = function (dropDownId, event) {
    var dropDown = angular.element(dropDownId);
    if (!dropDown.hasClass('open')) dropDown.addClass('open');
    event.stopPropagation();
  };
});
angular.module('sp.services').service('errorService', ['authFactory', function (authFactory) {
  this.handleError = function (error) {
    // Handle
    console.error(error);
    if (error.status === 401) {
      authFactory.logout();
      console.error("Unauthorized request, signing out...");
    }
  };
}]);
'use strict';

services.service('inputValidationService', ['ALLOWED_FILE_EXTENTIONS', function (ALLOWED_FILE_EXTENTIONS) {
  var allowedExtentionsArray = ALLOWED_FILE_EXTENTIONS.split(', ');
  this.isValidInput = function (input) {
    if (typeof input === 'undefined' || input === '' || input === null) {
      return false;
    } else return true;
  };
  this.isValidOptionalInput = function (input) {
    if (typeof input === 'undefined') {
      return false;
    } else return true;
  };
  this.isValidDateTime = function (input) {
    if (typeof input === 'undefined') {
      return false;
    }
    var pattern = /\d{4}-\d{2}-\d{2} \d{2}:\d{2}/i; // 2016-09-01 08:15
    return pattern.test(input);
  };
  this.isValidDate = function (input) {
    if (typeof input === 'undefined') {
      return false;
    }
    var pattern = /\d{4}-\d{2}-\d{2}/i; // 2016-09-01
    return pattern.test(input);
  };
  this.isValidTime = function (input) {
    if (typeof input === 'undefined') {
      return false;
    }
    var pattern = /\d{2}:\d{2}/i; // 08:15
    return pattern.test(input);
  };
  this.isValidEmail = function (input) {
    if (typeof input === 'undefined') {
      return false;
    }
    var pattern = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/g;
    return pattern.test(input);
  };
  this.areValidFiles = function (files) {
    var areValidFiles = true;
    angular.forEach(files, function (file) {
      if (!file || !file.name) {
        areValidFiles = false;
      } else {
        var extention = "." + file.name.split('.').pop().toLowerCase();
        if (allowedExtentionsArray.indexOf(extention) < 0) {
          areValidFiles = false;
        }
      }
    });
    return areValidFiles;
  };
}]);
angular.module('sp.services').service('megaFilterService', ['$filter', 'generalHelperService', function ($filter, generalHelperService) {
  this.filterAll = function (filteredOrders, filterSelectionObject) {
    // First filter
    function filterByAssignmentType(originalOrders, filterSelectionObject) {
      var nothingFiltered = true;
      var filteredOrders = [];

      // FUTURE: This filtering does not preserve the original order, fix this!
      angular.forEach(filterSelectionObject.orderTypes, function (type) {
        if (type.selected) {
          var subset = $filter('filter')(originalOrders, {
            order_type: type.id
          }, true);
          filteredOrders = filteredOrders.concat(subset);
          nothingFiltered = false;
        }
      });
      if (nothingFiltered) {
        return filterByDeliveryStatus(originalOrders, filterSelectionObject);
      } else {
        return filterByDeliveryStatus(filteredOrders, filterSelectionObject);
      }
    }

    // Second filter
    function filterByDeliveryStatus(filteredOrders, filterSelectionObject) {
      var nothingFiltered = true;
      var nextFiltered = [];

      // FUTURE: This filtering does not preserve the original order, fix this!
      angular.forEach(filterSelectionObject.deliveryStatus, function (status) {
        if (status.selected) {
          var subset = $filter('filter')(filteredOrders, {
            task_status: status.id
          }, true);
          nextFiltered = nextFiltered.concat(subset);
          nothingFiltered = false;
        }
      });
      if (nothingFiltered) {
        return filterByDeliveryTime(filteredOrders, filterSelectionObject);
      } else {
        return filterByDeliveryTime(nextFiltered, filterSelectionObject);
      }
    }

    // Third filter
    function filterByDeliveryTime(filteredOrder, filterSelectionObject) {
      var nothingFiltered = true;
      var nextFiltered = [];

      // FUTURE: This filtering does not preserve the original order, fix this!
      if (!filterSelectionObject.deliveryTimeFrom && !filterSelectionObject.deliveryTimeTo) {
        nextFiltered = filteredOrder;
      } else if (filterSelectionObject.deliveryTimeFrom && filterSelectionObject.deliveryTimeTo) {
        var from = new Date(filterSelectionObject.deliveryTimeFrom);
        from.setHours(0);
        from.setMinutes(0);
        var to = new Date(filterSelectionObject.deliveryTimeTo);
        to.setHours(23);
        to.setMinutes(59);
        angular.forEach(filteredOrder, function (data) {
          var date = new Date(data.date_i + ' ' + data.time_i);
          if (date >= from && date <= to) {
            nextFiltered.push(data);
          }
        });
      } else if (!filterSelectionObject.deliveryTimeFrom && filterSelectionObject.deliveryTimeTo) {
        var to = new Date(filterSelectionObject.deliveryTimeTo);
        angular.forEach(filteredOrder, function (data) {
          var date = new Date(data.date_i + ' ' + data.time_i);
          if (date <= to) {
            nextFiltered.push(data);
          }
        });
      } else if (filterSelectionObject.deliveryTimeFrom && !filterSelectionObject.deliveryTimeTo) {
        var from = new Date(filterSelectionObject.deliveryTimeFrom);
        angular.forEach(filteredOrder, function (data) {
          var date = new Date(data.date_i + ' ' + data.time_i);
          if (date >= from) {
            nextFiltered.push(data);
          }
        });
      }
      return filterByProjects(nextFiltered, filterSelectionObject);
    }

    // Fourth filter
    function filterByProjects(filteredOrders, filterSelectionObject) {
      var nothingFiltered = true;
      var nextFiltered = [];

      // FUTURE: This filtering does not preserve the original order, fix this!
      angular.forEach(filterSelectionObject.projects, function (project) {
        if (project.selected) {
          var subset = $filter('filter')(filteredOrders, {
            project_id: project.id
          }, true);
          nextFiltered = nextFiltered.concat(subset);
          nothingFiltered = false;
        }
      });
      if (nothingFiltered) {
        return filterBySubProjects(filteredOrders, filterSelectionObject);
      } else {
        return filterBySubProjects(nextFiltered, filterSelectionObject);
      }
    }

    // Fifth filter
    function filterBySubProjects(filteredOrders, filterSelectionObject) {
      var nothingFiltered = true;
      var nextFiltered = [];

      // FUTURE: This filtering does not preserve the original order, fix this!
      angular.forEach(filterSelectionObject.sub_projects, function (sub_project_label) {
        if (sub_project_label.selected) {
          angular.forEach(filteredOrders, function (order) {
            angular.forEach(order.sub_projects, function (sub_project) {
              if (sub_project.sub_project_id === sub_project_label.id) {
                nextFiltered.push(order);
              }
            });
          });
          nothingFiltered = false;
        }
      });
      if (nothingFiltered) {
        return filterByVehicleDropLocations(filteredOrders, filterSelectionObject);
      } else {
        return filterByVehicleDropLocations(nextFiltered, filterSelectionObject);
      }
    }

    // sixth filter
    function filterByVehicleDropLocations(filteredOrders, filterSelectionObject) {
      var nothingFiltered = true;
      var nextFiltered = [];

      // FUTURE: This filtering does not preserve the original order, fix this!
      angular.forEach(filterSelectionObject.vehicle_drop_locations, function (drop_location) {
        if (drop_location.selected) {
          var subset = $filter('filter')(filteredOrders, {
            vehicle_drop_location_id: drop_location.id
          }, true);
          nextFiltered = nextFiltered.concat(subset);
          nothingFiltered = false;
        }
      });
      if (nothingFiltered) {
        return filterByCompanies(filteredOrders, filterSelectionObject);
      } else {
        return filterByCompanies(nextFiltered, filterSelectionObject);
      }
    }

    // seventh filter
    function filterByCompanies(filteredOrders, filterSelectionObject) {
      var nothingFiltered = true;
      var nextFiltered = [];

      // FUTURE: This filtering does not preserve the original order, fix this!
      angular.forEach(filterSelectionObject.companies, function (company) {
        if (company.selected) {
          var subset = $filter('filter')(filteredOrders, {
            work_order_company_id: company.id
          }, true);
          nextFiltered = nextFiltered.concat(subset);
          nothingFiltered = false;
        }
      });
      if (nothingFiltered) {
        return filterByWorkOrders(filteredOrders, filterSelectionObject);
      } else {
        return filterByWorkOrders(nextFiltered, filterSelectionObject);
      }
    }

    // eighth filter
    function filterByWorkOrders(filteredOrders, filterSelectionObject) {
      var nothingFiltered = true;
      var nextFiltered = [];

      // FUTURE: This filtering does not preserve the original order, fix this!
      angular.forEach(filterSelectionObject.work_orders, function (work_order) {
        if (work_order.selected) {
          var subset = $filter('filter')(filteredOrders, {
            work_order_id: work_order.id
          }, true);
          nextFiltered = nextFiltered.concat(subset);
          nothingFiltered = false;
        }
      });
      if (nothingFiltered) {
        return filterByPassCodeError(filteredOrders, filterSelectionObject);
      } else {
        return filterByPassCodeError(nextFiltered, filterSelectionObject);
      }
    }

    // nineth filter
    function filterByPassCodeError(filteredOrders, filterSelectionObject) {
      var nothingFiltered = true;
      var nextFiltered = [];
      // FUTURE: This filtering does not preserve the original order, fix this!
      angular.forEach(filterSelectionObject.error_codes, function (errorCode) {
        if (errorCode.selected) {
          var subset = $filter('filter')(filteredOrders, {
            well_sec_error_code: errorCode.code
          }, true);
          nextFiltered = nextFiltered.concat(subset);
          nothingFiltered = false;
        }
      });
      if (nothingFiltered) {
        return filteredOrders;
      } else {
        return nextFiltered;
      }
    }

    //FUTURE: Having filters calling eachother is not good architecture, there should ne one function calling each filter in order.
    return filterByAssignmentType(filteredOrders, filterSelectionObject);
  };

  // Functions to extract the selectable filter options in the GUI.
  this.extractUniqueProjects = function (extractToArray, extractFromArray) {
    angular.forEach(extractFromArray, function (data) {
      if (typeof data['project_id'] !== 'undefined' && data['project_name'] !== '' && generalHelperService.isUnique(extractToArray, 'id', data['project_id'])) {
        extractToArray.push({
          name: data.project_name,
          id: data.project_id
        });
      }
    });
  };
  this.extractUniqueSubProjects = function (extractToArray, extractFromArray) {
    angular.forEach(extractFromArray, function (data) {
      angular.forEach(data.sub_projects, function (data) {
        if (typeof data['sub_project_id'] !== 'undefined' && data['sub_project_name'] !== '' && generalHelperService.isUnique(extractToArray, 'id', data['sub_project_id'])) {
          extractToArray.push({
            name: data.sub_project_name,
            id: data.sub_project_id
          });
        }
      });
    });
  };
  this.extractUniqueVehicleDropLocations = function (extractToArray, extractFromArray) {
    angular.forEach(extractFromArray, function (data) {
      if (typeof data['vehicle_drop_location_id'] !== 'undefined' && data['vehicle_drop_location_name'] !== '' && generalHelperService.isUnique(extractToArray, 'id', data['vehicle_drop_location_id'])) {
        extractToArray.push({
          name: data.vehicle_drop_location_name,
          id: data.vehicle_drop_location_id
        });
      }
    });
  };
  this.extractUniqueCompanies = function (extractToArray, extractFromArray) {
    angular.forEach(extractFromArray, function (data) {
      if (typeof data['work_order_company_id'] !== 'undefined' && data['work_order_company_name'] !== '' && generalHelperService.isUnique(extractToArray, 'id', data['work_order_company_id'])) {
        extractToArray.push({
          name: data.work_order_company_name,
          id: data.work_order_company_id
        });
      }
    });
  };
  this.extractUniqueWorkOrders = function (extractToArray, extractFromArray) {
    angular.forEach(extractFromArray, function (data) {
      if (typeof data['work_order_id'] !== 'undefined' && data['work_order_name'] !== '' && generalHelperService.isUnique(extractToArray, 'id', data['work_order_id'])) {
        var label = '';
        if (data.erp_system_reference) label = data.work_order_name + '(' + data.erp_system_reference + ')';else label = data.work_order_name;
        extractToArray.push({
          name: label,
          id: data.work_order_id
        });
      }
    });
  };
  this.extractUniqueErrorCodes = function (extractToArray, extractFromArray) {
    angular.forEach(extractFromArray, function (data) {
      if (data['well_sec_error_code'] && data['well_sec_error_code'] !== '' && generalHelperService.isUnique(extractToArray, 'code', data['well_sec_error_code'])) {
        extractToArray.push({
          code: data['well_sec_error_code']
        });
      }
    });
  };
  this.getEmptyFilter = function () {
    return {
      orderTypes: [],
      taskStatuses: [],
      projects: [],
      subProjects: [],
      vehicleDropLocations: [],
      resourceLocations: [],
      companies: [],
      workOrders: [],
      deliveryTimeFrom: null,
      deliveryTimeTo: null
    };
  };
  this.copyFilter = function (filter) {
    function flattenDate(date) {
      return new Date(moment.utc(date).format('YYYY-MM-DD'));
    }
    var copy = {};
    copy.orderTypes = filter.orderTypes ? filter.orderTypes.slice(0) : [];
    copy.taskStatuses = filter.taskStatuses ? filter.taskStatuses.slice(0) : [];
    copy.projects = filter.projects ? filter.projects.slice(0) : [];
    copy.subProjects = filter.subProjects ? filter.subProjects.slice(0) : [];
    copy.vehicleDropLocations = filter.projects ? filter.vehicleDropLocations.slice(0) : [];
    copy.resourceLocations = filter.projects ? filter.resourceLocations.slice(0) : [];
    copy.companies = filter.companies ? filter.companies.slice(0) : [];
    copy.workOrders = filter.workOrders ? filter.workOrders.slice(0) : [];
    copy.deliveryTimeFrom = filter.deliveryTimeFrom ? flattenDate(filter.deliveryTimeFrom) : null;
    copy.deliveryTimeTo = filter.deliveryTimeTo ? flattenDate(filter.deliveryTimeTo) : null;
    return copy;
  };
  this.isEmptyFilter = function (filter) {
    return (!filter.orderTypes || filter.orderTypes.length === 0) && (!filter.taskStatuses || filter.taskStatuses.length === 0) && (!filter.projects || filter.projects.length === 0) && (!filter.subProjects || filter.subProjects.length === 0) && (!filter.vehicleDropLocations || filter.vehicleDropLocations.length === 0) && (!filter.resourceLocations || filter.resourceLocations.length === 0) && (!filter.companies || filter.companies.length === 0) && (!filter.workOrders || filter.workOrders.length === 0) && (!filter.deliveryTimeFrom || filter.deliveryTimeFrom == '') && (!filter.deliveryTimeTo || filter.deliveryTimeTo == '');
  };
  this.includeOrExcludeOrderType = function (filter, orderType, shallBeIncluded) {
    if (!filter.orderTypes) {
      filter.orderTypes = [];
    }
    var index = filter.orderTypes.indexOf(orderType);
    var isIncluded = index !== -1;
    if (shallBeIncluded) {
      if (!isIncluded) {
        filter.orderTypes.push(orderType);
      }
    } else {
      if (isIncluded) {
        filter.orderTypes.splice(index, 1);
      }
    }
  };
}]);
'use strict';

services.service('roleService', ['$localStorage', function ($localStorage) {
  this.isInternal = function () {
    return $localStorage.user.role_id === RoleEnum.ADMINISTRATOR || $localStorage.user.role_id === RoleEnum.SERVICENTER || $localStorage.user.role_id === RoleEnum.PROJECT_OWNER || $localStorage.user.role_id === RoleEnum.WAREHOUSE_PLANNER || $localStorage.user.role_id === RoleEnum.WAREHOUSE_OPERATOR;
  };
  this.isAdmin = function () {
    return $localStorage.user.role_id === RoleEnum.ADMINISTRATOR;
  };
  this.isServicenter = function () {
    return $localStorage.user.role_id === RoleEnum.SERVICENTER;
  };
  this.isProjectOwner = function () {
    return $localStorage.user.role_id === RoleEnum.PROJECT_OWNER;
  };
  this.isWarehousePlanner = function () {
    return $localStorage.user.role_id === RoleEnum.WAREHOUSE_PLANNER;
  };
  this.isWarehouseOperator = function () {
    return $localStorage.user.role_id === RoleEnum.WAREHOUSE_OPERATOR;
  };
  this.isCustomer = function () {
    return $localStorage.user.role_id === RoleEnum.CUSTOMER;
  };
  this.myRoleId = function () {
    return $localStorage.user.role_id;
  };
}]);
'use strict';

services.service('taskStatusService', function () {
  this.isConfirmedOrLater = function (taskStatusId) {
    if (taskStatusId === TaskStatusTypeEnum.CONFIRMED || taskStatusId === TaskStatusTypeEnum.PICKED || taskStatusId === TaskStatusTypeEnum.ARRIVED || taskStatusId === TaskStatusTypeEnum.ASSIGNED_TRANSPORT || taskStatusId === TaskStatusTypeEnum.ASSIGNED_ROUTE || taskStatusId === TaskStatusTypeEnum.DELIVERED || taskStatusId === TaskStatusTypeEnum.STORED || taskStatusId === TaskStatusTypeEnum.COMPLETED) {
      return true;
    } else return false;
  };
  this.isConfirmed = function (taskStatusId) {
    return taskStatusId === TaskStatusTypeEnum.CONFIRMED;
  };
  this.isPicked = function (taskStatusId) {
    return taskStatusId === TaskStatusTypeEnum.PICKED;
  };
  this.isArrived = function (taskStatusId) {
    return taskStatusId === TaskStatusTypeEnum.ARRIVED;
  };
  this.isAssignedToTransport = function (taskStatusId) {
    return taskStatusId === TaskStatusTypeEnum.ASSIGNED_TRANSPORT;
  };
  this.isAssignedToRoute = function (taskStatusId) {
    return taskStatusId === TaskStatusTypeEnum.ASSIGNED_ROUTE;
  };
  this.isDelivered = function (taskStatusId) {
    return taskStatusId === TaskStatusTypeEnum.DELIVERED;
  };
  this.isStored = function (taskStatusId) {
    return taskStatusId === TaskStatusTypeEnum.STORED;
  };
  this.isCompleted = function (taskStatusId) {
    return taskStatusId === TaskStatusTypeEnum.COMPLETED;
  };
  this.isNotified = function (taskStatusId) {
    return taskStatusId === TaskStatusTypeEnum.NOTIFIED;
  };
  this.isCancelled = function (taskStatusId) {
    return taskStatusId === TaskStatusTypeEnum.CANCELLED;
  };
});
'use strict';

function OrderCalendarDayController($scope, $rootScope, $translate) {
  var ctrl = this;
  ctrl.templateScope = {
    isWeekView: false,
    showHours: true
  };
  var getCalendarTitle = function getCalendarTitle() {
    var currentMoment = moment(ctrl.viewDate);
    var currentMonth = $translate.instant(currentMoment.format('MMMM').toUpperCase());
    var currentDay = $translate.instant(currentMoment.format('ddd').toUpperCase());
    return [currentDay, currentMoment.format('DD'), currentMonth, currentMoment.format('YYYY')].join(' ');
  };

  // Events and bindings
  ctrl.$doCheck = function () {
    ctrl.title = getCalendarTitle();

    //FUTURE: Dynamically update day event width to fit whole calendar?
  };

  ctrl.toggleLeft = function () {
    date = ctrl.viewDate;
    date.setDate(date.getDate() - 1);
    $scope.$broadcast('calendar.refreshView');
    $rootScope.$broadcast('updateOrders');
  };
  ctrl.toggleRight = function () {
    date = ctrl.viewDate;
    date.setDate(date.getDate() + 1);
    $scope.$broadcast('calendar.refreshView');
    $rootScope.$broadcast('updateOrders');
  };
  $scope.$on('updateCalendar', function (event) {
    $scope.$broadcast('calendar.refreshView');
  });
}
;
components.component('orderCalendarDay', {
  templateUrl: 'app/components/orders/order_calendar_day.html',
  controller: ['$scope', '$rootScope', '$translate', OrderCalendarDayController],
  bindings: {
    events: '=',
    viewDate: '=',
    onEventClick: '='
  }
});
'use strict';

function OrderCalendarWeekController($scope, $rootScope, $translate) {
  var ctrl = this;
  ctrl.dayCalendarObjects = [];
  ctrl.dummyArray = []; // Empty event array for hour list column

  ctrl.templateScope = {
    isWeekView: true,
    showHours: false
  };
  ctrl.templateScopeOnFirstColumn = {
    isWeekView: true,
    showHours: true
  };
  var createHourListCalendarObject = function createHourListCalendarObject() {
    return {
      titleDay: 'TIME',
      titleNumber: '',
      date: moment()
    };
  };
  ctrl.toggleLeft = function () {
    date = ctrl.viewDate;
    date.setDate(date.getDate() - 7);
    ctrl.updateDayCalendarObjects();
    $scope.$broadcast('updateCalendar');
    $rootScope.$broadcast('updateOrders');
  };
  ctrl.toggleRight = function () {
    date = ctrl.viewDate;
    date.setDate(date.getDate() + 7);
    ctrl.updateDayCalendarObjects();
    $scope.$broadcast('updateCalendar');
    $rootScope.$broadcast('updateOrders');
  };
  ctrl.updateDayCalendarObjects = function () {
    ctrl.dayCalendarObjects = [];
    ctrl.dayCalendarObjects.push(createHourListCalendarObject());
    var weekday = moment(ctrl.viewDate);
    while (weekday.format('ddd') !== 'Mon') {
      weekday.subtract(1, 'days'); // Get nearest Monday
    }

    for (var i = 0; i < 7; i++) {
      var date = weekday.format('YYYY-MM-DD');
      var titleDay = weekday.format('ddd').toUpperCase();
      var titleNumber = weekday.format('D');
      var newDayCalendarObject = {
        date: date,
        titleDay: titleDay,
        titleNumber: titleNumber
      };
      ctrl.dayCalendarObjects.push(newDayCalendarObject);
      weekday.add(1, 'days');
    }
    ;
  };
  var getCalendarTitle = function getCalendarTitle() {
    var currentMoment = moment(ctrl.viewDate);
    return $translate.instant('WEEK') + ' ' + currentMoment.format('WW');
  };

  // Events and bindings
  ctrl.$doCheck = function () {
    ctrl.title = getCalendarTitle();
    //FUTURE: Dynamically update day event width to fit whole calendar?
  };

  ctrl.$onInit = function () {
    ctrl.updateDayCalendarObjects();
  };
  $scope.$on('updateCalendar', function (event) {
    ctrl.updateDayCalendarObjects();
    $scope.$broadcast('calendar.refreshView');
  });
}
;
components.component('orderCalendarWeek', {
  templateUrl: 'app/components/orders/order_calendar_week.html',
  controller: ['$scope', '$rootScope', '$translate', OrderCalendarWeekController],
  bindings: {
    events: '=',
    viewDate: '=',
    onEventClick: '='
  }
});
'use strict';

/**This component represents a Serviplan table. To use, provide the necessary bindings
 * in an <sp-table> element. Content placed between the tags will be transcluded into the tool area
 * above the table.
*/
function TableController($filter, keyCodes) {
  var controller = this;
  controller.$onInit = function () {
    // Initialize default values
    if (controller.isSelectionEnabled === undefined) controller.isSelectionEnabled = true;
    controller.totalItems = controller.items ? controller.items.length : 0;
    controller.paginationRange = controller.paginationRange || 5;
    controller.itemRange = controller.itemRange || 15;
    controller.itemRangeBottom = 0;
    controller.itemRangeTop = controller.itemRange - 1;
    controller.currentPage = 1;
    controller.isCheckAllCheckboxChecked = false;
    controller.searchFieldString = '';
    controller.filterString = '';
    controller.keyCode = '';
    controller.lastSortCol = controller.tableHeaderItems[0] ? controller.tableHeaderItems[0].propertyName : ""; // Default to sorting by first property
    controller.sortCol = controller.lastSortCol;
    controller.isSortReversed = false; // set the default sort order
  };

  controller.getPropertyFromItem = function (item, propertyName) {
    if (!item.hasOwnProperty(propertyName)) {
      return "";
    }
    return item[propertyName] ? item[propertyName].toString() : "";
  };
  controller.reverseSorting = function () {
    if (controller.lastSortCol === controller.sortCol && !controller.isSortReversed) {
      controller.isSortReversed = true;
    } else {
      controller.lastSortCol = controller.sortCol;
      controller.isSortReversed = false;
    }
  };
  controller.sortingArrowOnClick = function (tableHeaderName) {
    controller.sortCol = tableHeaderName;
    controller.reverseSorting();
  };
  controller.checkAllCheckboxOnClick = function () {
    if (controller.isCheckAllCheckboxChecked) {
      controller.selectAllFiltered();
    } else {
      controller.deselectAll();
    }
  };
  controller.selectAllFiltered = function () {
    var filteredItems = $filter('filter')(controller.items, controller.filterString);
    angular.forEach(filteredItems, function (item) {
      item.selected = true;
    });
    controller.updateSelectedArray();
  };
  controller.deselectAll = function () {
    angular.forEach(controller.items, function (item) {
      item.selected = false;
    });
    controller.updateSelectedArray();
  };
  controller.updateSelectedArray = function () {
    controller.selectedItems = [];
    controller.allSelectedItems = [];
    angular.forEach(controller.items, function (item) {
      if (item.selected) {
        controller.allSelectedItems.push(item);
      }
    });
    controller.selectedItems = $filter('filter')(controller.allSelectedItems, controller.filterString);
  };
  controller.updateTableRange = function () {
    controller.itemRangeBottom = (controller.currentPage - 1) * controller.itemRange;
  };
  controller.updateTableRange();
  controller.updateVisibleItems = function () {
    controller.selectedItems = $filter('filter')(controller.allSelectedItems, controller.filterString);
    var filteredItems = controller.items;
    if (controller.filterString) {
      filteredItems = $filter('filter')(controller.items, controller.filterString);
    }
    controller.totalItems = filteredItems.length;
  };
  controller.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      // Enter key pressed
      controller.filterString = controller.searchFieldString;
      controller.updateVisibleItems();
    }
  };

  // Event handlers and callbacks
  controller.$onChanges = function () {
    controller.updateSelectedArray();
    controller.updateVisibleItems();
  };
}

// Name component "spTable" to avoid clash with standard table element
components.component('spTable', {
  templateUrl: 'app/shared/sp_table.html',
  transclude: {
    'tools': '?spTableTools'
  },
  bindings: {
    items: '<',
    selectedItems: '=?',
    tableHeaderItems: '<',
    isSelectionEnabled: '<',
    itemOnClick: '<',
    paginationRange: '<',
    itemRange: '<'
  },
  controller: ['$filter', 'keyCodes', TableController]
});
'use strict';

controllers.controller('AdminController', ['$uibModal', '$scope', '$rootScope', '$filter', '$translate', 'userFactory', 'subProjectFactory', 'generalHelperService', 'errorService', 'roleService', '$localStorage', 'mainProjectFactory', 'projectFactory', function ($uibModal, $scope, $rootScope, $filter, $translate, userFactory, subProjectFactory, generalHelperService, errorService, roleService, $localStorage, mainProjectFactory, projectFactory) {
  $scope.identifyRoles = function () {
    $scope.isAdmin = roleService.isAdmin();
    $scope.isServicenter = roleService.isServicenter();
    $scope.isProjectOwner = roleService.isProjectOwner();
    $scope.isWarehousePlanner = roleService.isWarehousePlanner();
    $scope.isWarehouseOperator = roleService.isWarehouseOperator();
    $scope.isCustomer = roleService.isCustomer();
    $scope.isInternal = roleService.isInternal();
  };
  $scope.identifyRoles();
  function loadUserData() {
    if (userFactory.isUserDataSet()) {
      $scope.user = {
        user_id: $localStorage.user.user_id,
        user_login: $localStorage.user.login,
        user_type: $scope.isInternal ? 'Intern' : 'Extern',
        user_email: $localStorage.user.email,
        user_name: $localStorage.user.user_name,
        user_phone: $localStorage.user.phone_number,
        user_role_name: $localStorage.user.user_role_name.toUpperCase(),
        user_company_name: $scope.isInternal ? '' : $localStorage.user.companies.length > 0 ? $localStorage.user.companies[0].company_name : 'Okänd'
      };
    }
  }
  ;
  loadUserData();
  function createMainProjectsTree(mainProjects, projects, subProjects) {
    var list = {};
    angular.forEach(mainProjects, function (mainProject) {
      var mpKey = mainProject.main_project_id;
      list[mpKey] = {
        mainProject: mainProject,
        projects: {}
      };
      angular.forEach(projects, function (project) {
        if (mpKey == project.main_project_id) {
          var pKey = project.project_id;
          list[mpKey].projects[pKey] = {
            project: project,
            subProjects: {}
          };
          angular.forEach(subProjects, function (subProject) {
            var spKey = subProject.sub_project_id;
            if (pKey == subProject.project_id) {
              list[mpKey].projects[pKey].subProjects[spKey] = subProject;
            }
          });
        }
      });
    });
    return list;
  }
  function loadAllProjectTypes() {
    if (!$rootScope.main_projects || !$rootScope.projects || $rootScope.sub_projects) {
      userFactory.getMe().then(function (response) {
        var data = response.data,
          main_projects = mainProjectFactory.repackageDTOArray(data.MainProjects),
          projects = projectFactory.repackageDTOArray(data.Projects),
          sub_projects = subProjectFactory.repackageDTOArray(data.SubProjects);
        $scope.mainProjectsTree = createMainProjectsTree(main_projects, projects, sub_projects);
      }, function (error) {
        errorService.handleError(error);
      });
    }
  }
  loadAllProjectTypes();
  var animationsEnabled = true;
  $scope.createSubProject = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/sub_project/sub_project_form.html',
      controller: 'SubProjectInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create_sub_project';
        },
        id: function id() {
          return -1;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };
  $scope.createWorkOrder = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/work_order/work_order_form.html',
      controller: 'WorkOrderInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create_work_order';
        },
        id: function id() {
          return -1;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };
  $scope.objectLength = function (object) {
    if (object) {
      return Object.keys(object).length;
    }
    return 0;
  };
  $scope.$on('updatedUserData', function (event) {
    loadUserData();
  });
}]);
'use strict';

controllers.controller('DeviationCodeController', ['$uibModal', '$scope', '$rootScope', '$filter', 'deviationCodeFactory', 'errorService', 'roleService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, deviationCodeFactory, errorService, roleService, keyCodes) {
  $scope.isAdmin = roleService.isAdmin();
  $scope.innerRange = 5;
  $scope.currentPage = 1;
  $scope.itemRangeBottom = 0;
  $scope.itemRangeTop = 14;
  $scope.itemRange = 15;
  $scope.selectedAny = false;
  $scope.selectedAll = false;
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.hasMixedSelection = false;
  $scope.showInactive = false;
  $scope.searchString = '';
  $scope.keyCode = '';
  $scope.lastSortCol = 'name';
  $scope.sortCol = 'name';
  $scope.sortReverse = false;
  $scope.sortReverseFn = function () {
    if ($scope.lastSortCol === $scope.sortCol && !$scope.sortReverse) {
      $scope.sortReverse = true;
    } else {
      $scope.lastSortCol = $scope.sortCol;
      $scope.sortReverse = false;
    }
  };
  var selected = [];
  $rootScope.reloadTable = function () {
    $scope.deviation_codes = [];
    deviationCodeFactory.getDeviationCodes().then(function (response) {
      var data = response.data;
      $scope.deviation_codes = deviationCodeFactory.repackageDTOArray(data);
      $scope.totalItems = $scope.deviation_codes.length;
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $rootScope.reloadTable();
  $scope.checkAll = function () {
    if (!$scope.selectedAll) {
      $scope.unCheckAll();
      return;
    }
    var filtered = getVisibleItems($scope.deviation_codes);
    angular.forEach(filtered, function (p) {
      p.selected = true;
    });
    $scope.updateSelection();
  };
  $scope.unCheckAll = function () {
    angular.forEach($scope.deviation_codes, function (p) {
      p.selected = $scope.selectedAll;
      if (p.selected) {
        selected.push(p);
      }
    });
    $scope.updateSelection();
  };
  $scope.updateSelection = function () {
    var oneActiveSelected = false;
    var oneInactiveSelected = false;
    var filtered = getVisibleItems($scope.deviation_codes);
    $scope.selectedAny = false;
    selected = [];
    angular.forEach(filtered, function (p) {
      if (!$scope.selectedAny && p.selected) {
        $scope.selectedAny = true;
      }
      if (p.selected) {
        selected.push(p);
      }
      if (!oneActiveSelected && p.is_active && p.selected) {
        oneActiveSelected = true;
      }
      if (!oneInactiveSelected && !p.is_active && p.selected) {
        oneInactiveSelected = true;
      }
    });
    if (!$scope.selectedAny) {
      $scope.selectedAll = false;
    }

    // Mixed selection
    if (oneActiveSelected && oneInactiveSelected) {
      $scope.hasMixedSelection = true;
      $scope.hasActiveSelection = true;
      $scope.hasInactiveSelection = true;
    } else {
      $scope.hasMixedSelection = false;
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
    }

    //Active selction
    if (oneActiveSelected && !oneInactiveSelected) {
      $scope.hasActiveSelection = true;
    } else $scope.hasActiveSelection = false;

    //Inactive selction
    if (!oneActiveSelected && oneInactiveSelected) {
      $scope.hasInactiveSelection = true;
    } else $scope.hasInactiveSelection = false;
  };
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENNTER) {
      $scope.searchString = $scope.pendingSearchString;
      $scope.updateFullTableRange();
    }
  };
  $scope.updateFullTableRange = function () {
    $scope.updateSelection();
    var filtered = getVisibleItems($scope.deviation_codes);
    $scope.totalItems = filtered.length;
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.currentPage - 1) * $scope.itemRange;
  };
  function getVisibleItems(array) {
    var filtered = array;
    if (!$scope.showInactive) {
      filtered = $filter('inactive')(filtered, $scope.showInactive);
    }
    if ($scope.searchString) {
      filtered = $filter('filter')(filtered, $scope.searchString);
    }
    return filtered;
  }

  // --- MODAL - CREATE ---
  var animationsEnabled = true;
  $scope.createDeviationCode = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/deviation_code/deviation_code_form.html',
      controller: 'DeviationCodeInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create_deviation_code';
        },
        id: function id() {
          return -1;
        }
      }
    });
    modalInstance.result.then(function (results) {
      console.log("Results from modal exit: \n" + results);
    });
  };
  $scope.activateDeviationCodes = function (isActive) {
    selected.forEach(function (data) {
      if (isActive) {
        deviationCodeFactory.activateDeviationCode(data.deviation_code_id).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      } else {
        deviationCodeFactory.deactivateDeviationCode(data.deviation_code_id).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      }
    });
  };

  // --- MODAL - VIEW GATE ---
  $scope.viewDeviationCode = function (_id) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/deviation_code/deviation_code_form.html',
      controller: 'DeviationCodeInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view_deviation_code';
        },
        id: function id() {
          return _id;
        }
      }
    });
    modalInstance.result.then(function (results) {
      console.log("Results from modal exit: \n" + results);
    });
  };
  $scope.$on('deviationCodeRepeatFinished', function (deviationCodeRepeatFinishedEvent) {
    $scope.updateFullTableRange();
  });
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('DeviationCodeInstanceController', ['$uibModalInstance', 'form_type', 'id', '$scope', '$rootScope', 'deviationCodeFactory', function ($uibModalInstance, form_type, id, $scope, $rootScope, deviationCodeFactory) {
  $scope.validated = false;
  $scope.form_type = form_type;
  $scope.deviation_code_name = '';
  if (form_type === 'view_deviation_code') {
    deviationCodeFactory.getDeviationCode(id).then(function (response) {
      var data = response.data;
      $scope.deviation_code_id = id;
      $scope.deviation_code_name = data.Name;
      $scope.is_active = data.IsActive;
    }, function (error) {
      errorService.handleError(error);
    });
  }

  // Finalizing or exiting form
  $scope.create = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = {
      "Name": $scope.deviation_code_name,
      "IsActive": true
    };
    deviationCodeFactory.createDeviationCode(DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close("Deviation code created"); // Pass in returned item here.
  };

  $scope.activation = function (isActive) {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    if (isActive) {
      deviationCodeFactory.activateDeviationCode($scope.deviation_code_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    } else {
      deviationCodeFactory.deactivateDeviationCode($scope.deviation_code_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    }
    var results = '';
    $uibModalInstance.close(results); // Pass in returned item here.
  };

  $scope.update = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = {
      "DeviationCodeId": $scope.deviation_code_id,
      "Name": $scope.deviation_code_name,
      "IsActive": $scope.is_active
    };
    deviationCodeFactory.updateDeviationCode(DTO.DeviationCodeId, DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(); // Pass in returned item here.
  };

  $scope.delete = function () {
    deviationCodeFactory.deleteDeviationCode($scope.deviation_code_id).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(''); // Pass in returned item here.
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    if (input === '') {
      return false;
    } else if (typeof input === 'undefined') {
      return false;
    } else if (input === null) {
      return false;
    } else return true;
  };
  $scope.validateForm = function () {
    $scope.formValid = $scope.deviation_code_name !== '' && typeof $scope.deviation_code_name !== 'undefined';
    return $scope.formValid;
  };
}]);
'use strict';

controllers.controller('InboxController', ['$uibModal', '$scope', '$rootScope', '$filter', '$translate', 'notificationsFactory', 'errorService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, $translate, notificationsFactory, errorService, keyCodes) {
  $scope.innerRange = 5;
  $scope.currentPage = 1;
  $scope.itemRangeBottom = 0;
  $scope.itemRangeTop = 14;
  $scope.itemRange = 15;
  $scope.selectedAny = false;
  $scope.selectedAll = false;
  $scope.hasSelection = false;
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.showInactive = false;
  $scope.searchString = '';
  $scope.keyCode = '';
  $scope.lastSortCol = 'notification_contact_name';
  $scope.sortCol = 'notification_contact_name';
  $scope.sortReverse = false;
  $scope.sortReverseFn = function () {
    if ($scope.lastSortCol === $scope.sortCol && !$scope.sortReverse) {
      $scope.sortReverse = true;
    } else {
      $scope.lastSortCol = $scope.sortCol;
      $scope.sortReverse = false;
    }
  };
  $scope.selectedNotifications = [];
  $rootScope.reloadTable = function () {
    $scope.notifications = [];
    notificationsFactory.getNotifications().then(function (response) {
      response.data.forEach(notificationsData);
      $scope.totalItems = $scope.notifications.length;
      $scope.notifications = $filter('orderBy')($scope.notifications, 'notification_date', true);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $rootScope.reloadTable();
  function notificationsData(data, index) {
    $scope.selectedAll = false;
    $scope.selectedAny = false;
    var tempNotification = {
      notification_id: data.NotificationId,
      notification_date: data.Date,
      notification_contact_name: data.ContactName,
      notification_phone_number: data.PhoneNumber,
      notification_email: data.To,
      notification_type_name: data.NotificationTemplateName,
      notification_message: (data.Body != undefined ? data.Body : '') + (data.Message != undefined ? data.Message : ''),
      notification_delivery_number: data.OrderNumber,
      // Leveransnummer
      notification_work_order: data.WorkOrderName,
      // Arbetsorder
      notification_isEmail: data.NotificationMedium === NotificationMediumEnum.EMAIL_NOTIFICATION,
      notification_isSMS: data.NotificationMedium === NotificationMediumEnum.SMS_NOTIFICATION
    };
    if (isUnique($scope.notifications, 'notification_id', data.NotificationId)) {
      $scope.notifications.push(tempNotification);
    }
  }
  function isUnique(array, idKey, id) {
    var unique = true;
    array.forEach(function (entry, index) {
      if (entry[idKey] === id) {
        unique = false;
      }
    });
    return unique;
  }
  $scope.displayDateSeparator = function (order1, order2) {
    if (order2 === null || typeof order2 === 'undefined') {
      return true;
    }
    return order1.notification_date !== order2.notification_date;
  };
  $scope.displayDate = function (date) {
    var months = loadMonthsFromLanguage();
    var today = new Date().toISOString().split('T')[0];
    var pDate = new Date(date);
    return (today === date ? $translate.instant('TODAY') + ' ' : '') + pDate.getDate() + ' ' + months[pDate.getMonth()];
  };
  $scope.isToday = function (date) {
    var today = new Date().toISOString().split('T')[0];
    return date == today;
  };
  $scope.isBeforeToday = function (date) {
    var today = new Date().toISOString().split('T')[0];
    return date < today;
  };
  function loadMonthsFromLanguage() {
    var translations = $translate.instant(['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']);
    var months = [];
    months.push(translations['JAN']);
    months.push(translations['FEB']);
    months.push(translations['MAR']);
    months.push(translations['APR']);
    months.push(translations['MAY']);
    months.push(translations['JUN']);
    months.push(translations['JUL']);
    months.push(translations['AUG']);
    months.push(translations['SEP']);
    months.push(translations['OCT']);
    months.push(translations['NOV']);
    months.push(translations['DEC']);
    return months;
  }
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.searchString = $scope.pendingSearchString;
      $scope.updateFullTableRange('filter', $scope.notifications, $scope.searchString);
    }
  };
  $scope.updateFullTableRange = function (filter, array, param) {
    var filtered = $filter(filter)(array, param);
    $scope.totalItems = filtered.length;
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.currentPage - 1) * $scope.itemRange;
  };
  $scope.$on('notificationRepeatFinished', function (notificationRepeatFinishedEvent) {
    $scope.updateFullTableRange('filter', $scope.notifications);
  });
}]);
'use strict';

angular.module('sp.controllers').controller('OrderController', ['$scope', '$rootScope', '$filter', 'orderFactory', '$translate', '$localStorage', '$location', 'roleService', 'taskStatusService', 'ngToast', 'generalHelperService', 'megaFilterService', 'keyCodes', 'calendarConfig', '$templateRequest', 'megaFilterModalService', '$q', 'showingArchive', 'orderFormModalService', 'warehouseBalanceModalService', function ($scope, $rootScope, $filter, orderFactory, $translate, $localStorage, $location, roleService, taskStatusService, ngToast, generalHelperService, megaFilterService, keyCodes, calendarConfig, $templateRequest, megaFilterModalService, $q, showingArchive, orderFormModalService, warehouseBalanceModalService) {
  if ($localStorage.user && $localStorage.user.session_main_project) {
    setMainProjectState();
  }
  $scope.OrderTypeEnum = OrderTypeEnum; // Makes OrderTypeEnum available in html

  $scope.calendarEvents = [];
  $scope.isFilterActive = function () {
    return !megaFilterService.isEmptyFilter($scope.filter);
  };
  // Load templates for calendar
  $templateRequest('app/components/orders/order_calendar_day_template.html');
  $templateRequest('app/components/orders/order_calendar_hourlist_template.html');

  // Global date reference
  $scope.viewDateRef = new Date();
  $scope.loadedMonth = null;

  // Pagination

  $scope.paginationConfig = {
    currentPage: 1,
    innerRange: 5,
    pageSize: 15,
    totalItems: 0
  };
  $scope.pagination = {
    from: null,
    to: null,
    skip: 0,
    take: $scope.paginationConfig.pageSize
  };
  $scope.filter = megaFilterService.getEmptyFilter();
  $scope.selectedAny = false;
  $scope.selectedAll = false;
  $scope.hasMixedSelection = false;
  $scope.searchString = '';
  $scope.keyCode = '';
  $scope.showingArchive = showingArchive;
  $scope.statusChangeAllowed = false;
  $scope.miniListOrders = [];
  function updateDeliveryDateFilter() {
    if ($scope.showingArchive) {
      if (!$scope.filter.deliveryTimeTo) {
        var endOfToday = new Date();
        endOfToday.setHours(23, 59, 59, 999);
        $scope.filter.deliveryTimeTo = endOfToday;
      }
      if (!$scope.filter.deliveryTimeFrom) {
        var today = new Date();
        var oneMonthAgo = new Date();
        oneMonthAgo.setHours(0, 0, 0, 0);
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        if (oneMonthAgo.getMonth() === today.getMonth()) {
          oneMonthAgo.setDate(0);
        }
        $scope.filter.deliveryTimeFrom = oneMonthAgo;
      }
    } else {
      $scope.filter.deliveryTimeTo = null;
      $scope.filter.deliveryTimeFrom = null;
    }
  }
  updateDeliveryDateFilter();
  function labelOld(orders) {
    var today = new Date(new Date().toLocaleDateString());
    orders.forEach(function (order, index) {
      var orderDate = new Date(order.date_i);
      if (today > orderDate) {
        order.old = true;
      } else {
        order.old = false;
      }
    });
    return orders;
  }
  function updateMiniListOrders() {
    $scope.miniListOrders.length = 0;
    if ($scope.currentOrdersPeriodType === 'LIST') {
      angular.forEach($scope.orders, function (order) {
        $scope.miniListOrders.push(order);
      });
    } else {
      var from = moment($scope.viewDateRef).startOf($scope.currentOrdersPeriodType).toDate();
      var to = moment($scope.viewDateRef).endOf($scope.currentOrdersPeriodType).toDate();
      angular.forEach($scope.orders, function (order) {
        var orderDate = new Date(order.date_i);
        if (orderDate >= from && orderDate <= to) {
          $scope.miniListOrders.push(order);
        }
      });
    }
  }
  function setMainProjectState() {
    $scope.mainProjectId = $localStorage.user.session_main_project.main_project_id;
    $scope.canCreateDirectDeliveryOrder = $localStorage.user.session_main_project.is_direct_delivery_function_enabled;
    $scope.canCreateTransshipmentOrder = $localStorage.user.session_main_project.is_transshipment_function_enabled;
    $scope.canCreateStoringOrder = $localStorage.user.session_main_project.is_storing_function_enabled;
    $scope.canCreateMaterialOrder = $localStorage.user.session_main_project.is_material_order_function_enabled;
    $scope.canCreateResourceBookingOrder = $localStorage.user.session_main_project.is_resource_booking_function_enabled;
    $scope.canOpenWarehouseBalance = $localStorage.user.session_main_project.is_warehouse_balance_function_enabled;
  }
  ;
  function loadOrders() {
    if (!$scope.mainProjectId) {
      return $q.reject('User data not initiated yet');
    }
    var loadTask;
    if ($scope.showingArchive) {
      if ($scope.currentOrdersType === 'PACKAGES') {
        loadTask = orderFactory.getArchivedWithPackages($scope.mainProjectId, $scope.filter, $scope.pagination, $scope.searchString);
      } else if ($scope.currentOrdersType === 'MY_ORDERS') {
        loadTask = orderFactory.getArchived($scope.mainProjectId, $scope.filter, $scope.pagination, $scope.searchString);
      }
    } else {
      if ($scope.currentOrdersType === 'PACKAGES') {
        loadTask = orderFactory.getOrdersWithPackages($scope.mainProjectId, $scope.filter, $scope.pagination, $scope.searchString);
      } else if ($scope.currentOrdersType === 'MY_ORDERS') {
        loadTask = orderFactory.getOrders($scope.mainProjectId, $scope.filter, $scope.pagination, $scope.searchString);
      }
    }
    if ($scope.currentOrdersType === 'EXTENDED_ORDERS') {
      loadTask = orderFactory.getOrdersFromExtendedSet($scope.mainProjectId, $scope.filter, $scope.pagination, $scope.searchString);
    }
    if (loadTask) {
      loadTask = loadTask.then(function (orderSlice) {
        var orders = orderSlice.items;
        if (!$scope.showingArchive) {
          orders = labelOld(orders);
        }
        orders = $filter('orderBy')(orders, 'time_i', false);
        orders = $filter('orderBy')(orders, 'date_i', false);
        $scope.orders = orders;
        $scope.filteredOrders = orders;
        $rootScope.orders = orders;
        $scope.paginationConfig.totalItems = orderSlice.totalCount;
        updateMiniListOrders();
        $rootScope.$broadcast('updatedOrders');
        $rootScope.$broadcast('updateCalendar');
      }, function () {
        // Error is handled by orderFactory
      });
    }
    return loadTask;
  }
  $scope.updatePaginationAndLoad = function (skip, take) {
    $scope.pagination.skip = skip;
    $scope.pagination.take = take;
    loadOrders();
  };
  function updateDatePagination() {
    $scope.pagination.from = moment($scope.viewDateRef).startOf('month').subtract(7, 'days').toDate();
    $scope.pagination.to = moment($scope.viewDateRef).endOf('month').add(7, 'days').toDate();
    $scope.loadedMonth = $scope.viewDateRef.getMonth();
  }
  function resetPagination() {
    $scope.pagination.skip = null;
    $scope.pagination.take = null;
    $scope.pagination.from = null;
    $scope.pagination.to = null;
    $scope.paginationConfig.currentPage = 1;
    $scope.loadedMonth = null;
    if ($scope.currentOrdersPeriodType === 'LIST') {
      $scope.pagination.skip = 0;
      $scope.pagination.take = $scope.paginationConfig.pageSize;
    } else if ($scope.currentOrdersPeriodType !== 'LIST') {
      updateDatePagination();
    }
  }
  function isDatePaginationIsOutOfRange() {
    return $scope.loadedMonth !== $scope.viewDateRef.getMonth();
  }
  $scope.onViewDateChanged = function (newDate, periodType) {
    $scope.viewDateRef = newDate;
    $scope.setCurrentOrdersView(periodType, $scope.currentOrdersType);
  };
  $scope.setCurrentOrdersView = function (periodType, ordersType) {
    var hasChangedOrdersType = $scope.currentOrdersType != ordersType;
    var hasChangedToListView = periodType === 'LIST' && $scope.currentOrdersPeriodType !== 'LIST';
    var hasChangedDateInCalendarView = periodType !== 'LIST' && isDatePaginationIsOutOfRange();
    updateOrderTypeFilterForPeriodType(periodType);
    $scope.currentOrdersPeriodType = periodType;
    $scope.currentOrdersType = ordersType;
    resetPagination();
    if (hasChangedOrdersType || hasChangedToListView || hasChangedDateInCalendarView) {
      loadOrders();
    }
  };
  function getDefaultOrderTypesForPeriodType(periodType) {
    switch (periodType) {
      case 'LIST':
        return [];
      case 'DAY':
      case 'WEEK':
        return [OrderTypeEnum.DIRECT_DELIVERY, OrderTypeEnum.RECURRING_DIRECT_DELIVERY];
        break;
      default:
        console.log('Unknown period type: ' + $scope.currentOrdersPeriodType);
        return undefined;
    }
  }
  function updateOrderTypeFilterForPeriodType(newPeriodType) {
    if ($scope.currentOrdersPeriodType === newPeriodType) return;
    var currentDefaultOrderTypes = getDefaultOrderTypesForPeriodType($scope.currentOrdersPeriodType);
    var isDefaultOrderTypes = generalHelperService.areEquivalentArrays($scope.filter.orderTypes, currentDefaultOrderTypes);
    if (isDefaultOrderTypes) {
      $scope.filter.orderTypes = getDefaultOrderTypesForPeriodType(newPeriodType);
    }
  }
  function setInitialCurrentOrdersView() {
    if ($location.search().date && !$scope.showingArchive) {
      var timestamp = Date.parse($location.search().date);
      if (isNaN(timestamp) == false) {
        $scope.viewDateRef = new Date(timestamp);
      }
    }
    var periodType = $location.search().periodType && !$scope.showingArchive ? $location.search().periodType.toUpperCase() : 'LIST';
    var ordersType = $scope.showingArchive ? 'MY_ORDERS' : 'EXTENDED_ORDERS';
    $scope.setCurrentOrdersView(periodType, ordersType);
  }
  setInitialCurrentOrdersView();
  $scope.$on('updateOrders', function () {
    if ($scope.currentOrdersPeriodType !== 'LIST' && isDatePaginationIsOutOfRange()) {
      updateDatePagination();
      loadOrders();
    } else if ($scope.currentOrdersPeriodType === 'LIST') {
      loadOrders();
    } else {
      updateMiniListOrders();
      $rootScope.$broadcast('updateCalendar');
    }
  });
  var selected = [];
  $scope.showSideMenu = false;
  $scope.identifyRoles = function () {
    $scope.isAdmin = roleService.isAdmin();
    $scope.isServicenter = roleService.isServicenter();
    $scope.isWarehousePlanner = roleService.isWarehousePlanner();
    $scope.isWarehouseOperator = roleService.isWarehouseOperator();
    $scope.isInternal = roleService.isInternal();
    $scope.isCustomer = roleService.isCustomer();
  };
  $scope.identifyRoles();
  var updateCalendarEvents = function updateCalendarEvents() {
    $scope.calendarEvents = [];
    angular.forEach($scope.calendarOrders, function (order) {
      $scope.calendarEvents.push(createCalendarEventFromOrder(order));
    });
  };
  $scope.toggleOrderTypeVisibility = function (orderType) {
    var shallInclude = !$scope.isOrderTypeSelected(orderType);
    megaFilterService.includeOrExcludeOrderType($scope.filter, orderType, shallInclude);
    loadOrders();
  };
  $scope.isOrderTypeSelected = function (orderType) {
    if (!$scope.filter.orderTypes) return false;
    return $scope.filter.orderTypes.indexOf(orderType) !== -1;
  };
  $scope.reloadTable = function () {
    $scope.selectedAll = false;
    $scope.selectedAny = false;
    if ($scope.currentOrdersType !== 'PACKAGES') {
      // Set filtered orders to calendar
      $scope.calendarOrders = $filter('filter')($scope.filteredOrders, {
        task_status: '!' + TaskStatusTypeEnum.CANCELLED
      }, true);
      updateCalendarEvents();
      // Update calendar view
      $rootScope.$broadcast('updateCalendar');
    }
  };
  var getCalendarEventColors = function getCalendarEventColors(order) {
    var borderClasses = {
      confirmed: 'sp-green-border',
      notified: 'sp-blue-border',
      canceled: 'sp-red-border',
      empty: 'sp-grey-border'
    };
    var borderClass = borderClasses[$scope.getTaskStatus(order.task_status)];
    var pinColorFirst = null;
    var pinColorSecond = null;
    var locationId = order.vehicle_drop_location_id ? order.vehicle_drop_location_id : order.resource_location_id ? order.resource_location_id : null;
    if (locationId) {
      pinColorFirst = $scope.generateFirstColorClass(locationId);
      pinColorSecond = $scope.generateSecondColorClass(locationId);
    }
    ;
    return [borderClass, pinColorFirst, pinColorSecond];
  };
  var createCalendarEventFromOrder = function createCalendarEventFromOrder(order) {
    var shortTitle = order.order_number.substring(0, 2);
    var startsAt = moment(order.date_i + ' ' + order.time_i, 'YYYY-MM-DD HH:mm').toDate();
    var endsAtDate = order.date_f ? order.date_f : order.date_i; // date_f is undefined when start and end on the same day
    var endsAtTime = order.time_f ? order.time_f : moment(order.time_i, 'HH:mm').add(60, 'm').format('HH:mm'); // If no time span, add 60 minutes for visibility
    var endsAt = moment(endsAtDate + ' ' + endsAtTime, 'YYYY-MM-DD HH:mm').toDate();

    // Handle extremely short events: add extra time, for calendar visibility, but remember the real end date
    var realEndsAt = new Date(endsAt.getTime());
    var duration = moment(endsAt).diff(moment(startsAt), 'minutes');
    if (duration <= 60) {
      endsAt = new Date(moment(endsAt).add(60 - duration, 'm'));
    }
    ;
    var colors = getCalendarEventColors(order);
    var calendarEvent = {
      title: $scope.getCalendarTooltipText(order),
      shortTitle: shortTitle,
      startsAt: startsAt,
      endsAt: endsAt,
      realEndsAt: realEndsAt,
      color: calendarConfig.colorTypes.white,
      borderClass: colors[0],
      order: order,
      pinColorFirst: colors[1],
      pinColorSecond: colors[2],
      dropLocationId: order.vehicle_drop_location_id,
      resourceLocationId: order.resource_location_id,
      draggable: false,
      resizable: false
    };
    return calendarEvent;
  };
  $scope.getCalendarTooltipText = function (order) {
    var tooltipText = order.order_type_name + ', ' + order.task_status_name;
    if (order.vehicle_drop_location_name) {
      tooltipText += ', ' + order.vehicle_drop_location_name;
    }
    ;
    if (order.resource_location_name) {
      tooltipText += ', ' + order.resource_location_name;
    }
    ;
    if (order.supplier) {
      tooltipText += ', ' + order.supplier;
    }
    ;
    if (order.content) {
      tooltipText += ', ' + order.content;
    }
    ;
    return tooltipText;
  };
  $scope.generateFirstColorClass = function (id) {
    return generalHelperService.generateFirstColorClass(id);
  };
  $scope.generateSecondColorClass = function (id) {
    return generalHelperService.generateSecondColorClass(id);
  };
  $scope.getTaskStatus = function (id) {
    switch (id) {
      case TaskStatusTypeEnum.CONFIRMED:
        return 'confirmed';
      case TaskStatusTypeEnum.CANCELLED:
        return 'canceled';
      case -1:
        return 'empty';
      default:
        return 'notified';
    }
  };
  $scope.isDirectOrder = function (orderType) {
    return OrderTypeEnum.DIRECT_DELIVERY === orderType;
  };
  $scope.isDirectOrRecurringDirectOrder = function (orderType) {
    return OrderTypeEnum.RECURRING_DIRECT_DELIVERY === orderType || OrderTypeEnum.DIRECT_DELIVERY === orderType;
  };
  $scope.isConfirmedOrLater = function (taskStatusId) {
    return taskStatusService.isConfirmedOrLater(taskStatusId);
  };
  $scope.isNotified = function (taskStatusId) {
    return taskStatusService.isNotified(taskStatusId);
  };
  $scope.isCancelled = function (taskStatusId) {
    return taskStatusService.isCancelled(taskStatusId);
  };
  $scope.formatDateOrMonth = function (dateOrMonth) {
    var dateOrMonthString = dateOrMonth.toString();
    if (dateOrMonthString.length === 1) {
      return "0" + dateOrMonth;
    } else return dateOrMonth;
  };

  // FUTURE: Duplicated function. break out of controller and store result for faster translations.
  function loadMonthsFromLanguage() {
    var translations = $translate.instant(['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']);
    var months = [];
    months.push(translations['JAN']);
    months.push(translations['FEB']);
    months.push(translations['MAR']);
    months.push(translations['APR']);
    months.push(translations['MAY']);
    months.push(translations['JUN']);
    months.push(translations['JUL']);
    months.push(translations['AUG']);
    months.push(translations['SEP']);
    months.push(translations['OCT']);
    months.push(translations['NOV']);
    months.push(translations['DEC']);
    return months;
  }
  function updateStatusChangeAllowed() {
    $scope.statusChangeAllowed = false;
    var markedOrders = $filter('filter')($scope.orders, {
      selected: true
    }, true);
    var firstOrderType = null;
    var firstOrderStatus = null;
    if (markedOrders && markedOrders.length > 0) {
      firstOrderType = markedOrders[0].order_type;
      firstOrderStatus = markedOrders[0].task_status;
      for (var i = 0; i < markedOrders.length; i++) {
        var currOrder = markedOrders[i];
        if (currOrder.order_type !== firstOrderType || currOrder.task_status !== firstOrderStatus || $scope.nextStatus === generalHelperService.getKeyByValue(TaskStatusTypeEnum, firstOrderStatus)) {
          $scope.statusChangeAllowed = false;
          return;
        }
      }
      $scope.statusChangeAllowed = true;
    } else {
      $scope.statusChangeAllowed = false;
    }
  }
  $scope.checkAll = function () {
    selected = [];
    angular.forEach($scope.filteredOrders, function (o) {
      o.selected = $scope.selectedAll;
      if (o.selected) {
        selected.push(o);
      }
    });
    $scope.updateSelection();
  };
  $scope.updateSelection = function () {
    var oneActiveSelected = false;
    var oneInactiveSelected = false;
    $scope.selectedAny = false;
    selected = [];
    angular.forEach($scope.filteredOrders, function (o) {
      if (!$scope.selectedAny && o.selected) {
        $scope.selectedAny = true;
      }
      if (o.selected) {
        selected.push(o);
      }
      if (!oneActiveSelected && o.is_active && o.selected) {
        oneActiveSelected = true;
      }
      if (!oneInactiveSelected && !o.is_active && o.selected) {
        oneInactiveSelected = true;
      }
    });
    if (!$scope.selectedAny) {
      $scope.selectedAll = false;
    }

    // Mixed selection
    if (oneActiveSelected && oneInactiveSelected) {
      $scope.hasMixedSelection = true;
      $scope.hasActiveSelection = true;
      $scope.hasInactiveSelection = true;
    } else {
      $scope.hasMixedSelection = false;
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
    }

    //Active selction
    if (oneActiveSelected && !oneInactiveSelected) {
      $scope.hasActiveSelection = true;
    } else $scope.hasActiveSelection = false;

    //Inactive selction
    if (!oneActiveSelected && oneInactiveSelected) {
      $scope.hasInactiveSelection = true;
    } else $scope.hasInactiveSelection = false;

    //Updating wether bulk change status is allowed
    if ($scope.currentOrdersPeriodType === 'LIST') {
      updateStatusChangeAllowed();
    }
  };
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.loadOrders();
    }
  };
  $scope.filterOrders = function () {
    loadOrders();
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.paginationConfig.currentPage - 1) * $scope.paginationConfig.pageSize;
  };
  $scope.createTransshipmentOrder = function () {
    $scope.createOrder(OrderTypeEnum.TRANSSHIPMENT);
  };
  $scope.createDirectDeliveryOrder = function () {
    $scope.createOrder(OrderTypeEnum.DIRECT_DELIVERY);
  };
  $scope.createStoringOrder = function () {
    $scope.createOrder(OrderTypeEnum.STORING);
  };
  $scope.createMaterialOrder = function () {
    $scope.createOrder(OrderTypeEnum.MATERIAL);
  };
  $scope.createResourceBookingOrder = function () {
    $scope.createOrder(OrderTypeEnum.RESOURCE_BOOKING);
  };
  $scope.openWarehouseBalance = function () {
    warehouseBalanceModalService.open();
  };
  $scope.createOrder = function (orderType) {
    orderFormModalService.openCreate(orderType).then(function () {
      loadOrders();
    });
  };
  $scope.viewOrder = function (order_type, id, copy) {
    if (id === -1 || $scope.orderInterctionIsLocked) return;
    var orderFormPromise;
    if ($scope.isInternal) {
      orderFormPromise = orderFormModalService.openManage(id, order_type, copy);
    } else {
      orderFormPromise = orderFormModalService.openView(id, order_type, copy);
    }
    orderFormPromise.then(function (results) {
      if (results.copy) {
        $scope.viewOrder(order_type, id, true);
      }
      if (results.success) {
        loadOrders();
      }
    });
  };
  $scope.viewOrderIfDirectDelivery = function (order_type, order_id) {
    if ($scope.isDirectOrRecurringDirectOrder(order_type)) {
      $scope.viewOrder(order_type, order_id, false);
    }
  };
  $scope.calendarOnEventClicked = function (calendarEvent) {
    var order = calendarEvent.order;
    $scope.viewOrder(order.order_type, order.order_id, false);
  };
  $scope.openMegaFilter = function () {
    megaFilterModalService.openFilter($scope.filter, $scope.showingArchive, $scope.showingArchive).then(function (newFilter) {
      $scope.filter = newFilter;
      loadOrders().then(function () {
        if (!$scope.showingArchive) {
          $scope.calendarOrders = $filter('filter')($scope.filteredOrders, {
            task_status: '!' + TaskStatusTypeEnum.CANCELLED
          }, true);
        }
      });
    }, function () {} // User clicked cancel
    );
  };

  $scope.displayDateSeparator = function (order1, order2) {
    if (order2 === null || typeof order2 === 'undefined') {
      return true;
    }
    return order1.date_i !== order2.date_i;
  };
  $scope.displayDate = function (date) {
    var months = loadMonthsFromLanguage();
    var today = new Date().toISOString().split('T')[0];
    var pDate = new Date(date);
    return (today === date ? $translate.instant('TODAY') + ' ' : '') + pDate.getDate() + ' ' + months[pDate.getMonth()];
  };
  $scope.isToday = function (date) {
    var today = new Date().toISOString().split('T')[0];
    return date === today;
  };
  $scope.isBeforeToday = function (date) {
    var today = new Date().toISOString().split('T')[0];
    return date < today;
  };
  $scope.getNextStatus = function (open) {
    $scope.nextStatus = null;
    if ($scope.statusChangeAllowed && open) {
      var markedOrders = $filter('filter')($scope.orders, {
        selected: true
      }, true);
      orderFactory.getNextStatus(markedOrders[0].order_type, markedOrders[0].task_status).then(function (result) {
        $scope.nextStatus = generalHelperService.getKeyByValue(TaskStatusTypeEnum, result.data);
        updateStatusChangeAllowed();
      });
    }
  };
  $scope.setNextStatus = function () {
    var markedOrders = $filter('filter')($scope.orders, {
      selected: true
    }, true);
    var markedOrderIds = markedOrders.map(function (order) {
      return order.order_id;
    });
    orderFactory.setNextStatusMultiple(markedOrderIds).then(function (result) {
      loadOrders();
      $scope.statusChangeAllowed = false;
      ngToast.success("Status för valda ordrar ändrade.");
    }, function (error) {
      ngToast.danger("Ett fel inträffade vid ändring av status för ordrar.");
    });
  };

  // Corrects the table on currentPage value change
  $scope.$watch('pagination.currentPage', function () {
    $scope.updateTableRange();
  }, true);
  $scope.$on('updatedOrders', function () {
    // $scope.showingArchive = $localStorage.header.btnActive === 'archive';
    if ($scope.showingArchive && ($scope.currentOrdersPeriodType !== 'LIST' || $scope.currentOrdersType === 'EXTENDED_ORDERS')) {
      $scope.currentOrdersPeriodType = 'LIST';
      $scope.currentOrdersType = 'MY_ORDERS';
    }
    $scope.reloadTable();
  });
  $scope.$on('updatedUserData', function () {
    setMainProjectState();
    $scope.identifyRoles();
    loadOrders();
  });
  $scope.$on('searchFromMobile', function (event, mobileSearchString) {
    $scope.searchString = mobileSearchString;
    loadOrders();
  });
}]);
'use strict';

controllers.controller('OrderCalendarController', ['$scope', '$rootScope', '$filter', '$translate', 'generalHelperService', function ($scope, $rootScope, $filter, $translate, generalHelperService) {
  // Global date references can be found in orderController.

  // Extend Date to get Week
  // Returns the ISO week of the date.
  Date.prototype.getWeek = function () {
    var date = new Date(this.getTime());
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    var week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
  };

  // ----- Day utility functions  -----
  function generateTodayString() {
    var today = new Date();
    var thisYear = today.getFullYear();
    var thisMonth = $scope.formatDateOrMonth(today.getMonth() + 1);
    var thisDate = $scope.formatDateOrMonth(today.getDate());
    var todayString = thisYear + '-' + thisMonth + '-' + thisDate;
    return todayString;
  }
  $scope.isToday = function (date) {
    var formatedDate = $scope.formatDateOrMonth(date);
    var todayString = generateTodayString();
    var compareDate = $scope.viewDateRef.getFullYear() + '-' + ($scope.viewDateRef.getMonth() + 1) + '-' + formatedDate;
    if (todayString === compareDate) {
      return true;
    } else return false;
  };

  // ----- Date utility functions -----
  // ISO week
  $scope.getFirstDateOfWeek = function (w, y) {
    var simple = new Date(y, 0, 1 + (w - 1) * 7);
    var dow = simple.getDay();
    var ISOweekStart = simple;
    if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
    return ISOweekStart;
  };

  // Gets the date of the first monday in current month
  $scope.getCalendarMondaysDate = function () {
    var searchDate = new Date($scope.viewDateRef);
    searchDate.setDate(1);
    while (searchDate.getDay() !== 1) {
      searchDate.setDate(searchDate.getDate() - 1);
    }
    return searchDate;
  };

  // Gets the date of day 0-6 of current week.
  $scope.getDateOfDay = function (day) {
    var week = $scope.viewDateRef.getWeek();
    var year = $scope.viewDateRef.getFullYear();
    var firstDateOfWeek = new Date($scope.getFirstDateOfWeek(week, year).getTime());
    var upcoming = $scope.getUpcomingDate(firstDateOfWeek, day - 1);
    return upcoming.getDate();
  };
  $scope.getDateObjectOfDay = function (day) {
    var week = $scope.viewDateRef.getWeek();
    var year = $scope.viewDateRef.getFullYear();
    var firstDateOfWeek = new Date($scope.getFirstDateOfWeek(week, year).getTime());
    var upcoming = $scope.getUpcomingDate(firstDateOfWeek, day - 1);
    return upcoming;
  };
  $scope.getDateObjectOfDateNumber = function (number) {
    var date = new Date($scope.viewDateRef.getTime());
    date.setDate(number);
    return date;
  };
  $scope.getUpcomingDate = function (date, increment) {
    var upcomming = new Date(date.getTime());
    upcomming.setDate(date.getDate() + increment);
    return upcomming;
  };

  // ----- Orders utility functions  -----
  $scope.getOrdersByDate = function (date) {
    var y = $scope.viewDateRef.getFullYear();
    var m = $scope.formatDateOrMonth($scope.viewDateRef.getMonth() + 1);
    var d = $scope.formatDateOrMonth(date);
    var dateString = y + '-' + m + '-' + d;
    var ordersInDate = [];
    for (var i = 0; i < $scope.calendarOrders.length; i++) {
      if ($scope.calendarOrders[i].date_i === dateString) {
        ordersInDate.push($scope.calendarOrders[i]);
      }
    }
    return ordersInDate;
  };
  $scope.getOrdersByDateObject = function (date) {
    var m = $scope.formatDateOrMonth(date.getMonth() + 1);
    var d = $scope.formatDateOrMonth(date.getDate());
    var dateString = date.getFullYear() + '-' + m + '-' + d;
    var ordersInDate = [];
    for (var i = 0; i < $scope.calendarOrders.length; i++) {
      if ($scope.calendarOrders[i].date_i === dateString) {
        ordersInDate.push($scope.calendarOrders[i]);
      }
    }
    return ordersInDate;
  };

  // Week is defined by viewDateRef, that is the week.
  $scope.getOrdersInCurrentWeek = function () {
    var datesThisWeek = [];
    var ordersThisWeek = [];
    for (var i = 1; i < 8; i++) {
      datesThisWeek.push($scope.getDateObjectOfDay(i));
    }
    for (var j = 0; j < datesThisWeek.length; j++) {
      ordersThisWeek = ordersThisWeek.concat($scope.getOrdersByDateObject(datesThisWeek[j]));
    }
    return ordersThisWeek;
  };

  // To make the orders align correctly. Sets part order initial time to first part initial time.
  function resetOrderPartTimesToInitial(orders) {
    angular.forEach(orders, function (partOrderNotFirst) {
      if (partOrderNotFirst.is_part && partOrderNotFirst.part_number !== 1) {
        angular.forEach($scope.calendarOrders, function (singleOrStartOrderPart) {
          if ((!singleOrStartOrderPart.is_part || singleOrStartOrderPart.is_part && singleOrStartOrderPart.part_number === 1) && singleOrStartOrderPart.order_id === partOrderNotFirst.order_id) {
            partOrderNotFirst.time_i = singleOrStartOrderPart.time_i;
          }
        });
      }
    });
    return orders;
  }
  ;
  $scope.getOrdersInCurrentWeekByDateAndHour = function (date, hour) {
    var ordersInHour = [];
    var ordersInWeek = $scope.getOrdersInCurrentWeek();
    resetOrderPartTimesToInitial(ordersInWeek);
    var h = ('' + hour).length === 1 ? '0' + hour : hour;
    var d = ('' + date).length === 1 ? '0' + date : date;
    var timePattern = new RegExp("^" + h + ":\\d{2}$");
    var datePattern = new RegExp("^\\d{4}-\\d{2}-" + d + "$");
    for (var i = 0; i < ordersInWeek.length; i++) {
      if (timePattern.test(ordersInWeek[i].time_i) && datePattern.test(ordersInWeek[i].date_i)) {
        ordersInHour.push(ordersInWeek[i]);
      }
    }
    return ordersInHour;
  };
  $scope.getOrdersByDateAndHour = function (date, hour) {
    var ordersByDate = $scope.getOrdersByDate(date);
    var h = ('' + hour).length === 1 ? '0' + hour : hour;
    var timePattern = new RegExp("^" + h + ":\\d{2}$");
    var ordersByTime = [];
    for (var i = 0; i < ordersByDate.length; i++) {
      if (timePattern.test(ordersByDate[i].time_i)) {
        ordersByTime.push(ordersByDate[i]);
      }
    }
    return ordersByTime;
  };
  $scope.getOrdersByHour = function (orders, hour) {
    var inHour = [];
    angular.forEach(orders, function (order, index) {
      var startHour = order.time_i.split(':')[0];
      if (startHour === '' + hour) {
        inHour.push(order);
      }
    });
    return inHour;
  };

  // Open order
  $scope.viewOrderFromCalendar = function (order, event, stopPropagation, orderInterctionIsLocked) {
    if (stopPropagation !== -1) event.stopPropagation();
    $scope.viewOrder(order.order_type, order.order_id, false, orderInterctionIsLocked);
  };

  // Other utility functions -----
  $scope.getTaskStatus = function (id) {
    switch (id) {
      case TaskStatusTypeEnum.CONFIRMED:
        return 'confirmed';
      case TaskStatusTypeEnum.CANCELLED:
        return 'canceled';
      case -1:
        return 'empty';
      default:
        return 'notified';
    }
  };

  // For week calendar view
  function generateOrderWeekPlaceholderList() {
    // Placeholder management for each date
    $scope.orderWeekPlaceholderList = [];
    for (var i = 1; i < 8; i++) {
      $scope.orderWeekPlaceholderList[i] = [];
      for (var j = 0; j < 24; j++) {
        $scope.orderWeekPlaceholderList[i][j] = {
          first: {
            order_id: -1,
            order: {
              task_status: -1,
              order_id: -1
            },
            available: true
          },
          second: {
            order_id: -1,
            order: {
              task_status: -1,
              order_id: -1
            },
            available: true
          },
          third: {
            order_id: -1,
            order: {
              task_status: -1,
              order_id: -1
            },
            available: true
          },
          fourth: {
            order_id: -1,
            order: {
              task_status: -1,
              order_id: -1
            },
            available: true
          }
        };
      }
    }
    ;
  }
  ;
  function incrementDay(day) {
    if (day < 7) {
      day++;
    }
    return day;
  }
  ;
  function placeOrdersAndReservePlaceholders() {
    for (var time = 0; time < 24; time++) {
      for (var day = 1; day < 8; day++) {
        var dateOfDay = $scope.getDateOfDay(day);
        var ordersInHour = $scope.getOrdersInCurrentWeekByDateAndHour(dateOfDay, time);
        ordersInHour.forEach(function (order) {
          var done = false;
          // Add orders reaching from previous week
          angular.forEach($scope.orderWeekPlaceholderList[day][time], function (placeholder, placeholderIndex) {
            if (!done && order.is_part && order.part_number !== 1 && day === 1) {
              placeholder.order_id = order.order_id;
              placeholder.order = order;
              placeholder.available = false;
              done = true;
              if (order.is_part && order.part_number !== order.parts_count) {
                // Reserv next date if not last
                $scope.orderWeekPlaceholderList[incrementDay(day)][time][placeholderIndex].order_id = order.order_id;
                $scope.orderWeekPlaceholderList[incrementDay(day)][time][placeholderIndex].available = false;
              }
            }
          });

          // Is part, part_number !== 1
          angular.forEach($scope.orderWeekPlaceholderList[day][time], function (placeholder, placeholderIndex) {
            if (!done && order.is_part && order.part_number !== 1 && placeholder.order_id === order.order_id) {
              placeholder.order_id = order.order_id;
              placeholder.order = order;
              placeholder.available = false;
              done = true;
              if (order.is_part && order.part_number !== order.parts_count) {
                // Reserv next date if not last
                $scope.orderWeekPlaceholderList[incrementDay(day)][time][placeholderIndex].order_id = order.order_id;
                $scope.orderWeekPlaceholderList[incrementDay(day)][time][placeholderIndex].available = false;
              }
            }
          });
          angular.forEach($scope.orderWeekPlaceholderList[day][time], function (placeholder, placeholderIndex) {
            if (!done && placeholder.available && (order.is_part && order.part_number === 1 || !order.is_part)) {
              placeholder.order_id = order.order_id;
              placeholder.order = order;
              placeholder.available = false;
              done = true;
              if (order.is_part && order.part_number !== order.parts_count) {
                // Reserv next date if not last
                $scope.orderWeekPlaceholderList[incrementDay(day)][time][placeholderIndex].order_id = order.order_id;
                $scope.orderWeekPlaceholderList[incrementDay(day)][time][placeholderIndex].available = false;
              }
            }
          });
        });
      }
    }
  }
  ;
  function removePlaceholdersByKeys(placeholderList, keysToRemove) {
    if (!keysToRemove.length) return;
    angular.forEach(keysToRemove, function (placeholderKey) {
      delete placeholderList[placeholderKey];
    });
  }
  function cleanUnusedPlaceholders() {
    var keysToRemove = [];
    for (var time = 0; time < 24; time++) {
      for (var day = 1; day < 8; day++) {
        var nLeftoverPlaceholders = 0;
        angular.forEach($scope.orderWeekPlaceholderList[day][time], function (placeholder, placeholderKey) {
          if (placeholder.available) {
            keysToRemove.push(placeholderKey);
          } else keysToRemove = [];
        });
        removePlaceholdersByKeys($scope.orderWeekPlaceholderList[day][time], keysToRemove);
      }
    }
  }

  // Run on initialization
  function generateOrderWeekPlaceholderListAndPlaceOrders() {
    // Sets upp a 2Dim array for four placeholders.
    generateOrderWeekPlaceholderList();
    // Fills the 2Dim array with orders by placing part_num  = 1 orders
    // and single orders and reserving for upcoming orders the next day.
    placeOrdersAndReservePlaceholders();
    //Cleans leftover placeholders so week-time cells won't allways fill up the full height.
    cleanUnusedPlaceholders();
  }
  ;
  generateOrderWeekPlaceholderListAndPlaceOrders();
  function generateOrderDayList() {
    var date = $scope.viewDateRef;
    var y = date.getFullYear();
    var m = $scope.formatDateOrMonth(date.getMonth() + 1);
    var d = $scope.formatDateOrMonth(date.getDate());
    var dateString = y + '-' + m + '-' + d;
    var ordersDateReset = resetOrderPartTimesToInitial($scope.calendarOrders);
    $scope.ordersInDay = [];
    $scope.ordersInDay = $filter('filter')(ordersDateReset, {
      date_i: dateString
    }, true);
  }
  ;
  generateOrderDayList();

  // There are more orders than placeholders in week view.
  $scope.hasMoreOrdersInWeek = function (day, time) {
    var dateOfDay = $scope.getDateOfDay(day);
    var placeholdersAreFull = $scope.getOrdersInCurrentWeekByDateAndHour(dateOfDay, time).length > 4;
    return placeholdersAreFull;
  };
  $scope.hasMissingOrdersFromPrevDayInWeek = function (day, time) {
    var ordersInCurrentDateAndTime = $scope.orderWeekPlaceholderList[day][time]; // With placeholders
    var ordersInPrevDateAndTime = $scope.getOrdersInCurrentWeekByDateAndHour($scope.getDateOfDay(day - 1), time);
    var search = true;
    var found = true;
    angular.forEach(ordersInPrevDateAndTime, function (prevOrder) {
      if (search && !$.isEmptyObject(ordersInCurrentDateAndTime) && prevOrder.is_part) {
        found = false;
        angular.forEach(ordersInCurrentDateAndTime, function (currentOrder) {
          if (!found && prevOrder.order_id === currentOrder.order_id || prevOrder.is_part && prevOrder.part_number === prevOrder.parts_count) {
            // A placeholder comparison

            found = true;
          }
        });
        if (!found) {
          search = false;
        }
      }
    });
    var isMissing = !found;
    return isMissing;
  };

  // Color utility functions
  $scope.generateFirstColorClass = function (id) {
    return generalHelperService.generateFirstColorClass(id);
  };
  $scope.generateSecondColorClass = function (id) {
    return generalHelperService.generateSecondColorClass(id);
  };

  // listen for the event
  $scope.$on('updateCalendar', function (event) {
    generateOrderWeekPlaceholderListAndPlaceOrders();
    generateOrderDayList();
    if (!$scope.$$phase) {
      $scope.$apply();
    }
  });
}]);
'use strict';

controllers.controller('OrderMobileController', ['$scope', '$rootScope', function ($scope, $rootScope) {
  $scope.isMobileOrderSelected = false;
  $scope.pagination.take = 14;
  $scope.selectedVehicleDropLocationId = null;
  $scope.showMore = function () {
    $scope.pagination.take += 10;
    $rootScope.$broadcast('updateOrders');
  };
  $scope.$on('filterVehicleDropLocationFromMobile', function (event, vehicleDropLocationId) {
    $scope.filter.vehicleDropLocations = [vehicleDropLocationId];
    $rootScope.$broadcast('updateOrders');
  });
}]);
'use strict';

controllers.controller('PackageController', ['$uibModal', '$scope', '$rootScope', '$filter', 'packageFactory', '$translate', 'errorService', 'keyCodes', 'generalHelperService', function ($uibModal, $scope, $rootScope, $filter, packageFactory, $translate, errorService, keyCodes, generalHelperService) {
  // Wrap dateTimes in Object to enable two-way binding
  var dateTimeNow = moment().format("YYYY-MM-DD HH:mm");
  $scope.filterDates = {
    to: dateTimeNow,
    from: moment(dateTimeNow).subtract(1, 'weeks').format("YYYY-MM-DD HH:mm")
  };
  $scope.getChildTranslationKey = function (childLocationTypeId) {
    return generalHelperService.getKeyByValue(PackageTimeValueTypeEnum, childLocationTypeId);
  };
  $scope.timeValueTypes = [{
    id: PackageTimeValueTypeEnum.CREATED,
    tag: $scope.getChildTranslationKey(PackageTimeValueTypeEnum.CREATED)
  }, {
    id: PackageTimeValueTypeEnum.UPDATED,
    tag: $scope.getChildTranslationKey(PackageTimeValueTypeEnum.UPDATED)
  }, {
    id: PackageTimeValueTypeEnum.DELIVERED,
    tag: $scope.getChildTranslationKey(PackageTimeValueTypeEnum.DELIVERED)
  }];
  $scope.chosenTimeValueType = $scope.timeValueTypes[0];
  $scope.innerRange = 5;
  $scope.currentPage = 1;
  $scope.itemRangeBottom = 0;
  $scope.itemRange = 15;
  $scope.itemRangeTop = $scope.itemRange - 1;
  $scope.totalItems = 0;
  $scope.selectedAny = false;
  $scope.selectedAll = false;
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.hasMixedSelection = false;
  $scope.showInactive = false;
  $scope.searchString = '';
  $scope.keyCode = '';
  $scope.lastSortCol = 'package_created';
  $scope.sortCol = 'package_created';
  $scope.sortReverse = true;
  $scope.sortReverseFn = function () {
    if ($scope.lastSortCol === $scope.sortCol && !$scope.sortReverse) {
      $scope.sortReverse = true;
    } else {
      $scope.lastSortCol = $scope.sortCol;
      $scope.sortReverse = false;
    }
  };
  var selected = [];
  var fetching = false;
  $rootScope.reloadTable = $scope.reloadPackageTable = function () {
    if (fetching) {
      return;
    }

    //Make sure that if chosenTimeValueType is updated, sort field is as well. 
    if ($scope.isTimeFilterActive()) {
      var isSame = $scope.sortCol === $scope.lastSortCol;
      $scope.setActiveTimeFilter();
      if (isSame) {
        $scope.lastSortCol = $scope.sortCol;
      }
    }
    function handleResponse(response) {
      var data = response.data;
      $scope.packages = packageFactory.repackageDTOArray(data);
      $scope.totalItems = $scope.packages.length;
      fetching = false;
    }
    fetching = true;
    if ($scope.filterDates.from || $scope.filterDates.to) {
      packageFactory.getPackagesWithFilter({
        dateTimeFrom: $scope.filterDates.from ? $scope.filterDates.from : null,
        dateTimeTo: $scope.filterDates.to ? $scope.filterDates.to : null
      }, $scope.chosenTimeValueType.id, $scope.searchString).then(handleResponse, function (error) {
        errorService.handleError(error);
        fetching = false;
      });
    } else {
      packageFactory.getPackages().then(handleResponse, errorService.handleError);
    }
  };
  $scope.checkAll = function () {
    selected = [];
    var filtered = $filter('inactive')($scope.packages, $scope.showInactive);
    angular.forEach(filtered, function (p) {
      p.selected = $scope.selectedAll;
      if (p.selected) {
        selected.push(p);
      }
    });
    $scope.updateSelection();
  };
  $scope.unCheckAll = function () {
    selected = [];
    angular.forEach($scope.packages, function (p) {
      p.selected = false;
    });
    $scope.updateSelection();
  };
  $scope.updateSelection = function () {
    var oneActiveSelected = false;
    var oneInactiveSelected = false;
    $scope.selectedAny = false;
    selected = [];
    angular.forEach($scope.packages, function (p) {
      if (!$scope.selectedAny && p.selected) {
        $scope.selectedAny = true;
      }
      if (p.selected) {
        selected.push(p);
      }
      if (!oneActiveSelected && p.is_active && p.selected) {
        oneActiveSelected = true;
      }
      if (!oneInactiveSelected && !p.is_active && p.selected) {
        oneInactiveSelected = true;
      }
    });
    if (!$scope.selectedAny) {
      $scope.selectedAll = false;
    }

    // Mixed selection
    if (oneActiveSelected && oneInactiveSelected) {
      $scope.hasMixedSelection = true;
      $scope.hasActiveSelection = true;
      $scope.hasInactiveSelection = true;
    } else {
      $scope.hasMixedSelection = false;
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
    }

    //Active selction
    if (oneActiveSelected && !oneInactiveSelected) {
      $scope.hasActiveSelection = true;
    } else $scope.hasActiveSelection = false;

    //Inactive selction
    if (!oneActiveSelected && oneInactiveSelected) {
      $scope.hasInactiveSelection = true;
    } else $scope.hasInactiveSelection = false;
  };
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.searchString = $scope.pendingSearchString;
      $scope.updateFullTableRange('filter', $scope.packages, $scope.searchString);
    }
  };
  $scope.updateFullTableRange = function (filter, array, param) {
    var filtered = $filter(filter)(array, param);
    $scope.totalItems = filtered.length;
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.currentPage - 1) * $scope.itemRange;
  };

  // --- MODAL - CREATE ---
  var animationsEnabled = true;
  $scope.createPackage = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/package/package.html',
      controller: 'PackageInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create_package';
        },
        id: function id() {
          return -1;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };

  // --- MODAL - VIEW PACKAGE ---
  $scope.viewPackage = function (_id) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/package/package.html',
      controller: 'PackageInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view_package';
        },
        id: function id() {
          return _id;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };
  $scope.setActiveTimeFilter = function () {
    switch ($scope.chosenTimeValueType.id) {
      case PackageTimeValueTypeEnum.DELIVERED:
        $scope.sortCol = 'package_delivered';
        break;
      case PackageTimeValueTypeEnum.UPDATED:
        $scope.sortCol = 'package_updated';
        break;
      default:
        $scope.sortCol = 'package_created';
        break;
    }
  };
  $scope.isTimeFilterActive = function () {
    switch ($scope.sortCol) {
      case 'package_delivered':
      case 'package_updated':
      case 'package_created':
        return true;
      default:
        return false;
    }
  };
  $scope.filterByDate = function () {
    $rootScope.reloadTable();
  };
  $rootScope.reloadTable();
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('PackageInstanceController', ['$uibModalInstance', 'form_type', 'id', '$scope', '$rootScope', 'packageFactory', 'projectFactory', 'inputValidationService', 'errorService', function ($uibModalInstance, form_type, id, $scope, $rootScope, packageFactory, projectFactory, inputValidationService, errorService) {
  $scope.validated = false;
  $scope.form_type = form_type;
  $scope.package_name = '';
  $scope.system_package_name = '';
  $scope.project_id = -1;
  $scope.project_name = '';
  $scope.location = '';
  $scope.comments = '';
  if (form_type === 'view_package') {
    packageFactory.getPackage(id).then(function (response) {
      var data = response.data;
      $scope.package_id = id;
      $scope.package_name = data.Name;
      $scope.system_package_name = data.SystemName;
      $scope.project_id = data.ProjectId;
      $scope.project_name = data.ProjectName;
      $scope.package_location = data.Location;
      $scope.is_active = data.IsActive;
      $scope.comments = data.Comments;
    }, function (error) {
      errorService.handleError(error);
    });
  }

  // Finalizing or exiting form
  $scope.create = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = {
      "Name": $scope.package_name,
      "SystemName": $scope.system_package_name,
      "Location": $scope.package_location,
      "ProjectId": $scope.project_id,
      "ProjectName": $scope.project_name,
      "IsActive": true,
      "Comments": $scope.comments
    };
    packageFactory.createPackage(DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close("Package created"); // Pass in returned item here.
  };

  $scope.update = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = {
      "PackageId": $scope.package_id,
      "Name": $scope.package_name,
      "SystemName": $scope.system_package_name,
      "Location": $scope.package_location,
      "ProjectId": $scope.project_id,
      "ProjectName": $scope.project_name,
      "IsActive": $scope.is_active,
      "Comments": $scope.comments
    };
    packageFactory.updatePackage(DTO.PackageId, DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(results); // Pass in returned item here.
  };

  $scope.delete = function () {
    var DTO = {
      "PackageId": $scope.package_id
    };
    packageFactory.updatePackage(DTO.PackageId, DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(results); // Pass in returned item here.
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  $scope.validateForm = function () {
    $scope.formValid = false;
    return $scope.formValid;
  };
}]);
'use strict';

controllers.controller('PackageCollectionController', ['$uibModal', '$scope', '$rootScope', '$filter', 'errorService', 'orderFactory', 'orderPackageCollectionFactory', 'packageFactory', 'taskStatusService', '$localStorage', 'roleService', 'keyCodes', 'generalHelperService', function ($uibModal, $scope, $rootScope, $filter, errorService, orderFactory, orderPackageCollectionFactory, packageFactory, taskStatusService, $localStorage, roleService, keyCodes, generalHelperService) {
  orderFactory.getGuid().then(function (response) {
    $scope.formGuid = response.data;
  });
  $scope.showSpecificPackageCollection = false;
  $scope.innerRange = 5;
  $scope.currentPage = 1;
  $scope.itemRangeBottom = 0;
  $scope.itemRange = 15;
  $scope.itemRangeTop = $scope.itemRange - 1;
  $scope.selectedAny = false;
  $scope.selectedAll = false;
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.hasMixedSelection = false;
  $scope.showInactive = false;
  $scope.searchString = '';
  $scope.keyCode = '';
  $scope.lastSortCol = 'valid_to';
  $scope.sortCol = 'valid_to';
  $scope.sortReverse = false; // Show the collection orders that are closest to needing renewal first.

  $scope.isAdmin = roleService.isInternal();
  $scope.isServicenter = roleService.isInternal();
  $scope.isInternal = roleService.isInternal();
  var dateTimeNow = moment().format("YYYY-MM-DD HH:mm");
  $scope.filterDates = {
    to: dateTimeNow,
    from: moment(dateTimeNow).subtract(1, 'weeks').format("YYYY-MM-DD HH:mm")
  };
  $scope.getChildTranslationKey = function (childLocationTypeId) {
    return generalHelperService.getKeyByValue(PackageTimeValueTypeEnum, childLocationTypeId);
  };
  $scope.timeValueTypes = [{
    id: PackageTimeValueTypeEnum.CREATED,
    tag: $scope.getChildTranslationKey(PackageTimeValueTypeEnum.CREATED)
  }, {
    id: PackageTimeValueTypeEnum.UPDATED,
    tag: $scope.getChildTranslationKey(PackageTimeValueTypeEnum.UPDATED)
  }, {
    id: PackageTimeValueTypeEnum.DELIVERED,
    tag: $scope.getChildTranslationKey(PackageTimeValueTypeEnum.DELIVERED)
  }];
  $scope.chosenTimeValueType = $scope.timeValueTypes[0];
  $scope.sortReverseFn = function () {
    if ($scope.lastSortCol === $scope.sortCol && !$scope.sortReverse) {
      $scope.sortReverse = true;
    } else {
      $scope.lastSortCol = $scope.sortCol;
      $scope.sortReverse = false;
    }
  };
  var selected = [];
  $rootScope.reloadTable = function (reloadPackageCollectionPackageTable) {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    $scope.selectedAll = false;
    $scope.selectedAny = false;
    orderFactory.getPackageCollections(sessionMainProject.main_project_id, $scope.searchString, {
      dateTimeFrom: $scope.filterDates.from ? $scope.filterDates.from : null,
      dateTimeTo: $scope.filterDates.to ? $scope.filterDates.to : null
    }, $scope.chosenTimeValueType.id).then(function (response) {
      var data = response.data;
      $scope.package_collections = orderPackageCollectionFactory.repackageDTOArray(data);
      $scope.totalItems = $scope.package_collections.length;
      if (reloadPackageCollectionPackageTable) {
        reloadPackageCollectionPackageTable($scope.package_collections);
      }
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $rootScope.reloadTable();
  $scope.checkAll = function () {
    if (!$scope.selectedAll) {
      $scope.unCheckAll();
      return;
    }
    var filtered = getVisibleItems($scope.package_collections);
    angular.forEach(filtered, function (p) {
      p.selected = true;
    });
    $scope.updateSelection();
  };
  $scope.unCheckAll = function () {
    angular.forEach($scope.package_collections, function (p) {
      p.selected = false;
    });
    $scope.updateSelection();
  };
  $scope.updateSelection = function () {
    var oneActiveSelected = false;
    var oneInactiveSelected = false;
    var filtered = getVisibleItems($scope.package_collections);
    $scope.selectedAny = false;
    selected = [];
    angular.forEach(filtered, function (p) {
      if (!$scope.selectedAny && p.selected) {
        $scope.selectedAny = true;
      }
      if (p.selected) {
        selected.push(p);
      }
      if (!oneActiveSelected && !$scope.isCancelled(p.task_status) && p.selected) {
        oneActiveSelected = true;
      }
      if (!oneInactiveSelected && $scope.isCancelled(p.task_status) && p.selected) {
        oneInactiveSelected = true;
      }
    });
    if (!$scope.selectedAny) {
      $scope.selectedAll = false;
    }

    // Mixed selection
    if (oneActiveSelected && oneInactiveSelected) {
      $scope.hasMixedSelection = true;
      $scope.hasActiveSelection = true;
      $scope.hasInactiveSelection = true;
    } else {
      $scope.hasMixedSelection = false;
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
    }

    //Active selction
    if (oneActiveSelected && !oneInactiveSelected) {
      $scope.hasActiveSelection = true;
    } else $scope.hasActiveSelection = false;

    //Inactive selction
    if (!oneActiveSelected && oneInactiveSelected) {
      $scope.hasInactiveSelection = true;
    } else $scope.hasInactiveSelection = false;
  };
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.searchString = $scope.pendingSearchString;
      $scope.updateFullTableRange();
    }
  };
  $scope.updateFullTableRange = function () {
    $scope.updateSelection();
    var filtered = getVisibleItems($scope.package_collections);
    $scope.totalItems = filtered.length;
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.currentPage - 1) * $scope.itemRange;
  };
  $scope.searchForPackageCollections = function () {
    $rootScope.reloadTable();
  };
  function getVisibleItems(array) {
    var filtered = array;
    if (!$scope.showDelivered) {
      filtered = $filter('filter')(filtered, {
        task_status: '!' + TaskStatusTypeEnum.DELIVERED
      }, true);
    }
    if (!$scope.showCancelled) {
      filtered = $filter('filter')(filtered, {
        task_status: '!' + TaskStatusTypeEnum.CANCELLED
      }, true);
    }
    if ($scope.searchString) {
      filtered = $filter('filter')(filtered, $scope.searchString);
    }
    return filtered;
  }

  // --- MODAL - CREATE ---
  $scope.createPackageCollection = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/package_collection/package_collection_form.html',
      controller: 'PackageCollectionFormController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create_package_collection';
        },
        packageCollectionOrder: function packageCollectionOrder() {
          return {};
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };
  $scope.activatePackageCollections = function (isActive) {
    selected.forEach(function (data) {
      var orderDTO = orderPackageCollectionFactory.createOrderDTO(data);
      if (isActive) {
        orderFactory.reactivatePackageCollectionOrder(data.order_id, orderDTO).then(function () {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      } else {
        orderFactory.cancelOrder(data.order_id, orderDTO).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      }
    });
  };
  $scope.reloadPackageTable = function () {
    $rootScope.reloadTable(function (packageCollections) {
      angular.forEach(packageCollections, function (p) {
        if (p.order_number + '. ' + p.work_order_name == $scope.currentPackageCollectionName) {
          $scope.openSpecificPackageCollection($scope.currentPackageCollectionName, p);
        }
      });
    });
  };
  $scope.openSpecificPackageCollection = function (name, packageCollection) {
    $scope.lastSortCol = 'package_created';
    $scope.sortCol = 'package_created';
    $scope.sortReverse = true; // Show the newest packages first
    $scope.currentPackageCollectionName = name;
    $scope.currentPackageCollectionOrderId = packageCollection.order_id;
    $scope.showSpecificPackageCollection = true;
    $scope.getPackagesWithPackageCollectionOrderId();
  };
  $scope.getPackagesWithPackageCollectionOrderId = function () {
    //Make sure that if chosenTimeValueType is updated, sort field is as well. 
    if ($scope.isTimeFilterActive()) {
      var isSame = $scope.sortCol === $scope.lastSortCol;
      $scope.setActiveTimeFilter();
      if (isSame) {
        $scope.lastSortCol = $scope.sortCol;
      }
    }
    function handleResponse(response) {
      var data = response.data;
      $scope.packages = packageFactory.repackageDTOArray(data);
      $scope.totalPackages = $scope.packages.length;
    }
    ;
    packageFactory.getPackagesWithFilter({
      dateTimeFrom: $scope.filterDates.from ? $scope.filterDates.from : null,
      dateTimeTo: $scope.filterDates.to ? $scope.filterDates.to : null
    }, $scope.chosenTimeValueType.id, $scope.searchString, $scope.currentPackageCollectionOrderId).then(handleResponse, function (error) {
      errorService.handleError(error);
    });
  };
  $scope.filterByDate = function () {
    $scope.getPackagesWithPackageCollectionOrderId();
  };
  $scope.closeSpecificPackageCollection = function () {
    $scope.lastSortCol = 'valid_to';
    $scope.sortCol = 'valid_to';
    $scope.sortReverse = false; // Show the collection orders that are closest to needing renewal first.
    $scope.packages = [];
    $scope.currentPackageCollectionName = '';
    $scope.showSpecificPackageCollection = false;
    $scope.totalPackages = 0;
    $scope.totalItems = $scope.package_collections.length;
  };
  $scope.isConfirmedOrLater = function (task_status) {
    return taskStatusService.isConfirmedOrLater(task_status);
  };
  $scope.isConfirmed = function (task_status) {
    return taskStatusService.isConfirmed(task_status);
  };
  $scope.isNotified = function (task_status) {
    return taskStatusService.isNotified(task_status);
  };
  $scope.isCancelled = function (task_status) {
    return taskStatusService.isCancelled(task_status);
  };
  $scope.isDelivered = function (task_status) {
    return taskStatusService.isDelivered(task_status);
  };

  // --- MODAL - VIEW PackageCollection ---
  $scope.viewPackageCollection = function (packageCollection) {
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/package_collection/package_collection_form.html',
      controller: 'PackageCollectionFormController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view_package_collection';
        },
        packageCollectionOrder: function packageCollectionOrder() {
          return packageCollection;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };
  $scope.setActiveTimeFilter = function () {
    switch ($scope.chosenTimeValueType.id) {
      case PackageTimeValueTypeEnum.DELIVERED:
        $scope.sortCol = 'package_delivered';
        break;
      case PackageTimeValueTypeEnum.UPDATED:
        $scope.sortCol = 'package_updated';
        break;
      default:
        $scope.sortCol = 'package_created';
        break;
    }
  };
  $scope.isTimeFilterActive = function () {
    switch ($scope.sortCol) {
      case 'package_delivered':
      case 'package_updated':
      case 'package_created':
        return true;
      default:
        return false;
    }
  };
  $scope.$on('packageCollectionsRepeatFinished', function (packageCollectionsRepeatFinishedEvent) {
    $scope.updateFullTableRange();
  });
  $scope.$on('updatedUserData', function (event) {
    $rootScope.reloadTable();
  });
  $rootScope.reloadTable();
}]);
'use strict';

app.controller('PackageCollectionFormController', ['$uibModalInstance', 'form_type', 'packageCollectionOrder', '$scope', '$rootScope', 'errorService', 'dropdownService', 'orderFactory', 'inputValidationService', 'companyFactory', 'roleService', 'workOrderFactory', 'orderPackageCollectionFactory', 'taskStatusService', '$localStorage', '$filter', 'ngToast', function ($uibModalInstance, form_type, packageCollectionOrder, $scope, $rootScope, errorService, dropdownService, orderFactory, inputValidationService, companyFactory, roleService, workOrderFactory, orderPackageCollectionFactory, taskStatusService, $localStorage, $filter, ngToast) {
  $scope.form_type = form_type;
  $scope.isAdmin = roleService.isAdmin();
  $scope.isInternal = roleService.isInternal();
  $scope.order = packageCollectionOrder;
  $scope.loadBase = function (workOrder, clear, buildDestinationLocationPath) {
    if (clear) {
      clearForm();
    }
    $scope.order.work_order_display_name = workOrder.work_order_display_name;
    $scope.order.work_order_id = workOrder.work_order_id;
    var id = workOrder.work_order_id;
    $scope.order.specified_street_address = typeof $scope.order.address !== 'undefined' && $scope.order.address != null;
    $scope.default_address_in_use = $scope.order.specified_street_address || typeof $scope.order.location_id !== 'undefined' && $scope.order.location_id != null || typeof $scope.order.vehicle_drop_location_id !== 'undefined' && $scope.order.vehicle_drop_location_id != null;
    orderFactory.getTransshipmentFormBase(id).then(function (response) {
      var data = response.data;
      $scope.order.vehicle_drop_locations = data.VehicleDropLocations;
      $scope.destinationLocations = data.DestinationLocations;
      $scope.destinationLocationPath = [];
      var depth = findTreeDepth($scope.destinationLocations);
      fillDestinationLocationPath($scope.destinationLocationPath, depth);
      if (buildDestinationLocationPath) {
        buildPath($scope.order.location_id);
      }
    }, function (error) {
      errorService.handleError(error);
    });
  };
  var sessionMainProject = $localStorage.user.session_main_project;
  if (!sessionMainProject) $uibModalInstance.dismiss('cancel');

  // Form setup.
  if (form_type === 'create_package_collection') {
    if ($scope.isInternal) {
      loadCompanies();
    }
  } else if (form_type === 'view_package_collection' || form_type === 'manage_package_collection') {
    var loadFormBaseOrder = {
      work_order_id: $scope.order.work_order_id,
      work_order_display_name: $scope.order.work_order_display_name,
      company_id: $scope.order.company_id,
      company_name: $scope.order.company_name
    };
    $scope.loadBase(loadFormBaseOrder, false, true);
  }
  function loadCompanies() {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) {
      errorService.handleError('No session main project');
      return;
    }
    companyFactory.getCompanies(false, sessionMainProject.division_id).then(function (response) {
      var data = response.data;
      $scope.companies = companyFactory.repackageCompanyDTOArray(data);
    }, function (error) {
      errorService.handleError(error);
    });
  }
  function loadWorkOrdersByCompany(companyId) {
    $scope.work_orders = [];
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) {
      errorService.handleError('No session main project');
      return;
    }
    workOrderFactory.getWorkOrdersByCompanyId(companyId, sessionMainProject.main_project_id).then(function (response) {
      var workOrderDTOArray = response.data;
      $scope.work_orders = workOrderFactory.repackageWorkOrderDTOArray(workOrderDTOArray);
    }, function (error) {
      errorService.handleError(error);
    });
  }
  ;
  function clearWorkOrder() {
    $scope.order.work_order_display_name = '';
    $scope.order.work_order_id = -1;
  }
  ;
  $scope.setBaseCompany = function (company) {
    clearWorkOrder();
    $scope.order.company_name = company.company_name;
    $scope.order.company_id = company.company_id; // Not really needed, since it is not sent to backend.
    loadWorkOrdersByCompany(company.company_id);
  };

  // Finalizing or exiting form
  $scope.create = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var finalDestination = getDestination();
    $scope.order.location_id = finalDestination.location_id;
    $scope.order.location_name = finalDestination.location_name;
    var DTO = orderPackageCollectionFactory.createOrderDTO($scope.order);
    orderFactory.createOrder(DTO, null, $scope.formGuid).then(function (response) {
      $rootScope.reloadTable();
      $uibModalInstance.close();
    }, function (error) {
      if (error.status === 409) {
        ngToast.warning("Kunde inte spara formuläret, ordern finns redan.");
      } else {
        ngToast.danger("Det gick inte att spara formuläret.");
      }
      errorService.handleError(error);
    });
  };
  $scope.activation = function (isActive) {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    if (isActive) {
      // TODO: Cannot activate this order type.
    } else {
      var DTO = orderPackageCollectionFactory.createOrderDTO($scope.order);
      orderFactory.cancelOrder($scope.order.order_id, DTO).then(function (response) {
        $rootScope.reloadTable();
        $uibModalInstance.close();
      }, function (error) {
        errorService.handleError(error);
      });
    }
  };
  $scope.update = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var finalDestination = getDestination();
    $scope.order.location_id = finalDestination.location_id;
    $scope.order.location_name = finalDestination.location_name;
    var DTO = orderPackageCollectionFactory.createOrderDTO($scope.order);
    orderFactory.updateOrder($scope.order.order_id, DTO).then(function (response) {
      $rootScope.reloadTable();
      $uibModalInstance.close();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  $scope.isValidDate = function (input) {
    return inputValidationService.isValidDate(input);
  };
  $scope.isConfirmedOrLater = function (task_status) {
    return taskStatusService.isConfirmedOrLater(task_status);
  };
  $scope.isCancelled = function (task_status) {
    return taskStatusService.isCancelled(task_status);
  };
  $scope.validateForm = function () {
    var selectedDestination = getDestination();
    var baseIsValid = inputValidationService.isValidInput($scope.order.package_collection_name) && inputValidationService.isValidDate($scope.order.valid_from) && inputValidationService.isValidDate($scope.order.valid_to);
    var destinationIsValid = inputValidationService.isValidInput(selectedDestination) && inputValidationService.isValidInput(selectedDestination.location_name) && inputValidationService.isValidInput(selectedDestination.is_scannable) && selectedDestination.is_scannable !== false;
    var destinationIsEmptyButVehicleDropLocationIsValid = selectedDestination.location_id === null && selectedDestination.location_name === null && inputValidationService.isValidInput($scope.order.vehicle_drop_location_id) && inputValidationService.isValidInput($scope.order.vehicle_drop_location_name);
    var locationIsValidOrIrrelevant = !$scope.default_address_in_use || $scope.order.specified_street_address || destinationIsValid || destinationIsEmptyButVehicleDropLocationIsValid;
    var streetAddressIsValidOrIrrelevant = !$scope.default_address_in_use || !$scope.order.specified_street_address || inputValidationService.isValidInput($scope.order.address) && inputValidationService.isValidInput($scope.order.zip_code) && inputValidationService.isValidInput($scope.order.city);
    $scope.formValid = baseIsValid && locationIsValidOrIrrelevant && streetAddressIsValidOrIrrelevant;
    return $scope.formValid;
  };
  $scope.initDateTimeEvents = function () {
    // Init date time picker
    $('#package-collection-datetimepicker1').datetimepicker({
      format: 'YYYY-MM-DD',
      locale: 'sv'
    });
    $('#package-collection-datetimepicker1').data().DateTimePicker.stepping(15);
    $('#package-collection-datetimepicker2').datetimepicker({
      format: 'YYYY-MM-DD',
      locale: 'sv'
    });
    $('#package-collection-datetimepicker2').data().DateTimePicker.stepping(15);
    $('#package-collection-datetimepicker1').on('dp.change', function (ev) {
      $scope.order.valid_from = $('#valid_from').val();
      if (!$scope.$$phase) {
        $scope.$apply(); //$digest or $apply
      }
    });

    $('#package-collection-datetimepicker2').on('dp.change', function (ev) {
      $scope.order.valid_to = $('#valid_to').val();
      if (!$scope.$$phase) {
        $scope.$apply(); //$digest or $apply
      }
    });
  };

  $scope.openDropdown = dropdownService.openDropdown;
  function clearForm() {
    $scope.order.specified_street_address = false;
    $scope.validated = false;
  }
  $scope.toggleDestinationInformation = function (specifiedAddress, editable) {
    if (!editable) return;
    if (specifiedAddress) {
      delete $scope.order.vehicle_drop_location_id;
      delete $scope.order.vehicle_drop_location_name;
      clearChildNodes(0);
    } else {
      delete $scope.order.address;
      delete $scope.order.city;
      delete $scope.order.zip_code;
    }
  };
  $scope.setVehicleDropLocation = function (dropLocation) {
    $scope.order.vehicle_drop_location_name = dropLocation.Name;
    $scope.order.vehicle_drop_location_id = dropLocation.LocationId;
    $scope.order.filterByProjectId = dropLocation.ProjectId;
    clearChildNodes(0);
  };

  // Destination functions START ---
  function buildPath(locationId) {
    // find base
    var currentBase;
    angular.forEach($scope.destinationLocations, function (loc) {
      if (loc.LocationId === locationId) {
        currentBase = loc;
      }
    });
    if (typeof currentBase === 'undefined') return;

    // Set Dropdown
    $scope.destinationLocationPath[currentBase.Level - 2] = {
      level: currentBase.Level,
      location_id: currentBase.LocationId,
      location_name: currentBase.Name,
      is_scannable: currentBase.IsScannable,
      is_destination: true
    };
    do {
      // find parent
      var parent;
      angular.forEach($scope.destinationLocations, function (loc) {
        if (loc.LocationId === currentBase.ParentLocationId) {
          parent = loc;
        }
      });
      var prevBase = currentBase;
      currentBase = parent;

      // Set dropdown
      if (typeof currentBase !== 'undefined') {
        $scope.destinationLocationPath[currentBase.Level - 2] = {
          level: currentBase.Level,
          location_id: currentBase.LocationId,
          location_name: currentBase.Name,
          is_scannable: currentBase.IsScannable
        };
      }
    } while (typeof currentBase !== 'undefined' && currentBase.Level !== prevBase.Level);
  }
  function findTreeDepth(destinationLocations) {
    var depth = 0;
    angular.forEach(destinationLocations, function (location) {
      if (location.Level > depth) {
        depth = location.Level;
      }
    });
    return depth;
  }
  function fillDestinationLocationPath(destinationLocationPath, depth) {
    for (var i = 0; i < depth; i++) {
      destinationLocationPath.push({
        level: i + 1,
        location_name: '',
        is_destination: false
      });
    }
  }
  function clearChildNodes(level) {
    angular.forEach($scope.destinationLocationPath, function (loc) {
      if (loc.level > level) {
        loc.location_name = '';
        delete loc.location_id;
        delete loc.is_destination;
        delete loc.is_scannable;
      }
    });
    clearDestinations();
  }
  $scope.parentHasChildren = function (parent) {
    if (typeof parent === 'undefined') return true;
    var hasChildren = false;
    angular.forEach($scope.destinationLocations, function (loc) {
      if (loc.ParentLocationId === parent.location_id || loc.ParentLocationId === parent.LocationId) {
        hasChildren = true;
      }
    });
    return hasChildren;
  };
  function clearDestinations() {
    angular.forEach($scope.destinationLocationPath, function (path) {
      path.is_destination = false;
    });
  }
  function getDestination() {
    var outPath = null;
    angular.forEach($scope.destinationLocationPath, function (path) {
      if (path.is_destination) {
        outPath = path;
      }
    });
    return outPath ? outPath : {
      location_id: null,
      location_name: null
    };
  }
  $scope.updatePath = function (path, location) {
    path.location_name = location.Name;
    path.location_id = location.LocationId;
    path.is_scannable = location.IsScannable;
    clearChildNodes(path.level);
    clearDestinations();
    path.is_destination = true;
  };
  $scope.checkDestination = function (path, disabled) {
    if (disabled) return;
    clearChildNodes(path.level);
    clearDestinations();
    path.is_destination = true;
  };

  // Destination END ---
}]);
controllers.controller('LoadingListInstanceController', ['$uibModalInstance', '$scope', 'delivery', 'generalHelperService', function ($uibModalInstance, $scope, delivery, generalHelperService) {
  $scope.delivery = delivery;
  $scope.delivery_orders = [];
  (function loadDeliveryOrders() {
    angular.forEach($scope.delivery.delivery_locations, function (deliveryLocation) {
      angular.forEach(deliveryLocation.orders, function (order) {
        $scope.delivery_orders.push(order);
      });
    });
  })();
  $scope.calculateItemCount = function () {
    var totalCount = 0;
    angular.forEach($scope.delivery_orders, function (order) {
      totalCount += order.total_count;
    });
    return totalCount;
  };
  $scope.calculateTotalWeight = function () {
    var weight = 0;
    angular.forEach($scope.delivery_orders, function (order) {
      weight += order.total_weight;
    });
    return weight;
  };
  $scope.calculateOrderWeight = function (order) {
    return generalHelperService.calculateOrderWeight(order);
  };
  $scope.printDiv = function (divId) {
    generalHelperService.printDiv(divId);
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}]);
'use strict';

controllers.controller('PlannerController', ['$uibModal', '$scope', '$rootScope', '$filter', 'orderFactory', '$translate', '$localStorage', 'routeFactory', 'deliveryFactory', 'vehicleFactory', 'generalHelperService', 'errorService', 'taskStatusService', 'roleService', 'inputValidationService', 'orderFormModalService', function ($uibModal, $scope, $rootScope, $filter, orderFactory, $translate, $localStorage, routeFactory, deliveryFactory, vehicleFactory, generalHelperService, errorService, taskStatusService, roleService, inputValidationService, orderFormModalService) {
  $scope.isDisabled = !$localStorage.user.session_main_project.is_plan_transport_function_enabled;
  $scope.planForDate = generalHelperService.dateToDateString(new Date());
  $scope.currentShipping = null;
  $scope.statusPlanning = DeliveryStatusTypeEnum.PLANNING;
  $scope.innerRange = 5;
  $scope.currentPage = 1;
  $scope.itemRange = 6;
  $scope.itemRangeBottom = 0;
  $scope.itemRangeTop = $scope.itemRange - 1;
  $scope.selectedAny = false;
  $scope.selectedAll = false;
  $scope.hasMixedSelection = false;
  $scope.selected = [];
  $scope.includeAllStatuses = false;
  $scope.isPlanForDateChecked = false;
  $scope.routes = [];
  $scope.identifyRoles = function () {
    $scope.isAdmin = roleService.isAdmin();
    $scope.isServicenter = roleService.isServicenter();
    $scope.isProjectOwner = roleService.isProjectOwner();
    $scope.isWarehousePlanner = roleService.isWarehousePlanner();
    $scope.isWarehouseOperator = roleService.isWarehouseOperator();
    $scope.isCustomer = roleService.isCustomer();
  };
  $scope.identifyRoles();
  $scope.reloadUnDelivered = function () {
    $scope.selectedAll = false;
    $scope.selectedAny = false;
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    $scope.totalItems = 0;
    orderFactory.getUndeliveredOrders(sessionMainProject.main_project_id, $scope.includeAllStatuses).then(function (response) {
      var orderDtoArray = response.data;
      $scope.orders = orderFactory.repackageDTOArray(orderDtoArray);
      $scope.orders = $filter('orderBy')($scope.orders, 'time_i', false);
      $scope.orders = $filter('orderBy')($scope.orders, 'date_i', false);
      $scope.totalItems = $scope.orders.length;
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $rootScope.reloadTable = function () {
    $scope.reloadPlannerTablesAndLists();
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.currentPage - 1) * $scope.itemRange;
  };

  // Load routes
  $scope.reloadRoutes = function () {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    routeFactory.getRouteTemplatesByMainProjectId(false, sessionMainProject.main_project_id).then(function (response) {
      var routeTemplateDtos = response.data;
      $scope.routeTemplates = routeFactory.repackageDTOArray(routeTemplateDtos);
      $scope.updateRouteList();
    }, function (error) {
      errorService.handleError(error);
    });
  };

  // Load deliveries
  $scope.reloadDeliveries = function () {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    deliveryFactory.getDeliveriesByDate($scope.planForDate, sessionMainProject.main_project_id).then(function (response) {
      var deliveryDtos = response.data;
      $scope.deliveries = [];
      $scope.route_deliveries = [];
      $scope.transport_deliveries = [];
      angular.forEach(deliveryDtos, function (deliveryDTO) {
        var delivery = deliveryFactory.repackageDTO(deliveryDTO);
        $scope.deliveries.push(delivery);
        if (deliveryDTO.DeliveryTypeId === DeliveryTypeEnum.ROUTE_DELIVERY) {
          $scope.route_deliveries.push(delivery);
        } else if (deliveryDTO.DeliveryTypeId === DeliveryTypeEnum.INTERNAL_TRANSPORT_DELIVERY || deliveryDTO.DeliveryTypeId === DeliveryTypeEnum.EXTERNAL_TRANSPORT_DELIVERY) {
          $scope.transport_deliveries.push(delivery);
        }
      });
      $scope.route_deliveries = $filter('orderBy')($scope.route_deliveries, 'delivery_status_type_id');
      $scope.transport_deliveries = $filter('orderBy')($scope.transport_deliveries, 'delivery_status_type_id');
      $scope.updateRouteList();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $scope.reloadPlannerTablesAndLists = function () {
    $scope.reloadUnDelivered();
    $scope.reloadDeliveries();
    $scope.reloadRoutes();
    if (!$scope.$$phase) {
      $scope.$apply();
    }
  };
  $scope.reloadPlannerTablesAndLists();
  $scope.updateRouteList = function () {
    var routeDeliveriesForDate = $filter('filter')($scope.route_deliveries, {
      delivery_date: $scope.planForDate
    });
    var deliveriesInPlanning = $filter('filter')(routeDeliveriesForDate, {
      delivery_status_type_id: DeliveryStatusTypeEnum.PLANNING
    }, true); // Filter orders deliveries not in planning state.

    $scope.routes = $scope.routeTemplates ? $scope.routeTemplates.concat(deliveriesInPlanning) : $scope.routeTemplates;
    $scope.routes = $filter('orderBy')($scope.routes, 'is_template', false);
  };

  // Load vehicles
  vehicleFactory.getVehicles(false).then(function (response) {
    var data = response.data;
    $scope.vehicles = vehicleFactory.repackageDTOArray(data);
  }, function (error) {
    errorService.handleError(error);
  });

  // Routes
  $scope.createRoute = function () {
    $scope.checkPlanForDate();
    if (!$scope.isPlanForDateSet) {
      return;
    }
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/planner/route_delivery.html',
      controller: 'SpecifyRouteInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        newRoute: function newRoute() {
          return true;
        },
        delivery: function delivery() {
          return {};
        },
        hasTime: function hasTime() {
          return false;
        },
        hasVehicle: function hasVehicle() {
          return false;
        },
        vehicles: function vehicles() {
          return $scope.vehicles;
        }
      }
    });
    modalInstance.result.then(function (delivery) {
      $scope.assignToNewRoute(delivery);
    });
  };
  $scope.assignToNewRoute = function (delivery) {
    var timeType = 0;
    if (typeof delivery.time !== 'undefined' && delivery.time !== '') {
      timeType = DeliveryTimeTypeEnum.SPECIFIC;
    } else if (typeof delivery.forenoon !== 'undefined' && delivery.forenoon) {
      timeType = DeliveryTimeTypeEnum.FORENOON;
    } else if (typeof delivery.afternoon !== 'undefined' && delivery.afternoon) {
      timeType = DeliveryTimeTypeEnum.AFTERNOON;
    }
    var orderIds = [];
    angular.forEach($scope.selected, function (order) {
      orderIds.push(order.order_id);
    });
    var deliveryDate = $scope.planForDate;
    var routeDTO = {
      "Name": delivery.route_name,
      "Time": delivery.time,
      "VehicleId": delivery.vehicle_id,
      "DeliveryTimeTypeId": timeType,
      "IsActive": true
    };
    var assignOrdersToNewRouteDeliveryDTO = {
      'OrderIds': orderIds,
      'DeliveryDate': deliveryDate,
      'Route': routeDTO
    };

    // Assigning first by creating new route
    deliveryFactory.assignOrdersToNewRoute(assignOrdersToNewRouteDeliveryDTO).then(function (response) {
      $scope.reloadPlannerTablesAndLists();
      $scope.uncheckAll();
    });
  };
  $scope.assignToRoute = function (route, isDisabled) {
    $scope.showShippingError = isDisabled;
    $scope.checkPlanForDate();
    if (!$scope.isPlanForDateSet || isDisabled) {
      return;
    }
    var deliveryDate = $scope.planForDate;
    var orderIds = [];
    angular.forEach($scope.selected, function (order) {
      orderIds.push(order.order_id);
    });

    // If template then create clone
    if (route.is_template) {
      // TODO: Modifying the input object, may cause problems for caller?
      route.is_template = false;
      route.source_template_id = route.route_id;
      delete route.route_id;
      var clonedRouteDTO = routeFactory.createDTO(route);
      routeFactory.createRoute(clonedRouteDTO).then(function (response) {
        var routeDTO = response.data;
        var assignOrdersToRouteDeliveryDTO = {
          'OrderIds': orderIds,
          'RouteId': routeDTO.RouteId,
          'DeliveryDate': deliveryDate
        };

        // Assign to created route
        deliveryFactory.assignOrdersToRoute(assignOrdersToRouteDeliveryDTO).then(function (response) {
          $scope.reloadPlannerTablesAndLists();
        }, function (error) {
          errorService.handleError(error);
        });
      }, function (error) {
        errorService.handleError(error);
      });
    } else {
      var routeId = route.route_id;
      var assignOrdersToRouteDeliveryDTO = {
        'OrderIds': orderIds,
        'RouteId': routeId,
        'DeliveryDate': deliveryDate
      };
      deliveryFactory.assignOrdersToRoute(assignOrdersToRouteDeliveryDTO).then(function (response) {
        $scope.reloadPlannerTablesAndLists();
      }, function (error) {
        errorService.handleError(error);
      });
    }
    $scope.uncheckAll();
  };
  $scope.updateRouteDelivery = function (_delivery) {
    if (!$scope.isDeliveryStatusPlanning(_delivery.delivery_status_type_id)) return;
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/planner/route_delivery.html',
      controller: 'SpecifyRouteInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        newRoute: function newRoute() {
          return false;
        },
        delivery: function delivery() {
          return _delivery;
        },
        hasTime: function hasTime() {
          return false;
        },
        hasVehicle: function hasVehicle() {
          return false;
        },
        vehicles: function vehicles() {
          return $scope.vehicles;
        }
      }
    });
    modalInstance.result.then(function (updatedDelivery) {
      var deliveryDTO = deliveryFactory.createDTO(updatedDelivery);
      deliveryFactory.updateDelivery(updatedDelivery.delivery_id, deliveryDTO).then(function (response) {
        $scope.reloadPlannerTablesAndLists();
        $scope.uncheckAll();
      }, function (error) {
        $scope.reloadPlannerTablesAndLists();
        errorService.handleError(error);
      });
    });
  };

  // Transports
  $scope.createTransportDelivery = function (_source) {
    $scope.checkPlanForDate();
    if (!$scope.isPlanForDateSet) {
      return;
    }
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/planner/transport_delivery.html',
      controller: 'SpecifyTransportDeliveryInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        source: function source() {
          return _source;
        },
        delivery: function delivery() {
          return {};
        },
        vehicles: function vehicles() {
          return $scope.vehicles;
        }
      }
    });
    modalInstance.result.then(function (results) {
      if (results !== null) {
        if (_source === 'internal_transport') {
          $scope.assignToNewInternalTransport(results);
        } else if (_source === 'external_transport') {
          $scope.assignToNewExternalTransport(results);
        }
      }
    });
  };
  $scope.assignToNewInternalTransport = function (delivery) {
    var orderIds = [];
    angular.forEach($scope.selected, function (order) {
      orderIds.push(order.order_id);
    });
    var DTO = {
      "ShippingId": $scope.selected[0].shipping_id,
      "Time": delivery.time,
      "DeliveryDate": $scope.planForDate + 'T00:00:00',
      "VehicleId": delivery.vehicle_id
    };
    var outObj = {
      'OrderIds': orderIds,
      'InternalTransportDelivery': DTO
    };
    deliveryFactory.assignOrdersToNewInternalTransport(outObj).then(function (response) {
      $scope.reloadPlannerTablesAndLists();
      $scope.uncheckAll();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $scope.assignToNewExternalTransport = function (delivery) {
    var orderIds = [];
    angular.forEach($scope.selected, function (order) {
      orderIds.push(order.order_id);
    });
    var DTO = {
      "ShippingId": $scope.selected[0].shipping_id,
      "DeliveryDate": $scope.planForDate + 'T00:00:00',
      "Time": delivery.departure_time,
      "Capacity": delivery.capacity
    };
    var outObj = {
      'OrderIds': orderIds,
      'ExternalTransportDelivery': DTO
    };
    deliveryFactory.assignOrdersToNewExternalTransport(outObj).then(function (response) {
      $scope.reloadPlannerTablesAndLists();
      $scope.uncheckAll();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $scope.assignToTransport = function (deliveryId, isDisabled) {
    $scope.checkPlanForDate();
    $scope.showShippingError = isDisabled;
    if (!$scope.isPlanForDateSet || isDisabled) {
      return;
    }
    var orderIds = [];
    angular.forEach($scope.selected, function (order) {
      orderIds.push(order.order_id);
    });
    var outObj = {
      'OrderIds': orderIds,
      'DeliveryId': deliveryId
    };
    deliveryFactory.assignOrdersTransport(outObj).then(function (response) {
      var data = response.data;
      $scope.reloadPlannerTablesAndLists();
      $scope.uncheckAll();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $scope.updateTransportDelivery = function (_delivery2) {
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/planner/transport_delivery.html',
      controller: 'SpecifyTransportDeliveryInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        source: function source() {
          return 'update';
        },
        delivery: function delivery() {
          return _delivery2;
        },
        vehicles: function vehicles() {
          return $scope.vehicles;
        }
      }
    });
    modalInstance.result.then(function (delivery) {
      var deliveryDTO = deliveryFactory.createDTO(delivery);
      deliveryFactory.updateDelivery(delivery.delivery_id, deliveryDTO).then(function (response) {
        $scope.reloadPlannerTablesAndLists();
      }, function (error) {
        $scope.reloadPlannerTablesAndLists();
        errorService.handleError(error);
      });
    });
  };

  // Delivery
  $scope.confirmDelivery = function (delivery) {
    deliveryFactory.confirmDelivery(delivery.delivery_id).then(function (response) {
      $scope.reloadPlannerTablesAndLists();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $scope.deleteDelivery = function (id) {
    deliveryFactory.deleteDelivery(id).then(function (response) {
      $scope.reloadPlannerTablesAndLists();
      $scope.uncheckAll();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $scope.deliverDelivery = function (id) {
    deliveryFactory.deliverDelivery(id).then(function (response) {
      $scope.reloadPlannerTablesAndLists();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $scope.removeOrderFromDelivery = function (orderId) {
    orderFactory.removeOrderFromDelivery(orderId).then(function (response) {
      $scope.reloadPlannerTablesAndLists();
      $scope.uncheckAll();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $scope.checkPlanForDate = function () {
    $scope.isPlanForDateChecked = true;
    var dateFormat = /\d{4}-\d{2}-\d{2}/i;
    var isCorrectFormat = dateFormat.test($scope.planForDate);
    if (isCorrectFormat) {
      $scope.isPlanForDateSet = true;
    } else $scope.isPlanForDateSet = false;
  };
  $scope.isDirectOrder = function (orderType) {
    return OrderTypeEnum.DIRECT_DELIVERY === orderType;
  };
  $scope.isDelivered = function (taskStatusId) {
    return taskStatusService.isDelivered(taskStatusId);
  };
  $scope.isConfirmedOrLater = function (taskStatusId) {
    return taskStatusService.isConfirmedOrLater(taskStatusId);
  };
  $scope.isNotified = function (taskStatusId) {
    return taskStatusService.isNotified(taskStatusId);
  };
  $scope.isCancelled = function (taskStatusId) {
    return taskStatusService.isCancelled(taskStatusId);
  };
  $scope.isDeliveryStatusPlanning = function (statusID) {
    return statusID === DeliveryStatusTypeEnum.PLANNING;
  };
  $scope.isDeliveryStatusConfirmed = function (statusID) {
    return statusID === DeliveryStatusTypeEnum.CONFIRMED;
  };
  $scope.isDeliveryStatusDelivered = function (statusID) {
    return statusID === DeliveryStatusTypeEnum.DELIVERED;
  };
  $scope.calculateOrderWeight = function (order) {
    return generalHelperService.calculateOrderWeight(order);
  };
  $scope.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  function loadMonthsFromLanguage() {
    var translations = $translate.instant(['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']);
    var months = [];
    months.push(translations['JAN']);
    months.push(translations['FEB']);
    months.push(translations['MAR']);
    months.push(translations['APR']);
    months.push(translations['MAY']);
    months.push(translations['JUN']);
    months.push(translations['JUL']);
    months.push(translations['AUG']);
    months.push(translations['SEP']);
    months.push(translations['OCT']);
    months.push(translations['NOV']);
    months.push(translations['DEC']);
    return months;
  }
  $scope.setCurrentShipping = function (shippingId) {
    if ($scope.selectedAny) $scope.currentShipping = shippingId;else $scope.currentShipping = null;
  };

  // Doesnt only set true. unchecks all if $scope.selectAll === false
  $scope.checkAll = function () {
    $scope.selected = [];
    var currentShippingInitiated = false;
    angular.forEach($scope.orders, function (p) {
      var hasShipping = inputValidationService.isValidInput(p.shipping_name);
      if (!currentShippingInitiated && hasShipping) {
        $scope.currentShipping = p.shipping_id;
        currentShippingInitiated = true;
      }
      p.selected = $scope.selectedAll && hasShipping && p.shipping_id === $scope.currentShipping;
      if (p.selected) $scope.selected.push(p);
    });
    $scope.updateSelection();
  };
  $scope.uncheckAll = function () {
    $scope.selected = [];
    angular.forEach($scope.orders, function (order) {
      order.selected = false;
    });
    $scope.updateSelection();
  };
  $scope.updateSelection = function () {
    $scope.selectedAny = false;
    $scope.selected = [];
    angular.forEach($scope.orders, function (p) {
      if (!$scope.selectedAny && p.selected) {
        $scope.selectedAny = true;
      }
      if (p.selected) {
        $scope.selected.push(p);
      }
    });
    if (!$scope.selectedAny) {
      $scope.selectedAll = false;
      delete $scope.currentShipping;
    }
  };
  $scope.viewOrder = function (order_type, id, copy) {
    if (id === -1) {
      return;
    }
    var orderFormPromise;
    if ($scope.isAdmin) {
      orderFormPromise = orderFormModalService.openManage(id, order_type, copy);
    } else {
      orderFormPromise = orderFormModalService.openView(id, order_type, copy);
    }
    orderFormPromise.then(function (results) {
      if (results.copy) {
        $scope.viewOrder(order_type, id, true);
      }
      if (results.success) {
        $rootScope.reloadTable();
      }
    });
  };
  $scope.openLoadingList = function (_delivery3) {
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/planner/loading_list.html',
      controller: 'LoadingListInstanceController',
      size: 'xlg',
      windowClass: 'sp-modal-window',
      resolve: {
        delivery: function delivery() {
          return _delivery3;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };
  $scope.displayDateSeparator = function (order1, order2) {
    if (order2 === null || typeof order2 === 'undefined') {
      return true;
    }
    return order1.date_i !== order2.date_i;
  };
  $scope.displayDate = function (date) {
    var months = loadMonthsFromLanguage();
    var today = new Date().toISOString().split('T')[0];
    var pDate = new Date(date);
    return (today === date ? $translate.instant('TODAY') + ' ' : '') + pDate.getDate() + ' ' + months[pDate.getMonth()];
  };
  $scope.isToday = function (date) {
    var today = new Date().toISOString().split('T')[0];
    return date == today;
  };
  $scope.isBeforeToday = function (date) {
    var today = new Date().toISOString().split('T')[0];
    return date < today;
  };
  $scope.generateFirstColorClass = function (id) {
    return generalHelperService.generateFirstColorClass(id);
  };
  $scope.generateSecondColorClass = function (id) {
    return generalHelperService.generateSecondColorClass(id);
  };
  $scope.initDateTimeEvents = function () {
    // Init Date time picker
    $('#planner-datetimepicker1').datetimepicker({
      locale: 'sv',
      format: 'YYYY-MM-DD',
      widgetPositioning: {
        horizontal: 'auto',
        vertical: 'bottom'
      }
    });
    $('#planner-datetimepicker1').on('dp.change', function (ev) {
      var dateInCalender = $('#planner-plan-for-date').val();
      if ($scope.planForDate === dateInCalender) return; // Don't do anything if the user just opened the calender view
      $scope.planForDate = dateInCalender;
      $scope.reloadDeliveries();
      $scope.checkPlanForDate();
      $scope.updateRouteList();
    });
  };
  $scope.$on('updatedUserData', function (event) {
    $scope.isDisabled = !$localStorage.user.session_main_project.is_plan_transport_function_enabled;
    $rootScope.reloadTable();
    $scope.reloadRoutes();
    $scope.reloadDeliveries();
    $scope.uncheckAll();
  });
  $scope.$on('orderStatusChanged', function () {
    $rootScope.reloadTable();
    $scope.reloadRoutes();
    $scope.reloadDeliveries();
    $scope.uncheckAll();
  });
}]);
controllers.controller("SpecifyTransportDeliveryInstanceController", ['$scope', '$uibModalInstance', 'source', 'delivery', 'vehicles', 'shippingFactory', 'vehicleTypeFactory', 'errorService', 'inputValidationService', '$filter', '$localStorage', function ($scope, $uibModalInstance, source, delivery, vehicles, shippingFactory, vehicleTypeFactory, errorService, inputValidationService, $filter, $localStorage) {
  var sessionMainProject = $localStorage.user.session_main_project;
  if (!$scope.sessionMainProject) $uibModalInstance.dismiss('No session main project available');
  $scope.source = source; // External/internal
  $scope.vehicles = $filter('filter')(vehicles, {
    main_project_id: sessionMainProject.main_project_id
  }, true);
  $scope.delivery = delivery;
  if ($scope.delivery.capacity) {
    $scope.delivery.vehicle_capacity_long = $scope.delivery.capacity + ' ton.';
  }
  vehicleTypeFactory.getVehicleTypes(sessionMainProject.main_project_id, false).then(function (response) {
    var data = response.data;
    var vehicleTypes = vehicleTypeFactory.repackageDTOArray(data);
    $scope.vehicle_types = $filter('filter')(vehicleTypes, {
      main_project_id: sessionMainProject.main_project_id
    }, true);
  }, function (error) {
    errorService.handleError(error);
  });
  function validInput(input) {
    return inputValidationService.isValidInput(input);
  }
  $scope.validateForm = function () {
    $scope.validated = true;
    if ($scope.source === 'internal_transport') {
      if (validInput($scope.delivery.vehicle_name)) {
        $scope.isFormValid = true;
      } else $scope.isFormValid = false;
    } else if ($scope.source === 'external_transport') {
      $scope.isFormValid = true;
    } else if ($scope.source === 'update') $scope.isFormValid = true;
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };
  $scope.save = function () {
    $scope.validateForm();
    if ($scope.isFormValid) {
      $uibModalInstance.close($scope.delivery);
    }
  };
  $scope.isInternalTransportUpdate = function (delivery_type_id) {
    return DeliveryTypeEnum.INTERNAL_TRANSPORT_DELIVERY === delivery_type_id;
  };
  $scope.isExternalTransportUpdate = function (delivery_type_id) {
    return DeliveryTypeEnum.EXTERNAL_TRANSPORT_DELIVERY === delivery_type_id;
  };
  $scope.initDateTimeEvents = function () {
    // Init date time picker
    $('#other-delivery-datetimepicker1').datetimepicker({
      locale: 'sv',
      format: 'LT',
      widgetPositioning: {
        horizontal: 'auto',
        vertical: 'bottom'
      }
    });
    $('#other-delivery-datetimepicker1').data().DateTimePicker.stepping(15);
    $('#other-delivery-datetimepicker1').on('dp.change', function (ev) {
      $scope.delivery.time = $('#other-departure-time').val();
      if (!$scope.$$phase) {
        //$digest or $apply
        $scope.$apply();
      }
    });
  };
}]);
controllers.controller("SpecifyRouteInstanceController", ['$scope', '$uibModalInstance', 'newRoute', 'delivery', 'hasTime', 'hasVehicle', 'vehicles', 'inputValidationService', '$localStorage', '$filter', function ($scope, $uibModalInstance, newRoute, delivery, hasTime, hasVehicle, vehicles, inputValidationService, $localStorage, $filter) {
  var sessionMainProject = $localStorage.user.session_main_project;
  if (!$scope.sessionMainProject) $uibModalInstance.dismiss('No session main project available');
  $scope.newRoute = newRoute;
  $scope.hasTime = hasTime;
  $scope.hasVehicle = hasVehicle;
  $scope.vehicles = $filter('filter')(vehicles, {
    main_project_id: sessionMainProject.main_project_id
  }, true);
  $scope.delivery = delivery;
  $scope.validated = false;
  $scope.isFormValid = false;
  function validInput(input) {
    return inputValidationService.isValidInput(input);
  }
  $scope.validateForm = function () {
    $scope.validated = true;
    if ($scope.newRoute) {
      if (validInput($scope.delivery.route_name) && ($scope.delivery.forenoon || $scope.delivery.afternoon || validInput($scope.delivery.time))) {
        $scope.isFormValid = true;
      } else $scope.isFormValid = false;
    } else $scope.isFormValid = true;
  };

  // Request to check checkbox
  $scope.setCheckbox = function (period) {
    if (period === 'AM' && $scope.delivery.afternoon) {
      $scope.delivery.afternoon = false;
    }
    if (period === 'PM' && $scope.delivery.forenoon) {
      $scope.delivery.forenoon = false;
    }
    $scope.delivery.time = '';
  };
  $scope.setTime = function () {
    $scope.delivery.forenoon = false;
    $scope.delivery.afternoon = false;
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };
  $scope.save = function () {
    $scope.validateForm();
    if ($scope.isFormValid) $uibModalInstance.close($scope.delivery);
  };
  $scope.initDateTimeEvents = function () {
    // Init Date time picker
    $('#route-delivery-datetimepicker1').datetimepicker({
      locale: 'sv',
      format: 'LT',
      widgetPositioning: {
        horizontal: 'auto',
        vertical: 'bottom'
      }
    });
    $('#route-delivery-datetimepicker1').data().DateTimePicker.stepping(15);
    $('#route-delivery-datetimepicker1').on('dp.change', function (ev) {
      $scope.delivery.time = $('#route-time').val();
      $scope.delivery.forenoon = false;
      $scope.delivery.afternoon = false;
      if (!$scope.$$phase) {
        //$digest cycle
        $scope.$apply();
      }
    });
  };
}]);
'use strict';

controllers.controller('CompanyController', ['$uibModal', '$scope', '$rootScope', '$filter', 'companyFactory', 'errorService', '$localStorage', 'roleService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, companyFactory, errorService, $localStorage, roleService, keyCodes) {
  $scope.isAdmin = roleService.isAdmin();
  $scope.isServicenter = roleService.isServicenter();
  $scope.innerRange = 5;
  $scope.currentPage = 1;
  $scope.itemRangeBottom = 0;
  $scope.itemRangeTop = 14;
  $scope.itemRange = 15;
  $scope.searchString = '';
  $scope.keyCode = '';
  $scope.lastSortCol = 'company_name';
  $scope.sortCol = 'company_name';
  $scope.sortReverse = false;
  $scope.sortReverseFn = function () {
    if ($scope.lastSortCol === $scope.sortCol && !$scope.sortReverse) {
      $scope.sortReverse = true;
    } else {
      $scope.lastSortCol = $scope.sortCol;
      $scope.sortReverse = false;
    }
  };
  $rootScope.reloadTable = function () {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) {
      errorService.handleError('No session main project');
      return;
    }
    $scope.selectedAll = false;
    $scope.selectedAny = false;
    companyFactory.getCompanies(true, sessionMainProject.division_id).then(function (response) {
      var data = response.data;
      $scope.companies = companyFactory.repackageCompanyDTOArray(data);
      $scope.totalItems = $scope.companies.length;
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $rootScope.reloadTable();
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.searchString = $scope.pendingSearchString;
      $scope.updateFullTableRange();
    }
  };
  $scope.updateFullTableRange = function (filter, array, param) {
    var filtered = $scope.companies;
    if (!$scope.showInactive) {
      filtered = $filter('inactive')(filtered, $scope.showInactive);
    }
    if ($scope.searchString) {
      filtered = $filter('filter')(filtered, $scope.searchString);
    }
    $scope.totalItems = filtered.length;
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.currentPage - 1) * $scope.itemRange;
  };

  // --- MODAL - CREATE ---
  var animationsEnabled = true;
  $scope.createCompany = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/customers/company/company_form.html',
      controller: 'CompanyInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create_company';
        },
        id: function id() {
          return -1;
        }
      }
    });
  };

  // --- MODAL - VIEW VEHICLE ---
  $scope.viewCompany = function (_id) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/customers/company/company_form.html',
      controller: 'CompanyInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view_company';
        },
        id: function id() {
          return _id;
        }
      }
    });
  };
  $scope.$on('companyRepeatFinished', function (companiesRepeatFinishedEvent) {
    $scope.updateFullTableRange();
  });
  $scope.$on('updatedUserData', function (event) {
    $rootScope.reloadTable();
  });
}]);

// TODO: Move the CompanyInstanceController to own file!
// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('CompanyInstanceController', ['$uibModalInstance', 'form_type', 'id', '$scope', '$rootScope', 'companyFactory', 'inputValidationService', 'errorService', 'dropdownService', '$localStorage', 'generalHelperService', 'notificationTemplateFactory', 'InputLengthLimits', function ($uibModalInstance, form_type, id, $scope, $rootScope, companyFactory, inputValidationService, errorService, dropdownService, $localStorage, generalHelperService, notificationTemplateFactory, InputLengthLimits) {
  $scope.InputLengthLimits = InputLengthLimits;
  $scope.validated = false;
  $scope.formLocked = true;
  $scope.form_type = form_type;
  var sessionMainProject = $localStorage.user.session_main_project;
  if (!sessionMainProject) {
    errorService.handleError('No session main project');
    $uibModalInstance.dismiss('cancel');
  }
  if (form_type === 'view_company') {
    companyFactory.getCompany(id).then(function (response) {
      $scope.company = companyFactory.repackageCompanyDTO(response.data);
      $scope.selectedErpCompanyDisplayName = $scope.company.company_display_name;
    }, function (error) {
      errorService.handleError(error);
    });
  } else if (form_type === 'create_company') {
    // Generate empty conf
    $scope.company = {};
    $scope.company.company_id = null;
    $scope.company.is_active = true;
    notificationTemplateFactory.getConfigurableTemplates().then(function (response) {
      var data = response.data;
      $scope.company.notification_configuration = notificationTemplateFactory.extendTemplatesWithNames(data);
    }, function (error) {
      errorService.handleError(error);
    });
    companyFactory.getErpCompanies(sessionMainProject.division_id).then(function (response) {
      var erpCompanyDTOArray = response.data;
      $scope.erpCompanies = companyFactory.repackageErpCompanyDTOArray(erpCompanyDTOArray);
      $scope.formLocked = false;
    }, function (error) {
      errorService.handleError(error);
    });
  }

  // Finalizing or exiting form
  $scope.create = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) return;
    var companyDTO = companyFactory.packageCompany($scope.company, sessionMainProject.division_id);
    companyFactory.createCompany(companyDTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close();
  };
  $scope.update = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var companyDTO = companyFactory.packageCompany($scope.company, sessionMainProject.division_id);
    companyFactory.updateCompany($scope.company.company_id, companyDTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close();
  };
  $scope.delete = function () {
    companyFactory.deleteCompany($scope.company.company_id).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close();
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  $scope.isValidEmail = function (input) {
    return inputValidationService.isValidEmail(input);
  };
  $scope.validateForm = function () {
    $scope.formValid = inputValidationService.isValidInput($scope.company.company_name) && inputValidationService.isValidInput($scope.company.contact) && inputValidationService.isValidInput($scope.company.phone) && inputValidationService.isValidEmail($scope.company.email);
    return $scope.formValid;
  };
  $scope.loadErpCompany = function (erpCompany) {
    $scope.selectedErpCompanyDisplayName = erpCompany.company_display_name;
    $scope.company.erp_system_company_no = erpCompany.erp_system_company_no;
    $scope.company.company_name = erpCompany.company_name;
    $scope.company.organization_number = erpCompany.organization_number;
  };
  $scope.openDropdown = dropdownService.openDropdown;
}]);
'use strict';

controllers.controller('UserController', ['$uibModal', '$scope', '$rootScope', '$filter', 'userFactory', 'roleService', 'errorService', 'keyCodes', '$routeParams', function ($uibModal, $scope, $rootScope, $filter, userFactory, roleService, errorService, keyCodes, $routeParams) {
  $scope.pagination = {
    currentPage: 1,
    totalItems: 0
  };

  // These variables used by the html to update attributes. They should only
  // be modified via updateSelection, not through other means.
  $scope.selection = {
    isActivatePossible: false,
    isDeactivatePossible: false,
    allUsersSelected: false
  };
  $scope.filterAndPagination = {
    filter: {
      includeActive: true,
      includeInactive: false,
      searchString: null,
      orderBy: 'user_name',
      orderDescending: false
    },
    pagination: {
      skip: 0,
      take: 15
    }
  };
  $scope.searchString = '';
  $scope.isSortingColumn = function (column) {
    return $scope.filterAndPagination.filter.orderBy == column;
  };
  $scope.isSortingColumnAndReversed = function (column) {
    return $scope.isSortingColumn(column) && $scope.filterAndPagination.filter.orderDescending;
  };
  $scope.handleColumnHeaderClicked = function (column) {
    if (column === $scope.filterAndPagination.filter.orderBy) {
      $scope.filterAndPagination.filter.orderDescending = !$scope.filterAndPagination.filter.orderDescending;
    } else {
      $scope.filterAndPagination.filter.orderBy = column;
      $scope.filterAndPagination.filter.orderDescending = false;
    }
    $scope.reloadTable();
  };
  $scope.identifyRoles = function () {
    $scope.isAdmin = roleService.isAdmin();
    $scope.isServicenter = roleService.isServicenter();
    $scope.isProjectOwner = roleService.isProjectOwner();
    $scope.isWarehousePlanner = roleService.isWarehousePlanner();
    $scope.isWarehouseOperator = roleService.isWarehouseOperator();
    $scope.isInternal = roleService.isInternal();
    $scope.isCustomer = roleService.isCustomer();
  };
  $scope.identifyRoles();
  $rootScope.reloadTable = function () {
    userFactory.getUsers($scope.filterAndPagination).then(function (response) {
      handleGetUsersResponse(response.data);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $rootScope.reloadTable();
  $scope.handleCheckAllToggled = function () {
    if ($scope.selection.allUsersSelected) {
      checkAll();
    } else {
      unCheckAll();
    }
  };
  function checkAll() {
    var filtered = getSelectableItems($scope.users);
    angular.forEach(filtered, function (p) {
      p.selected = true;
    });
    $scope.updateSelection();
  }
  ;
  function unCheckAll() {
    angular.forEach($scope.users, function (p) {
      p.selected = false;
    });
    $scope.updateSelection();
  }
  ;
  $scope.updateSelection = function () {
    var filtered = getSelectableItems($scope.users);
    var nrOfSelectedUsers = 0;
    var activatedUserSelected = false;
    var deactivatedUserSelected = false;
    angular.forEach(filtered, function (u) {
      if (u.selected) {
        nrOfSelectedUsers++;
      }
      if (u.selected && u.is_active) {
        activatedUserSelected = true;
      }
      if (u.selected && !u.is_active) {
        deactivatedUserSelected = true;
      }
    });
    if (nrOfSelectedUsers == filtered.length) {
      $scope.selection.allUsersSelected = true;
    } else {
      $scope.selection.allUsersSelected = false;
    }
    $scope.selection.isActivatePossible = !activatedUserSelected && deactivatedUserSelected;
    $scope.selection.isDeactivatePossible = activatedUserSelected && !deactivatedUserSelected;
  };
  function handleGetUsersResponse(data) {
    $scope.users = [];
    data.Items.forEach(loadUserData);
    $scope.pagination.totalItems = data.TotalCount;
  }
  ;
  function loadUserData(data) {
    var getCompanyName = function getCompanyName(data) {
      if (data.RoleName == 'Customer') {
        if (data.Companies.length > 0) return data.Companies[0].Name;
        return "N/A";
      }
      return "";
    };
    var getIsSelectable = function getIsSelectable(data) {
      if (data.RoleName == 'Customer') {
        return true;
      } else {
        if ($scope.isAdmin) return true;
        if ($scope.isServicenter && data.RoleId != RoleEnum.ADMINISTRATOR) return true;
        if ($scope.isProjectOwner && data.RoleId != RoleEnum.ADMINISTRATOR && data.RoleId != RoleEnum.SERVICENTER) return true;
      }
      return false;
    };
    $scope.users.push({
      user_id: data.UserId,
      user_login: data.Login,
      user_type: data.RoleTypeName,
      user_email: data.Email,
      user_name: data.Name,
      user_phone: data.PhoneNumber,
      user_role_name: data.RoleName,
      user_company_name: getCompanyName(data),
      is_active: !data.IsDeactivated,
      is_selectable: getIsSelectable(data),
      selected: false
    });
    $scope.updateSelection();
  }
  $scope.activateUsers = function (isActive) {
    var selectedUsers = getSelectedUsers();
    var selectedUserIds = selectedUsers.map(function (u) {
      return u.user_id;
    });
    var onSuccess = function onSuccess(response) {
      $rootScope.reloadTable();
    };
    var onFailure = function onFailure(error) {
      errorService.handleError(error);
    };
    if (isActive) {
      userFactory.reActivateUsers(selectedUserIds).then(onSuccess, onFailure);
    } else {
      userFactory.deactivateUsers(selectedUserIds).then(onSuccess, onFailure);
    }
  };
  function getSelectedUsers() {
    filtered = $filter('filter')($scope.users, function (i) {
      return i.selected;
    });
    return filtered;
  }
  function getSelectableItems(array) {
    filtered = $filter('filter')(array, function (i) {
      return i.is_selectable;
    });
    return filtered;
  }
  $scope.handleSearchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.filterAndPagination.filter.searchString = $scope.pendingSearchString;
      $scope.reloadTable();
    }
  };
  $scope.handleSearchButtonClicked = function () {
    $scope.filterAndPagination.filter.searchString = $scope.pendingSearchString;
    $scope.reloadTable();
  };
  $scope.handleShowActiveChanged = function () {
    $scope.reloadTable();
  };
  $scope.handlePaginationUpdated = function () {
    itemRangeBottom = ($scope.pagination.currentPage - 1) * $scope.filterAndPagination.pagination.take;
    $scope.filterAndPagination.pagination.skip = itemRangeBottom;
    $rootScope.reloadTable();
  };

  // --- MODAL - CREATE ---
  var animationsEnabled = true;
  $scope.createUser = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/customers/users/user_form.html',
      controller: 'UserInstanceController',
      size: 'lg',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create_user';
        },
        id: function id() {
          return -1;
        }
      }
    });
    modalInstance.result.then(function (results) {
      if (results.success) {
        $rootScope.reloadTable();
      }
    });
  };

  // --- MODAL - VIEW USER ---
  $scope.viewUser = function (_id) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/customers/users/user_form.html',
      controller: 'UserInstanceController',
      size: 'lg',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view_user';
        },
        id: function id() {
          return _id;
        }
      }
    });
    modalInstance.result.then(function (results) {
      if (results.success) {
        $rootScope.reloadTable();
      }
    });
  };
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('UserInstanceController', ['$uibModalInstance', 'form_type', 'id', '$scope', 'companyFactory', 'userFactory', 'workOrderFactory', 'mainProjectFactory', 'roleService', 'errorService', '$localStorage', 'InputLengthLimits', function ($uibModalInstance, form_type, id, $scope, companyFactory, userFactory, workOrderFactory, mainProjectFactory, roleService, errorService, $localStorage, InputLengthLimits) {
  $scope.InputLengthLimits = InputLengthLimits;
  $scope.form_type = form_type;
  $scope.canEdit = false;
  $scope.register_user = {};
  $scope.selectedMainProjects = [];
  $scope.selectedWorkorders = [];
  $scope.lang = {};
  $scope.lang.SWEDISH = LanguageEnum.SWEDISH;
  $scope.lang.ENGLISH = LanguageEnum.ENGLISH;
  $scope.language_id = LanguageEnum.SWEDISH;
  $scope.identifyRoles = function () {
    $scope.isAdmin = roleService.isAdmin();
    $scope.isServicenter = roleService.isServicenter();
    $scope.isProjectOwner = roleService.isProjectOwner();
    $scope.isWarehousePlanner = roleService.isWarehousePlanner();
    $scope.isWarehouseOperator = roleService.isWarehouseOperator();
    $scope.isInternal = roleService.isInternal();
    $scope.isCustomer = roleService.isCustomer();
  };
  $scope.identifyRoles();
  if (form_type === 'view_user') {
    $scope.user_id = id;
    userFactory.getUser($scope.user_id).then(function (response) {
      var data = response.data;
      $scope.DTO = data;
      $scope.canEdit = canEditUserWithRole(data.RoleId);
      $scope.isActivated = data.IsActivated;
      $scope.register_user.username = data.Login, $scope.register_user.contact_name = data.Name;
      $scope.register_user.contact_email = data.Email, $scope.register_user.contact_phone_nr = data.PhoneNumber;
      $scope.register_user.roleId = data.RoleId;
      $scope.selectedCompanies = data.Companies;
      $scope.selectedWorkorders = data.WorkOrders;
      $scope.selectedMainProjects = data.MainProjects;
      $scope.language_id = data.LanguageId;
      $scope.showExternal = false;
      $scope.showInternal = false;
      $scope.showAdmin = false;
      $scope.showServicecenter = false;
      $scope.showProjectOwner = false;
      $scope.showTeamledare = false;
      $scope.showOperator = false;
      switch (data.RoleId) {
        case RoleEnum.CUSTOMER:
          $scope.showExternalDiv();
          break;
        case RoleEnum.ADMINISTRATOR:
          $scope.showInternalDiv();
          break;
        case RoleEnum.SERVICENTER:
          $scope.showInternalDiv();
          $scope.showServicecenterDiv();
          break;
        case RoleEnum.PROJECT_OWNER:
          $scope.showInternalDiv();
          $scope.showProjectOwnerDiv();
          break;
        case RoleEnum.WAREHOUSE_OPERATOR:
          $scope.showInternalDiv();
          $scope.showOperatorDiv();
          break;
        case RoleEnum.WAREHOUSE_PLANNER:
          $scope.showInternalDiv();
          $scope.showTeamledareDiv();
          break;
        default:
          break;
      }
      angular.forEach($scope.selectedMainProjects, function (smp) {
        angular.forEach($scope.main_projects, function (mp) {
          if (smp.MainProjectId == mp.main_project_id) {
            mp.checked = true;
          }
        });
      });
      if ($scope.selectedCompanies.length > 0) {
        $scope.company_id = $scope.selectedCompanies[0].CompanyId;
        $scope.company_display_name = $scope.selectedCompanies[0].Name;
      }
      if ($scope.selectedWorkorders.length > 0) {
        $scope.subcontractor_company_display_name = $scope.selectedWorkorders[0].CompanyName + ($scope.selectedWorkorders[0].ErpSystemReference ? " (" + $scope.selectedWorkorders[0].ErpSystemReference + ")" : "");
        $scope.subcontractor_company_id = $scope.selectedWorkorders[0].CompanyId;
        $scope.loadWorkorders();
      }
      $scope.evaluateProgress();
    }, function (error) {
      errorService.handleError(error);
    });
  }

  //Reachabla in view
  $scope.cancel = function () {
    $uibModalInstance.close(false);
  };
  $scope.showExternal = true;
  $scope.showInternal = false;
  $scope.showExternalDiv = function () {
    $scope.showExternal = true;
    $scope.showInternal = false;
    $scope.showAdmin = false;
    $scope.showServicecenter = false;
    $scope.showProjectOwner = false;
    $scope.showTeamledare = false;
    $scope.showOperator = false;
    $scope.evaluateProgress();
  };
  $scope.showInternalDiv = function () {
    $scope.showExternal = false;
    $scope.showInternal = true;
    $scope.showAdmin = $scope.isAdmin;
    $scope.showServicecenter = !$scope.isAdmin;
    $scope.showProjectOwner = false;
    $scope.showTeamledare = false;
    $scope.showOperator = false;
    $scope.evaluateProgress();
  };
  $scope.showAdminDiv = function () {
    $scope.showAdmin = true;
    $scope.showServicecenter = false;
    $scope.showProjectOwner = false;
    $scope.showTeamledare = false;
    $scope.showOperator = false;
    $scope.evaluateProgress();
  };
  $scope.showServicecenterDiv = function () {
    getMainProjects();
    $scope.showAdmin = false;
    $scope.showServicecenter = true;
    $scope.showProjectOwner = false;
    $scope.showTeamledare = false;
    $scope.showOperator = false;
    $scope.evaluateProgress();
  };
  $scope.showProjectOwnerDiv = function () {
    getMainProjects();
    $scope.showAdmin = false;
    $scope.showServicecenter = false;
    $scope.showProjectOwner = true;
    $scope.showTeamledare = false;
    $scope.showOperator = false;
    $scope.evaluateProgress();
  };
  $scope.showTeamledareDiv = function () {
    getMainProjects();
    $scope.showAdmin = false;
    $scope.showServicecenter = false;
    $scope.showProjectOwner = false;
    $scope.showTeamledare = true;
    $scope.showOperator = false;
    $scope.evaluateProgress();
  };
  $scope.showOperatorDiv = function () {
    getMainProjects();
    $scope.showAdmin = false;
    $scope.showServicecenter = false;
    $scope.showProjectOwner = false;
    $scope.showTeamledare = false;
    $scope.showOperator = true;
    $scope.evaluateProgress();
  };
  function getCompanies() {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) {
      errorService.handleError('No session main project');
      return;
    }
    companyFactory.getCompanies(false, sessionMainProject.division_id).then(function (response) {
      var data = response.data;
      $scope.companies = companyFactory.repackageCompanyDTOArray(data);
    }, function (error) {
      errorService.handleError(error);
    });
  }
  getCompanies();
  function canEditUserWithRole(roleId) {
    var editableRoles = [];
    switch (roleService.myRoleId()) {
      case RoleEnum.ADMINISTRATOR:
        editableRoles = [RoleEnum.ADMINISTRATOR, RoleEnum.SERVICENTER, RoleEnum.PROJECT_OWNER, RoleEnum.WAREHOUSE_PLANNER, RoleEnum.WAREHOUSE_OPERATOR, RoleEnum.CUSTOMER];
        break;
      case RoleEnum.SERVICENTER:
        editableRoles = [RoleEnum.SERVICENTER, RoleEnum.PROJECT_OWNER, RoleEnum.WAREHOUSE_PLANNER, RoleEnum.WAREHOUSE_OPERATOR, RoleEnum.CUSTOMER];
        break;
      case RoleEnum.PROJECT_OWNER:
        editableRoles = [RoleEnum.PROJECT_OWNER, RoleEnum.WAREHOUSE_PLANNER, RoleEnum.WAREHOUSE_OPERATOR, RoleEnum.CUSTOMER];
        break;
      case RoleEnum.WAREHOUSE_PLANNER:
        editableRoles = [RoleEnum.WAREHOUSE_PLANNER, RoleEnum.WAREHOUSE_OPERATOR, RoleEnum.CUSTOMER];
        break;
      case RoleEnum.WAREHOUSE_OPERATOR:
        editableRoles = [RoleEnum.WAREHOUSE_OPERATOR, RoleEnum.CUSTOMER];
        break;
      case RoleEnum.CUSTOMER:
        editableRoles = [RoleEnum.CUSTOMER];
        break;
      default:
        break;
    }
    return editableRoles.includes(roleId);
  }
  function inSelectedMainProjectsArray(mainProjectIdToLookFor) {
    var retVal = false;
    $scope.selectedMainProjects.forEach(function (smp, index) {
      if (smp.MainProjectId == mainProjectIdToLookFor) retVal = true;
    });
    return retVal;
  }
  function getMainProjects() {
    $scope.main_projects = [];
    mainProjectFactory.getMainProjects().then(function (response) {
      var data = response.data;
      data.forEach(function (project, index) {
        $scope.main_projects.push({
          main_project_id: project.MainProjectId,
          main_project_name: project.Name,
          checked: inSelectedMainProjectsArray(project.MainProjectId)
        });
      });
    }, function (error) {
      errorService.handleError(error);
    });
  }
  function isWorkorderSelected(work_order_id) {
    var found = false;
    $scope.selectedWorkorders.forEach(function (swo, index) {
      if (swo.WorkOrderId == work_order_id) {
        found = true;
      }
    });
    return found;
  }
  function removeFromSelectedWorkorders(work_order_id) {
    $scope.selectedWorkorders = $scope.selectedWorkorders.filter(function (swo) {
      return swo.WorkOrderId !== work_order_id;
    });
  }
  function saveSelectedWorkorders() {
    $scope.workorders.forEach(function (wo, index) {
      var isChecked = isWorkorderSelected(wo.work_order_id);
      if (wo.checked && !isChecked) {
        $scope.selectedWorkorders.push({
          WorkOrderId: wo.work_order_id
        });
      } else if (!wo.checked && isChecked) {
        removeFromSelectedWorkorders(wo.work_order_id);
      }
    });
  }
  function getWorkOrdersByCompanyId(id) {
    if ($scope.workorders != undefined && $scope.workorders.length > 0) {
      saveSelectedWorkorders();
    }
    $scope.workorders = [];
    if ($scope.isAdmin || $scope.isServicenter) {
      workOrderFactory.getAllWorkOrdersByCompanyId(id).then(function (response) {
        var data = response.data;
        angular.forEach(data, function (data, index) {
          $scope.workorders.push({
            work_order_id: data.WorkOrderId,
            work_order_name: data.Name,
            checked: isWorkorderSelected(data.WorkOrderId)
          });
        });
      }, function (error) {
        errorService.handleError(error);
      });
    } else {
      var sessionMainProject = $localStorage.user.session_main_project;
      if (!sessionMainProject) {
        errorService.handleError('No session main project');
        return;
      }
      workOrderFactory.getWorkOrdersByCompanyId(id, sessionMainProject.main_project_id).then(function (response) {
        var data = response.data;
        angular.forEach(data, function (data, index) {
          $scope.workorders.push({
            work_order_id: data.WorkOrderId,
            work_order_name: data.Name,
            checked: isWorkorderSelected(data.WorkOrderId)
          });
        });
      }, function (error) {
        errorService.handleError(error);
      });
    }
  }
  $scope.onMainProjectCheckboxChanged = function () {
    $scope.updateSelectedMainProjects();
    $scope.evaluateProgress();
  };
  $scope.evaluateProgress = function () {
    $scope.sectionOneDone = $scope.register_user.username !== '' && typeof $scope.register_user.username !== 'undefined';
    $scope.sectionTwoDone = $scope.sectionOneDone && ($scope.showExternal && $scope.company_id !== '' && $scope.company_id !== 'undefined' && $scope.company_id !== undefined || $scope.showExternal && $scope.subcontractor_company_id !== '' && $scope.subcontractor_company_id !== 'undefined' && $scope.subcontractor_company_id !== undefined || $scope.showAdmin || $scope.showServicecenter && $scope.selectedMainProjects.length > 0 || $scope.showProjectOwner && $scope.selectedMainProjects.length > 0 || $scope.showTeamledare && $scope.selectedMainProjects.length > 0 || $scope.showOperator && $scope.selectedMainProjects.length > 0);
    $scope.sectionThreeDone = $scope.sectionOneDone && $scope.sectionTwoDone && $scope.register_user.contact_name !== '' && typeof $scope.register_user.contact_name !== 'undefined' && $scope.register_user.contact_phone_nr !== '' && $scope.register_user.contact_phone_nr !== 'null' && typeof $scope.register_user.contact_phone_nr !== 'undefined' && $scope.register_user.contact_email !== '' && typeof $scope.register_user.contact_email !== 'undefined';
    $scope.sectionFourDone = $scope.sectionOneDone && $scope.sectionTwoDone && $scope.sectionThreeDone && $scope.language_id !== '' && $scope.language_id !== 'undefined' && $scope.language_id !== undefined;
  };
  $scope.validateForm = function () {
    $scope.formValid = typeof $scope.register_user.username !== 'undefined' && $scope.register_user.username !== '' && typeof $scope.register_user.contact_name !== 'undefined' && $scope.register_user.contact_name !== '';
    return $scope.formValid;
  };
  $scope.loadWorkorders = function () {
    $scope.showWorkorders = $scope.subcontractor_company_id !== '' && $scope.subcontractor_company_id !== 'undefined' && $scope.subcontractor_company_id !== undefined;
    if ($scope.showWorkorders) {
      getWorkOrdersByCompanyId($scope.subcontractor_company_id);
    }
  };
  $scope.subcontractorDropdownChanged = function () {
    $scope.validateForm();
    $scope.evaluateProgress();
    $scope.loadWorkorders();
  };
  $scope.updateSelectedMainProjects = function () {
    $scope.selectedMainProjects = [];
    $scope.main_projects.forEach(function (mp, index) {
      if (mp.checked) {
        $scope.selectedMainProjects.push({
          MainProjectId: mp.main_project_id
        });
      }
    });
  };
  $scope.createOrUpdate = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var roleId = -1;
    if ($scope.showExternal) {
      roleId = RoleEnum.CUSTOMER;
    } else if ($scope.showInternal) {
      if ($scope.showAdmin) {
        roleId = RoleEnum.ADMINISTRATOR;
      } else if ($scope.showServicecenter) {
        roleId = RoleEnum.SERVICENTER;
      } else if ($scope.showProjectOwner) {
        roleId = RoleEnum.PROJECT_OWNER;
      } else if ($scope.showTeamledare) {
        roleId = RoleEnum.WAREHOUSE_PLANNER;
      } else if ($scope.showOperator) {
        roleId = RoleEnum.WAREHOUSE_OPERATOR;
      }
    }
    $scope.selectedCompanies = [];
    if ($scope.showExternal && $scope.company_id !== '' && $scope.company_id !== 'undefined' && $scope.company_id !== undefined) {
      $scope.selectedCompanies.push({
        companyId: $scope.company_id
      });
    }
    ;
    if ($scope.showExternal && $scope.subcontractor_company_id !== '' && $scope.subcontractor_company_id !== 'undefined' && $scope.subcontractor_company_id !== undefined) {
      saveSelectedWorkorders();
    }
    ;
    if ($scope.showInternal && ($scope.showServicecenter || $scope.showProjectOwner || $scope.showTeamledare || $scope.showOperator)) {
      $scope.updateSelectedMainProjects();
    }
    var results = {};
    if ($scope.form_type == 'create_user') {
      var DTO = {
        "Login": $scope.register_user.username,
        "Email": $scope.register_user.contact_email,
        "Name": $scope.register_user.contact_name,
        "PhoneNumber": $scope.register_user.contact_phone_nr,
        "RoleId": roleId,
        "Companies": $scope.selectedCompanies,
        "WorkOrders": $scope.selectedWorkorders,
        "MainProjects": $scope.selectedMainProjects,
        "LanguageId": $scope.language_id
      };
      userFactory.createUser(DTO, roleId).then(function (response) {
        results.success = true;
        $uibModalInstance.close(results);
      }, function (error) {
        errorService.handleError(error);
        $scope.errorMessage = error.data.Message;
        $scope.showErrorMessage = true;
      });
    } else if ($scope.form_type == 'manage_user') {
      var DTO = {
        "UserId": $scope.user_id,
        "Login": $scope.register_user.username,
        "Email": $scope.register_user.contact_email,
        "Name": $scope.register_user.contact_name,
        "PhoneNumber": $scope.register_user.contact_phone_nr,
        "RoleId": roleId,
        "Companies": $scope.selectedCompanies,
        "WorkOrders": $scope.selectedWorkorders,
        "MainProjects": $scope.selectedMainProjects,
        "LanguageId": $scope.language_id
      };
      userFactory.updateUser(DTO).then(function (response) {
        results.success = true;
        if (response.UserId == $localStorage.UserId) {
          userFactory.setUserData(true);
        }
        $uibModalInstance.close(results);
      }, function (error) {
        errorService.handleError(error);
        $scope.errorMessage = error.data.Message;
        $scope.showErrorMessage = true;
      });
    }
  };
  $scope.resendActivationLink = function () {
    $scope.activationLinkSent = false;
    userFactory.resendActivationLink($scope.DTO).then(function (response) {
      $scope.activationLinkSent = true;
    }, function (error) {
      errorService.handleError(error);
    });
  };
}]);
'use strict';

controllers.controller('GateController', ['$uibModal', '$scope', '$rootScope', '$filter', 'gateFactory', 'errorService', '$localStorage', 'roleService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, gateFactory, errorService, $localStorage, roleService, keyCodes) {
  $scope.canEdit = roleService.isAdmin() || roleService.isServicenter() || roleService.isProjectOwner();
  $scope.gates = [];
  $rootScope.reloadTable = function () {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    gateFactory.getGatesByMainProjectId(sessionMainProject.main_project_id).then(function (response) {
      var data = response.data;
      $scope.gates = gateFactory.repackageDTOArray(data);
      $scope.filterInactiveItems();
    }, function (error) {
      errorService.handleError(error);
    });
  };

  // Table bindings
  $scope.projects = [];
  $scope.system_gates = [];
  $scope.tableItems = $scope.gates;
  $scope.selectedItems = [];
  $scope.tableHeaderItems = [{
    propertyName: 'gate_name',
    translateName: 'GATE'
  }, {
    propertyName: 'system_gate_name',
    translateName: 'SYSTEM_GATE_NAME'
  }, {
    propertyName: 'gate_location',
    translateName: 'LOCATION'
  }, {
    propertyName: 'project_name',
    translateName: 'PROJECT'
  }, {
    propertyName: 'is_active',
    translateName: 'ACTIVE'
  }];

  // Handle active/inactive
  $scope.showInactive = {
    value: false
  }; // Wrap in object to bind ng-model to correct scope
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.filterInactiveItems = function () {
    $scope.tableItems = $filter('filter')($scope.gates, {
      inactive: $scope.showInactive.value
    });
  };
  $scope.activateSelectedItems = function (setToActive) {
    $scope.selectedItems.forEach(function (data) {
      if (setToActive) {
        gateFactory.activateGate(data.gate_id).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      } else {
        gateFactory.deactivateGate(data.gate_id).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      }
    });
  };
  $rootScope.reloadTable(); // Initialize table

  $scope.$watchCollection('selectedItems', function () {
    if ($scope.selectedItems.length === 0) {
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
    } else {
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
      angular.forEach($scope.selectedItems, function (item) {
        if (item.is_active) {
          $scope.hasActiveSelection = true;
        } else {
          $scope.hasInactiveSelection = true;
        }
      });
    }
  });

  // --- MODAL - CREATE ---
  var animationsEnabled = true;
  $scope.createGate = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/gate_management/gate/gate_form.html',
      controller: 'GateInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create_gate';
        },
        id: function id() {
          return -1;
        }
      }
    });
    modalInstance.result.then(function (results) {
      $rootScope.reloadTable();
    });
  };

  // --- MODAL - VIEW GATE ---
  $scope.viewGate = function (gate) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/gate_management/gate/gate_form.html',
      controller: 'GateInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view_gate';
        },
        id: function id() {
          return gate.gate_id;
        }
      }
    });
    modalInstance.result.then(function (results) {
      $rootScope.reloadTable();
    });
  };

  // Events
  $scope.$on('updatedUserData', function (event) {
    $rootScope.reloadTable();
  });
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('GateInstanceController', ['$uibModalInstance', 'form_type', 'id', '$scope', '$rootScope', 'gateFactory', 'projectFactory', 'errorService', 'inputValidationService', '$localStorage', '$filter', function ($uibModalInstance, form_type, id, $scope, $rootScope, gateFactory, projectFactory, errorService, inputValidationService, $localStorage, $filter) {
  $scope.validated = false;
  $scope.form_type = form_type;
  $scope.gate_name = '';
  $scope.system_gate_name = '';
  $scope.system_gate_id = -1;
  $scope.project_id = -1;
  $scope.project_name = '';
  $scope.location = '';
  $scope.comments = '';
  if (form_type === 'view_gate') {
    gateFactory.getGate(id).then(function (response) {
      var data = response.data;
      $scope.gate_id = id;
      $scope.gate_name = data.Name;
      $scope.system_gate_name = data.SystemName;
      $scope.system_gate_id = data.SystemId;
      $scope.project_id = data.ProjectId;
      $scope.project_name = data.ProjectName;
      $scope.gate_location = data.Location;
      $scope.is_active = data.IsActive;
      $scope.comments = data.Comments;
    }, function (error) {
      errorService.handleError(error);
    });
  }

  // Populate projects list
  function loadProjects() {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    projectFactory.getProjects(sessionMainProject.main_project_id, false).then(function (response) {
      var data = response.data;
      $scope.projects = projectFactory.repackageDTOArray(data);
    }, function (error) {
      errorService.handleError(error);
    });
  }
  function loadSystemGates() {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    gateFactory.getSystemGates(sessionMainProject.main_project_id).then(function (response) {
      var data = response.data;
      $scope.system_gates = gateFactory.repackageSystemGateDTOArray(data);
    }, function (error) {
      errorService.handleError(error);
    });
  }
  loadProjects();
  loadSystemGates();

  // Finalizing or exiting form
  $scope.create = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = {
      "Name": $scope.gate_name,
      "SystemName": $scope.system_gate_name,
      "SystemId": $scope.system_gate_id,
      "Location": $scope.gate_location,
      "ProjectId": $scope.project_id,
      "ProjectName": $scope.project_name,
      "IsActive": true,
      "Comments": $scope.comments
    };
    gateFactory.createGate(DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close("Gate created"); // Pass in returned item here.
  };

  $scope.activation = function (isActive) {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    if (isActive) {
      gateFactory.activateGate($scope.gate_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    } else {
      gateFactory.deactivateGate($scope.gate_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    }
    $uibModalInstance.close(''); // Pass in returned item here.
  };

  $scope.update = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = {
      "GateId": $scope.gate_id,
      "Name": $scope.gate_name,
      "SystemName": $scope.system_gate_name,
      "SystemId": $scope.system_gate_id,
      "Location": $scope.gate_location,
      "ProjectId": $scope.project_id,
      "ProjectName": $scope.project_name,
      "IsActive": $scope.is_active,
      "Comments": $scope.comments
    };
    gateFactory.updateGate(DTO.GateId, DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(''); // Pass in returned item here.
  };

  $scope.delete = function () {
    gateFactory.deleteGate($scope.gate_id).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(''); // Pass in returned item here.
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  $scope.validateForm = function () {
    $scope.formValid = inputValidationService.isValidInput($scope.gate_name) && inputValidationService.isValidInput($scope.gate_location) && inputValidationService.isValidInput($scope.system_gate_name) && inputValidationService.isValidInput($scope.project_name);
    return $scope.formValid;
  };
  $scope.$on('updatedUserData', function (event) {
    loadProjects();
  });
}]);
'use strict';

controllers.controller('GateBookingController', ['$uibModal', '$scope', '$rootScope', '$filter', 'errorService', 'orderFactory', 'orderPackageCollectionFactory', 'taskStatusService', '$localStorage', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, errorService, orderFactory, orderPackageCollectionFactory, taskStatusService, $localStorage, keyCodes) {
  $scope.innerRange = 5;
  $scope.currentPage = 1;
  $scope.itemRangeBottom = 0;
  $scope.itemRangeTop = 14;
  $scope.itemRange = 15;
  $scope.selectedAny = false;
  $scope.selectedAll = false;
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.hasMixedSelection = false;
  $scope.searchString = '';
  $scope.keyCode = '';
  $scope.lastSortCol = 'booking_number';
  $scope.sortCol = 'booking_number';
  $scope.sortReverse = false;
  $scope.sortReverseFn = function () {
    if ($scope.lastSortCol === $scope.sortCol && !$scope.sortReverse) {
      $scope.sortReverse = true;
    } else {
      $scope.lastSortCol = $scope.sortCol;
      $scope.sortReverse = false;
    }
  };
  var selected = [];
  $rootScope.reloadTable = function () {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    $scope.selectedAll = false;
    $scope.selectedAny = false;
    orderFactory.getGateBookings(sessionMainProject.main_project_id).then(function (response) {
      $scope.gateBookings = response.data;
      $scope.totalItems = $scope.gateBookings.length;
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $rootScope.reloadTable();
  $scope.checkAll = function () {
    selected = [];
    var filtered = $scope.package_collections;
    if (!$scope.showCancelled) filtered = $filter('filter')(filtered, {
      task_status: '!' + TaskStatusTypeEnum.CANCELLED
    }, true);
    angular.forEach(filtered, function (p) {
      p.selected = $scope.selectedAll;
      if (p.selected) {
        selected.push(p);
      }
    });
    $scope.updateSelection();
  };
  $scope.unCheckAll = function () {
    selected = [];
    angular.forEach($scope.package_collections, function (p) {
      p.selected = false;
    });
    $scope.updateSelection();
  };
  $scope.updateSelection = function () {
    var oneActiveSelected = false;
    var oneInactiveSelected = false;
    $scope.selectedAny = false;
    selected = [];
    angular.forEach($scope.package_collections, function (p) {
      if (!$scope.selectedAny && p.selected) {
        $scope.selectedAny = true;
      }
      if (p.selected) {
        selected.push(p);
      }
      if (!oneActiveSelected && !$scope.isCancelled(p.task_status) && p.selected) {
        oneActiveSelected = true;
      }
      if (!oneInactiveSelected && $scope.isCancelled(p.task_status) && p.selected) {
        oneInactiveSelected = true;
      }
    });
    if (!$scope.selectedAny) {
      $scope.selectedAll = false;
    }

    // Mixed selection
    if (oneActiveSelected && oneInactiveSelected) {
      $scope.hasMixedSelection = true;
      $scope.hasActiveSelection = true;
      $scope.hasInactiveSelection = true;
    } else {
      $scope.hasMixedSelection = false;
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
    }

    //Active selction
    if (oneActiveSelected && !oneInactiveSelected) {
      $scope.hasActiveSelection = true;
    } else $scope.hasActiveSelection = false;

    //Inactive selction
    if (!oneActiveSelected && oneInactiveSelected) {
      $scope.hasInactiveSelection = true;
    } else $scope.hasInactiveSelection = false;
  };
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.searchString = $scope.pendingSearchString;
      $scope.updateFullTableRange('filter', $scope.package_collections, $scope.searchString);
    }
  };
  $scope.updateFullTableRange = function (filter, array, param) {
    var filtered = $filter(filter)(array, param);
    $scope.totalItems = filtered.length;
  };
  $scope.updateFullTableRangeShowCancelled = function (array, showCancelled) {
    var finalArray = array;
    if (!$scope.showCancelled) {
      finalArray = $filter('filter')(array, {
        task_status: '!' + TaskStatusTypeEnum.CANCELLED
      }, true);
    }
    $scope.totalItems = finalArray.length;
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.currentPage - 1) * $scope.itemRange;
  };
  $scope.activatePackageCollections = function (isActive) {
    selected.forEach(function (data) {
      var orderDTO = orderPackageCollectionFactory.createOrderDTO(data);
      if (isActive) {
        // TODO: Not possible to reactivate an order yet.
      } else {
        orderFactory.cancelOrder(data.order_id, orderDTO).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      }
    });
  };
  $scope.isConfirmedOrLater = function (task_status) {
    return taskStatusService.isConfirmedOrLater(task_status);
  };
  $scope.isNotified = function (task_status) {
    return taskStatusService.isNotified(task_status);
  };
  $scope.isCancelled = function (task_status) {
    return taskStatusService.isCancelled(task_status);
  };
  $scope.$on('updatedUserData', function (event) {
    $rootScope.reloadTable();
  });
  $scope.$on('bookingOrderCreated', function (event) {
    $rootScope.reloadTable();
  });
}]);
'use strict';

controllers.controller('GatePassController', ['$uibModal', '$scope', '$rootScope', '$filter', 'gatePassFactory', 'errorService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, gatePassFactory, errorService, keyCodes) {
  $scope.innerRange = 5;
  $scope.currentPage = 1;
  $scope.itemRangeBottom = 0;
  $scope.itemRangeTop = 14;
  $scope.itemRange = 15;
  $scope.searchString = '';
  $scope.keyCode = '';
  $scope.lastSortCol = 'occurred';
  $scope.sortCol = 'occurred';
  $scope.sortReverse = true;
  $scope.sortReverseFn = function () {
    if ($scope.lastSortCol === $scope.sortCol && !$scope.sortReverse) {
      $scope.sortReverse = true;
    } else {
      $scope.lastSortCol = $scope.sortCol;
      $scope.sortReverse = false;
    }
  };
  var selected = [];
  $rootScope.reloadTable = function () {
    $scope.gates = [];
    gatePassFactory.getAllGatePasses().then(function (response) {
      response.data.forEach(loadData);
      $scope.totalItems = $scope.gates.length;
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $rootScope.reloadTable();
  function loadData(data, index) {
    $scope.selectedAll = false;
    $scope.selectedAny = false;
    var tempGate = {
      gate_pass_id: data.GatePassId,
      gate_id: data.GateId,
      gate_name: data.GateName,
      order_id: data.OrderId,
      order_number: data.OrderNumber,
      event_id: data.EventId,
      occurred: data.Occured,
      company: data.Company
    };
    if (isUnique($scope.gates, 'gate_pass_id', data.GatePassId)) {
      $scope.gates.push(tempGate);
    }
  }
  function isUnique(array, idKey, id) {
    var unique = true;
    array.forEach(function (entry, index) {
      if (entry[idKey] === id) {
        unique = false;
      }
    });
    return unique;
  }
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.searchString = $scope.pendingSearchString;
      $scope.updateFullTableRange('filter', $scope.gates, $scope.searchString);
    }
  };
  $scope.updateFullTableRange = function (filter, array, param) {
    var filtered = $filter(filter)(array, param);
    $scope.totalItems = filtered.length;
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.currentPage - 1) * $scope.itemRange;
  };
}]);
'use strict';

controllers.controller('ContactController', ['$uibModal', '$scope', '$rootScope', '$filter', 'contactFactory', 'errorService', '$localStorage', 'roleService', function ($uibModal, $scope, $rootScope, $filter, contactFactory, errorService, $localStorage, roleService) {
  var vm = this;
  vm.hasEditPermission = roleService.isAdmin() || roleService.isServicenter() || roleService.isProjectOwner();
  vm.contacts = [];
  $rootScope.updateContacts = function () {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) {
      errorService.handleError('No session main project');
      return;
    }
    contactFactory.getContacts(sessionMainProject.main_project_id, true).then(function (response) {
      var data = response.data;
      vm.contacts = contactFactory.repackageDTOArray(data);
      vm.filterInactiveContacts();
    }, function (error) {
      errorService.handleError(error);
    });
  };

  // Table bindings
  vm.tableItems = vm.contacts;
  vm.selectedContacts = [];
  vm.tableHeaderItems = [{
    propertyName: 'name',
    translateName: 'NAME'
  }, {
    propertyName: 'phone',
    translateName: 'PHONE'
  }, {
    propertyName: 'email',
    translateName: 'EMAIL'
  }, {
    propertyName: 'company',
    translateName: 'COMPANY'
  }, {
    propertyName: 'description',
    translateName: 'DESCRIPTION'
  }, {
    propertyName: 'is_active',
    translateName: 'ACTIVE'
  }];

  // Handle active/inactive contacts
  vm.showInactive = {
    value: false
  }; // Wrap in object to bind ng-model to correct scope
  vm.isActivatePossible = false;
  vm.isDectivatePossible = false;
  vm.filterInactiveContacts = function () {
    vm.tableItems = $filter('inactive')(vm.contacts, vm.showInactive.value);
  };
  vm.activateContacts = function (setToActive) {
    var onSuccess = function onSuccess(response) {
      $rootScope.updateContacts();
    };
    var onFailure = function onFailure(error) {
      errorService.handleError(error);
    };
    var selectedIds = vm.selectedContacts.map(function (contact) {
      return contact.contact_id;
    });
    if (setToActive) {
      contactFactory.activateContacts(selectedIds).then(onSuccess, onFailure);
    } else {
      contactFactory.deactivateContacts(selectedIds).then(onSuccess, onFailure);
    }
  };
  $rootScope.updateContacts(); // Initialize contacts

  $scope.$watchCollection('vm.selectedContacts', function () {
    var hasActiveSelection = false;
    var hasInactiveSelection = false;
    if (vm.selectedContacts.length >= 0) {
      angular.forEach(vm.selectedContacts, function (contact) {
        if (contact.is_active) {
          hasActiveSelection = true;
        } else {
          hasInactiveSelection = true;
        }
      });
    }
    vm.isActivatePossible = hasInactiveSelection && !hasActiveSelection;
    vm.isDeactivatePossible = hasActiveSelection && !hasInactiveSelection;
  });

  // --- MODAL - CREATE ---
  var animationsEnabled = true;
  vm.createContact = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/contact/contact_form.html',
      controller: 'ContactInstanceController',
      controllerAs: 'vm',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        formType: function formType() {
          return 'create';
        },
        id: function id() {
          return -1;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };

  // --- MODAL - VIEW ---
  vm.viewContact = function (contact) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/contact/contact_form.html',
      controller: 'ContactInstanceController',
      controllerAs: 'vm',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        formType: function formType() {
          return 'view';
        },
        id: function id() {
          return contact.contact_id;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };

  // Events
  $scope.$on('updatedUserData', function (event) {
    $rootScope.updateContacts();
  });
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('ContactInstanceController', ['$uibModalInstance', 'formType', 'id', '$rootScope', 'contactFactory', 'errorService', 'inputValidationService', '$localStorage', 'roleService', 'InputLengthLimits', function ($uibModalInstance, formType, id, $rootScope, contactFactory, errorService, inputValidationService, $localStorage, roleService, InputLengthLimits) {
  var vm = this;
  vm.isValid = false;
  vm.isValidated = false;
  vm.formType = formType;
  vm.hasEditPermission = roleService.isAdmin() || roleService.isServicenter() || roleService.isProjectOwner();
  var sessionMainProject = $localStorage.user.session_main_project;
  if (!sessionMainProject) {
    errorService.handleError('No session main project');
    $uibModalInstance.dismiss('cancel');
  }
  if (formType === 'view') {
    contactFactory.getContact(id).then(function (response) {
      var data = response.data;
      vm.name = data.Name;
      vm.phone = data.Phone;
      vm.email = data.Email;
      vm.company = data.Company, vm.main_contact_id = data.MainContactId;
      vm.description = data.Description;
      vm.is_active = data.IsActive;
    }, function (error) {
      errorService.handleError(error);
    });
  }

  // Finalizing or exiting form
  vm.createItem = function () {
    vm.validateForm();
    if (!vm.isValid) {
      return;
    }
    var DTO = {
      "Name": vm.name,
      "Phone": vm.phone,
      "Email": vm.email,
      "Company": vm.company,
      "Description": vm.description,
      "MainProjectId": sessionMainProject.main_project_id,
      "IsActive": true
    };
    contactFactory.createContact(DTO).then(function (response) {
      $rootScope.updateContacts();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close();
  };
  vm.activation = function (isActive) {
    vm.validateForm();
    if (!vm.isValid) {
      return;
    }
    if (isActive) {
      contactFactory.activateContact(id).then(function (response) {
        $rootScope.updateContacts();
      }, function (error) {
        errorService.handleError(error);
      });
    } else {
      contactFactory.deactivateContact(id).then(function (response) {
        $rootScope.updateContacts();
      }, function (error) {
        errorService.handleError(error);
      });
    }
    $uibModalInstance.close();
  };
  vm.updateItem = function () {
    vm.validateForm();
    if (!vm.isValid) {
      return;
    }
    var DTO = {
      "Name": vm.name,
      "Phone": vm.phone,
      "Email": vm.email,
      "Company": vm.company,
      "Description": vm.description,
      "MainProjectId": $localStorage.user.session_main_project.main_project_id,
      "IsActive": vm.is_active
    };
    contactFactory.updateContact(id, DTO).then(function (response) {
      $rootScope.updateContacts();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(); // Pass in returned item here.
  };

  vm.deleteItem = function () {
    contactFactory.deleteContact(id).then(function (response) {
      $rootScope.updateContacts();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(); // Pass in returned item here.
  };

  vm.setFormTypeManage = function () {
    vm.formType = 'manage';
  };
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  vm.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  vm.isValidEmail = function (input) {
    return inputValidationService.isValidEmail(input);
  };
  vm.validateForm = function () {
    vm.updateIsValid();
    vm.isValidated = true;
  };
  vm.updateIsValid = function () {
    vm.isValid = inputValidationService.isValidInput(vm.name) && inputValidationService.isValidInput(vm.phone) && inputValidationService.isValidEmail(vm.email);
    return vm.isValid;
  };
  vm.inputLengthLimits = {
    name: 100,
    company: 100,
    phone: InputLengthLimits.PHONE,
    email: InputLengthLimits.EMAIL,
    description: 1000
  };
}]);
'use strict';

controllers.controller('LocationController', ['$uibModal', '$scope', '$rootScope', '$filter', 'locationFactory', '$translate', 'errorService', '$localStorage', 'roleService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, locationFactory, $translate, errorService, $localStorage, roleService, keyCodes) {
  $scope.isAdmin = roleService.isAdmin();
  $scope.locationLevelIndexDepth = 0;
  $scope.sortCol = "sort_order";
  var nonCollapsedNodeCollection = [];
  var rulesApplied = false;
  var sessionMainProject = $localStorage.user.session_main_project;

  // For ng-repeat
  $scope.getEmptyLevels = function (levels) {
    if (levels <= 2) {
      return;
    }
    return new Array(levels);
  };
  locationFactory.getLocationTreeRules(sessionMainProject.division_id).then(function (response) {
    $scope.locationTreeRules = response.data;
    if (!rulesApplied && $scope.locations.length) applyLocationTreeRules();
  }, function (error) {
    errorService.handleError(error);
  });
  $rootScope.reloadTable = function () {
    if (!sessionMainProject) return;
    $scope.locations = [];
    locationFactory.getLocations(sessionMainProject.main_project_id).then(function (response) {
      var data = response.data;
      var locations = locationFactory.repackageDTOArray(data);
      findTreeDepth(locations);
      $scope.locations = $filter('orderBy')(locations, 'sort_order');
      $scope.totalItems = $scope.locations.length;
      if (!rulesApplied && $scope.locationTreeRules) applyLocationTreeRules();
      if (nonCollapsedNodeCollection.length > 0) reopenNodeTree(nonCollapsedNodeCollection, $scope.locations);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $rootScope.reloadTable();

  // LocationTreeRules start
  function applyLocationTreeRules() {
    angular.forEach($scope.locations, function (location) {
      location.possibleChildren = getLocationChildren(location.location_type_id);
    });
  }
  function getLocationChildren(locationTypeId) {
    var possibleChildren = [];
    angular.forEach($scope.locationTreeRules, function (rule) {
      if (rule.LocationTypeId === locationTypeId) {
        possibleChildren = rule.ChildLocationTypeIds;
      }
    });
    return possibleChildren;
  }
  // LocationTreeRules end

  function findTreeDepth(tree) {
    angular.forEach(tree, function (node) {
      if (node.level > $scope.locationLevelIndexDepth) {
        $scope.locationLevelIndexDepth = node.level;
      }
    });
  }
  function isUnique(array, idKey, id) {
    var unique = true;
    array.forEach(function (entry, index) {
      if (entry[idKey] === id) {
        unique = false;
      }
    });
    return unique;
  }
  $scope.hasChildren = function (location) {
    var hasAnyChild = $scope.locations.some(function (l) {
      return l.parent_location_id === location.location_id;
    });
    return hasAnyChild;
  };
  function getChildLocations(parent) {
    var children = $filter('filter')($scope.locations, function (l) {
      return l.parent_location_id === parent.location_id;
    });
    return children;
  }
  $scope.expandSection = function (location) {
    if (location.collapsed) {
      $scope.toggleNode(location);
    }
    var children = getChildLocations(location);
    angular.forEach(children, function (child) {
      child.show = true;
    });
  };
  $scope.collapseSection = function (location) {
    if (!location.collapsed) {
      $scope.toggleNode(location);
    }
    var children = getChildLocations(location);
    angular.forEach(children, function (child) {
      child.show = false;
      $scope.collapseSection(child); // Collapse all sub-sections
    });
  };

  $scope.updateCollapsed = function () {
    angular.forEach($scope.locations, function (location) {
      var parent = findParent(location);
      if (!parent) {
        location.show = true; // Always show first node
      } else {
        location.show = !parent.collapsed;
      }
    });
  };

  // Toggles and remembers wich are opened. Reopen on table refresh
  $scope.toggleNode = function (node) {
    node.collapsed = !node.collapsed;
    if (!node.collapsed) {
      nonCollapsedNodeCollection.push(node);
    } else {
      var index = nonCollapsedNodeCollection.indexOf(node);
      nonCollapsedNodeCollection.splice(index, 1);
    }
  };
  function reopenNodeTree(nonCollapsedNodeCollection, locations) {
    // Update collapsed = false from saved collection
    angular.forEach(nonCollapsedNodeCollection, function (savedNode) {
      angular.forEach(locations, function (node) {
        if (savedNode.location_id === node.location_id) {
          node.collapsed = false;
        }
      });
    });
    // Open table
    $scope.updateCollapsed();
  }
  ;
  function findParent(node) {
    var parent = $scope.locations.find(function (l) {
      return l.location_id === node.parent_location_id;
    });
    return parent;
  }
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.searchLocationTree($scope.pendingSearchString);
    }
  };
  $scope.searchLocationTree = function (locationName) {
    var lastsibbling = null;
    var pattern = new RegExp('.*' + locationName + '.*', 'i');
    resetSearchedNode();
    resetSearchedPath();
    angular.forEach($scope.locations, function (data, index) {
      if (pattern.test(data.location_name)) {
        data.searched_node = true;
        lastsibbling = findLastSibbling(data, index);
        lightUpAndExpandPath(lastsibbling[0], lastsibbling[1]);
      }
    });
  };
  function findLastSibbling(node, index) {
    var nodeLevel = node.level;
    var sibbling = null;
    var sibblingIndex = null;
    var currentNode = null;
    for (var i = index; i < $scope.locations.length; i++) {
      currentNode = $scope.locations[i];
      if (currentNode.level !== nodeLevel) {
        break;
      }
      if (currentNode.level === node.level) {
        sibbling = currentNode;
        sibblingIndex = index;
      }
    }

    // Is at least self
    return [sibbling, sibblingIndex];
  }
  function lightUpAndExpandPath(endNode, index) {
    var endNodeLevel = endNode.level;
    if (endNodeLevel === 0) {
      return;
    }
    var currentNode = null;
    var currentPathLevel = endNode.level;
    var prevNodeParentId = endNode.parent_location_id;
    endNode.show = true;
    for (var i = index; i >= 0; i--) {
      currentNode = $scope.locations[i];
      if (currentNode.level < currentPathLevel) {
        currentPathLevel = currentNode.level;
      }
      if (currentNode.level === currentPathLevel) {
        currentNode.show = true;
      }
      if (currentNode.location_id === prevNodeParentId) {
        currentNode.searched_path = true;
        currentNode.collapsed = false;
        prevNodeParentId = currentNode.parent_location_id;
        currentNode = $scope.locations[i];
      }
      if (currentNode.level === 0) {
        break;
      }
    }
  }
  $scope.closeTree = function () {
    angular.forEach($scope.locations, function (data, index) {
      data.show = false;
      data.collapsed = true;
      data.searched_path = false;
      data.searched_node = false;
    });
  };
  $scope.openTree = function () {
    angular.forEach($scope.locations, function (data, index) {
      data.show = true;
      data.collapsed = false;
      data.searched_path = false;
      data.searched_node = false;
    });
  };
  function resetSearchedNode() {
    angular.forEach($scope.locations, function (data, index) {
      data.searched_node = false;
    });
  }
  function resetSearchedPath() {
    angular.forEach($scope.locations, function (data, index) {
      data.searched_path = false;
    });
  }

  // --- MODAL - CREATE ---
  $scope.createLocation = function (parentId, _possibleChildren) {
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/location/location_form.html',
      controller: 'LocationInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create_location';
        },
        id: function id() {
          return parentId;
        },
        possibleChildren: function possibleChildren() {
          return _possibleChildren;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };

  // --- MODAL - VIEW UNLOADING PLACE ---
  $scope.viewLocation = function (_id, _possibleChildren2) {
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/location/location_form.html',
      controller: 'LocationInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view_location';
        },
        id: function id() {
          return _id;
        },
        possibleChildren: function possibleChildren() {
          return _possibleChildren2;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };
  $scope.$on('updatedUserData', function (event) {
    $rootScope.reloadTable();
  });
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('LocationInstanceController', ['$uibModalInstance', 'form_type', 'id', 'possibleChildren', '$scope', '$rootScope', 'locationFactory', '$translate', 'errorService', 'inputValidationService', 'generalHelperService', function ($uibModalInstance, form_type, id, possibleChildren, $scope, $rootScope, locationFactory, $translate, errorService, inputValidationService, generalHelperService) {
  $scope.validated = false;
  $scope.form_type = form_type;
  if (form_type === 'view_location') {
    locationFactory.getLocation(id).then(function (response) {
      var data = response.data;
      $scope.location = locationFactory.repackageDTO(data);
      doChecks($scope.location.location_type_id);
      $scope.location.location_type_name = $translate.instant($scope.getChildTranslationKey($scope.location.location_type_id));
    }, errorService.handleError);
  } else if (form_type === 'create_location') {
    $scope.location = {
      possibleChildren: possibleChildren,
      parent_location_id: id
    };
    $scope.canEditScannable = true;
    $scope.canEditBaseData = true;
  }
  function doChecks(typeId) {
    checkCanEditScannable(typeId);
    checkCanEditBaseData(typeId);
  }
  function checkCanEditScannable(typeId) {
    $scope.canEditScannable = !(typeId === LocationTypeEnum.MAIN_PROJECT || typeId === LocationTypeEnum.PROJECT || typeId === LocationTypeEnum.VEHICLE || typeId === LocationTypeEnum.GROUPAGE_AREA);
  }
  ;
  function checkCanEditBaseData(typeId) {
    $scope.canEditBaseData = !(typeId === LocationTypeEnum.MAIN_PROJECT || typeId === LocationTypeEnum.PROJECT || typeId === LocationTypeEnum.SUB_PROJECT || typeId === LocationTypeEnum.VEHICLE || typeId === LocationTypeEnum.GROUPAGE_AREA);
  }
  ;

  // Finalizing or exiting form
  $scope.create = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var locations = [];
    var DTO = locationFactory.createDTO($scope.location);
    locations.push(DTO);

    // Create multiple locations
    if ($scope.addMultipleLocations) {
      locations = [];
      var index = $scope.number_start;
      for (var i = 0; i < $scope.n_locations; i++) {
        locations.push(jQuery.extend({}, DTO));
        locations[i].Name += index;
        index++;
      }
    }
    locations.forEach(function (data) {
      locationFactory.createLocation(data).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    });
    $uibModalInstance.close(); // Pass in returned item here.
  };

  $scope.activation = function (isActive) {
    $scope.validated = true;
    if (!$scope.validateForm()) return;
    if (isActive) {
      locationFactory.activateLocation($scope.location.location_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    } else {
      locationFactory.deactivateLocation($scope.location.location_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    }
    $uibModalInstance.close(); // Pass in returned item here.
  };

  $scope.update = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = locationFactory.createDTO($scope.location);
    DTO['IsActive'] = $scope.location.is_active;
    locationFactory.updateLocation(DTO.LocationId, DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(); // Pass in returned item here.
  };

  $scope.delete = function () {
    locationFactory.deleteLocation($scope.location.location_id).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(); // Pass in returned item here.
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  $scope.validateForm = function () {
    $scope.formValid = inputValidationService.isValidInput($scope.location.location_type_name) && inputValidationService.isValidInput($scope.location.location_name);
    if ($scope.formValid && $scope.addMultipleLocations) {
      $scope.formValid = inputValidationService.isValidInput($scope.number_start) && inputValidationService.isValidInput($scope.n_locations);
    }
    return $scope.formValid;
  };
  $scope.getChildTranslationKey = function (childLocationTypeId) {
    return generalHelperService.getKeyByValue(LocationTypeEnum, childLocationTypeId);
  };
  $scope.inputLengthLimits = {
    vehicle_drop: 30,
    floor: 20,
    room: 20,
    position: 20,
    other: 20
  };
  $scope.getInputLengthLimit = function () {
    if (!$scope.location) {
      return 100;
    }
    switch ($scope.location.location_type_id) {
      case LocationTypeEnum.VEHICLE_DROP:
        return $scope.inputLengthLimits.vehicle_drop;
      case LocationTypeEnum.FLOOR:
        return $scope.inputLengthLimits.floor;
      case LocationTypeEnum.ROOM:
        return $scope.inputLengthLimits.room;
      case LocationTypeEnum.POSITION:
        return $scope.inputLengthLimits.position;
      case LocationTypeEnum.OTHER:
        return $scope.inputLengthLimits.other;
      default:
        return 100;
    }
  };
}]);
'use strict';

controllers.controller('MainProjectController', ['$uibModal', '$scope', '$rootScope', '$filter', 'mainProjectFactory', 'errorService', 'userFactory', 'roleService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, mainProjectFactory, errorService, userFactory, roleService, keyCodes) {
  $scope.isAdmin = roleService.isAdmin();
  $scope.innerRange = 5;
  $scope.currentPage = 1;
  $scope.itemRangeBottom = 0;
  $scope.itemRangeTop = 14;
  $scope.itemRange = 15;
  $scope.selectedAny = false;
  $scope.selectedAll = false;
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.hasMixedSelection = false;
  $scope.showInactive = false;
  $scope.searchString = '';
  $scope.keyCode = '';
  $scope.lastSortCol = 'main_project_name';
  $scope.sortCol = 'main_project_name'; // set the default sort 
  $scope.sortReverse = false; // set the default sort order
  $scope.sortReverseFn = function () {
    if ($scope.lastSortCol === $scope.sortCol && !$scope.sortReverse) {
      $scope.sortReverse = true;
    } else {
      $scope.lastSortCol = $scope.sortCol;
      $scope.sortReverse = false;
    }
  };
  var selected = [];
  $rootScope.reloadTable = function () {
    $scope.selectedAll = false;
    $scope.selectedAny = false;
    mainProjectFactory.getMainProjects().then(function (response) {
      var data = response.data;
      $scope.main_projects = mainProjectFactory.repackageDTOArray(data);
      $scope.totalItems = $scope.main_projects.length; // Data from external models must be loaded after projects are set.
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $rootScope.reloadTable();
  $scope.checkAll = function () {
    if (!$scope.selectedAll) {
      $scope.unCheckAll();
      return;
    }
    var filtered = getVisibleItems($scope.main_projects);
    angular.forEach(filtered, function (p) {
      p.selected = true;
    });
    $scope.updateSelection();
  };
  $scope.unCheckAll = function () {
    angular.forEach($scope.main_projects, function (p) {
      p.selected = false;
    });
    $scope.updateSelection();
  };
  $scope.updateSelection = function () {
    var oneActiveSelected = false;
    var oneInactiveSelected = false;
    var filtered = getVisibleItems($scope.main_projects);
    $scope.selectedAny = false;
    selected = [];
    angular.forEach(filtered, function (p) {
      if (!$scope.selectedAny && p.selected) {
        $scope.selectedAny = true;
      }
      if (p.selected) {
        selected.push(p);
      }
      if (!oneActiveSelected && p.is_active && p.selected) {
        oneActiveSelected = true;
      }
      if (!oneInactiveSelected && !p.is_active && p.selected) {
        oneInactiveSelected = true;
      }
    });
    if (!$scope.selectedAny) {
      $scope.selectedAll = false;
    }

    // Mixed selection
    if (oneActiveSelected && oneInactiveSelected) {
      $scope.hasMixedSelection = true;
      $scope.hasActiveSelection = true;
      $scope.hasInactiveSelection = true;
    } else {
      $scope.hasMixedSelection = false;
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
    }

    //Active selction
    if (oneActiveSelected && !oneInactiveSelected) {
      $scope.hasActiveSelection = true;
    } else $scope.hasActiveSelection = false;

    //Inactive selction
    if (!oneActiveSelected && oneInactiveSelected) {
      $scope.hasInactiveSelection = true;
    } else $scope.hasInactiveSelection = false;
  };
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.searchString = $scope.pendingSearchString;
      $scope.updateFullTableRange();
    }
  };
  $scope.updateFullTableRange = function () {
    $scope.updateSelection();
    var filtered = getVisibleItems($scope.main_projects);
    $scope.totalItems = filtered.length;
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.currentPage - 1) * $scope.itemRange;
  };

  // --- MODAL - CREATE ---
  $scope.createMainProject = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/main_project/main_project_form.html',
      controller: 'MainProjectInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create_main_project';
        },
        id: function id() {
          return -1;
        }
      }
    });
    modalInstance.result.then(function (results) {
      userFactory.setUserData(true);
    });
  };
  $scope.activateMainProjects = function (isActive) {
    selected.forEach(function (data) {
      if (isActive) {
        mainProjectFactory.activateMainProject(data.main_project_id).then(function (response) {
          $rootScope.reloadTable();
          userFactory.setUserData(true);
        }, function (error) {
          errorService.handleError(error);
        });
      } else {
        mainProjectFactory.deactivateMainProject(data.main_project_id).then(function (response) {
          $rootScope.reloadTable();
          userFactory.setUserData(true);
        }, function (error) {
          errorService.handleError(error);
        });
      }
    });
  };
  function getVisibleItems(array) {
    var filtered = array;
    if (!$scope.showInactive) {
      filtered = $filter('inactive')(filtered, $scope.showInactive);
    }
    if ($scope.searchString) {
      filtered = $filter('filter')(filtered, $scope.searchString);
    }
    return filtered;
  }

  // --- MODAL - VIEW UNLOADING PLACE ---
  $scope.viewMainProject = function (_id) {
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/main_project/main_project_form.html',
      controller: 'MainProjectInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view_main_project';
        },
        id: function id() {
          return _id;
        }
      }
    });
    modalInstance.result.then(function (results) {
      userFactory.setUserData(true);
    });
  };
  $scope.$on('mainProjectsRepeatFinished', function (mainProjectsRepeatFinishedEvent) {
    $scope.updateFullTableRange();
  });
  $scope.$on('updatedUserData', function (event) {
    $rootScope.reloadTable();
  });
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('MainProjectInstanceController', ['$uibModalInstance', 'form_type', 'id', '$scope', '$rootScope', 'mainProjectFactory', 'divisionFactory', 'inputValidationService', 'userFactory', 'errorService', 'InputLengthLimits', function ($uibModalInstance, form_type, id, $scope, $rootScope, mainProjectFactory, divisionFactory, inputValidationService, userFactory, errorService, InputLengthLimits) {
  $scope.main_project = {};
  $scope.validated = false;
  $scope.form_type = form_type;
  if (form_type === 'view_main_project') {
    mainProjectFactory.getMainProject(id).then(function (response) {
      var data = response.data;
      var mainProject = mainProjectFactory.repackageDTO(data);
      $scope.main_project = mainProject;
      loadLesParameterList(id);
      loadValuesFromDTO();
    }, function (error) {
      errorService.handleError(error);
    });
  } else if (form_type === 'create_main_project') {
    loadLesParameterList(id);
    $scope.main_project.is_direct_delivery_function_enabled = true;
  }
  function loadDivisions() {
    divisionFactory.getDivisions().then(function (response) {
      var data = response.data;
      $scope.divisions = divisionFactory.repackageDTOArray(data);
    }, function (error) {
      errorService.handleError(error);
    });
  }
  ;
  loadDivisions();
  function loadLesParameterList(mainProjectId) {
    var lesParameters = [];
    angular.forEach(LesParameterTypeEnum, function (value, key) {
      lesParameters.push({
        MainProjectId: mainProjectId ? mainProjectId : null,
        LesParameterId: undefined,
        // The db will assign a unique key
        LesParameterTypeName: key,
        LesParameterTypeId: value,
        Value: ''
      });
    });
    $scope.main_project.les_parameters = lesParameters;
  }
  function loadValuesFromDTO() {
    angular.forEach($scope.main_project.les_parameters, function (les) {
      angular.forEach($scope.main_project.les_parameters_dto, function (lesDTO) {
        if (les.LesParameterTypeId == lesDTO.LesParameterTypeId) {
          les.Value = lesDTO.Value;
          les.LesParameterId = lesDTO.LesParameterId;
        }
      });
    });
  }

  // Finalizing or exiting form
  $scope.create = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = mainProjectFactory.createDTO($scope.main_project);
    DTO['IsActive'] = true;
    var results = '';
    mainProjectFactory.createMainProject(DTO).then(function (response) {
      userFactory.setUserData(true); // Refreshes available mainprojects in header, force refresh
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(results); // Pass in returned item here.
  };

  $scope.activation = function (isActive) {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    if (isActive) {
      mainProjectFactory.activateMainProject($scope.main_project.main_project_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    } else {
      mainProjectFactory.deactivateMainProject($scope.main_project.main_project_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    }
    var results = '';
    $uibModalInstance.close(results); // Pass in returned item here.
  };

  $scope.update = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = mainProjectFactory.createDTO($scope.main_project);
    var results = '';
    mainProjectFactory.updateMainProject(DTO.MainProjectId, DTO).then(function (response) {
      $rootScope.reloadTable();
      userFactory.setUserData(true);
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(results); // Pass in returned item here.
  };

  $scope.delete = function () {
    var results = '';
    mainProjectFactory.deleteMainProject($scope.main_project.main_project_id).then(function (response) {
      userFactory.setUserData(true); // Refreshes available mainprojects, force refresh = true
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(results); // Pass in returned item here.
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  $scope.validateForm = function () {
    $scope.formValid = inputValidationService.isValidInput($scope.main_project.main_project_name) && inputValidationService.isValidInput($scope.main_project.groupage_area_name) && inputValidationService.isValidInput($scope.main_project.city) && inputValidationService.isValidInput($scope.main_project.division_name) && inputValidationService.isValidInput($scope.main_project.external_support_phone_number) && inputValidationService.isValidInput($scope.main_project.external_support_email) && inputValidationService.isValidInput($scope.main_project.main_project_article_number) && inputValidationService.isValidInput($scope.main_project.main_project_hours_to_min_order_date);
    return $scope.formValid;
  };
  $scope.inputLengthLimits = {
    main_project_name: 30,
    groupage_area_name: 30,
    phone: InputLengthLimits.PHONE,
    email: InputLengthLimits.EMAIL
  };
}]);
'use strict';

controllers.controller('MainProjectFileController', ['$uibModal', 'roleService', 'errorService', '$scope', '$rootScope', '$localStorage', 'mainProjectFileFactory', function ($uibModal, roleService, errorService, $scope, $rootScope, $localStorage, mainProjectFileFactory) {
  $scope.hasEditPermission = roleService.isAdmin() || roleService.isServicenter() || roleService.isProjectOwner();
  $scope.mainProjectFiles = [];
  $rootScope.updateMainProjectFiles = function () {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    mainProjectFileFactory.getMainProjectFiles(sessionMainProject.main_project_id).then(function (response) {
      var data = response.data;
      $scope.mainProjectFiles = mainProjectFileFactory.repackageDTOArray(data);
    }, function (error) {
      errorService.handleError(error);
    });
  };

  // Table bindings
  $scope.tableHeaderItems = [{
    propertyName: 'header',
    translateName: 'TITLE'
  }, {
    propertyName: 'fileName',
    translateName: 'FILE'
  }, {
    propertyName: 'comments',
    translateName: 'COMMENTS'
  }, {
    propertyName: 'fileUploaded',
    translateName: 'DATE'
  }, {
    propertyName: 'file',
    translateName: 'DOWNLOAD'
  }];
  $rootScope.updateMainProjectFiles();

  // --- MODAL - CREATE ---
  $scope.createMainProjectFile = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/main_project_file/main_project_file_form.html',
      controller: 'MainProjectFileInstanceController',
      controllerAs: 'vm',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        formType: function formType() {
          return 'create';
        },
        id: function id() {
          return -1;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };

  // --- MODAL - VIEW ---
  $scope.viewMainProjectFile = function (item) {
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/main_project_file/main_project_file_form.html',
      controller: 'MainProjectFileInstanceController',
      controllerAs: 'vm',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        formType: function formType() {
          return 'view';
        },
        id: function id() {
          return item.mainProjectFileId;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };

  // Events
  $scope.$on('updatedUserData', function (event) {
    $rootScope.updateMainProjectFiles();
  });
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('MainProjectFileInstanceController', ['$uibModalInstance', '$localStorage', '$rootScope', 'formType', 'inputValidationService', 'roleService', 'errorService', 'mainProjectFileFactory', 'id', function ($uibModalInstance, $localStorage, $rootScope, formType, inputValidationService, roleService, errorService, mainProjectFileFactory, id) {
  var vm = this;
  vm.id = id;
  vm.formType = formType;
  vm.showErrors = false;
  vm.filename = "", vm.isValidInput = false;
  vm.hasEditPermission = roleService.isAdmin() || roleService.isServicenter() || roleService.isProjectOwner();
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  if (formType === 'view') {
    mainProjectFileFactory.getMainProjectFile(id).then(function (response) {
      var data = response.data;
      vm.mainProjectFileId = vm.id;
      vm.filename = data.File != null ? data.File.FileName : "", vm.header = data.Header;
      vm.comments = data.Comments;
    }, function (error) {
      errorService.handleError(error);
    });
  }
  vm.createItem = function () {
    vm.showErrors = true;
    if (!vm.validateForm()) {
      return;
    }
    var DTO = {
      "MainProjectId": $localStorage.user.session_main_project.main_project_id,
      "Header": vm.header,
      "Comments": vm.comments
    };
    mainProjectFileFactory.createMainProjectFile(DTO, vm.file).then(function (response) {
      $rootScope.updateMainProjectFiles();
      $uibModalInstance.close();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.updateItem = function () {
    vm.showErrors = true;
    if (!vm.validateForm()) {
      return;
    }
    var DTO = {
      "MainProjectId": $localStorage.user.session_main_project.main_project_id,
      "Header": vm.header,
      "Comments": vm.comments
    };
    mainProjectFileFactory.updateMainProjectFile(id, DTO, vm.file).then(function (response) {
      $rootScope.updateMainProjectFiles();
      $uibModalInstance.close();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.deleteItem = function () {
    mainProjectFileFactory.deleteMainProjectFile(id).then(function (response) {
      $rootScope.updateMainProjectFiles();
      $uibModalInstance.close();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.setFormTypeManage = function () {
    vm.formType = 'manage';
  };
  vm.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  vm.validateForm = function () {
    return inputValidationService.isValidInput(vm.header) && vm.isValidFile;
  };
  vm.onFileSelected = function (newFile, isValid) {
    vm.file = newFile;
    vm.isValidFile = isValid;
  };
}]);
'use strict';

controllers.controller('ProjectController', ['$uibModal', '$scope', '$rootScope', '$filter', 'projectFactory', 'errorService', '$localStorage', 'roleService', function ($uibModal, $scope, $rootScope, $filter, projectFactory, errorService, $localStorage, roleService) {
  $scope.isAdmin = roleService.isAdmin();
  $scope.isServicenter = roleService.isServicenter();
  $scope.isProjectOwner = roleService.isProjectOwner();
  $scope.projects = [];
  $rootScope.updateProjects = function () {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    projectFactory.getProjects(sessionMainProject.main_project_id, true).then(function (response) {
      var data = response.data;
      $scope.projects = projectFactory.repackageDTOArray(data);
      $scope.filterInactiveProjects();
    }, function (error) {
      errorService.handleError(error);
    });
  };

  // Table bindings
  $scope.tableItems = $scope.projects;
  $scope.selectedProjects = [];
  $scope.tableHeaderItems = [{
    propertyName: 'project_name',
    translateName: 'PROJECT'
  }, {
    propertyName: 'project_short_name',
    translateName: 'PROJECT_NUMBER'
  }, {
    propertyName: 'city',
    translateName: 'CITY'
  }, {
    propertyName: 'gate_in_name',
    translateName: 'GATES_IN'
  }, {
    propertyName: 'gate_out_name',
    translateName: 'GATES_OUT'
  }, {
    propertyName: 'is_active',
    translateName: 'ACTIVE'
  }];

  // Handle active/inactive projects
  $scope.showInactive = {
    value: false
  }; // Wrap in object to bind ng-model to correct scope
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.filterInactiveProjects = function () {
    $scope.tableItems = $filter('inactive')($scope.projects, $scope.showInactive.value);
  };
  $scope.activateProjects = function (setToActive) {
    $scope.selectedProjects.forEach(function (project) {
      if (setToActive) {
        projectFactory.activateProject(project.project_id).then(function (response) {
          $rootScope.updateProjects();
        }, function (error) {
          errorService.handleError(error);
        });
      } else {
        projectFactory.deactivateProject(project.project_id).then(function (response) {
          $rootScope.updateProjects();
        }, function (error) {
          errorService.handleError(error);
        });
      }
    });
  };
  $rootScope.updateProjects(); // Initialize projects

  $scope.$watchCollection('selectedProjects', function () {
    if ($scope.selectedProjects.length === 0) {
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
    } else {
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
      angular.forEach($scope.selectedProjects, function (project) {
        if (project.is_active) {
          $scope.hasActiveSelection = true;
        } else {
          $scope.hasInactiveSelection = true;
        }
      });
    }
  });

  // --- MODAL - CREATE ---
  var animationsEnabled = true;
  $scope.createProject = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/project/project_form.html',
      controller: 'ProjectInstanceController',
      controllerAs: 'vm',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create';
        },
        id: function id() {
          return -1;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };

  // --- MODAL - VIEW ---
  $scope.viewProject = function (project) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/project/project_form.html',
      controller: 'ProjectInstanceController',
      controllerAs: 'vm',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view';
        },
        id: function id() {
          return project.project_id;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };

  // Events
  $scope.$on('updatedUserData', function (event) {
    $rootScope.updateProjects();
  });
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('ProjectInstanceController', ['$uibModalInstance', 'form_type', 'id', '$rootScope', 'projectFactory', 'errorService', 'inputValidationService', '$localStorage', 'roleService', function ($uibModalInstance, form_type, id, $rootScope, projectFactory, errorService, inputValidationService, $localStorage, roleService) {
  var vm = this;
  vm.validated = false;
  vm.form_type = form_type;
  vm.isAdmin = roleService.isAdmin();
  var sessionMainProject = $localStorage.user.session_main_project;
  if (!sessionMainProject) $uibModalInstance.dismiss('cancel');
  if (form_type === 'view') {
    projectFactory.getProject(id).then(function (response) {
      var data = response.data;
      vm.project_id = id;
      vm.project_name = data.Name;
      vm.project_short_name = data.ShortName;
      vm.main_project_id = data.MainProjectId;
      vm.main_project_name = data.MainProjectName;
      vm.gate_in_id = data.DefaultGateInId;
      vm.gate_in_name = data.DefaultGateInName;
      vm.gate_out_id = data.DefaultGateOutId;
      vm.gate_out_name = data.DefaultGateOutName;
      vm.zip_code = parseInt(data.ZipCode);
      vm.city = data.City;
      vm.is_active = data.IsActive;
      vm.comments = data.Comments;
    }, function (error) {
      errorService.handleError(error);
    });
  } else {
    vm.main_project_id = sessionMainProject.main_project_id;
    vm.main_project_name = sessionMainProject.main_project_name;
  }

  // Finalizing or exiting form
  vm.createItem = function () {
    vm.validated = true;
    if (!vm.validateForm()) {
      return;
    }
    var DTO = {
      "Name": vm.project_name,
      "ProjectId": vm.project_id,
      "ShortName": vm.project_short_name,
      "MainProjectId": vm.main_project_id,
      "MainProjectName": vm.main_project_name,
      "DefaultInGateId": vm.gate_in_id,
      "DefaultInGateName": vm.gate_in_name,
      "DefaultOutGateId": vm.gate_out_id,
      "DefaultOutGateName": vm.gate_out_name,
      "ZipCode": vm.zip_code,
      "City": vm.city,
      "IsActive": true,
      "Comments": vm.comments
    };
    projectFactory.createProject(DTO).then(function (response) {
      $rootScope.updateProjects();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close();
  };
  vm.activation = function (isActive) {
    vm.validated = true;
    if (!vm.validateForm()) {
      return;
    }
    if (isActive) {
      projectFactory.activateProject(vm.project_id).then(function (response) {
        $rootScope.updateProjects();
      }, function (error) {
        errorService.handleError(error);
      });
    } else {
      projectFactory.deactivateProject(vm.project_id).then(function (response) {
        $rootScope.updateProjects();
      }, function (error) {
        errorService.handleError(error);
      });
    }
    $uibModalInstance.close();
  };
  vm.updateItem = function () {
    vm.validated = true;
    if (!vm.validateForm()) {
      return;
    }
    var DTO = {
      "ProjectId": vm.project_id,
      "Name": vm.project_name,
      "ShortName": vm.project_short_name,
      "MainProjectId": vm.main_project_id,
      "MainProjectName": vm.main_project_name,
      "DefaultInGateId": vm.gate_in_id,
      "DefaultInGateName": vm.gate_in_name,
      "DefaultOutGateId": vm.gate_out_id,
      "DefaultOutGateName": vm.gate_out_name,
      "ZipCode": vm.zip_code,
      "City": vm.city,
      "IsActive": vm.is_active,
      "Comments": vm.comments
    };
    projectFactory.updateProject(DTO.ProjectId, DTO).then(function (response) {
      $rootScope.updateProjects();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(); // Pass in returned item here.
  };

  vm.deleteItem = function () {
    projectFactory.deleteProject(vm.project_id).then(function (response) {
      $rootScope.updateProjects();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(); // Pass in returned item here.
  };

  vm.setFormTypeManage = function () {
    vm.form_type = 'manage';
  };
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  vm.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  vm.validateForm = function () {
    vm.formValid = inputValidationService.isValidInput(vm.project_name) && inputValidationService.isValidInput(vm.main_project_name) && inputValidationService.isValidInput(vm.city) && inputValidationService.isValidInput(vm.zip_code);
    return vm.formValid;
  };
  vm.inputLengthLimits = {
    project_name: 20
  };
}]);
'use strict';

controllers.controller('SubProjectController', ['$uibModal', '$scope', '$rootScope', '$filter', 'subProjectFactory', 'errorService', '$localStorage', 'roleService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, subProjectFactory, errorService, $localStorage, roleService, keyCodes) {
  $scope.isAdmin = roleService.isAdmin();
  $scope.isServicenter = roleService.isServicenter();
  $scope.isProjectOwner = roleService.isProjectOwner();
  $scope.subProjects = [];
  $rootScope.reloadTable = function () {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    subProjectFactory.getSubProjects(sessionMainProject.main_project_id, true).then(function (response) {
      var data = response.data;
      $scope.subProjects = subProjectFactory.repackageDTOArray(data);
      $scope.filterInactiveItems();
    }, function (error) {
      errorService.handleError(error);
    });
  };

  // Table bindings
  $scope.tableItems = $scope.subProjects;
  $scope.selectedItems = [];
  $scope.tableHeaderItems = [{
    propertyName: 'sub_project_name',
    translateName: 'SUB_PROJECT'
  }, {
    propertyName: 'sub_project_short_name',
    translateName: 'SUB_PROJECT_NUMBER'
  }, {
    propertyName: 'project_name',
    translateName: 'PROJECT'
  }, {
    propertyName: 'is_active',
    translateName: 'ACTIVE'
  }];

  // Handle active/inactive
  $scope.showInactive = {
    value: false
  }; // Wrap in object to bind ng-model to correct scope
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.filterInactiveItems = function () {
    $scope.tableItems = $filter('inactive')($scope.subProjects, $scope.showInactive.value);
  };
  $scope.activateSelectedItems = function (setToActive) {
    $scope.selectedItems.forEach(function (data) {
      if (setToActive) {
        subProjectFactory.activateSubProject(data.sub_project_id).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      } else {
        subProjectFactory.deactivateSubProject(data.sub_project_id).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      }
    });
  };
  $rootScope.reloadTable(); // Initialize table

  $scope.$watchCollection('selectedItems', function () {
    if ($scope.selectedItems.length === 0) {
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
    } else {
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
      angular.forEach($scope.selectedItems, function (subProject) {
        if (subProject.is_active) {
          $scope.hasActiveSelection = true;
        } else {
          $scope.hasInactiveSelection = true;
        }
      });
    }
  });

  // --- MODAL - CREATE ---
  var animationsEnabled = true;
  $scope.createSubProject = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/sub_project/sub_project_form.html',
      controller: 'SubProjectInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create_sub_project';
        },
        id: function id() {
          return -1;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };

  // --- MODAL - VIEW SUB PROJECT ---
  $scope.viewSubProject = function (subProject) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/sub_project/sub_project_form.html',
      controller: 'SubProjectInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view_sub_project';
        },
        id: function id() {
          return subProject.sub_project_id;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };

  // Events
  $scope.$on('updatedUserData', function (event) {
    $rootScope.reloadTable();
  });
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('SubProjectInstanceController', ['$uibModalInstance', 'form_type', 'id', '$scope', '$rootScope', 'subProjectFactory', 'mainProjectFactory', 'projectFactory', 'companyFactory', '$localStorage', 'errorService', function ($uibModalInstance, form_type, id, $scope, $rootScope, subProjectFactory, mainProjectFactory, projectFactory, companyFactory, $localStorage, errorService) {
  var sessionMainProject = $localStorage.user.session_main_project;
  if (!sessionMainProject) {
    errorService.handleError('No session main project');
    $uibModalInstance.dismiss('cancel');
  }
  $scope.validated = false;
  $scope.form_type = form_type;
  if (form_type === 'view_sub_project') {
    subProjectFactory.getSubProject(id).then(function (response) {
      var data = response.data;
      $scope.sub_project_id = id;
      $scope.sub_project_name = data.Name;
      $scope.sub_project_short_name = data.ShortName;
      $scope.project_id = data.ProjectId;
      $scope.project_name = data.ProjectName;
      $scope.main_project_id = data.MainProjectId;
      $scope.main_project_name = data.MainProjectName;
      $scope.contractor_id = data.OwnerCompanyId;
      $scope.contractor_name = data.OwnerCompanyName;
      $scope.building_contractor_id = data.ResponsibleCompanyId;
      $scope.building_contractor_name = data.ResponsibleCompanyName;
      $scope.is_active = data.IsActive;
      $scope.comments = data.Comments;
    }, function (error) {
      errorService.handleError(error);
    });
  } else {
    $scope.main_project_id = sessionMainProject.main_project_id;
    $scope.main_project_name = sessionMainProject.main_project_name;
  }

  // Populate projects list
  projectFactory.getProjects(sessionMainProject.main_project_id, false).then(function (response) {
    var data = response.data;
    $scope.projects = projectFactory.repackageDTOArray(data);
  }, function (error) {
    errorService.handleError(error);
  });

  // Populate company list
  companyFactory.getCompanies(false, sessionMainProject.division_id).then(function (response) {
    var data = response.data;
    $scope.companies = companyFactory.repackageCompanyDTOArray(data);
  }, function (error) {
    errorService.handleError(error);
  });
  $scope.updateProjects = function (mainProject) {
    $scope.project_name = "";
    $scope.project_id = null;
    $scope.projects.forEach(function (data, index) {
      if (data.main_project_id === mainProject.main_project_id) {
        data.show = true;
      } else data.show = false;
    });
  };

  // Finalizing or exiting form
  $scope.create = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = {
      "Name": $scope.sub_project_name,
      "ShortName": $scope.sub_project_short_name,
      "ProjectName": $scope.project_name,
      "ProjectId": $scope.project_id,
      "OwnerCompanyId": $scope.contractor_id,
      "OwnerCompanyName": $scope.contractor_name,
      "ResponsibleCompanyId": $scope.building_contractor_id,
      "ResponsibleCompanyName": $scope.building_contractor_name,
      "IsActive": true,
      "Comments": $scope.comments
    };
    var results = '';
    subProjectFactory.createSubProject(DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(results); // Pass in returned item here.
  };

  $scope.activation = function (isActive) {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    if (isActive) {
      subProjectFactory.activateSubProject($scope.sub_project_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    } else {
      subProjectFactory.deactivateSubProject($scope.sub_project_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    }
    var results = '';
    $uibModalInstance.close(results); // Pass in returned item here.
  };

  $scope.update = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = {
      "Name": $scope.sub_project_name,
      "SubProjectId": $scope.sub_project_id,
      "ShortName": $scope.sub_project_short_name,
      "ProjectName": $scope.project_name,
      "ProjectId": $scope.project_id,
      "OwnerCompanyId": $scope.contractor_id,
      "OwnerCompanyName": $scope.contractor_name,
      "ResponsibleCompanyId": $scope.building_contractor_id,
      "ResponsibleCompanyName": $scope.building_contractor_name,
      "IsActive": $scope.is_active,
      "Comments": $scope.comments
    };
    var results = '';
    subProjectFactory.updateSubProject(DTO.SubProjectId, DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(results); // Pass in returned item here.
  };

  $scope.delete = function () {
    var results = '';
    subProjectFactory.deleteSubProject($scope.sub_project_id).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(results); // Pass in returned item here.
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    if (input === '') {
      return false;
    } else if (typeof input === 'undefined') {
      return false;
    } else if (input === null) {
      return false;
    } else return true;
  };
  $scope.validateForm = function () {
    $scope.formValid = $scope.sub_project_name !== '' && typeof $scope.sub_project_name !== 'undefined' && $scope.project_name !== '' && typeof $scope.project_name !== 'undefined';
    return $scope.formValid;
  };
  $scope.inputLengthLimits = {
    sub_project_name: 30
  };
}]);
'use strict';

controllers.controller('WorkOrderController', ['$uibModal', '$scope', '$rootScope', '$filter', 'workOrderFactory', 'errorService', '$localStorage', 'roleService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, workOrderFactory, errorService, $localStorage, roleService, keyCodes) {
  $scope.isAdmin = roleService.isAdmin();
  $scope.isServicenter = roleService.isServicenter();
  $scope.isProjectOwner = roleService.isProjectOwner();
  $scope.innerRange = 5;
  $scope.currentPage = 1;
  $scope.itemRangeBottom = 0;
  $scope.itemRangeTop = 14;
  $scope.itemRange = 15;
  $scope.searchString = '';
  $scope.keyCode = '';
  $scope.lastSortCol = 'work_order_name';
  $scope.sortCol = 'work_order_name';
  $scope.sortReverse = false;
  $scope.sortReverseFn = function () {
    if ($scope.lastSortCol === $scope.sortCol && !$scope.sortReverse) {
      $scope.sortReverse = true;
    } else {
      $scope.lastSortCol = $scope.sortCol;
      $scope.sortReverse = false;
    }
  };
  $rootScope.reloadTable = function () {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    workOrderFactory.getWorkOrders(sessionMainProject.main_project_id, true).then(function (response) {
      var data = response.data;
      $scope.work_orders = workOrderFactory.repackageWorkOrderDTOArray(data);
      $scope.totalItems = $scope.work_orders.length;
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $rootScope.reloadTable();
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.searchString = $scope.pendingSearchString;
      $scope.updateFullTableRange();
    }
  };
  $scope.updateFullTableRange = function () {
    var filtered = $scope.work_orders;
    if (!$scope.showInactive) {
      filtered = $filter('inactive')(filtered, $scope.showInactive);
    }
    if ($scope.searchString) {
      filtered = $filter('filter')(filtered, $scope.searchString);
    }
    $scope.totalItems = filtered.length;
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.currentPage - 1) * $scope.itemRange;
  };

  // --- MODAL - CREATE ---
  var animationsEnabled = true;
  $scope.createWorkOrder = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/work_order/work_order_form.html',
      controller: 'WorkOrderInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create_work_order';
        },
        id: function id() {
          return -1;
        }
      }
    });
    modalInstance.result.then(function (results) {
      $rootScope.reloadTable();
    });
  };

  // --- MODAL - VIEW Work order Project ---
  $scope.viewWorkOrder = function (_id) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/projects/work_order/work_order_form.html',
      controller: 'WorkOrderInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view_work_order';
        },
        id: function id() {
          return _id;
        }
      }
    });
    modalInstance.result.then(function (results) {
      $rootScope.reloadTable();
    });
  };
  $scope.$on('workOrderRepeatFinished', function (workOrderRepeatFinishedEvent) {
    $scope.updateFullTableRange();
  });
  $scope.$on('updatedUserData', function (event) {
    $rootScope.reloadTable();
  });
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('WorkOrderInstanceController', ['$uibModalInstance', 'form_type', 'id', '$scope', '$rootScope', 'workOrderFactory', 'subProjectFactory', 'projectFactory', 'companyFactory', '$filter', 'inputValidationService', 'errorService', 'dropdownService', '$localStorage', 'InputLengthLimits', function ($uibModalInstance, form_type, id, $scope, $rootScope, workOrderFactory, subProjectFactory, projectFactory, companyFactory, $filter, inputValidationService, errorService, dropdownService, $localStorage, InputLengthLimits) {
  $scope.InputLengthLimits = InputLengthLimits;
  $scope.workOrder = {
    project_id: -1
  };
  $scope.validated = false;
  $scope.formLocked = true;
  $scope.form_type = form_type;
  $scope.dropdowns = [{
    s: 'start'
  }]; // Keeps one dropdown available always
  $scope.dropdownsList = [];
  $scope.sessionMainProject = $localStorage.user.session_main_project;
  if (!$scope.sessionMainProject) {
    errorService.handleError('No session main project');
    $uibModalInstance.dismiss('cancel');
  }

  // Populate projects list
  projectFactory.getProjects($scope.sessionMainProject.main_project_id, false).then(function (response) {
    var data = response.data;
    $scope.projects = projectFactory.repackageDTOArray(data);
    getSubProjects();
  }, function (error) {
    errorService.handleError(error);
  });
  function getSubProjects() {
    subProjectFactory.getSubProjects($scope.sessionMainProject.main_project_id, false).then(function (response) {
      var data = response.data;
      $scope.sub_projects = subProjectFactory.repackageDTOArray(data);
      $scope.createDropdowns();
      if (form_type === 'view_work_order') {
        getWorkOrder(); // Sets sub_projects to selected if any in workorder.
      } else if (form_type === 'create_work_order') {
        $scope.formLocked = false;
      }
    }, function (error) {
      errorService.handleError(error);
    });
  }
  if (form_type === 'create_work_order') {
    // Populate company list
    companyFactory.getCompanies(false, $scope.sessionMainProject.division_id).then(function (response) {
      var data = response.data;
      $scope.companies = companyFactory.repackageCompanyDTOArray(data);
    }, function (error) {
      errorService.handleError(error);
    });
  }

  // Function definitions
  /////////////////////////

  $scope.loadCompany = function (company) {
    $scope.workOrder.company_name = company.company_name;
    $scope.workOrder.company_id = company.company_id;
    clearFormWorkOrder();
    companyFactory.getErpWorkOrders(company.company_id).then(function (response) {
      var data = response.data;
      $scope.erpWorkOrders = repackageErpWorkOrderDTOArray(data);
      $scope.workOrder.notificationConfiguration = company.notification_configuration;
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $scope.loadErpWorkOrder = function (erpWorkOrder) {
    clearFormWorkOrder();
    $scope.workOrder.erp_system_reference = erpWorkOrder.erp_system_reference; // Not shown in view
    $scope.workOrder.erp_system_short_name = erpWorkOrder.erp_system_short_name;
    $scope.workOrder.work_order_name = erpWorkOrder.erp_system_short_name; // Work order name editable by user
    $scope.workOrder.work_order_type = erpWorkOrder.work_order_type;
    $scope.workOrder.work_order_group = erpWorkOrder.work_order_group;
    $scope.selectedErpWorkOrderDisplayName = erpWorkOrder.erp_display_name; // Shown in view
  };

  function repackageErpWorkOrderDTOArray(erpWorkOrderDTOArray) {
    var erpWorkOrderArray = [];
    angular.forEach(erpWorkOrderDTOArray, function (erpWorkOrderDTO) {
      erpWorkOrderArray.push(repackageErpWorkOrderDTO(erpWorkOrderDTO));
    });
    erpWorkOrderArray.sort(compareWorkOrders);
    return erpWorkOrderArray;
  }
  function repackageErpWorkOrderDTO(erpWorkOrderDTO) {
    return {
      erp_display_name: workOrderFactory.workOrderDisplayName(erpWorkOrderDTO.Name, erpWorkOrderDTO.SystemReference),
      erp_system_reference: erpWorkOrderDTO.SystemReference,
      erp_system_short_name: erpWorkOrderDTO.Name,
      work_order_type: erpWorkOrderDTO.Type,
      work_order_group: erpWorkOrderDTO.Group
    };
  }
  ;
  function compareWorkOrders(wo1, wo2) {
    return wo1.erp_display_name.localeCompare(wo2.erp_display_name);
  }
  function clearFormWorkOrder() {
    if ($scope.workOrder.erp_system_reference) {
      // If <- then the rest is loaded as well.
      delete $scope.workOrder.erp_display_name;
      delete $scope.workOrder.erp_system_reference;
      delete $scope.workOrder.work_order_id;
      delete $scope.workOrder.work_order_name;
      delete $scope.workOrder.work_order_type;
      delete $scope.workOrder.work_order_group;
      delete $scope.workOrder.contact_person;
      delete $scope.workOrder.email;
      delete $scope.workOrder.phone_number;
    }
    delete $scope.selectedErpWorkOrderDisplayName;
  }
  function getWorkOrder() {
    workOrderFactory.getWorkOrder(id).then(function (response) {
      var data = response.data;
      $scope.workOrder = workOrderFactory.repackageWorkOrderDTO(data);
      $scope.selectedErpWorkOrderDisplayName = $scope.workOrder.erp_display_name;
      loadSelectedSubProjectsToDropdowns();
    }, function (error) {
      errorService.handleError(error);
    });
  }

  // Number of dropdowns is decided by how many SubProjects belonging to currently selected Project
  $scope.createDropdowns = function () {
    angular.forEach($scope.projects, function (project) {
      var dropdowns = [];
      var filteredSubProjects = $filter('filter')($scope.sub_projects, {
        project_id: project.project_id
      }, true);
      if (filteredSubProjects) {
        for (var i = 0; i < filteredSubProjects.length; i++) {
          dropdowns.push({
            tempId: i // Angular dont like to track the repeated list if empty.
          });
        }
      }

      $scope.dropdownsList[project.project_id] = dropdowns.length > 0 ? dropdowns : [{
        s: 'start'
      }]; // at least one empty dropdown if no SubProject
    });
  };

  function getNextInsertIndex(dropdowns) {
    var index = 0;
    angular.forEach(dropdowns, function (dropdown) {
      if (dropdown.subProject) {
        index++;
      }
    });
    return index;
  }
  ;
  function loadSelectedSubProjectsToDropdowns() {
    angular.forEach($scope.workOrder.sub_projects, function (selectedSubProject) {
      angular.forEach($scope.sub_projects, function (subProject) {
        if (selectedSubProject.sub_project_id === subProject.sub_project_id) {
          subProject.selected = true;
          var insertIndex = getNextInsertIndex($scope.dropdownsList[subProject.project_id]);
          $scope.dropdownsList[subProject.project_id][insertIndex].subProject = subProject;
        }
      });
    });
  }
  $scope.clearSelectedSubProjects = function () {
    angular.forEach($scope.dropdownsList[$scope.workOrder.project_id], function (dropDownSubproject) {
      angular.forEach($scope.sub_projects, function (subProject) {
        if (dropDownSubproject.subProject.sub_project_id === subProject.sub_project_id) {
          dropDownSubproject.subProject = {};
          subProject.selected = false;
        }
      });
    });
  };
  $scope.projectHasSubProject = function (project) {
    var hasSubProject = false;
    angular.forEach($scope.sub_projects, function (subP) {
      if (!hasSubProject && subP.project_id === project.project_id) {
        hasSubProject = true;
      }
    });
    return hasSubProject;
  };
  function createSubProjectsToOut() {
    var subProjectsOut = [];
    $scope.sub_projects.forEach(function (data, index) {
      if (data.selected) subProjectsOut.push(subProjectFactory.createDTO(data));
    });
    return subProjectsOut;
  }
  $scope.hasOneSelectedSubproject = function (subProjects) {
    var hasOneSelected = false;
    angular.forEach(subProjects, function (data) {
      if (!hasOneSelected && data.selected) {
        hasOneSelected = true;
      }
    });
    return hasOneSelected;
  };

  // If a new sub_project is selected over another the old value must be made available again.
  $scope.trySwapSubProjects = function (subProjectToRemove) {
    $scope.subProjectsCanBeDeleted = true;
    if (!subProjectToRemove) return;
    angular.forEach($scope.sub_projects, function (sp) {
      if (subProjectToRemove.sub_project_id === sp.sub_project_id) {
        sp.selected = false;
        delete sp.subProject;
      }
    });
  };
  $scope.cloneObject = function (object) {
    return jQuery.extend({}, object);
  };

  // Finalizing or exiting form
  $scope.create = function (updateEpix) {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    $scope.workOrder.subProjectsOut = createSubProjectsToOut();
    var workOrderDTO = workOrderFactory.packageWorkOrder($scope.workOrder);
    workOrderDTO['IsActive'] = true;
    workOrderFactory.createWorkOrder(workOrderDTO).then(function (response) {
      if (updateEpix) {
        var workOrderId = response.data;
        createEpixXML(workOrderId);
      } else {
        $uibModalInstance.close();
      }
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $scope.update = function (updateEpix) {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    $scope.workOrder.subProjectsOut = createSubProjectsToOut();
    var workOrderDTO = workOrderFactory.packageWorkOrder($scope.workOrder);
    workOrderFactory.updateWorkOrder(workOrderDTO.WorkOrderId, workOrderDTO).then(function (response) {
      if (updateEpix) {
        createEpixXML(workOrderDTO.WorkOrderId);
      } else {
        $uibModalInstance.close();
      }
    }, function (error) {
      errorService.handleError(error);
    });
  };
  function createEpixXML(workOrderId) {
    workOrderFactory.createEpixXML(workOrderId).then(function (response) {
      $uibModalInstance.close();
    }, function (error) {
      errorService.handleError(error);
    });
  }
  $scope.delete = function () {
    workOrderFactory.deleteWorkOrder($scope.workOrder.work_order_id).then(function (response) {
      $uibModalInstance.close();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  $scope.isValidEmail = function (input) {
    return inputValidationService.isValidEmail(input);
  };
  $scope.validateForm = function () {
    $scope.formValid = inputValidationService.isValidInput($scope.workOrder.company_name) && inputValidationService.isValidInput($scope.workOrder.erp_system_reference) && inputValidationService.isValidInput($scope.workOrder.work_order_name) && inputValidationService.isValidInput($scope.workOrder.project_name) && inputValidationService.isValidInput($scope.workOrder.contact_name) && inputValidationService.isValidInput($scope.workOrder.contact_phone) && inputValidationService.isValidEmail($scope.workOrder.contact_email) && $scope.hasOneSelectedSubproject($scope.sub_projects) // If true, then project is selected as well.
    ;

    return $scope.formValid;
  };
  $scope.openDropdown = dropdownService.openDropdown;
}]);
'use strict';

controllers.controller('DeliveryStatisticsController', ['$uibModal', '$scope', '$rootScope', '$filter', 'subProjectFactory', 'statisticsReportFactory', 'errorService', '$localStorage', 'inputValidationService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, subProjectFactory, statisticsReportFactory, errorService, $localStorage, $inputValidationService, keyCodes) {
  $scope.innerRange = 5;
  $scope.currentPage = 1;
  $scope.itemRangeBottom = 0;
  $scope.itemRangeTop = 14;
  $scope.itemRange = 15;
  $scope.selectedAny = false;
  $scope.selectedAll = false;
  $scope.searchString = '';
  $scope.keyCode = '';
  $scope.isReportGenerationEnabled = false;
  $scope.blob = null;
  $scope.reportFileName = "delivery_statistics.xlsx";
  $scope.reportRecordCount = 0;
  $scope.reportTotalRecordCount = 0;
  $scope.fromDate = null;
  $scope.toDate = null;
  $scope.showInactive = false;
  $scope.lastSortCol = 'sub_project_name';
  $scope.sortCol = 'sub_project_name'; // set the default sort
  $scope.sortReverse = false; // set the default sort order
  $scope.sortReverseFn = function () {
    if ($scope.lastSortCol === $scope.sortCol && !$scope.sortReverse) {
      $scope.sortReverse = true;
    } else {
      $scope.lastSortCol = $scope.sortCol;
      $scope.sortReverse = false;
    }
  };
  var selected = [];
  $rootScope.reloadTable = function () {
    $scope.selectedAll = false;
    $scope.selectedAny = false;
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    subProjectFactory.getSubProjects(sessionMainProject.main_project_id, true).then(function (response) {
      var data = response.data;
      $scope.sub_projects = subProjectFactory.repackageDTOArray(data);
      $scope.totalItems = $scope.sub_projects.length;
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $rootScope.reloadTable();
  $scope.checkAll = function () {
    if (!$scope.selectedAll) {
      $scope.unCheckAll();
      return;
    }
    var filtered = getVisibleItems($scope.sub_projects);
    angular.forEach(filtered, function (p) {
      p.selected = true;
    });
    $scope.updateSelection();
  };
  $scope.unCheckAll = function () {
    angular.forEach($scope.sub_projects, function (p) {
      p.selected = $scope.selectedAll;
      if (p.selected) {
        selected.push(p);
      }
    });
    $scope.updateSelection();
  };
  $scope.updateSelection = function () {
    var filtered = getVisibleItems($scope.sub_projects);
    $scope.selectedAny = false;
    selected = [];
    angular.forEach(filtered, function (p) {
      if (!$scope.selectedAny && p.selected) {
        $scope.selectedAny = true;
      }
      if (p.selected) {
        selected.push(p);
      }
    });
    if (!$scope.selectedAny) {
      $scope.selectedAll = false;
    }
    updateIsReportGenerationEnabled();
  };
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.searchString = $scope.pendingSearchString;
      $scope.updateFullTableRange('filter', $scope.sub_projects, $scope.searchString);
    }
  };
  $scope.updateFullTableRange = function (filter, array, param) {
    $scope.updateSelection();
    var filtered = getVisibleItems($scope.sub_projects);
    $scope.totalItems = filtered.length;
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.currentPage - 1) * $scope.itemRange;
  };
  function getVisibleItems(array) {
    var filtered = array;
    if (!$scope.showInactive) {
      filtered = $filter('inactive')(filtered, $scope.showInactive);
    }
    if ($scope.searchString) {
      filtered = $filter('filter')(filtered, $scope.searchString);
    }
    return filtered;
  }
  $scope.$on('subProjectsRepeatFinished', function (subProjectsRepeatFinishedEvent) {
    $scope.updateFullTableRange('inactive', $scope.sub_projects, $scope.showInactive);
  });
  $scope.$on('updatedUserData', function (event) {
    $rootScope.reloadTable();
  });
  $scope.generateStatisticsReport = function () {
    var selectedIDs = selected.map(function (x) {
      return x.sub_project_id;
    });
    statisticsReportFactory.getDeliveryReport(selectedIDs, $scope.fromDate, $scope.toDate).then(function (response) {
      var responseDTO = statisticsReportFactory.repackageDTO(response.data);
      $scope.reportRecordCount = responseDTO.recordCount;
      $scope.reportTotalRecordCount = responseDTO.totalRecordCount;
      $scope.blob = new Blob([responseDTO.excelArrayBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      openDownloadDialog();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $scope.initDateTimeEvents = function () {
    //Init date time pickers
    var fromDatePicker = $('#fromdate-datetimepicker');
    var toDatePicker = $('#todate-datetimepicker');
    fromDatePicker.datetimepicker({
      format: 'YYYY-MM-DD',
      locale: 'sv'
    });
    fromDatePicker.data().DateTimePicker.stepping(15);
    toDatePicker.datetimepicker({
      format: 'YYYY-MM-DD',
      locale: 'sv',
      useCurrent: false
    });
    toDatePicker.data().DateTimePicker.stepping(15);
    fromDatePicker.on('dp.change', function (ev) {
      var newValue = $('#from_date_input_field').val();
      $scope.fromDate = newValue === "" ? null : newValue;
      toDatePicker.data("DateTimePicker").minDate(ev.date);
      $scope.$apply(updateIsReportGenerationEnabled);
    });
    toDatePicker.on('dp.change', function (ev) {
      var newValue = $('#to_date_input_field').val();
      $scope.toDate = newValue === "" ? null : newValue;
      fromDatePicker.data("DateTimePicker").maxDate(ev.date);
      $scope.$apply(updateIsReportGenerationEnabled);
    });
    fromDatePicker.on('dp.error', function (ev) {
      var newValue = $('#from_date_input_field').val();
      $scope.fromDate = newValue === "" ? null : newValue;
      $scope.$apply(updateIsReportGenerationEnabled);
    });
    toDatePicker.on('dp.error', function (ev) {
      var newValue = $('#to_date_input_field').val();
      $scope.toDate = newValue === "" ? null : newValue;
      $scope.$apply(updateIsReportGenerationEnabled);
    });
  };
  function updateIsReportGenerationEnabled() {
    $scope.isReportGenerationEnabled = $scope.selectedAny && ($inputValidationService.isValidDate($scope.fromDate) || $scope.fromDate === null) && ($inputValidationService.isValidDate($scope.toDate) || $scope.toDate === null);
  }
  ;
  function openDownloadDialog() {
    $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/statistics/shared/statistics_download_modal.html',
      controller: 'statisticsDownloadModalController',
      size: 'lg',
      scope: $scope,
      windowClass: 'sp-modal-window'
    });
  }
  ;
}]);
'use strict';

controllers.controller('PlanningStatisticsController', ['$uibModal', '$scope', '$rootScope', 'statisticsReportFactory', 'errorService', '$localStorage', 'inputValidationService', function ($uibModal, $scope, $rootScope, statisticsReportFactory, errorService, $localStorage, $inputValidationService) {
  $scope.isReportGenerationEnabled = false;
  $scope.blob = null;
  $scope.reportFileName = "planning_statistics.xlsx";
  $scope.reportRecordCount = 0;
  $scope.reportTotalRecordCount = 0;
  $scope.fromDate = null;
  $scope.toDate = null;
  $scope.generateStatisticsReport = function () {
    statisticsReportFactory.getPlanningReport($localStorage.user.session_main_project.main_project_id, $scope.fromDate, $scope.toDate).then(function (response) {
      var responseDTO = statisticsReportFactory.repackageDTO(response.data);
      $scope.reportRecordCount = responseDTO.recordCount;
      $scope.reportTotalRecordCount = responseDTO.totalRecordCount;
      $scope.blob = new Blob([responseDTO.excelArrayBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      openDownloadDialog();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $scope.initDateTimeEvents = function () {
    //Init date time pickers
    var fromDatePicker = $('#fromdate-planning-datetimepicker');
    var toDatePicker = $('#todate-planning-datetimepicker');
    fromDatePicker.datetimepicker({
      format: 'YYYY-MM-DD',
      locale: 'sv'
    });
    fromDatePicker.data().DateTimePicker.stepping(15);
    toDatePicker.datetimepicker({
      format: 'YYYY-MM-DD',
      locale: 'sv',
      useCurrent: false
    });
    toDatePicker.data().DateTimePicker.stepping(15);
    fromDatePicker.on('dp.change', function (ev) {
      var newValue = $('#from_date_input_field').val();
      $scope.fromDate = newValue === "" ? null : newValue;
      toDatePicker.data("DateTimePicker").minDate(ev.date);
      $scope.$apply(updateIsReportGenerationEnabled);
    });
    toDatePicker.on('dp.change', function (ev) {
      var newValue = $('#to_date_input_field').val();
      $scope.toDate = newValue === "" ? null : newValue;
      fromDatePicker.data("DateTimePicker").maxDate(ev.date);
      $scope.$apply(updateIsReportGenerationEnabled);
    });
    fromDatePicker.on('dp.error', function (ev) {
      var newValue = $('#from_date_input_field').val();
      $scope.fromDate = newValue === "" ? null : newValue;
      $scope.$apply(updateIsReportGenerationEnabled);
    });
    toDatePicker.on('dp.error', function (ev) {
      var newValue = $('#to_date_input_field').val();
      $scope.toDate = newValue === "" ? null : newValue;
      $scope.$apply(updateIsReportGenerationEnabled);
    });
  };
  function updateIsReportGenerationEnabled() {
    $scope.isReportGenerationEnabled = $localStorage.user.session_main_project.main_project_id && ($inputValidationService.isValidDate($scope.fromDate) || $scope.fromDate === null) && ($inputValidationService.isValidDate($scope.toDate) || $scope.toDate === null);
  }
  ;
  function openDownloadDialog() {
    $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/statistics/shared/statistics_download_modal.html',
      controller: 'statisticsDownloadModalController',
      size: 'lg',
      scope: $scope,
      windowClass: 'sp-modal-window'
    });
  }
  ;
}]);
'use strict';

app.controller('statisticsDownloadModalController', ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
  $scope.save = function () {
    promptDownload($scope.blob);
    $uibModalInstance.close();
  };
  $scope.close = function () {
    $scope.blob = null;
    $scope.reportRecordCount = 0;
    $scope.reportTotalRecordCount = 0;
    $uibModalInstance.close();
  };
  function promptDownload(blob) {
    // IE11: use the msSaveOrOpenBlob API
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, $scope.reportFileName);
    }
    // Firefox and Chrome: simulate download link click
    else {
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = $scope.reportFileName;
      a.click();
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }
  }
}]);
'use strict';

controllers.controller('DivisionController', ['$uibModal', '$scope', '$rootScope', '$filter', 'divisionFactory', 'errorService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, divisionFactory, errorService) {
  $scope.innerRange = 5;
  $scope.currentPage = 1;
  $scope.itemRangeBottom = 0;
  $scope.itemRangeTop = 14;
  $scope.itemRange = 15;
  $scope.selectedAny = false;
  $scope.selectedAll = false;
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.hasMixedSelection = false;
  $scope.showInactive = false;
  $scope.searchString = '';
  $scope.keyCode = '';
  var selected = [];
  $rootScope.reloadTable = function () {
    $scope.data = [];
    divisionFactory.getDivisions().then(function (response) {
      $scope.data = response.data;
      $scope.totalItems = $scope.data.length;
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $rootScope.reloadTable();
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.searchString = $scope.pendingSearchString;
      $scope.updateFullTableRange('filter', $scope.data, $scope.searchString);
    }
  };
  $scope.updateFullTableRange = function (filter, array, param) {
    var filtered = $filter(filter)(array, param);
    $scope.totalItems = filtered.length;
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.currentPage - 1) * $scope.itemRange;
  };

  // --- MODAL - VIEW VEHICLE ---
  var animationsEnabled = false;
  $scope.viewDivision = function (_id) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/system/division/division_form.html',
      controller: 'DivisionInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view';
        },
        id: function id() {
          return _id;
        }
      }
    });
  };
  $scope.$on('dataRepeatFinished', function (dataRepeatFinishedEvent) {
    $scope.updateFullTableRange('inactive', $scope.data, $scope.showInactive);
  });
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('DivisionInstanceController', ['$uibModalInstance', 'form_type', 'id', '$scope', '$rootScope', 'divisionFactory', function ($uibModalInstance, form_type, id, $scope, $rootScope, divisionFactory) {
  $scope.validated = false;
  $scope.form_type = form_type;
  if (form_type === 'view') {
    divisionFactory.getDivision(id).then(function (response) {
      $scope.data = response.data;
    }, function (error) {
      errorService.handleError(error);
    });
  }
  $scope.update = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    divisionFactory.updateDivision($scope.data.DivisionId, $scope.data).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close();
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    if (input === '') {
      return false;
    } else if (typeof input === 'undefined') {
      return false;
    } else if (input === null) {
      return false;
    } else return true;
  };
  $scope.validateForm = function () {
    $scope.formValid = $scope.data.MainProjectShortNamePrefix !== '' && typeof $scope.data.MainProjectShortNamePrefix !== 'undefined' && $scope.data.ProjectShortNamePrefix !== '' && typeof $scope.data.ProjectShortNamePrefix !== 'undefined' && $scope.data.SubProjectShortNamePrefix !== '' && typeof $scope.data.SubProjectShortNamePrefix !== 'undefined' && $scope.data.WorkOrderShortNamePrefix !== '' && typeof $scope.data.WorkOrderShortNamePrefix !== 'undefined' && $scope.data.DirectDeliveryOrderNumberPrefix !== '' && typeof $scope.data.DirectDeliveryOrderNumberPrefix !== 'undefined' && $scope.data.StoringOrderNumberPrefix !== '' && typeof $scope.data.StoringOrderNumberPrefix !== 'undefined' && $scope.data.TransshipmentOrderNumberPrefix !== '' && typeof $scope.data.TransshipmentOrderNumberPrefix !== 'undefined' && $scope.data.MaterialOrderNumberPrefix !== '' && typeof $scope.data.MaterialOrderNumberPrefix !== 'undefined' && $scope.data.RecurringDirectDeliveryOrderNumberPrefix !== '' && typeof $scope.data.RecurringDirectDeliveryOrderNumberPrefix !== 'undefined' && $scope.data.PackageCollectionOrderNumberPrefix !== '' && typeof $scope.data.PackageCollectionOrderNumberPrefix !== 'undefined' && $scope.data.ResourceBookingOrderNumberPrefix !== '' && typeof $scope.data.ResourceBookingOrderNumberPrefix !== 'undefined';
    return $scope.formValid;
  };
}]);
'use strict';

controllers.controller('NotificationTemplateController', ['$uibModal', '$scope', '$rootScope', '$filter', 'notificationTemplateFactory', 'errorService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, notificationTemplateFactory, errorService, keyCodes) {
  $scope.innerRange = 5;
  $scope.currentPage = 1;
  $scope.itemRangeBottom = 0;
  $scope.itemRangeTop = 14;
  $scope.itemRange = 15;
  $scope.selectedAny = false;
  $scope.selectedAll = false;
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.hasMixedSelection = false;
  $scope.showInactive = false;
  $scope.searchString = '';
  $scope.keyCode = '';
  $scope.lastSortCol = 'Name';
  $scope.sortCol = 'Name';
  $scope.sortReverse = false;
  $scope.sortReverseFn = function () {
    if ($scope.lastSortCol === $scope.sortCol && !$scope.sortReverse) {
      $scope.sortReverse = true;
    } else {
      $scope.lastSortCol = $scope.sortCol;
      $scope.sortReverse = false;
    }
  };
  $rootScope.reloadTable = function () {
    $scope.data = [];
    notificationTemplateFactory.getNotificationTemplates().then(function (response) {
      $scope.data = response.data;
      $scope.totalItems = $scope.data.length;
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $rootScope.reloadTable();
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.searchString = $scope.pendingSearchString;
      $scope.updateFullTableRange('filter', $scope.data, $scope.searchString);
    }
  };
  $scope.updateFullTableRange = function (filter, array, param) {
    var filtered = $filter(filter)(array, param);
    $scope.totalItems = filtered.length;
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.currentPage - 1) * $scope.itemRange;
  };

  // --- MODAL - VIEW VEHICLE ---
  var animationsEnabled = false;
  $scope.viewNotificationTemplate = function (_id) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/system/notification_template/notification_template_form.html',
      controller: 'NotificationTemplateInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view';
        },
        id: function id() {
          return _id;
        }
      }
    });
  };
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('NotificationTemplateInstanceController', ['$uibModalInstance', 'form_type', 'id', '$scope', '$rootScope', 'notificationTemplateFactory', 'errorService', function ($uibModalInstance, form_type, id, $scope, $rootScope, notificationTemplateFactory, errorService) {
  $scope.validated = false;
  $scope.form_type = form_type;
  if (form_type === 'view') {
    notificationTemplateFactory.getNotificationTemplate(id).then(function (response) {
      $scope.data = response.data;
    }, function (error) {
      errorService.handleError(error);
    });
  }
  $scope.update = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    notificationTemplateFactory.updateNotificationTemplate($scope.data.NotificationType, $scope.data).then(function () {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close();
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    if (input === '') {
      return false;
    } else if (typeof input === 'undefined') {
      return false;
    } else if (input === null) {
      return false;
    } else return true;
  };
  $scope.validateForm = function () {
    $scope.formValid = true;
    return $scope.formValid;
  };
}]);
'use strict';

controllers.controller('PrinterController', ['$uibModal', '$scope', '$rootScope', '$filter', 'printerFactory', 'errorService', 'roleService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, printerFactory, errorService, roleService, keyCodes) {
  $scope.isAdmin = roleService.isAdmin();
  $scope.innerRange = 5;
  $scope.currentPage = 1;
  $scope.itemRangeBottom = 0;
  $scope.itemRangeTop = 14;
  $scope.itemRange = 15;
  $scope.selectedAny = false;
  $scope.selectedAll = false;
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.hasMixedSelection = false;
  $scope.showInactive = false;
  $scope.searchString = '';
  $scope.keyCode = '';
  $scope.lastSortCol = 'Location';
  $scope.sortCol = 'Location';
  $scope.sortReverse = false;
  $scope.sortReverseFn = function () {
    if ($scope.lastSortCol === $scope.sortCol && !$scope.sortReverse) {
      $scope.sortReverse = true;
    } else {
      $scope.lastSortCol = $scope.sortCol;
      $scope.sortReverse = false;
    }
  };
  var selected = [];
  $rootScope.reloadTable = function () {
    $scope.data = [];
    printerFactory.getAllPrinters().then(function (response) {
      $scope.data = response.data;
      $scope.totalItems = $scope.data.length;
    }, errorService.handleError);
  };
  $rootScope.reloadTable();
  $scope.checkAll = function () {
    if (!$scope.selectedAll) {
      $scope.unCheckAll();
      return;
    }
    var filtered = getVisibleItems($scope.data);
    angular.forEach(filtered, function (p) {
      p.selected = true;
    });
    $scope.updateSelection();
  };
  $scope.unCheckAll = function () {
    angular.forEach($scope.data, function (p) {
      p.selected = $scope.selectedAll;
      if (p.selected) {
        selected.push(p);
      }
    });
    $scope.updateSelection();
  };
  $scope.updateSelection = function () {
    var oneActiveSelected = false;
    var oneInactiveSelected = false;
    var filtered = getVisibleItems($scope.data);
    $scope.selectedAny = false;
    selected = [];
    angular.forEach(filtered, function (p) {
      if (!$scope.selectedAny && p.selected) {
        $scope.selectedAny = true;
      }
      if (p.selected) {
        selected.push(p);
      }
      if (!oneActiveSelected && p.IsActive && p.selected) {
        oneActiveSelected = true;
      }
      if (!oneInactiveSelected && !p.IsActive && p.selected) {
        oneInactiveSelected = true;
      }
    });
    if (!$scope.selectedAny) {
      $scope.selectedAll = false;
    }

    // Mixed selection
    if (oneActiveSelected && oneInactiveSelected) {
      $scope.hasMixedSelection = true;
      $scope.hasActiveSelection = true;
      $scope.hasInactiveSelection = true;
    } else {
      $scope.hasMixedSelection = false;
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
    }

    //Active selction
    if (oneActiveSelected && !oneInactiveSelected) {
      $scope.hasActiveSelection = true;
    } else $scope.hasActiveSelection = false;

    //Inactive selction
    if (!oneActiveSelected && oneInactiveSelected) {
      $scope.hasInactiveSelection = true;
    } else $scope.hasInactiveSelection = false;
  };
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.searchString = $scope.pendingSearchString;
      $scope.updateFullTableRange();
    }
  };
  $scope.updateFullTableRange = function () {
    $scope.updateSelection();
    var filtered = getVisibleItems($scope.data);
    $scope.totalItems = filtered.length;
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.currentPage - 1) * $scope.itemRange;
  };
  function getVisibleItems(array) {
    var filtered = array;
    if (!$scope.showInactive) {
      filtered = $filter('inactive')(filtered, $scope.showInactive);
    }
    if ($scope.searchString) {
      filtered = $filter('filter')(filtered, $scope.searchString);
    }
    return filtered;
  }

  // --- MODAL - CREATE ---
  var animationsEnabled = false;
  $scope.createPrinter = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/system/printer/printer_form.html',
      controller: 'PrinterInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create';
        },
        id: function id() {
          return -1;
        }
      }
    });
  };
  $scope.activatePrinters = function (isActive) {
    selected.forEach(function (data) {
      if (isActive) {
        printerFactory.activatePrinter(data.PrinterId).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      } else {
        printerFactory.deactivatePrinter(data.PrinterId).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      }
    });
  };

  // --- MODAL - VIEW VEHICLE ---
  $scope.viewPrinter = function (_id) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/system/printer/printer_form.html',
      controller: 'PrinterInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view';
        },
        id: function id() {
          return _id;
        }
      }
    });
  };
  $scope.$on('dataRepeatFinished', function (vehiclesRepeatFinishedEvent) {
    $scope.updateFullTableRange();
  });
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('PrinterInstanceController', ['$uibModalInstance', 'form_type', 'id', '$scope', '$rootScope', 'printerFactory', 'mainProjectFactory', 'InputLengthLimits', function ($uibModalInstance, form_type, id, $scope, $rootScope, printerFactory, mainProjectFactory, InputLengthLimits) {
  $scope.InputLengthLimits = InputLengthLimits;
  $scope.validated = false;
  $scope.form_type = form_type;
  if (form_type === 'view') {
    printerFactory.getPrinter(id).then(function (response) {
      $scope.data = response.data;
    }, function (error) {
      errorService.handleError(error);
    });
  }

  // Populate projects list
  $scope.mainProjects = [];
  mainProjectFactory.getMainProjects().then(function (response) {
    $scope.mainProjects = response.data;
  }, function (error) {
    errorService.handleError(error);
  });

  // Finalizing or exiting form
  $scope.create = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    $scope.data.IsActive = true;
    printerFactory.createPrinter($scope.data).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(); // Pass in returned item here.
  };

  $scope.activation = function (isActive) {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    if (isActive) {
      printerFactory.activatePrinter($scope.data.PrinterId).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
        ;
      });
    } else {
      printerFactory.deactivatePrinter($scope.data.PrinterId).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    }
    var results = '';
    $uibModalInstance.close(results); // Pass in returned item here.
  };

  $scope.update = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    printerFactory.updatePrinter($scope.data.PrinterId, $scope.data).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close();
  };
  $scope.delete = function () {
    printerFactory.deletePrinter($scope.data.PrinterId).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close();
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    if (input === '') {
      return false;
    } else if (typeof input === 'undefined') {
      return false;
    } else if (input === null) {
      return false;
    } else return true;
  };
  $scope.validateForm = function () {
    $scope.formValid = $scope.data.Name !== '' && typeof $scope.data.Name !== 'undefined' && $scope.data.Location !== '' && typeof $scope.data.Location !== 'undefined' && $scope.data.Partition !== '' && typeof $scope.data.Partition !== 'undefined' && $scope.data.Company !== '' && typeof $scope.data.Company !== 'undefined' && $scope.data.StreetAddress !== '' && typeof $scope.data.StreetAddress !== 'undefined' && $scope.data.ZipCode !== '' && typeof $scope.data.ZipCode !== 'undefined' && $scope.data.City !== '' && typeof $scope.data.City !== 'undefined' && $scope.data.Phone !== '' && typeof $scope.data.Phone !== 'undefined' && $scope.data.Email !== '' && typeof $scope.data.Email !== 'undefined';
    return $scope.formValid;
  };
}]);
'use strict';

controllers.controller('RouteController', ['$uibModal', '$scope', '$rootScope', '$filter', 'routeFactory', 'errorService', 'roleService', '$localStorage', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, routeFactory, errorService, roleService, $localStorage, keyCodes) {
  $scope.canEdit = roleService.isAdmin() || roleService.isServicenter() || roleService.isProjectOwner() || roleService.isWarehousePlanner();
  $scope.routes = [];
  $rootScope.reloadTable = function () {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    routeFactory.getRouteTemplatesByMainProjectId(true, sessionMainProject.main_project_id).then(function (response) {
      var routeDtos = response.data;
      $scope.routes = routeFactory.repackageDTOArray(routeDtos);
      $scope.filterInactiveItems();
    }, function (error) {
      errorService.handleError(error);
    });
  };

  // Table bindings
  $scope.tableItems = $scope.vehicleTypes;
  $scope.selectedItems = [];
  $scope.tableHeaderItems = [{
    propertyName: 'route_name',
    translateName: 'ROUTE'
  }, {
    propertyName: 'display_time',
    translateName: 'DEPARTURE_TIME'
  }, {
    propertyName: 'is_active',
    translateName: 'ACTIVE'
  }];

  // Handle active/inactive
  $scope.showInactive = {
    value: false
  }; // Wrap in object to bind ng-model to correct scope
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.filterInactiveItems = function () {
    $scope.tableItems = $filter('inactive')($scope.routes, $scope.showInactive.value);
  };
  $scope.activateSelectedItems = function (setToActive) {
    $scope.selectedItems.forEach(function (data) {
      if (setToActive) {
        routeFactory.activateRoute(data.route_id).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      } else {
        routeFactory.deactivateRoute(data.route_id).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      }
    });
  };
  $rootScope.reloadTable(); // Initialize table

  $scope.$watchCollection('selectedItems', function () {
    if ($scope.selectedItems.length === 0) {
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
    } else {
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
      angular.forEach($scope.selectedItems, function (item) {
        if (item.is_active) {
          $scope.hasActiveSelection = true;
        } else {
          $scope.hasInactiveSelection = true;
        }
      });
    }
  });

  // --- MODAL - CREATE ---
  var animationsEnabled = false;
  $scope.createRoute = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/transports/route/route_form.html',
      controller: 'RouteInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create';
        },
        route: function route() {
          return {};
        }
      }
    });
  };

  // --- MODAL - VIEW VEHICLE ---
  $scope.viewRoute = function (_route) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/transports/route/route_form.html',
      controller: 'RouteInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view';
        },
        route: function route() {
          return _route;
        }
      }
    });
  };

  // Events
  $scope.$on('updatedUserData', function (event) {
    $rootScope.reloadTable();
  });
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('RouteInstanceController', ['$uibModalInstance', 'form_type', 'route', '$scope', '$rootScope', 'routeFactory', 'mainProjectFactory', 'inputValidationService', 'vehicleFactory', '$localStorage', 'errorService', function ($uibModalInstance, form_type, route, $scope, $rootScope, routeFactory, mainProjectFactory, inputValidationService, vehicleFactory, $localStorage, errorService) {
  $scope.validated = false;
  $scope.form_type = form_type;
  $scope.route = route; // Loads route

  var sessionMainProject = $localStorage.user.session_main_project;
  if (!sessionMainProject) $uibModalInstance.dismiss('cancel');
  if (form_type !== 'view_route') {
    $scope.route.main_project_id = sessionMainProject.main_project_id;
    $scope.route.main_project_name = sessionMainProject.main_project_name;
  }

  // Load vehicles
  vehicleFactory.getVehicles(false).then(function (response) {
    var data = response.data;
    $scope.vehicles = vehicleFactory.repackageDTOArray(data);
  }, function (error) {
    errorService.handleError(error);
  });

  // Finalizing or exiting form
  $scope.create = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = routeFactory.createDTO($scope.route, true);
    routeFactory.createRoute(DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(); // Pass in returned item here.
  };

  $scope.activation = function (isActive) {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    if (isActive) {
      routeFactory.activateRoute($scope.route.route_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    } else {
      routeFactory.deactivateRoute($scope.route.route_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    }
    var results = '';
    $uibModalInstance.close(results); // Pass in returned item here.
  };

  $scope.update = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = routeFactory.createDTO($scope.route, $scope.route.is_template);
    routeFactory.updateRoute($scope.route.route_id, DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close();
  };
  $scope.delete = function () {
    routeFactory.deleteRoute($scope.route.route_id).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close();
  };
  $scope.updateTimeSelection = function (switchTo) {
    switch (switchTo) {
      case 'afternoon':
        $scope.route.is_forenoon = false;
        $scope.route.time = "";
        break;
      case 'forenoon':
        $scope.route.is_afternoon = false;
        $scope.route.time = '';
        break;
      case 'time':
        $scope.route.is_afternoon = false;
        $scope.route.is_forenoon = false;
        break;
      default:
        break;
    }
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  $scope.validateForm = function () {
    $scope.formValid = inputValidationService.isValidInput($scope.route.main_project_name) && inputValidationService.isValidInput($scope.route.route_name) && (inputValidationService.isValidTime($scope.route.time) || $scope.route.is_afternoon || $scope.route.is_forenoon);
    return $scope.formValid;
  };
  $scope.clearVehicle = function () {
    delete $scope.route.vehicle_id;
    delete $scope.route.vehicle_name;
  };
  $scope.initDateTimeEvents = function () {
    // Init date time picker
    $('#route-datetimepicker1').datetimepicker({
      locale: 'sv',
      format: 'LT'
    });
    $('#route-datetimepicker1').data().DateTimePicker.stepping(15);

    // Makes changes to the scope whenever dp.change triggers
    $('#route-datetimepicker1').on('dp.change', function (ev) {
      $scope.route.time = $('#time').val();
      $scope.updateTimeSelection('time');
      if (!$scope.$$phase) {
        $scope.$apply(); //$digest or $apply
      }
    });
  };
}]);
'use strict';

controllers.controller('ShippingController', ['$uibModal', '$scope', '$rootScope', '$filter', 'shippingFactory', 'errorService', 'roleService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, shippingFactory, errorService, roleService, keyCodes) {
  $scope.isAdmin = roleService.isAdmin();
  $scope.innerRange = 5;
  $scope.currentPage = 1;
  $scope.itemRangeBottom = 0;
  $scope.itemRangeTop = 14;
  $scope.itemRange = 15;
  $scope.selectedAny = false;
  $scope.selectedAll = false;
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.hasMixedSelection = false;
  $scope.showInactive = false;
  $scope.searchString = '';
  $scope.keyCode = '';
  $scope.lastSortCol = 'shipping_name';
  $scope.sortCol = 'shipping_name';
  $scope.sortReverse = false;
  $scope.sortReverseFn = function () {
    if ($scope.lastSortCol === $scope.sortCol && !$scope.sortReverse) {
      $scope.sortReverse = true;
    } else {
      $scope.lastSortCol = $scope.sortCol;
      $scope.sortReverse = false;
    }
  };
  var selected = [];
  $rootScope.reloadTable = function () {
    $scope.selectedAll = false;
    $scope.selectedAny = false;
    shippingFactory.getShippings(true).then(function (response) {
      var data = response.data;
      $scope.shippings = shippingFactory.repackageDTOArray(data);
      $scope.totalItems = $scope.shippings.length;
    }, function (error) {
      errorService.handleError(error);
    });
  };
  $rootScope.reloadTable();
  $scope.checkAll = function () {
    if (!$scope.selectedAll) {
      $scope.unCheckAll();
      return;
    }
    var filtered = getVisibleItems($scope.shippings);
    angular.forEach(filtered, function (p) {
      p.selected = true;
    });
    $scope.updateSelection();
  };
  $scope.unCheckAll = function () {
    angular.forEach($scope.shippings, function (p) {
      p.selected = false;
    });
    $scope.updateSelection();
  };
  $scope.updateSelection = function () {
    var oneActiveSelected = false;
    var oneInactiveSelected = false;
    var filtered = getVisibleItems($scope.shippings);
    $scope.selectedAny = false;
    selected = [];
    angular.forEach(filtered, function (p) {
      if (!$scope.selectedAny && p.selected) {
        $scope.selectedAny = true;
      }
      if (p.selected) {
        selected.push(p);
      }
      if (!oneActiveSelected && p.is_active && p.selected) {
        oneActiveSelected = true;
      }
      if (!oneInactiveSelected && !p.is_active && p.selected) {
        oneInactiveSelected = true;
      }
    });
    if (!$scope.selectedAny) {
      $scope.selectedAll = false;
    }

    // Mixed selection
    if (oneActiveSelected && oneInactiveSelected) {
      $scope.hasMixedSelection = true;
      $scope.hasActiveSelection = true;
      $scope.hasInactiveSelection = true;
    } else {
      $scope.hasMixedSelection = false;
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
    }

    //Active selction
    if (oneActiveSelected && !oneInactiveSelected) {
      $scope.hasActiveSelection = true;
    } else $scope.hasActiveSelection = false;

    //Inactive selction
    if (!oneActiveSelected && oneInactiveSelected) {
      $scope.hasInactiveSelection = true;
    } else $scope.hasInactiveSelection = false;
  };
  $scope.searchKeyUp = function (keyCode) {
    if (keyCode === keyCodes.ENTER) {
      $scope.searchString = $scope.pendingSearchString;
      $scope.updateFullTableRange();
    }
  };
  $scope.updateFullTableRange = function () {
    $scope.updateSelection();
    var filtered = getVisibleItems($scope.shippings);
    $scope.totalItems = filtered.length;
  };
  $scope.updateTableRange = function () {
    $scope.itemRangeBottom = ($scope.currentPage - 1) * $scope.itemRange;
  };
  function getVisibleItems(array) {
    var filtered = array;
    if (!$scope.showInactive) {
      filtered = $filter('inactive')(filtered, $scope.showInactive);
    }
    if ($scope.searchString) {
      filtered = $filter('filter')(filtered, $scope.searchString);
    }
    return filtered;
  }

  // --- MODAL - CREATE ---
  var animationsEnabled = true;
  $scope.createShipping = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/transports/shipping/shipping_form.html',
      controller: 'ShippingInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create_shipping';
        },
        id: function id() {
          return -1;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };
  $scope.activateShippings = function (isActive) {
    selected.forEach(function (data) {
      if (isActive) {
        shippingFactory.activateShipping(data.shipping_id).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      } else {
        shippingFactory.deactivateShipping(data.shipping_id).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      }
    });
  };

  // --- MODAL - VIEW GATE ---
  $scope.viewShipping = function (_id) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/transports/shipping/shipping_form.html',
      controller: 'ShippingInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view_shipping';
        },
        id: function id() {
          return _id;
        }
      }
    });
    modalInstance.result.then(function (results) {});
  };
  $scope.$on('shippingsRepeatFinished', function (shippingsRepeatFinishedEvent) {
    $scope.updateFullTableRange();
  });
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('ShippingInstanceController', ['$uibModalInstance', 'form_type', 'id', '$scope', '$rootScope', 'shippingFactory', 'mainProjectFactory', 'inputValidationService', 'errorService', 'roleService', function ($uibModalInstance, form_type, id, $scope, $rootScope, shippingFactory, mainProjectFactory, inputValidationService, errorService, roleService) {
  $scope.shipping = {};
  $scope.validated = false;
  $scope.form_type = form_type;
  $scope.isAdmin = roleService.isAdmin();
  if (form_type === 'view_shipping') {
    shippingFactory.getShipping(id).then(function (response) {
      var data = response.data;
      $scope.shipping = shippingFactory.repackageDTO(data);
    }, function (error) {
      errorService.handleError(error);
    });
  }

  // Populate projects list
  $scope.main_projects = [];
  mainProjectFactory.getMainProjects().then(function (response) {
    var data = response.data;
    data.forEach(function (main_project, index) {
      $scope.main_projects.push({
        main_project_name: main_project.Name,
        main_project_id: main_project.MainProjectId
      });
    });
  }, function (error) {
    errorService.handleError(error);
  });

  // Finalizing or exiting form
  $scope.create = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = shippingFactory.createDTO($scope.shipping);
    shippingFactory.createShipping(DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(''); // Pass in returned item here.
  };

  $scope.activation = function (isActive) {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    if (isActive) {
      shippingFactory.activateShipping($scope.shipping.shipping_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    } else {
      shippingFactory.deactivateShipping($scope.shipping.shipping_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    }
    $uibModalInstance.close(''); // Pass in returned item here.
  };

  $scope.update = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = shippingFactory.createDTO($scope.shipping);
    shippingFactory.updateShipping(DTO.ShippingId, DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(''); // Pass in returned item here.
  };

  $scope.delete = function () {
    shippingFactory.deleteShipping($scope.shipping.shipping_id).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(''); // Pass in returned item here.
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  $scope.validateForm = function () {
    $scope.formValid = inputValidationService.isValidInput($scope.shipping.main_project_name) && inputValidationService.isValidInput($scope.shipping.shipping_name) && inputValidationService.isValidInput($scope.shipping.unifaun_reference);
    return $scope.formValid;
  };
}]);
'use strict';

app.controller('VehicleFormController', ['$uibModalInstance', 'form_type', 'id', '$scope', '$rootScope', 'vehicleFactory', 'vehicleTypeFactory', 'inputValidationService', '$localStorage', 'errorService', function ($uibModalInstance, form_type, id, $scope, $rootScope, vehicleFactory, vehicleTypeFactory, inputValidationService, $localStorage, errorService) {
  $scope.validated = false;
  $scope.form_type = form_type;
  var sessionMainProject = $localStorage.user.session_main_project;
  if (!sessionMainProject) $uibModalInstance.dismiss('cancel');
  if (form_type === 'view_vehicle') {
    vehicleFactory.getVehicle(id).then(function (response) {
      var data = response.data;
      $scope.vehicle_id = id;
      $scope.vehicle_name = data.Name;
      $scope.vehicle_type_id = data.VehicleTypeId;
      $scope.vehicle_type_code = data.VehicleTypeCode;
      $scope.main_project_id = data.MainProjectId;
      $scope.main_project_name = data.MainProjectName;
      $scope.is_active = data.IsActive;
    }, function (error) {
      errorService.handleError(error);
    });
  } else {
    $scope.main_project_id = sessionMainProject.main_project_id;
    $scope.main_project_name = sessionMainProject.main_project_name;
  }

  // Populate vehicle types list
  vehicleTypeFactory.getVehicleTypes(sessionMainProject.main_project_id, false).then(function (response) {
    var data = response.data;
    $scope.vehicle_types = vehicleTypeFactory.repackageDTOArray(data);
  }, function (error) {
    errorService.handleError(error);
  });

  // Finalizing or exiting form
  $scope.create = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = {
      "Name": $scope.vehicle_name,
      "VehicleTypeId": $scope.vehicle_type_id,
      "MainProjectId": $scope.main_project_id,
      "IsActive": true
    };
    vehicleFactory.createVehicle(DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(); // Pass in returned item here.
  };

  $scope.activation = function (isActive) {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    if (isActive) {
      vehicleFactory.activateVehicle($scope.vehicle_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    } else {
      vehicleFactory.deactivateVehicle($scope.vehicle_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    }
    var results = '';
    $uibModalInstance.close(results); // Pass in returned item here.
  };

  $scope.update = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = {
      "VehicleId": $scope.vehicle_id,
      "Name": $scope.vehicle_name,
      "VehicleTypeId": $scope.vehicle_type_id,
      "MainProjectId": $scope.main_project_id,
      "IsActive": $scope.is_active
    };
    vehicleFactory.updateVehicle($scope.vehicle_id, DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close();
  };
  $scope.delete = function () {
    vehicleFactory.deleteVehicle($scope.vehicle_id).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close();
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  $scope.validateForm = function () {
    $scope.formValid = inputValidationService.isValidInput($scope.vehicle_name) && inputValidationService.isValidInput($scope.vehicle_type_code) && inputValidationService.isValidInput($scope.main_project_name);
    return $scope.formValid;
  };
  $scope.inputLengthLimits = {
    vehicle: 30
  };
}]);
'use strict';

controllers.controller('VehicleController', ['$uibModal', '$scope', '$rootScope', '$filter', 'vehicleFactory', 'errorService', '$localStorage', 'roleService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, vehicleFactory, errorService, $localStorage, roleService, keyCodes) {
  $scope.canEdit = roleService.isAdmin() || roleService.isServicenter() || roleService.isProjectOwner() || roleService.isWarehousePlanner();
  $scope.vehicles = [];
  $rootScope.reloadTable = function () {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    vehicleFactory.getVehiclesByMainProjectId(true, sessionMainProject.main_project_id).then(function (response) {
      var data = response.data;
      $scope.vehicles = vehicleFactory.repackageDTOArray(data);
      $scope.filterInactiveItems();
    }, function (error) {
      errorService.handleError(error);
    });
  };

  // Table bindings
  $scope.tableItems = $scope.vehicleTypes;
  $scope.selectedItems = [];
  $scope.tableHeaderItems = [{
    propertyName: 'vehicle_name',
    translateName: 'VEHICLE'
  }, {
    propertyName: 'vehicle_type_code',
    translateName: 'VEHICLE_TYPE'
  }, {
    propertyName: 'is_active',
    translateName: 'ACTIVE'
  }];

  // Handle active/inactive
  $scope.showInactive = {
    value: false
  }; // Wrap in object to bind ng-model to correct scope
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.filterInactiveItems = function () {
    $scope.tableItems = $filter('inactive')($scope.vehicles, $scope.showInactive.value);
  };
  $scope.activateSelectedItems = function (setToActive) {
    $scope.selectedItems.forEach(function (data) {
      if (setToActive) {
        vehicleFactory.activateVehicle(data.vehicle_id).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      } else {
        vehicleFactory.deactivateVehicle(data.vehicle_id).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      }
    });
  };
  $rootScope.reloadTable(); // Initialize table

  $scope.$watchCollection('selectedItems', function () {
    if ($scope.selectedItems.length === 0) {
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
    } else {
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
      angular.forEach($scope.selectedItems, function (item) {
        if (item.is_active) {
          $scope.hasActiveSelection = true;
        } else {
          $scope.hasInactiveSelection = true;
        }
      });
    }
  });

  // --- MODAL - CREATE ---
  var animationsEnabled = true;
  $scope.createVehicle = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/transports/vehicle/vehicle_form.html',
      controller: 'VehicleFormController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create_vehicle';
        },
        id: function id() {
          return -1;
        }
      }
    });
  };

  // --- MODAL - VIEW VEHICLE ---
  $scope.viewVehicle = function (vehicle) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/transports/vehicle/vehicle_form.html',
      controller: 'VehicleFormController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view_vehicle';
        },
        id: function id() {
          return vehicle.vehicle_id;
        }
      }
    });
  };

  // Events
  $scope.$on('updatedUserData', function (event) {
    $rootScope.reloadTable();
  });
}]);
'use strict';

controllers.controller('VehicleTypeController', ['$uibModal', '$scope', '$rootScope', '$filter', 'vehicleTypeFactory', 'errorService', '$localStorage', 'roleService', 'keyCodes', function ($uibModal, $scope, $rootScope, $filter, vehicleTypeFactory, errorService, $localStorage, roleService, keyCodes) {
  $scope.canEdit = roleService.isAdmin() || roleService.isServicenter() || roleService.isProjectOwner();
  $scope.vehicleTypes = [];
  $rootScope.reloadTable = function () {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return;
    vehicleTypeFactory.getVehicleTypes(sessionMainProject.main_project_id, true).then(function (response) {
      var data = response.data;
      var vehicleTypes = vehicleTypeFactory.repackageDTOArray(data);
      $scope.vehicleTypes = $filter('filter')(vehicleTypes, {
        main_project_id: sessionMainProject.main_project_id
      }, true);
      $scope.filterInactiveItems();
    }, function (error) {
      errorService.handleError(error);
    });
  };

  // Table bindings
  $scope.tableItems = $scope.vehicleTypes;
  $scope.selectedItems = [];
  $scope.tableHeaderItems = [{
    propertyName: 'vehicle_type_code',
    translateName: 'VEHICLE_TYPE'
  }, {
    propertyName: 'vehicle_capacity',
    translateName: 'CAPACITY'
  }, {
    propertyName: 'is_active',
    translateName: 'ACTIVE'
  }];

  // Handle active/inactive
  $scope.showInactive = {
    value: false
  }; // Wrap in object to bind ng-model to correct scope
  $scope.hasActiveSelection = false;
  $scope.hasInactiveSelection = false;
  $scope.filterInactiveItems = function () {
    $scope.tableItems = $filter('inactive')($scope.vehicleTypes, $scope.showInactive.value);
  };
  $scope.activateSelectedItems = function (setToActive) {
    $scope.selectedItems.forEach(function (data) {
      if (setToActive) {
        vehicleTypeFactory.activateVehicleType(data.vehicle_type_id).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      } else {
        vehicleTypeFactory.deactivateVehicleType(data.vehicle_type_id).then(function (response) {
          $rootScope.reloadTable();
        }, function (error) {
          errorService.handleError(error);
        });
      }
    });
  };
  $rootScope.reloadTable(); // Initialize table

  $scope.$watchCollection('selectedItems', function () {
    if ($scope.selectedItems.length === 0) {
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
    } else {
      $scope.hasActiveSelection = false;
      $scope.hasInactiveSelection = false;
      angular.forEach($scope.selectedItems, function (item) {
        if (item.is_active) {
          $scope.hasActiveSelection = true;
        } else {
          $scope.hasInactiveSelection = true;
        }
      });
    }
  });

  // --- MODAL - CREATE ---
  var animationsEnabled = true;
  $scope.createVehicleType = function () {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/transports/vehicle_type/vehicle_type_form.html',
      controller: 'VehicleTypeInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'create_vehicle_type';
        },
        id: function id() {
          return -1;
        }
      }
    });
  };

  // --- MODAL - VIEW VEHICLE ---
  $scope.viewVehicleType = function (vehicleType) {
    var modalInstance = $uibModal.open({
      animation: animationsEnabled,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/components/transports/vehicle_type/vehicle_type_form.html',
      controller: 'VehicleTypeInstanceController',
      size: 'md',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return 'view_vehicle_type';
        },
        id: function id() {
          return vehicleType.vehicle_type_id;
        }
      }
    });
  };

  // Events
  $scope.$on('updatedUserData', function (event) {
    $rootScope.reloadTable();
  });
}]);

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
app.controller('VehicleTypeInstanceController', ['$uibModalInstance', 'form_type', 'id', '$scope', '$rootScope', 'vehicleTypeFactory', 'mainProjectFactory', '$localStorage', 'inputValidationService', 'errorService', function ($uibModalInstance, form_type, id, $scope, $rootScope, vehicleTypeFactory, mainProjectFactory, $localStorage, inputValidationService, errorService) {
  $scope.validated = false;
  $scope.form_type = form_type;
  var sessionMainProject = $localStorage.user.session_main_project;
  if (!sessionMainProject) $uibModalInstance.dismiss('cancel');
  if (form_type === 'view_vehicle_type') {
    vehicleTypeFactory.getVehicleType(id).then(function (response) {
      var data = response.data;
      $scope.vehicle_type_id = data.VehicleTypeId;
      $scope.vehicle_type_code = data.Code;
      $scope.main_project_id = data.MainProjectId;
      $scope.main_project_name = data.MainProjectName;
      $scope.capacity = data.Capacity;
      $scope.is_active = data.IsActive;
    }, function (error) {
      errorService.handleError(error);
    });
  } else {
    $scope.main_project_id = sessionMainProject.main_project_id;
    $scope.main_project_name = sessionMainProject.main_project_name;
  }

  // Finalizing or exiting form
  $scope.create = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = {
      "Code": $scope.vehicle_type_code,
      "MainProjectId": $scope.main_project_id,
      "Capacity": $scope.capacity,
      "IsActive": true
    };
    vehicleTypeFactory.createVehicleType(DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close(); // Pass in returned item here.
  };

  $scope.activation = function (isActive) {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    if (isActive) {
      vehicleTypeFactory.activateVehicleType($scope.vehicle_type_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
        ;
      });
    } else {
      vehicleTypeFactory.deactivateVehicleType($scope.vehicle_type_id).then(function (response) {
        $rootScope.reloadTable();
      }, function (error) {
        errorService.handleError(error);
      });
    }
    var results = '';
    $uibModalInstance.close(results); // Pass in returned item here.
  };

  $scope.update = function () {
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    var DTO = {
      "VehicleTypeId": $scope.vehicle_type_id,
      "Code": $scope.vehicle_type_code,
      "MainProjectId": $scope.main_project_id,
      "Capacity": $scope.capacity,
      "IsActive": $scope.is_active
    };
    vehicleTypeFactory.updateVehicleType($scope.vehicle_type_id, DTO).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close();
  };
  $scope.delete = function () {
    vehicleTypeFactory.deleteVehicleType($scope.vehicle_type_id).then(function (response) {
      $rootScope.reloadTable();
    }, function (error) {
      errorService.handleError(error);
    });
    $uibModalInstance.close();
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  $scope.validateForm = function () {
    $scope.formValid = inputValidationService.isValidInput($scope.vehicle_type_code) && inputValidationService.isValidInput($scope.main_project_name) && inputValidationService.isValidInput($scope.capacity);
    return $scope.formValid;
  };
}]);
angular.module('sp.components').component('deviceMenuButton', {
  templateUrl: 'app/components/uiComponents/deviceMenuButton/device_menu_button.html',
  bindings: {
    href: '@',
    onClick: '&',
    isActive: '<',
    isMainNavigation: '<',
    icon: '@',
    title: '@',
    titleTranslateTag: '@',
    type: '@',
    iconIsSimpleLine: '<'
  },
  controller: function controller() {
    var ctrl = this;
    ctrl.$onInit = function () {
      ctrl.href = ctrl.href || '#';
      ctrl.iconColor = 'white';
    };
    ctrl.setMouseDownColor = function () {
      ctrl.iconColor = ctrl.type == 'close' ? 'red' : 'blue';
    };
    ctrl.setMouseUpColor = function () {
      ctrl.iconColor = 'white';
    };
  }
});
function FileUploadController(ALLOWED_FILE_EXTENTIONS, inputValidationService) {
  var ctrl = this;

  // Is called when binding values are changed
  ctrl.$onChanges = function (bindings) {
    if (bindings.isRequired) {
      onChanges();
    }
  };
  ctrl.isValid = false;
  ctrl.file = undefined;
  ctrl.files = [];
  ctrl.ALLOWED_FILE_EXTENTIONS = ALLOWED_FILE_EXTENTIONS;

  // Watch for our custom `fileselect` event
  // FUTURE: This should be done using a directive instead
  ctrl.initFileSelectEvent = function () {
    $(':file').on('fileselect', function (event, numFiles, label) {
      var input = $('#fileSelectedText');
      log = numFiles > 1 ? numFiles + ' filer valda' : label;
      if (input) {
        input.val(log);
      } else {
        if (log) alert(log);
      }
      onChanges();
    });
  };
  function onChanges() {
    var data = ctrl.isMultipleFilesAllowed ? ctrl.files : ctrl.file ? [ctrl.file] : [];
    var areValidFiles = inputValidationService.areValidFiles(data);
    ctrl.isValid = (data.length > 0 || !ctrl.isRequired) && areValidFiles;
    ctrl.onSelect({
      "$files": data,
      "$file": ctrl.file,
      "$isValid": ctrl.isValid
    });
  }
}
angular.module('sp.components').component('fileUpload', {
  templateUrl: 'app/components/uiComponents/fileUpload/fileUpload.html',
  controller: ['ALLOWED_FILE_EXTENTIONS', 'inputValidationService', FileUploadController],
  bindings: {
    displayText: '<?',
    isDisabled: '<',
    isRequired: '<',
    isMultipleFilesAllowed: '<',
    showErrors: '<',
    onSelect: '&'
  }
});
angular.module('sp.components').component('filterCategory', {
  templateUrl: 'app/components/uiComponents/filterCategory/filter_category.html',
  bindings: {
    title: '@',
    availableItems: '<',
    itemNameMap: '<',
    onSelectItem: '&',
    isSelected: '&',
    doTranslate: '<',
    itemLimit: '<'
  },
  controller: function controller() {
    var ctrl = this;
    ctrl.$onInit = function () {
      ctrl.limit = ctrl.itemLimit || 100;
    };
  }
});
angular.module('sp.components').component('filterSection', {
  templateUrl: 'app/components/uiComponents/filterSection/filter_section.html',
  transclude: true,
  bindings: {
    title: '@'
  },
  controller: function controller() {
    var ctrl = this;
    ctrl.show = true;
  }
});
function FitlerableDropdownController(dropdownService, inputValidationService) {
  var ctrl = this;

  // Is called when binding values are changed
  ctrl.$onChanges = function (bindings) {
    if (bindings.data && bindings.data.currentValue) {
      ctrl.handleInputChange();
    }
  };
  ctrl.openDropdown = function ($event) {
    dropdownService.openDropdown(ctrl.id, $event);
  };
  ctrl.isValid = function () {
    return inputValidationService.isValidInput(ctrl.data) || !ctrl.isRequired;
  };
  ctrl.inputSearchFilter = function (item) {
    if (!ctrl.data) return true; // Display all options if no input

    var compareString = item[ctrl.itemsDisplayProperty].toLowerCase();
    var stringToFind = ctrl.data.toLowerCase();
    return compareString.indexOf(stringToFind) !== -1;
  };
  ctrl.customFilter = function (item) {
    return !ctrl.itemsFilter || ctrl.itemsFilter(item);
  };
  ctrl.getDisplayValue = function (item) {
    return item[ctrl.itemsDisplayProperty];
  };
  ctrl.handleInputChange = function () {
    ctrl.onValidationChange({
      "$isValid": ctrl.isValid()
    });
  };
  ctrl.handleSelectionChange = function (item) {
    ctrl.onSelect({
      "$item": item
    });
  };
  ctrl.clearSelection = function () {
    ctrl.data = undefined;
    ctrl.handleSelectionChange(undefined);
  };
}
angular.module('sp.components').component('dropdownInput', {
  templateUrl: 'app/components/uiComponents/filterableDropdown/filterableDropdown.html',
  controller: ['dropdownService', 'inputValidationService', FitlerableDropdownController],
  bindings: {
    id: '@',
    label: '@',
    data: '<',
    items: '<',
    itemsDisplayProperty: '@',
    itemsFilter: '<',
    onSelect: '&',
    onValidationChange: '&',
    isDisabled: '<',
    showErrors: '<',
    isRequired: '<'
  }
});
angular.module('sp.components').component('fontAwesomeIcon', {
  templateUrl: 'app/components/uiComponents/fontAwesomeIcon/font_awesome_icon.html',
  bindings: {
    icon: '@',
    color: '@',
    iconIsSimpleLine: '<'
  },
  controller: function controller() {
    var ctrl = this;
    var imagePath = '../../../../assets/icons/';
    ctrl.$onInit = function () {
      ctrl.color = ctrl.color || '';
    };
    ctrl.getIconImageSource = function () {
      return imagePath + ctrl.icon + (ctrl.color ? '-' + ctrl.color : '') + '.svg';
    };
    ctrl.getIconClass = function () {
      return ctrl.iconIsSimpleLine ? ctrl.icon : 'fa fa-' + ctrl.icon;
    };
  }
});
angular.module('sp.components').component('mainMenuButton', {
  templateUrl: 'app/components/uiComponents/mainMenuButton/main_menu_button.html',
  bindings: {
    href: '@',
    onClick: '&',
    isActive: '<',
    isDisabled: '<',
    iconClass: '@',
    titleTag: '@',
    tooltipTag: '@'
  }
});
'use strict';

function MiniCalendarController($filter) {
  var ctrl = this;
  ctrl.$onChanges = function (bindings) {
    generateCalendarCells();
  };
  ctrl.initDateTimeEvents = function () {
    $('#mini-cal-datepicker.input-group.date').datepicker({
      format: 'M yyyy',
      language: 'sv',
      todayHighlight: true,
      minViewMode: 'months',
      maxViewMode: 'years',
      orientation: 'top',
      autoclose: 'true'
    });
    $('#mini-cal-datepicker.input-group.date').on('changeDate', function (e) {
      date = new Date(ctrl.viewDate);
      date.setFullYear(e.date.getFullYear());
      date.setMonth(e.date.getMonth());
      if (ctrl.periodType === 'WEEK') {
        ctrl.onDateSelected({
          "$newDate": date,
          "$periodType": 'WEEK'
        });
      } else {
        ctrl.onDateSelected({
          "$newDate": date,
          "$periodType": 'DAY'
        });
      }
    });
  };
  ctrl.openDate = function (date) {
    ctrl.onDateSelected({
      "$newDate": date,
      "$periodType": 'DAY'
    });
  };
  var nDays = 7;
  ctrl.dayRepeater = [0, 1, 2, 3, 4, 5, 6];
  var nRows = 6;
  ctrl.rowRepeater = [0, 1, 2, 3, 4, 5];
  ctrl.calendarCells = [];
  ctrl.dayStrings = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
  ctrl.monthStrings = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  function getUpcomingDate(date, increment) {
    var upcomming = new Date(date.getTime());
    upcomming.setDate(date.getDate() + increment);
    return upcomming;
  }
  ;

  // Gets the date of the first monday in current month
  function getCalendarMondaysDate() {
    var searchDate = new Date(ctrl.viewDate);
    searchDate.setDate(1);
    while (searchDate.getDay() !== 1) {
      searchDate.setDate(searchDate.getDate() - 1);
    }
    return searchDate;
  }
  function notInCurrentMonth(date) {
    return date.getMonth() !== ctrl.viewDate.getMonth();
  }
  function isToday(date) {
    var today = new Date();
    return today.getDate() === date.getDate() && today.getMonth() === date.getMonth() && today.getYear() === date.getYear();
  }
  function dateHasOrders(date) {
    var d = ctrl.formatDateOrMonth(date.getDate());
    var m = ctrl.formatDateOrMonth(date.getMonth() + 1);
    var y = date.getFullYear();
    var dateString = y + '-' + m + '-' + d;
    var ordersFilteredByDate = $filter('filter')(ctrl.calendarOrders, {
      date_i: '' + dateString
    }, true);
    if (typeof ordersFilteredByDate === 'undefined') {
      return false;
    }
    if (ordersFilteredByDate.length > 0) {
      return true;
    } else return false;
  }
  function generateCalendarCells() {
    if (!ctrl.viewDate) return;
    var firstMonday = getCalendarMondaysDate();
    for (var i = 0; i < nDays; i++) {
      ctrl.calendarCells[i] = [];
      for (var j = 0; j < nRows; j++) {
        var cellIndex = 7 * j + i;
        var date = getUpcomingDate(firstMonday, cellIndex);
        ctrl.calendarCells[i][j] = {
          date: date,
          isToday: isToday(date),
          isOutOfScope: notInCurrentMonth(date),
          hasOrders: dateHasOrders(date)
        };
      }
    }
  }
}
;
angular.module('sp.components').component('miniCalendar', {
  templateUrl: 'app/components/uiComponents/miniCalendar/mini_calendar.html',
  controller: ['$filter', MiniCalendarController],
  bindings: {
    viewDate: '<',
    onDateSelected: '&',
    periodType: '@',
    calendarOrders: '<',
    formatDateOrMonth: '<'
  }
});
angular.module('sp.components').component('mobileChangeMainProjectComponent', {
  templateUrl: 'app/components/uiComponents/mobileChangeMainProjectComponent/mobile_change_main_project_component.html',
  bindings: {
    onClose: '&',
    mainProjects: '<',
    onSelect: '&',
    currentlySelected: '<'
  }
});
'use strict';

/**Component used to apply megafiltering in the mobile version of Serviplan.
 * Currently only filters vehicle drop locations.
*/
function MobileFilterController(megaFilterService, $rootScope, $filter, locationFactory, $localStorage) {
  var ctrl = this;
  ctrl.vehicleDropLocations = [];
  ctrl.mainProjectId = $localStorage.user.session_main_project.main_project_id;
  ctrl.vehicleDropLocationClicked = function (vehicleDropLocation) {
    if (ctrl.currentlySelected.id === vehicleDropLocation.Id) {
      ctrl.currentlySelected.id = null;
      ctrl.currentlySelected.name = '';
    } else {
      ctrl.currentlySelected.id = vehicleDropLocation.Id;
      ctrl.currentlySelected.name = vehicleDropLocation.name;
    }
    ;
    ctrl.onSelect();
  };
  ctrl.$onInit = function () {
    locationFactory.getFilterableVehicleDropLocations(ctrl.mainProjectId, ctrl.isArchive, ctrl.isArchive).then(function (result) {
      ctrl.vehicleDropLocations = result.data;
    });
  };
}
;
angular.module('sp.components').component('mobileFilter', {
  templateUrl: 'app/components/uiComponents/mobileFilter/mobile_filter.html',
  bindings: {
    onClose: '&',
    onSelect: '&',
    currentlySelected: '<',
    isArchive: '<'
  },
  controller: ['megaFilterService', '$rootScope', '$filter', 'locationFactory', '$localStorage', MobileFilterController]
});
function CreateButtonsController() {}
angular.module('sp.components').component('createButtons', {
  templateUrl: 'app/components/uiComponents/modalForm/createButtons.html',
  controller: CreateButtonsController,
  bindings: {
    onCancel: '&',
    onCreate: '&'
  }
});
function ManageButtonsController() {
  ctrl = this;
  ctrl.showConfirmDelete = false;
}
angular.module('sp.components').component('manageButtons', {
  templateUrl: 'app/components/uiComponents/modalForm/manageButtons.html',
  controller: ManageButtonsController,
  bindings: {
    showDelete: '<',
    showActivate: '<',
    isActive: '<?',
    onCancel: '&',
    onUpdate: '&',
    onDelete: '&?',
    onActivationChange: '&?'
  }
});
/**
 * Intended to be used in modal forms to create, view or manage an item.
 * Example:
 
 <modal-form-wrapper id="id" form-type="{{vm.formType}}" on-cancel="vm.cancel()"
        item-type-translate-tag="TRANSLATE_TAG" item-name="{{vm.itemName}}"
        show-error-message="vm.showErrors">

    <modal-form-inputs>
        <input type="text" ng-model="vm.itemName />
    </modal-form-inputs>

    <modal-form-create-buttons>
        <button ng-click="vm.createItem()">Create</button>
    </modal-form-create-buttons>

    <modal-form-manage-buttons>
        <button ng-click="vm.updateItem()">Update</button>
    </modal-form-manage-buttons>

</modal-form-wrapper>
 */

function ModalFormWrapperController() {}
angular.module('sp.components').component('modalFormWrapper', {
  templateUrl: 'app/components/uiComponents/modalForm/modalFormWrapper.html',
  transclude: {
    'inputs': '?modalFormInputs',
    'createButtons': '?modalFormCreateButtons',
    'viewButtons': '?modalFormViewButtons',
    'manangeButtons': '?modalFormManageButtons'
  },
  controller: ModalFormWrapperController,
  bindings: {
    id: '@',
    formType: '@',
    itemTypeTranslateTag: '@',
    itemName: '@',
    showErrorMessage: '<',
    onCancel: '&'
  }
});
function ViewButtonsController() {}
angular.module('sp.components').component('viewButtons', {
  templateUrl: 'app/components/uiComponents/modalForm/viewButtons.html',
  controller: ViewButtonsController,
  bindings: {
    onSetFormTypeManage: '&'
  }
});
function ContactInputsController(inputValidationService, InputLengthLimits) {
  var ctrl = this;

  // Is called when binding values are changed
  ctrl.$onChanges = function (bindings) {
    if (isDataResolved(bindings)) {
      ctrl.handleInputChange();
    }
  };
  function isDataResolved(changes) {
    return !!changes.data && !!changes.data.currentValue;
  }
  ctrl.InputLengthLimits = InputLengthLimits;
  ctrl.isValidName = function () {
    return inputValidationService.isValidInput(ctrl.data.contact_name);
  };
  ctrl.isValidEmail = function (input) {
    return hasValidNotifitionSelection() && (inputValidationService.isValidEmail(ctrl.data.email) || !ctrl.data.email_notif);
  };
  ctrl.isValidPhone = function (input) {
    return hasValidNotifitionSelection() && (inputValidationService.isValidInput(ctrl.data.phone_nr) || !ctrl.data.sms_notif);
  };
  function hasValidNotifitionSelection() {
    return ctrl.data.email_notif || ctrl.data.sms_notif || !ctrl.areNotificationsRequired;
  }
  ctrl.handleInputChange = function () {
    ctrl.isValid = ctrl.isValidName() && ctrl.isValidPhone() && ctrl.isValidEmail();
    ctrl.onValidationChange({
      "$isValid": ctrl.isValid
    });
  };
  ctrl.handleContactSelected = function (selectedContact) {
    var newData = {
      "contact_id": ctrl.data.contact_id,
      "contact_name": selectedContact.name,
      "phone_nr": selectedContact.phone,
      "email": selectedContact.email,
      "sms_notif": ctrl.data.sms_notif,
      "email_notif": ctrl.data.email_notif
    };
    ctrl.onContactSelected({
      "$data": newData
    });
  };
}
angular.module('sp.components').component('contactInputs', {
  templateUrl: 'app/components/uiComponents/orderForm/contactInputs.html',
  controller: ['inputValidationService', 'InputLengthLimits', ContactInputsController],
  bindings: {
    id: '@',
    label: '@',
    data: '<',
    onValidationChange: '&',
    isDisabled: '<',
    showErrors: '<',
    areNotificationsRequired: '<',
    contactList: '<?',
    onContactSelected: '&?'
  }
});
function DeliveryTimeSlotInputsController(inputValidationService, generalHelperService, recurringDirectDeliveryHelper, $timeout, $scope) {
  var ctrl = this;
  var minimumDeliveryTimespan = moment.duration(15, 'minutes');
  var maximumDeliveryTimespan = moment.duration(3, 'months');
  var defaultDeliveryTimeSpan = moment.duration(1, 'hours');
  ctrl.$onInit = function () {
    ctrl.isRecurringOrder = ctrl.orderType === OrderTypeEnum.RECURRING_DIRECT_DELIVERY;
  };

  // Is called when binding values are changed
  ctrl.$onChanges = function (bindings) {
    if (bindings.data && bindings.data.currentValue) {
      if (isEmpty(bindings.data.currentValue)) {
        clearSection();
      }
    }
    if (isDataResolved(bindings)) {
      ctrl.handleInputChange();
    }
  };
  ctrl.hasRecurringTimeSlot = false;
  ctrl.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  ctrl.handleIsRecurringOrderChanged = function () {
    ctrl.onRecurringOrderSelected({
      "$isRecurringOrder": ctrl.isRecurringOrder
    });
    ctrl.handleInputChange();
  };
  ctrl.handleInputChange = function () {
    var slottime1Set = inputValidationService.isValidInput(ctrl.data.time_i);
    var slottime2Set = inputValidationService.isValidInput(ctrl.data.time_f);
    var recurringStartSet = inputValidationService.isValidDate(ctrl.data.recurring_start);
    var recurringEndSet = inputValidationService.isValidDate(ctrl.data.recurring_end);
    var isValid = ctrl.isRecurringOrder ? recurringStartSet && recurringEndSet && evaluateRecurringWeek(ctrl.data.recurring_week) : slottime1Set && slottime2Set;
    ctrl.onValidationChange({
      "$isValid": isValid
    });
  };
  ctrl.initDateTimeEvents = function () {
    // Init date time pickers
    $('#slottime_initial_datetimepicker').datetimepicker({
      format: 'YYYY-MM-DD HH:mm',
      locale: 'sv'
    });
    $('#slottime_initial_datetimepicker').data().DateTimePicker.stepping(15);
    $('#slottime_final_datetimepicker').datetimepicker({
      format: 'YYYY-MM-DD HH:mm',
      locale: 'sv'
    });
    $('#slottime_final_datetimepicker').data().DateTimePicker.stepping(15);
    $('#recurring_start_datepicker').datetimepicker({
      format: 'YYYY-MM-DD',
      locale: 'sv'
    });
    $('#recurring_end_datepicker').datetimepicker({
      format: 'YYYY-MM-DD',
      locale: 'sv'
    });

    // Date time picker events
    $('#slottime_initial_datetimepicker').on('dp.change', function () {
      // Set standard initial
      var initial = $('#slottime_initial').val();
      if (!ctrl.isInternal) {
        initial = generalHelperService.limitDateTimeToCurrent(initial);
        $('#slottime_initial').val(initial);
      }
      ctrl.data.time_i = initial;
      var final = generalHelperService.addTimespanToDateTime(initial, defaultDeliveryTimeSpan);
      $('#slottime_final').val(final);
      ctrl.data.time_f = final;
      ctrl.handleInputChange();
    });
    $('#slottime_final_datetimepicker').on('dp.change', function () {
      // Set standard final
      var initial = $('#slottime_initial').val();
      var final = $('#slottime_final').val();
      var newFinal = generalHelperService.getValidFinalDateTime(initial, final);
      if (!ctrl.isInternal) {
        newFinal = generalHelperService.limitDateTimeToCurrent(newFinal);
      }
      if (ctrl.data.time_i) {
        newFinal = generalHelperService.limitDateTimeSpan(initial, newFinal, minimumDeliveryTimespan, maximumDeliveryTimespan, ctrl.isRecurringOrder);
      }
      $('#slottime_final').val(newFinal);
      ctrl.data.time_f = newFinal;
      ctrl.handleInputChange();
    });
    $('#recurring_start_datepicker').on('dp.change', function () {
      // Set recurring_start
      var start = $('#recurring_start').val();
      var end = $('#recurring_end').val();
      var newStart = generalHelperService.getValidInitialDateTime(start, end);
      // Note: Only internal personnel may add recurring orders, so limitation to current date is not implemented.

      $('#recurring_start').val(newStart);
      ctrl.data.recurring_start = newStart;
      if (ctrl.data.recurring_end) {
        var newEnd = generalHelperService.limitDateTimeSpan(newStart, newEnd, 0, maximumDeliveryTimespan, ctrl.isRecurringOrder);
        $('#recurring_end').val(newEnd);
        ctrl.data.recurring_end = newEnd;
      }
      ctrl.updateAllowedPassages();
      ctrl.handleInputChange();
    });
    $('#recurring_end_datepicker').on('dp.change', function () {
      // Set recurring_end
      var start = $('#recurring_start').val();
      var end = $('#recurring_end').val();
      var newEnd = generalHelperService.getValidFinalDateTime(start, end);
      // Note: Only internal personnel may add recurring orders, so limitation to current date is not implemented.
      if (ctrl.data.recurring_start) {
        newEnd = generalHelperService.limitDateTimeSpan(start, newEnd, 0, maximumDeliveryTimespan, ctrl.isRecurringOrder);
      }
      $('#recurring_end').val(newEnd);
      ctrl.data.recurring_end = newEnd;
      ctrl.updateAllowedPassages();
      ctrl.handleInputChange();
    });
  };

  // Recurring order start --
  ctrl.addRecurringSpan = function () {
    var recurringDay = ctrl.data.recurring_week[ctrl.data.at_recurring_day];
    if (!recurringDay.slots) recurringDay.slots = [];
    recurringDay.slots.push({
      week_day: recurringDay.week_day,
      time_i: '',
      time_f: ''
    });
    ctrl.updateAllowedPassages();
  };
  ctrl.removeRecurringSpan = function () {
    var slots = ctrl.data.recurring_week[ctrl.data.at_recurring_day].slots;
    if (slots) {
      slots.splice(slots.length - 1, 1);
    }
    ctrl.updateAllowedPassages();
  };
  ctrl.updateAllowedPassages = function () {
    $timeout(function () {
      // added dummy timeout to simulate delay
      var allowedPassages = recurringDirectDeliveryHelper.calculateAllowedPassages(ctrl.data.recurring_week, ctrl.data.recurring_start, ctrl.data.recurring_end, ctrl.data.week_frequency);
      ctrl.data.allowed_passages = allowedPassages;
      if (!$scope.$$phase) {
        $scope.$apply(); //$digest or $apply
      }
    });
  };

  ctrl.deactivateRecurringDays = function () {
    angular.forEach(ctrl.data.recurring_week, function (data) {
      data.active = false;
    });
  };
  function evaluateRecurringWeek(recurringWeek) {
    var isValid = true;
    var hasAtLeastOneTimeSlot = false;
    angular.forEach(recurringWeek, function (day) {
      if (day.slots.length > 0) {
        hasAtLeastOneTimeSlot = true;
      }
      angular.forEach(day.slots, function (slot) {
        if (!inputValidationService.isValidInput(slot.time_i) || !inputValidationService.isValidInput(slot.time_f)) {
          isValid = false;
        }
      });
    });
    ctrl.hasRecurringTimeSlot = hasAtLeastOneTimeSlot;
    return ctrl.hasRecurringTimeSlot && isValid;
  }
  $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent, index, day) {
    // Start datetimepickers
    var slots;
    if (day === 0) slots = ctrl.data.recurring_week[6].slots;else slots = ctrl.data.recurring_week[day - 1].slots;
    var pickerSuffixIndexAndFromOrTo = '#picker_day-' + day + '-index-';
    var inputElementSuffixIndexAndFromOrTo = '#inputElement_day-' + day + '-index-';

    // Activate all dateTimePickers.
    for (var i = 0; i < slots.length; i++) {
      $(pickerSuffixIndexAndFromOrTo + i + '-fromto-1').datetimepicker({
        format: 'LT',
        locale: 'sv'
      });
      $(pickerSuffixIndexAndFromOrTo + i + '-fromto-1').data().DateTimePicker.stepping(15);
      $(pickerSuffixIndexAndFromOrTo + i + '-fromto-2').datetimepicker({
        format: 'LT',
        locale: 'sv'
      });
      $(pickerSuffixIndexAndFromOrTo + i + '-fromto-2').data().DateTimePicker.stepping(15);
    }
    for (i = 0; i < slots.length; i++) {
      if (!slots[i].is_setup) {
        var elementIdWithIndex = inputElementSuffixIndexAndFromOrTo + i;
        // Date time picker events
        $(pickerSuffixIndexAndFromOrTo + i + '-fromto-1').on('dp.change', function (ev) {
          var id = ev.currentTarget.id.slice(19, 20); //... extracts slot index in day
          var initial = $(elementIdWithIndex + '-fromto-1').val();
          slots[id].time_i = initial;
          var final = generalHelperService.addTimespanToTime(initial, defaultDeliveryTimeSpan);
          final = generalHelperService.limitTimespan(initial, final, minimumDeliveryTimespan, '23:45');
          $(pickerSuffixIndexAndFromOrTo + i + '-fromto-2').val(final);
          slots[id].time_f = final;
          if (!$scope.$$phase) {
            $scope.$apply(); //$digest or $apply
          }

          ctrl.handleInputChange();
        });
        $(pickerSuffixIndexAndFromOrTo + i + '-fromto-2').on('dp.change', function (ev) {
          var id = ev.currentTarget.id.slice(19, 20); //... extracts slot index in day
          var initial = $(elementIdWithIndex + '-fromto-1').val();
          var final = $(elementIdWithIndex + '-fromto-2').val();
          var newFinal = generalHelperService.getValidFinalDateTime(initial, final);
          if (initial) {
            newFinal = generalHelperService.limitTimespan(initial, newFinal, minimumDeliveryTimespan, '23:45');
          }
          $(elementIdWithIndex + '-fromto-2').val(newFinal);
          slots[id].time_f = newFinal;
          if (!$scope.$$phase) {
            $scope.$apply(); //$digest or $apply
          }

          ctrl.handleInputChange();
        });
        slots[i].is_setup = true;
      }
    }
  });
  // Recurring order end --

  function clearSection() {
    ctrl.data.week_frequency = '1'; // Week frequency, odd, even, all
    ctrl.data.recurring_week = [{
      day_name: 'MON',
      slots: [],
      week_day: 1,
      active: true
    }, {
      day_name: 'TUE',
      slots: [],
      week_day: 2
    }, {
      day_name: 'WED',
      slots: [],
      week_day: 3
    }, {
      day_name: 'THU',
      slots: [],
      week_day: 4
    }, {
      day_name: 'FRI',
      slots: [],
      week_day: 5
    }, {
      day_name: 'SAT',
      slots: [],
      week_day: 6
    }, {
      day_name: 'SUN',
      slots: [],
      week_day: 0
    }];
    ctrl.handleInputChange();
  }
  function isEmpty(obj) {
    return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
  }
  function isDataResolved(changes) {
    return !!changes.data && !!changes.data.currentValue;
  }
}
angular.module('sp.components').component('deliveryTimeSlotInputs', {
  templateUrl: 'app/components/uiComponents/orderForm/deliveryTimeSlotInputs.html',
  controller: ['inputValidationService', 'generalHelperService', 'recurringDirectDeliveryHelper', '$timeout', '$scope', DeliveryTimeSlotInputsController],
  bindings: {
    id: '@',
    data: '<',
    onValidationChange: '&',
    isDisabled: '<',
    showErrors: '<',
    isInternal: '<',
    orderType: '<',
    isRecurringAllowed: '<',
    isRecurringDisabled: '<',
    onRecurringOrderSelected: '&?'
  }
});
function ResourceBookingInputsController(inputValidationService, generalHelperService, orderFactory, errorService, $scope) {
  var ctrl = this;
  var minimumDeliveryTimespan = moment.duration(15, 'minutes');
  var maximumDeliveryTimespan = moment.duration(3, 'months');
  var defaultDeliveryTimeSpan = moment.duration(1, 'hours');

  // Is called when binding values are changed
  ctrl.$onChanges = function (bindings) {
    if (isDataResolved(bindings)) {
      if (ctrl.data.length < 1) {
        ctrl.addResourceBooking();
      }
      ctrl.handleInputChange();
    }
  };
  ctrl.isValidResourceLocation = function (resourceBooking) {
    return inputValidationService.isValidInput(resourceBooking.resource_location_name) && inputValidationService.isValidInput(resourceBooking.resource_location_id);
  };
  ctrl.isValidSlotTimeStart = function (resourceBooking) {
    return inputValidationService.isValidInput(resourceBooking.slot_time_start);
  };
  ctrl.isValidSlotTimeEnd = function (resourceBooking) {
    return inputValidationService.isValidInput(resourceBooking.slot_time_end);
  };
  ctrl.handleInputChange = function () {
    var isValid = false;
    var hasInvalidBooking = false;
    if (ctrl.data && ctrl.data.length > 0) {
      angular.forEach(ctrl.data, function (item) {
        if (!ctrl.isValidResourceLocation(item) || !ctrl.isValidSlotTimeStart(item) || !ctrl.isValidSlotTimeEnd(item)) {
          hasInvalidBooking = true;
        }
      });
      isValid = !hasInvalidBooking;
    } else {
      isValid = false;
    }
    ctrl.onValidationChange({
      "$isValid": isValid
    });
  };
  ctrl.handleResourceLocationSelected = function (selectedResourceLocation, resourceBooking) {
    resourceBooking.resource_location_id = selectedResourceLocation.LocationId;
    resourceBooking.resource_location_name = selectedResourceLocation.Name;
    ctrl.checkIsAvailable(resourceBooking);
    ctrl.handleInputChange();
  };
  ctrl.addResourceBooking = function () {
    if (!ctrl.isAddAllowed()) return;
    ctrl.data.push({
      "resource_location_name": "",
      "slot_time_start": undefined,
      "slot_time_end": undefined
    });
    ctrl.handleInputChange();
  };
  ctrl.removeResourceBooking = function () {
    if (!ctrl.isDeleteAllowed()) return;
    ctrl.data.pop();
    ctrl.handleInputChange();
  };
  ctrl.isAddAllowed = function () {
    if (!ctrl.data) return false;
    return ctrl.data.length < 5;
  };
  ctrl.isDeleteAllowed = function () {
    if (!ctrl.data) return false;
    return ctrl.data.length > 1;
  };
  ctrl.checkIsAvailable = function (resourceBooking) {
    if (!resourceBooking.slot_time_start || !resourceBooking.slot_time_end || !resourceBooking.resource_location_id) return;
    orderFactory.isResourceAvailable(resourceBooking.slot_time_start, resourceBooking.slot_time_end, resourceBooking.resource_location_id, resourceBooking.resource_booking_id).then(function (response) {
      resourceBooking.isUnavailable = !response.data;
    }, function (error) {
      errorService.handleError(error);
    });
  };
  ctrl.initDateTimeEvents = function (index) {
    // Init date time pickers
    $('#slottime-start-datetimepicker' + index).datetimepicker({
      format: 'YYYY-MM-DD HH:mm',
      locale: 'sv'
    });
    $('#slottime-start-datetimepicker' + index).data().DateTimePicker.stepping(15);
    $('#slottime-end-datetimepicker' + index).datetimepicker({
      format: 'YYYY-MM-DD HH:mm',
      locale: 'sv'
    });
    $('#slottime-end-datetimepicker' + index).data().DateTimePicker.stepping(15);

    // Date time picker events
    $('#slottime-start-datetimepicker' + index).on('dp.change', function () {
      // Set standard start & end
      var start = $('#slottime-start-input' + index).val();
      if (!ctrl.isInternal) {
        start = generalHelperService.limitDateTimeToCurrent(start);
        $('#slottime-start-input' + index).val(start);
      }
      ctrl.data[index].slot_time_start = start;
      var end = generalHelperService.addTimespanToDateTime(start, defaultDeliveryTimeSpan);
      $('#slottime-end-input' + index).val(end);
      ctrl.data[index].slot_time_end = end;
      ctrl.checkIsAvailable(ctrl.data[index]);
      ctrl.handleInputChange();
    });
    $('#slottime-end-datetimepicker' + index).on('dp.change', function () {
      // Set standard end
      var start = $('#slottime-start-input' + index).val();
      var end = $('#slottime-end-input' + index).val();
      var newEnd = generalHelperService.getValidFinalDateTime(start, end);
      if (!ctrl.isInternal) {
        newEnd = generalHelperService.limitDateTimeToCurrent(newEnd);
      }
      if (ctrl.data[index].slot_time_start) {
        newFinal = generalHelperService.limitDateTimeSpan(start, newEnd, minimumDeliveryTimespan, maximumDeliveryTimespan, false);
      }
      $('#slottime-end-input' + index).val(newEnd);
      ctrl.data[index].slot_time_end = newEnd;
      ctrl.checkIsAvailable(ctrl.data[index]);
      ctrl.handleInputChange();
    });
    ctrl.data[index].is_initiated = true;
  };
  $scope.$on('ngRepeatFinished', function () {
    for (var i = 0; i < ctrl.data.length; i++) {
      if (!ctrl.data[i].is_initiated) {
        ctrl.initDateTimeEvents(i);
      }
    }
  });
  function isDataResolved(changes) {
    return !!changes.data && !!changes.data.currentValue;
  }
}
angular.module('sp.components').component('resourceBookingInputs', {
  templateUrl: 'app/components/uiComponents/orderForm/resourceBookingInputs.html',
  controller: ['inputValidationService', 'generalHelperService', 'orderFactory', 'errorService', '$scope', ResourceBookingInputsController],
  bindings: {
    data: '<',
    onValidationChange: '&',
    isInternal: '<',
    isDisabled: '<',
    showErrors: '<',
    resourceList: '<'
  }
});
function SectionBookingChoiceController(inputValidationService, generalHelperService, $localStorage, orderFactory, taskStatusService, errorService, $scope, roleService) {
  var ctrl = this;
  ctrl.sessionMainProject = $localStorage.user.session_main_project;
  ctrl.isCompleted = false;
  var isValidFiles = true;
  var isValidDeliveryTimeSlots = false;
  var isValidResourceBookings = true;
  ctrl.showDirectDeliveryCollisionWarning = false;
  ctrl.finalDestinationLocationNodes = [];
  ctrl.currentProjectId = -1;
  ctrl.dropLocationParentId = -1;
  ctrl.$onInit = function () {
    identifyRoles();
    setVisibiltyFlags();
    ctrl.handleInputChanged();
  };

  // Is called when binding values are changed
  ctrl.$onChanges = function (bindings) {
    if (bindings.data && bindings.data.currentValue) {
      if (isEmpty(bindings.data.currentValue)) {
        clearSection();
      } else if (ctrl.isGateBooking || ctrl.data && ctrl.data.hasGateIntegration) {
        ctrl.validateGateValues();
        ctrl.handleInputChanged();
      }
    }
    if (bindings.isPreviousSectionCompleted) {
      ctrl.handleInputChanged();
    }
    if (bindings.vehicleDropLocations) {
      setCurrentProjectIdFromVehicleDropLocation();
    }
    if (bindings.finalDestinationLocations) {
      updateFinalDestination();
    }
  };
  ctrl.handleValidationChange = function (source, value) {
    switch (source) {
      case "delivery_time_slots":
        isValidDeliveryTimeSlots = value;
        ctrl.checkDirectDeliveryCollision();
        break;
      case "resource_bookings":
        isValidResourceBookings = value;
        break;
      default:
        console.log(source + " is not a valid source");
        break;
    }
    ctrl.handleInputChanged();
  };
  ctrl.handleIsRecurringOrderChanged = function (isRecurringOrder) {
    ctrl.onRecurringOrderSelected({
      "$isRecurringOrder": isRecurringOrder
    });
  };
  ctrl.handleDestinationInformationSelection = function (isOptionSpecifiedAdress) {
    if (isOptionSpecifiedAdress) {
      delete ctrl.data.vehicle_drop_location_id;
      delete ctrl.data.vehicle_drop_location_name;
      ctrl.clearFinalDestination();
    } else {
      delete ctrl.data.address;
      delete ctrl.data.city;
      delete ctrl.data.zip_code;
    }
    ctrl.handleInputChanged();
  };
  ctrl.handleVehicleDropLocationSelected = function (vehicleDropLocation) {
    ctrl.data.vehicle_drop_location_name = vehicleDropLocation.Name;
    ctrl.data.vehicle_drop_location_id = vehicleDropLocation.LocationId;
    setDropLocationDependingInfo(vehicleDropLocation);
    delete ctrl.data.gate_in_id;
    delete ctrl.data.gate_in_name;
    delete ctrl.data.gate_out_id;
    delete ctrl.data.gate_out_name;
    delete ctrl.data.extra_gate_in_id;
    delete ctrl.data.extra_gate_in_name;
    delete ctrl.data.extra_gate_out_id;
    delete ctrl.data.extra_gate_out_name;
    clearChildNodes(0);
    ctrl.checkDirectDeliveryCollision();
    ctrl.handleInputChanged();
  };
  function setDropLocationDependingInfo(vehicleDropLocation) {
    if (!vehicleDropLocation) {
      ctrl.currentProjectId = -1;
      ctrl.dropLocationParentId = -1;
    } else {
      ctrl.currentProjectId = vehicleDropLocation.ProjectId;
      ctrl.dropLocationParentId = vehicleDropLocation.ParentLocationId;
    }
  }
  function setCurrentProjectIdFromVehicleDropLocation() {
    if (!ctrl.data.vehicle_drop_location_id) return;
    angular.forEach(ctrl.vehicleDropLocations, function (location) {
      if (ctrl.data.vehicle_drop_location_id == location.LocationId) {
        setDropLocationDependingInfo(location);
      }
    });
  }
  ctrl.handleFinalDestinationSelected = function (node, location) {
    node.location_name = location.Name;
    node.location_id = location.LocationId;
    node.is_scannable = location.IsScannable;
    clearChildNodes(node.level);
    removeSelectedFinalDestination();
    node.is_destination = true;
    ctrl.data.destination_location_id = location.LocationId;
    ctrl.data.destination_location_name = location.LocationName;
    ctrl.handleInputChanged();
  };
  ctrl.handleFilesSelected = function (files, isValid) {
    if (isValid) {
      ctrl.data.file_attachments_to_add = files;
    }
    isValidFiles = isValid;
  };
  ctrl.getFilePath = function (fileName) {
    return orderFactory.createFileLink(ctrl.orderId, fileName);
  };
  ctrl.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  ctrl.isValidArrivalTime = function () {
    if (!ctrl.showArrivalTime) return true;
    return inputValidationService.isValidDateTime(ctrl.data.arrival_time);
  };
  ctrl.isValidDeliveryTimeSlots = function () {
    if (!ctrl.showDeliveryTimeSlots) return true;
    return isValidDeliveryTimeSlots;
  };
  ctrl.isValidVehicleDropLocation = function () {
    if (!ctrl.showUnloadingPlace || ctrl.data.specified_address) return true;
    return inputValidationService.isValidInput(ctrl.data.vehicle_drop_location_name) || ctrl.isResourceBooking;
  };
  ctrl.isValidFinalDestination = function () {
    if (!ctrl.showUnloadingPlace || ctrl.data.specified_address) return true;
    var destination = getFinalDestination();
    return (!ctrl.sessionMainProject.is_final_destination_required || ctrl.isResourceBooking) && destination.LocationId == null || inputValidationService.isValidInput(destination) && inputValidationService.isValidInput(destination.Name) && inputValidationService.isValidInput(destination.IsScannable) && destination.IsScannable !== false;
  };
  ctrl.isValidStaircase = function () {
    if (!ctrl.data.staircase_location_id && !ctrl.data.staircase_location_name) return true;
    selectedStaircase = null;
    angular.forEach(ctrl.finalDestinationLocations, function (location) {
      if (location.LocationId == ctrl.data.staircase_location_id) {
        selectedStaircase = location;
      }
    });
    if (!selectedStaircase) return false;
    return inputValidationService.isValidOptionalInput(ctrl.data.staircase_location_name) && selectedStaircase.Name == ctrl.data.staircase_location_name;
  };
  ctrl.isValidSpecifiedAddress = function () {
    if (!ctrl.showSpecifiedAddress || !ctrl.data.specified_address) return true;
    return inputValidationService.isValidInput(ctrl.data.address) && inputValidationService.isValidInput(ctrl.data.zip_code) && inputValidationService.isValidInput(ctrl.data.city);
  };
  ctrl.isValidNumberOfTransports = function () {
    if (!ctrl.showNumberOfTransports) return true;
    return inputValidationService.isValidInput(ctrl.data.n_transports);
  };
  ctrl.validateGateValues = function () {
    if (!ctrl.data.gates || !ctrl.data.gates.length) return;

    // Track if we made any changes for user feedback
    var invalidGatesDetected = false;

    // Helper function to check if gate is valid (exists and is not disabled)
    function isValidGate(gateName, gatesList) {
      if (!gateName) return true; // No gate selected is considered valid
      var matchingGate = gatesList.find(function (g) {
        return g.Name === gateName;
      });
      return matchingGate && !matchingGate.IsDisabled;
    }

    // Check if gate_in exists in available gates and is not disabled
    if (ctrl.data.gate_in_name && !isValidGate(ctrl.data.gate_in_name, ctrl.data.gates)) {
      // Store original value for display in a warning
      ctrl.invalidGateInName = ctrl.data.gate_in_name;
      // Clear the invalid values
      delete ctrl.data.gate_in_id;
      delete ctrl.data.gate_in_name;
      invalidGatesDetected = true;
    }

    // Check if gate_out exists in available gates and is not disabled
    if (ctrl.data.gate_out_name && !isValidGate(ctrl.data.gate_out_name, ctrl.data.gates)) {
      ctrl.invalidGateOutName = ctrl.data.gate_out_name;
      delete ctrl.data.gate_out_id;
      delete ctrl.data.gate_out_name;
      invalidGatesDetected = true;
    }

    // Handle extra gates if they exist
    if (ctrl.data.extra_gates && ctrl.data.extra_gates.length) {
      if (ctrl.data.extra_gate_in_name && !isValidGate(ctrl.data.extra_gate_in_name, ctrl.data.extra_gates)) {
        ctrl.invalidExtraGateInName = ctrl.data.extra_gate_in_name;
        delete ctrl.data.extra_gate_in_id;
        delete ctrl.data.extra_gate_in_name;
        invalidGatesDetected = true;
      }
      if (ctrl.data.extra_gate_out_name && !isValidGate(ctrl.data.extra_gate_out_name, ctrl.data.extra_gates)) {
        ctrl.invalidExtraGateOutName = ctrl.data.extra_gate_out_name;
        delete ctrl.data.extra_gate_out_id;
        delete ctrl.data.extra_gate_out_name;
        invalidGatesDetected = true;
      }
    }
    if (invalidGatesDetected) {
      // Set a flag to display a warning message to the user
      ctrl.hasInvalidGates = true;
    } else {
      ctrl.hasInvalidGates = false;
    }

    // Clear warning flags when there are no invalid gates
    if (!ctrl.hasInvalidGates) {
      ctrl.invalidGateInName = null;
      ctrl.invalidGateOutName = null;
      ctrl.invalidExtraGateInName = null;
      ctrl.invalidExtraGateOutName = null;
    }
    return invalidGatesDetected;
  };
  ctrl.isValidGates = function () {
    // If gates aren't required for this order type, always return true
    if (!ctrl.isGateBooking && !ctrl.data.hasGateIntegration) return true;

    // For a gate booking, both in and out gates are always required
    if (ctrl.isGateBooking) {
      return inputValidationService.isValidInput(ctrl.data.gate_in_name) && inputValidationService.isValidInput(ctrl.data.gate_out_name) && inputValidationService.isValidInput(ctrl.data.gate_in_id) && inputValidationService.isValidInput(ctrl.data.gate_out_id);
    }

    // For other order types with gate integration, check if gates are both selected
    // and valid (exist in the gates collection and aren't disabled)
    if (ctrl.data.hasGateIntegration) {
      // First, check if gates are selected at all
      var gatesSelected = inputValidationService.isValidInput(ctrl.data.gate_in_name) && inputValidationService.isValidInput(ctrl.data.gate_out_name) && inputValidationService.isValidInput(ctrl.data.gate_in_id) && inputValidationService.isValidInput(ctrl.data.gate_out_id);
      if (!gatesSelected) return false;

      // Then verify they exist in the gates collection and aren't disabled
      if (ctrl.data.gates && ctrl.data.gates.length > 0) {
        var gateInValid = ctrl.data.gates.some(function (g) {
          return g.GateId === ctrl.data.gate_in_id && g.Name === ctrl.data.gate_in_name && !g.IsDisabled;
        });
        var gateOutValid = ctrl.data.gates.some(function (g) {
          return g.GateId === ctrl.data.gate_out_id && g.Name === ctrl.data.gate_out_name && !g.IsDisabled;
        });
        return gateInValid && gateOutValid;
      }

      // If we have no gates collection to validate against, check if the IDs and names are populated
      return true;
    }

    // Default fallback
    return true;
  };
  ctrl.isValidResourceBookings = function () {
    if (!ctrl.showResourceBookings) return true;
    return isValidResourceBookings;
  };
  ctrl.isValidExternalOrderReference = function () {
    if (!ctrl.showExternalOrderReference) return true;
    return inputValidationService.isValidInput(ctrl.data.ext_order_reference);
  };
  ctrl.deleteKeyFromObject = function (object, key) {
    if (object[key]) delete object[key];
  };
  ctrl.handleInputChanged = function () {
    // If this is a gate booking or has gate integration, validate gates
    if ((ctrl.isGateBooking || ctrl.data.hasGateIntegration) && ctrl.data.gates) {
      ctrl.validateGateValues();
    }
    var isValid = isValidFiles && ctrl.isValidArrivalTime() && ctrl.isValidDeliveryTimeSlots() && ctrl.isValidVehicleDropLocation() && ctrl.isValidFinalDestination() && ctrl.isValidResourceBookings() && ctrl.isValidStaircase() && ctrl.isValidSpecifiedAddress() && ctrl.isValidNumberOfTransports() && ctrl.isValidGates();
    ctrl.isCompleted = isValid && ctrl.isPreviousSectionCompleted;
    ctrl.onCompletedChange({
      "$isCompleted": ctrl.isCompleted
    });
  };
  ctrl.initDateTimeEvents = function () {
    // Init date time pickers
    $('#arrival-time-datetimepicker').datetimepicker({
      format: 'YYYY-MM-DD HH:mm',
      locale: 'sv'
    });
    $('#arrival-time-datetimepicker').data().DateTimePicker.stepping(15);

    // Date time picker events
    $('#arrival-time-datetimepicker').on('dp.change', function () {
      var arrivalTime = $('#arrival-time-input').val();
      if (!ctrl.isInternal && ctrl.orderType === OrderTypeEnum.STORING) {
        arrivalTime = generalHelperService.limitDateTimeToCurrent(arrivalTime);
      }
      if (ctrl.minDeliveryDate) {
        var minDeliveryDate = !ctrl.isExpress ? ctrl.minDeliveryDate : generalHelperService.dateToDateTimeString(new Date());
        arrivalTime = generalHelperService.getValidFinalDateTime(minDeliveryDate, arrivalTime);
      }
      ctrl.data.arrival_time = arrivalTime;
      ctrl.handleInputChanged();
      if (!$scope.$$phase) {
        //$digest or $apply
        $scope.$apply();
      }
    });
  };
  ctrl.checkDirectDeliveryCollision = function () {
    if (!ctrl.showDeliveryTimeSlots) return;
    if (!ctrl.data.timeslots.time_i || !ctrl.data.timeslots.time_f || !ctrl.data.vehicle_drop_location_id) {
      ctrl.showDirectDeliveryCollisionWarning = false;
      return;
    }
    orderFactory.isTimeSlotAvailable(ctrl.data.timeslots.time_i, ctrl.data.timeslots.time_f, ctrl.data.vehicle_drop_location_id, ctrl.orderId).then(function (response) {
      var slotIsAvailable = response.data;
      ctrl.showDirectDeliveryCollisionWarning = !slotIsAvailable;
    }, function (error) {
      errorService.handleError(error);
    });
  };
  ctrl.isConfirmedOrLater = function () {
    return taskStatusService.isConfirmedOrLater(ctrl.taskStatus);
  };
  ctrl.isDelivered = function () {
    return taskStatusService.isDelivered(ctrl.taskStatus);
  };

  // --- Final destination ---
  ctrl.clearFinalDestination = function () {
    removeSelectedFinalDestination();
    clearChildNodes(0);
    removeSelectedStaircase();
    ctrl.handleInputChanged();
  };
  ctrl.checkFinalDestination = function (node, disabled) {
    if (disabled) return;
    clearChildNodes(node.level);
    removeSelectedFinalDestination();
    node.is_destination = true;
    ctrl.handleInputChanged();
  };
  ctrl.parentHasChildren = function (parent) {
    if (typeof parent === 'undefined') return true;
    var hasChildren = false;
    angular.forEach(ctrl.finalDestinationLocations, function (loc) {
      if (loc.ParentLocationId === parent.location_id || loc.ParentLocationId === parent.LocationId) {
        hasChildren = true;
      }
    });
    return hasChildren;
  };
  function updateFinalDestination() {
    var depth = findTreeDepth(ctrl.finalDestinationLocations);
    setFinalDestinationLocationNodes(depth);
    if (ctrl.data.destination_location_id) {
      buildFinalDestinationTreeFromLocation(ctrl.data.destination_location_id);
    }
    ctrl.handleInputChanged();
  }
  function buildFinalDestinationTreeFromLocation(location_id) {
    // Find base
    var currentBase;
    angular.forEach(ctrl.finalDestinationLocations, function (loc) {
      if (loc.LocationId === location_id) {
        currentBase = loc;
      }
    });
    if (typeof currentBase === 'undefined') return;

    // Set Dropdown
    ctrl.finalDestinationLocationNodes[currentBase.Level - 2] = {
      level: currentBase.Level,
      location_id: currentBase.LocationId,
      location_name: currentBase.Name,
      is_scannable: currentBase.IsScannable,
      is_destination: true
    };
    do {
      // Find parent
      var parent;
      angular.forEach(ctrl.finalDestinationLocations, function (loc) {
        if (loc.LocationId === currentBase.ParentLocationId) {
          parent = loc;
        }
      });
      var prevBase = currentBase;
      currentBase = parent;

      // Set dropdown
      if (typeof currentBase !== 'undefined') {
        ctrl.finalDestinationLocationNodes[currentBase.Level - 2] = {
          level: currentBase.Level,
          location_id: currentBase.LocationId,
          location_name: currentBase.Name,
          is_scannable: currentBase.IsScannable
        };
      }
    } while (typeof currentBase !== 'undefined' && currentBase.Level !== prevBase.Level);
  }
  function findTreeDepth(nodes) {
    var depth = 0;
    angular.forEach(nodes, function (node) {
      if (node.Level > depth) {
        depth = node.Level;
      }
    });
    return depth;
  }
  function setFinalDestinationLocationNodes(depth) {
    ctrl.finalDestinationLocationNodes = [];
    for (var i = 0; i < depth; i++) {
      ctrl.finalDestinationLocationNodes.push({
        level: i + 1,
        location_name: '',
        is_destination: false
      });
    }
  }
  function clearChildNodes(level) {
    angular.forEach(ctrl.finalDestinationLocationNodes, function (loc) {
      if (loc.level > level) {
        loc.location_name = '';
        delete loc.location_id;
        delete loc.is_destination;
        delete loc.is_scannable;
      }
    });
    removeSelectedFinalDestination();
  }
  function removeSelectedFinalDestination() {
    angular.forEach(ctrl.finalDestinationLocationNodes, function (node) {
      node.is_destination = false;
    });
    ctrl.data.destination_location_id = null;
    ctrl.data.destination_location_name = '';
  }
  function getFinalDestination() {
    var selectedLocation = null;
    angular.forEach(ctrl.finalDestinationLocations, function (location) {
      if (location.LocationId == ctrl.data.destination_location_id) {
        selectedLocation = location;
      }
    });
    return selectedLocation ? selectedLocation : {
      LocationId: null,
      Name: null
    };
  }
  // --- Final destination end ---

  // --- Staircase ---
  ctrl.getCurrentSubProjectLocationNode = function () {
    var subProjects = [];
    angular.forEach(ctrl.finalDestinationLocations, function (loc) {
      if (loc.LocationTypeName === 'SubProject') {
        subProjects.push(loc);
      }
    });
    var selectedNode = null;
    angular.forEach(ctrl.finalDestinationLocationNodes, function (node) {
      var matchingLocation = null;
      angular.forEach(subProjects, function (loc) {
        if (loc.LocationId == node.location_id) {
          matchingLocation = loc;
        }
      });
      if (matchingLocation) {
        selectedNode = node;
      }
    });
    node = selectedNode ? selectedNode : {
      location_id: null,
      location_name: null
    };
    return node;
  };
  ctrl.handleStaircaseSelected = function (location) {
    ctrl.staircase_name = location.Name;
    ctrl.data.staircase_location_id = location.LocationId;
    ctrl.data.staircase_location_name = location.Name;
    ctrl.handleInputChanged();
  };
  function removeSelectedStaircase() {
    ctrl.data.staircase_location_id = null;
    ctrl.data.staircase_location_name = '';
  }

  // --- Staircase end ---

  function clearSection() {
    ctrl.data.n_transports = 1;
    ctrl.data.n_unbooked_transports = 0;
    ctrl.data.specified_address = false;
    setDropLocationDependingInfo(null);
    ctrl.clearFinalDestination();
    ctrl.data.timeslots = {};
    ctrl.data.resource_bookings = [];
    ctrl.data.staircase_location_id = null;
    ctrl.data.staircase_location_name = '';
    ctrl.handleInputChanged();
  }
  function setVisibiltyFlags() {
    ctrl.showArrivalTime = ctrl.orderType === OrderTypeEnum.TRANSSHIPMENT || ctrl.orderType === OrderTypeEnum.STORING || ctrl.orderType === OrderTypeEnum.MATERIAL;
    ctrl.showDeliveryTimeSlots = ctrl.orderType === OrderTypeEnum.DIRECT_DELIVERY || ctrl.orderType === OrderTypeEnum.RECURRING_DIRECT_DELIVERY || ctrl.orderType === OrderTypeEnum.GATE_BOOKING;
    ctrl.showNumberOfTransports = ctrl.orderType === OrderTypeEnum.DIRECT_DELIVERY;
    ctrl.showUnloadingPlace = ctrl.orderType === OrderTypeEnum.DIRECT_DELIVERY || ctrl.orderType === OrderTypeEnum.RECURRING_DIRECT_DELIVERY || ctrl.orderType == OrderTypeEnum.TRANSSHIPMENT || ctrl.orderType === OrderTypeEnum.MATERIAL || ctrl.orderType === OrderTypeEnum.RESOURCE_BOOKING;
    ctrl.showResourceBookings = ctrl.orderType === OrderTypeEnum.RESOURCE_BOOKING;
    ctrl.showSpecifiedAddress = ctrl.orderType === OrderTypeEnum.MATERIAL;
    ctrl.showExternalOrderReference = ctrl.orderType === OrderTypeEnum.STORING;
    ctrl.showDestinationInformationSelector = ctrl.orderType === OrderTypeEnum.MATERIAL;
    ctrl.showAdditionalOptions = ctrl.orderType === OrderTypeEnum.TRANSSHIPMENT || ctrl.orderType === OrderTypeEnum.STORING || ctrl.orderType === OrderTypeEnum.MATERIAL;
    ctrl.showExtendedAdditionalOptions = ctrl.orderType === OrderTypeEnum.DIRECT_DELIVERY || ctrl.orderType === OrderTypeEnum.RECURRING_DIRECT_DELIVERY;
    ctrl.showFileUpload = ctrl.orderType === OrderTypeEnum.DIRECT_DELIVERY || ctrl.orderType === OrderTypeEnum.RECURRING_DIRECT_DELIVERY || ctrl.orderType == OrderTypeEnum.TRANSSHIPMENT || ctrl.orderType === OrderTypeEnum.STORING || ctrl.orderType === OrderTypeEnum.MATERIAL || ctrl.orderType === OrderTypeEnum.RESOURCE_BOOKING;
    ctrl.isGateBooking = ctrl.orderType === OrderTypeEnum.GATE_BOOKING;
    ctrl.isResourceBooking = ctrl.orderType === OrderTypeEnum.RESOURCE_BOOKING;
  }
  function isEmpty(obj) {
    return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
  }
  function identifyRoles() {
    ctrl.isInternal = roleService.isInternal();
    ctrl.isWarehousePlanner = roleService.isWarehousePlanner();
    ctrl.isWarehouseOperator = roleService.isWarehouseOperator();
  }
}
angular.module('sp.components').component('sectionBookingChoice', {
  templateUrl: 'app/components/uiComponents/orderForm/sectionBookingChoice.html',
  controller: ['inputValidationService', 'generalHelperService', '$localStorage', 'orderFactory', 'taskStatusService', 'errorService', '$scope', 'roleService', SectionBookingChoiceController],
  bindings: {
    sectionHeader: '@',
    sectionNumberIconClass: '@',
    data: '<',
    orderType: '<',
    orderId: '<',
    taskStatus: '<',
    minDeliveryDate: '<?',
    isExpress: '<?',
    isDisabled: '<',
    isFileUploadDisabled: '<',
    showErrors: '<',
    hideWarnings: '<',
    isPreviousSectionCompleted: '<',
    onCompletedChange: '&',
    onVehicleDropLocationSelected: '&?',
    vehicleDropLocations: '<?',
    finalDestinationLocations: '<?',
    resourceLocations: '<?',
    onRecurringOrderSelected: '&?'
  }
});
function SectionDeliveryInformationController(inputValidationService, workOrderFactory) {
  var ctrl = this;
  ctrl.isCompleted = false;
  ctrl.suppliers = [];

  // Is called when binding values are changed
  ctrl.$onChanges = function (bindings) {
    if (bindings.data && bindings.data.currentValue) {
      if (isEmpty(bindings.data.currentValue)) {
        clearSection();
      }
    }
    if (bindings.isPreviousSectionCompleted) {
      ctrl.handleInputChanged();
    }
    if (bindings.workOrderId) {
      reloadSuppliers(ctrl.workOrderId);
    }
  };
  ctrl.isValidSupplier = function () {
    return inputValidationService.isValidInput(ctrl.data.supplier);
  };
  ctrl.isValidVehicleTypeName = function () {
    if (ctrl.hideVehicleType) {
      return true;
    }
    return inputValidationService.isValidInput(ctrl.data.vehicle_type_name);
  };
  ctrl.isValidMaterial = function () {
    return inputValidationService.isValidInput(ctrl.data.material);
  };
  ctrl.isValidMaterialAmount = function () {
    return inputValidationService.isValidInput(ctrl.data.n_materials);
  };
  ctrl.handleInputChanged = function () {
    var isValid = ctrl.isValidSupplier() && ctrl.isValidVehicleTypeName() && ctrl.isValidMaterial() && ctrl.isValidMaterialAmount();
    ctrl.isCompleted = isValid && ctrl.isPreviousSectionCompleted;
    ctrl.onCompletedChange({
      "$isCompleted": ctrl.isCompleted
    });
  };
  ctrl.deleteKeyFromObject = function (object, key) {
    if (object[key]) delete object[key];
  };
  ctrl.deleteSupplier = deleteSupplier;
  function clearSection() {
    ctrl.data.supplier = undefined;
    ctrl.data.vehicle_type_id = undefined;
    ctrl.data.vehicle_type_name = undefined;
    ctrl.data.material = undefined;
    ctrl.data.materials = [];
    ctrl.data.n_materials = undefined;
  }
  function isEmpty(obj) {
    return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
  }
  function reloadSuppliers(workOrderId) {
    if (workOrderId) {
      workOrderFactory.getSuppliers(workOrderId).then(function (response) {
        ctrl.suppliers = response.data;
      });
    } else {
      ctrl.suppliers = [];
    }
  }
  function deleteSupplier(supplierId) {
    workOrderFactory.deleteSupplier(ctrl.workOrderId, supplierId).then(function (response) {
      reloadSuppliers(ctrl.workOrderId);
    });
  }
}
angular.module('sp.components').component('sectionDeliveryInformation', {
  templateUrl: 'app/components/uiComponents/orderForm/sectionDeliveryInformation.html',
  controller: ['inputValidationService', 'workOrderFactory', SectionDeliveryInformationController],
  bindings: {
    sectionHeader: '@',
    sectionNumberIconClass: '@',
    data: '<',
    workOrderId: '<',
    hideVehicleType: '<',
    isDisabled: '<',
    hideWarnings: '<',
    showErrors: '<',
    isPreviousSectionCompleted: '<',
    onCompletedChange: '&'
  }
});
function SectionProjectController($localStorage) {
  var ctrl = this;
  var isContactPersonValid = false;
  var isCompanyValid = false;
  var isWorkOrderValid = false;
  ctrl.showReceiver2 = false;
  ctrl.showReceiver3 = false;
  ctrl.isCompleted = false;

  // Is called when binding values are changed
  ctrl.$onChanges = function (bindings) {
    if (bindings.data && bindings.data.currentValue) {
      if (isEmpty(bindings.data.currentValue)) {
        clearSection();
      }
    }
    if (bindings.isPreviousSectionCompleted) {
      handleCompletionChange();
    }
  };
  ctrl.handleValidationChange = function (source, value) {
    switch (source) {
      case "contact_person":
        isContactPersonValid = value;
        break;
      case "company":
        isCompanyValid = value;
        break;
      case "work_order":
        isWorkOrderValid = value;
        break;
      default:
        console.log(source + " is not a valid source");
        break;
    }
    handleCompletionChange();
  };
  ctrl.onCompanySelected = function (company) {
    ctrl.onFormResetAction();
    clearSection();
    if (company) {
      ctrl.data.company_id = company.company_id;
      ctrl.data.company_name = company.company_name;
    } else {
      ctrl.data.company_id = undefined;
      ctrl.data.company_name = undefined;
    }
  };
  ctrl.onWorkOrderSelected = function (workOrder) {
    ctrl.onFormResetAction();
    clearSection();
    if (workOrder) {
      ctrl.data.work_order_id = workOrder.work_order_id;
      ctrl.data.work_order_name = workOrder.work_order_name;
      ctrl.data.company_id = workOrder.company_id;
      ctrl.data.company_name = workOrder.company_name;
      ctrl.onWorkOrderChanged({
        "$workOrderId": workOrder.work_order_id
      });
    }
  };
  ctrl.filterByCompany = function (item) {
    return item["company_id"] === ctrl.data.company_id;
  };
  ctrl.isConfirmedOrLater = function () {
    return ctrl.formType !== "create_order";
  };
  function handleCompletionChange() {
    var isValid = isContactPersonValid && isCompanyValid && isWorkOrderValid;
    ctrl.isCompleted = isValid && ctrl.isPreviousSectionCompleted;
    ctrl.onCompletedChange({
      "$isCompleted": ctrl.isCompleted
    });
  }
  function clearSection() {
    ctrl.data.work_order_id = undefined;
    ctrl.data.work_order_name = undefined;
    ctrl.data.contact_person = defaultContact();
  }
  function defaultContact() {
    var _$localStorage$user$s, _$localStorage$user$s2;
    return {
      "sms_notif": (_$localStorage$user$s = (_$localStorage$user$s2 = $localStorage.user.session_main_project) === null || _$localStorage$user$s2 === void 0 ? void 0 : _$localStorage$user$s2.send_sms_notifications_by_default) !== null && _$localStorage$user$s !== void 0 ? _$localStorage$user$s : false,
      "email_notif": true
    };
  }
  function isEmpty(obj) {
    return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
  }
}
angular.module('sp.components').component('sectionProject', {
  templateUrl: 'app/components/uiComponents/orderForm/sectionProject.html',
  controller: ['$localStorage', SectionProjectController],
  bindings: {
    sectionHeader: '@',
    sectionNumberIconClass: '@',
    formType: '@',
    data: '<',
    isDisabled: '<',
    showErrors: '<',
    hideContactPerson: '<',
    isPreviousSectionCompleted: '<',
    onCompletedChange: '&',
    onFormResetAction: '&',
    onWorkOrderChanged: '&',
    companies: '<',
    workOrders: '<'
  }
});
function SectionReceiversController(contactFactory, $localStorage, errorService, $q) {
  var ctrl = this;
  var isReceiver1Valid = false;
  var isReceiver2Valid = false;
  var isReceiver3Valid = false;
  ctrl.showReceiver2 = false;
  ctrl.showReceiver3 = false;
  ctrl.isCompleted = false;
  ctrl.contactList = [];

  // Is called when binding values are changed
  ctrl.$onChanges = function (bindings) {
    if (bindings.data && bindings.data.currentValue) {
      if (isEmpty(bindings.data.currentValue)) {
        clearAll();
      }
    }
    if (bindings.isPreviousSectionCompleted) {
      handleCompletionChange();
    }
  };
  ctrl.addReceiver = function (receiver) {
    switch (receiver) {
      case 2:
        ctrl.showReceiver2 = true;
        break;
      case 3:
        ctrl.showReceiver3 = true;
        break;
      default:
        console.log("Can't add receiver " + receiver);
    }
    handleCompletionChange();
  };
  ctrl.deleteReceiver = function (receiver) {
    switch (receiver) {
      case 2:
        ctrl.showReceiver2 = false;
        ctrl.data.receiver2 = defaultContact();
        break;
      case 3:
        ctrl.showReceiver3 = false;
        ctrl.data.receiver3 = defaultContact();
        break;
      default:
        console.log("Can't delete receiver " + receiver);
    }
  };
  ctrl.handleValidationChange = function (source, value) {
    switch (source) {
      case "receiver1":
        isReceiver1Valid = value;
        break;
      case "receiver2":
        isReceiver2Valid = value;
        break;
      case "receiver3":
        isReceiver3Valid = value;
        break;
      default:
        console.log(source + " is not a valid source");
        break;
    }
    handleCompletionChange();
  };
  ctrl.handelDataChange = function (source, value) {
    switch (source) {
      case "receiver1":
        ctrl.data.receiver1 = value;
        break;
      case "receiver2":
        ctrl.data.receiver2 = value;
        break;
      case "receiver3":
        ctrl.data.receiver3 = value;
        break;
      default:
        console.log(source + " is not a valid source");
        break;
    }
  };
  ctrl.copyContactInfo = function () {
    ctrl.data.receiver1 = {
      "contact_id": ctrl.data.receiver1.contact_id,
      "contact_name": ctrl.copyContactData.contact_name,
      "phone_nr": ctrl.copyContactData.phone_nr,
      "email": ctrl.copyContactData.email,
      "sms_notif": ctrl.data.receiver1.sms_notif,
      "email_notif": ctrl.data.receiver1.email_notif
    };
    ctrl.copyContactData.sms_notif = false;
    ctrl.copyContactData.email_notif = false;
  };
  function handleCompletionChange() {
    if (ctrl.formType !== "create_order") {
      ctrl.showReceiver2 = isReceiver2Valid;
      ctrl.showReceiver3 = isReceiver3Valid;
    }
    var isValid = isReceiver1Valid && (!ctrl.showReceiver2 || isReceiver2Valid) && (!ctrl.showReceiver3 || isReceiver3Valid);
    ctrl.isCompleted = isValid && ctrl.isPreviousSectionCompleted;
    ctrl.onCompletedChange({
      "$isCompleted": ctrl.isCompleted
    });
  }
  function clearAll() {
    ctrl.data.receiver1 = defaultContact();
    ctrl.deleteReceiver(2);
    ctrl.deleteReceiver(3);
  }
  function loadContacts() {
    var sessionMainProject = $localStorage.user.session_main_project;
    if (!sessionMainProject) return $q.reject();
    return contactFactory.getContacts(sessionMainProject.main_project_id, false).then(function (response) {
      var data = response.data;
      ctrl.contactList = contactFactory.repackageDTOArray(data);
    }, function (error) {
      errorService.handleError(error);
    });
  }
  loadContacts();
  function defaultContact() {
    var _$localStorage$user$s, _$localStorage$user$s2;
    return {
      "sms_notif": (_$localStorage$user$s = (_$localStorage$user$s2 = $localStorage.user.session_main_project) === null || _$localStorage$user$s2 === void 0 ? void 0 : _$localStorage$user$s2.send_sms_notifications_by_default) !== null && _$localStorage$user$s !== void 0 ? _$localStorage$user$s : false,
      "email_notif": true
    };
  }
  function isEmpty(obj) {
    return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
  }
}
angular.module('sp.components').component('sectionReceivers', {
  templateUrl: 'app/components/uiComponents/orderForm/sectionReceivers.html',
  controller: ['contactFactory', '$localStorage', 'errorService', '$q', SectionReceiversController],
  bindings: {
    sectionHeader: '@',
    sectionNumberIconClass: '@',
    formType: '@',
    data: '<',
    isDisabled: '<',
    showErrors: '<',
    isPreviousSectionCompleted: '<',
    onCompletedChange: '&',
    copyContactData: '<'
  }
});
angular.module('serviplan').component('versionNotification', {
  templateUrl: 'app/components/uiComponents/versionNotification/version_notification.html',
  bindings: {
    show: '<',
    error: '<'
  },
  controller: ['$window', function ($window) {
    var ctrl = this;
    ctrl.reload = function () {
      $window.location.reload();
    };
  }]
});
angular.module('sp.controllers').controller('ActivateController', ['$uibModal', '$rootScope', '$scope', '$http', '$location', '$cookies', '$httpParamSerializer', 'authFactory', 'userFactory', '$localStorage', 'errorService', function ($uibModal, $rootScope, $scope, $http, $location, $cookies, $httpParamSerializer, authFactory, userFactory, $localStorage, errorService) {
  $scope.activate = function (password) {
    if ($location.search().login !== 'undefined' && $location.search().token !== 'undefined' && password !== 'undefined') {
      var DTO = {
        "Login": $location.search().login,
        "Token": $location.search().token,
        "Password": password
      };
      userFactory.activateUser(DTO).then(function (response) {
        $scope.showLinkToLogin = true;
      }, function (error) {
        errorService.handleError(error);
        $scope.errorMessage = error.data.Message;
        $scope.showErrorMessage = true;
      });
    }
  };
  $scope.keyUp = function (keyCode) {
    if (keyCode === 13) {
      $scope.activate($scope.activate.password);
    }
  };
  $scope.disableButton = function () {
    var retVal = false;
    retVal = $scope.activate.password !== $scope.activate.password2;
    retVal = !$scope.activate.password === 'undefined' && $scope.activate.password.length === 0;
    return retVal;
  };
  $scope.showPassword1 = false;
  $scope.togglePassword1 = function () {
    $scope.showPassword1 = !$scope.showPassword1;
  };
  $scope.showPassword2 = false;
  $scope.togglePassword2 = function () {
    $scope.showPassword2 = !$scope.showPassword2;
  };
}]);
(function () {
  'use strict';

  angular.module('sp.controllers').controller('LoginController', ['$uibModal', '$rootScope', '$scope', '$http', '$cookies', '$localStorage', '$window', 'authFactory', 'errorService', 'keyCodes', '$timeout', 'ENV', 'loadRecaptchaService', loginController]);
  function loginController($uibModal, $rootScope, $scope, $http, $cookies, $localStorage, $window, authFactory, errorService, keyCodes, $timeout, ENV, loadRecaptchaService) {
    loadRecaptchaService.loadApi();
    var siteKey = ENV.recaptchaSiteKey;
    $scope.login = function (username, password) {
      // TODO: This code could be simplified using async/await once JS version is updated.
      grecaptcha.ready(function () {
        grecaptcha.execute(siteKey, {
          action: 'login'
        }).then(function (captchaToken) {
          authFactory.login(username, password, captchaToken).then(function (response) {
            var data = response.data,
              today = new Date(),
              expireDate = new Date(new Date(new Date().setDate(today.getDate() + 1)).setHours(2, 0, 0, 0));
            $http.defaults.headers.common.Authorization = 'Bearer ' + data.access_token;
            $cookies.put("access_token", data.access_token, {
              "expires": expireDate
            });
            $localStorage.user.current_user = data.userName;
            $localStorage.user.isLoggedIn = true;
            $localStorage.header = {
              btnActive: 'booking_and_delivery'
            };
            $rootScope.header = {
              btnActive: 'booking_and_delivery'
            };
            $timeout(function () {
              window.location.href = "/";
            }, 250);
          }, function (error) {
            var data = error.data;
            $scope.errorMessageKey = data.error_description;
            $scope.showLoginError = true;
            errorService.handleError(error);
          });
        }, function (error) {
          // TODO: It is a bit unclear how these errors would look. Perhaps this code should be changed.
          $scope.errorMessageKey = JSON.stringify(error);
          $scope.showLoginError = true;
          errorService.handleError(error);
        });
      });
    };
    $scope.keyUp = function (keyCode) {
      if (keyCode === keyCodes.ENTER) {
        $scope.login($scope.login.username, $scope.login.password);
      }
    };
    $scope.showPassword = false;
    $scope.togglePassword = function () {
      $scope.showPassword = !$scope.showPassword;
    };
  }
})();
controllers.controller('RequestPasswordResetController', ['$location', '$window', 'userFactory', 'errorService', function ($location, $window, userFactory, errorService) {
  var vm = this;
  vm.passwordResetRequestDTO = {
    Login: ''
  };
  vm.requestPasswordReset = function () {
    userFactory.requestPasswordReset(vm.passwordResetRequestDTO).then(function () {
      vm.showLinkToLogin = true;
    }, function (error) {
      errorService.handleError(error);
      vm.showLinkToLogin = true;
    });
  };
  vm.redirectToLogin = function () {
    $window.location.href = "/login";
  };
}]);
controllers.controller('ResetPasswordController', ['$location', '$translate', '$window', 'userFactory', 'errorService', function ($location, $translate, $window, userFactory, errorService) {
  var vm = this;
  vm.resetPasswordDTO = {};
  vm.resetPasswordDTO.Login = $location.search().login;
  vm.resetPasswordDTO.Token = $location.search().token;
  vm.resetPasswordDTO.Password = null;
  vm.resetPassword = function () {
    if (vm.resetPasswordDTO.Login && vm.resetPasswordDTO.Token && vm.resetPasswordDTO.Password) {
      userFactory.resetPassword(vm.resetPasswordDTO).then(function () {
        vm.showLinkToLogin = true;
      }, function (error) {
        errorService.handleError(error);
        vm.errorMessage = $translate.instant(error.data.Message);
        vm.showErrorMessage = true;
      });
    }
  };
  vm.redirectToLogin = function () {
    $window.location.href = "/login";
  };
  vm.showPassword1 = false;
  vm.togglePassword1 = function () {
    vm.showPassword1 = !vm.showPassword1;
  };
  vm.showPassword2 = false;
  vm.togglePassword2 = function () {
    vm.showPassword2 = !vm.showPassword2;
  };
}]);
'use strict';

app.controller('SettingsController', ['$uibModalInstance', '$scope', '$rootScope', '$translate', 'userFactory', 'errorService', 'ngToast', 'isPasswordChangeRequired', 'InputLengthLimits', function ($uibModalInstance, $scope, $rootScope, $translate, userFactory, errorService, ngToast, isPasswordChangeRequired, InputLengthLimits) {
  $scope.InputLengthLimits = InputLengthLimits;
  $scope.form_type = 'view';
  $scope.validated = false;
  $scope.showFormSuccessMessage = false;
  $scope.showUserSettings = !isPasswordChangeRequired;
  $scope.lang = {};
  $scope.lang.SWEDISH = LanguageEnum.SWEDISH;
  $scope.lang.ENGLISH = LanguageEnum.ENGLISH;
  userFactory.getMe().then(function (response) {
    $scope.data = response.data;
  }, function (error) {
    errorService.handleError(error);
  });
  $scope.manage = function () {
    $scope.form_type = 'manage';
    $scope.showFormSuccessMessage = false;
  };
  $scope.save = function () {
    $scope.showFormSuccessMessage = false;
    $scope.validated = true;
    if (!$scope.validateForm()) {
      return;
    }
    userFactory.updateMe($scope.data).then(function (response) {
      $scope.showFormSuccessMessage = true;
      $scope.form_type = 'view';
    }, function (error) {
      ngToast.danger("Det gick inte att spara ändringarna.");
    });
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.isValidInput = function (input) {
    if (input === '') {
      return false;
    } else if (typeof input === 'undefined') {
      return false;
    } else if (input === null) {
      return false;
    } else return true;
  };
  $scope.validateForm = function () {
    $scope.formValid = $scope.data.LanguageId !== '' && typeof $scope.data.LanguageId !== 'undefined' && $scope.data.Login !== '' && typeof $scope.data.Login !== 'undefined' && $scope.data.Name !== '' && typeof $scope.data.Name !== 'undefined' && $scope.data.PhoneNumber !== '' && typeof $scope.data.PhoneNumber !== 'undefined' && $scope.data.Email !== '' && typeof $scope.data.Email !== 'undefined';
    return $scope.formValid;
  };
  $scope.showChangePassword = isPasswordChangeRequired;
  $scope.showPasswordExpiredMessage = isPasswordChangeRequired;
  $scope.changePasswordDTO = {};
  $scope.changePasswordDTO.OldPassword = "";
  $scope.changePasswordDTO.NewPassword = "";
  $scope.verifyNewPassword = "";
  $scope.showPasswordErrorMessage = false;
  $scope.showChangePasswordFailedMessage = false;
  $scope.showPasswordSuccessMessage = false;
  $scope.passwordErrorMessage = "";
  $scope.validatePasswordInput = function () {
    if (!$scope.changePasswordDTO.NewPassword || !$scope.changePasswordDTO.OldPassword || !$scope.verifyNewPassword) {
      $scope.passwordErrorMessage = $translate.instant('PASSWORD_ERROR_MESSAGE_EMPTY_FIELDS');
      $scope.showPasswordErrorMessage = true;
      return false;
    } else if ($scope.changePasswordDTO.NewPassword !== $scope.verifyNewPassword) {
      $scope.passwordErrorMessage = $translate.instant('PASSWORD_ERROR_MESSAGE_MISSMATCH');
      $scope.showPasswordErrorMessage = true;
      return false;
    } else {
      return true;
    }
  };
  $scope.setShowUserSettings = function () {
    $scope.showUserSettings = true;
    $scope.showChangePassword = false;
  };
  $scope.setShowChangePassword = function () {
    $scope.showUserSettings = false;
    $scope.showChangePassword = true;
  };
  $scope.changePassword = function () {
    $scope.showPasswordErrorMessage = false;
    $scope.showChangePasswordFailedMessage = false;
    $scope.showPasswordSuccessMessage = false;
    $scope.passwordErrorMessage = "";
    if (!$scope.validatePasswordInput()) {
      return;
    }
    userFactory.changePassword($scope.changePasswordDTO).then(function () {
      $scope.changePasswordDTO.OldPassword = "";
      $scope.changePasswordDTO.NewPassword = "";
      $scope.verifyNewPassword = "";
      $scope.showPasswordSuccessMessage = true;
      $scope.showPasswordExpiredMessage = false;
    }, function (error) {
      $scope.showChangePasswordFailedMessage = true;
      errorService.handleError(error);
    });
  };
  $scope.showOldPassword = false;
  $scope.toggleOldPassword = function () {
    $scope.showOldPassword = !$scope.showOldPassword;
  };
  $scope.showNewPassword = false;
  $scope.toggleNewPassword = function () {
    $scope.showNewPassword = !$scope.showNewPassword;
  };
  $scope.showVerifyNewPassword = false;
  $scope.toggleVerifyNewPassword = function () {
    $scope.showVerifyNewPassword = !$scope.showVerifyNewPassword;
  };
}]);
void function () {
  'use strict';

  angular.module('sp.directives').directive('cookieConsent', cookieConsent);
  function cookieConsent() {
    return {
      restrict: 'A',
      controller: 'CookieConsentController',
      controllerAs: 'ctrl',
      templateUrl: "app/directives/cookieConsent/cookieconsent.html"
    };
  }
  angular.module('sp.directives').controller('CookieConsentController', ['$cookies', '$uibModal', '$translate', CookieConsentController]);
  function CookieConsentController($cookies, $uibModal, $translate) {
    var vm = this;
    vm.isCookieAccepted = !!$cookies.get("cookies_accepted");
    vm.doShowMaximizedForm = function () {
      var url = '';
      switch ($translate.use()) {
        case 'sv_bl':
        case 'sv_pl':
          url = "app/directives/cookieConsent/readmore.sv.html";
          break;
        case 'en_bl':
        case 'en_pl':
        default:
          url = "app/directives/cookieConsent/readmore.en.html";
          break;
      }
      $uibModal.open({
        size: 'lg',
        templateUrl: url,
        controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
          $scope.doClose = function () {
            $uibModalInstance.close();
          };
        }]
      });
    };
    vm.handleConsentGranted = function () {
      vm.isCookieAccepted = true;
      var today = new Date();
      var expireDate = new Date(new Date().setMonth(today.getMonth() + 1));
      $cookies.put("cookies_accepted", true, {
        "expires": expireDate
      });
    };
  }
}();
angular.module('sp.directives').directive('header', function () {
  return {
    restrict: 'A',
    replace: true,
    controllerAs: '$ctrl',
    templateUrl: "app/directives/header/header.html",
    controller: ['$uibModal', '$rootScope', '$scope', 'authFactory', '$localStorage', 'languageFactory', 'orderFormModalService', 'roleService', function ($uibModal, $rootScope, $scope, authFactory, $localStorage, languageFactory, orderFormModalService, roleService) {
      var ctrl = this;
      $scope.$on('siteOutdated', function () {
        ctrl.siteOutdated = true;
      });
      $scope.$on('siteOutdatedError', function () {
        ctrl.siteOutdatedError = true;
      });
      ctrl.btnActive = $localStorage.header.btnActive;
      ctrl.supportedLanguages = languageFactory.supportedLanguages;
      ctrl.sessionLanguage = $rootScope.lang_prefix;
      ctrl.selectedVehicleDropLocation = {
        name: '',
        id: null
      };
      function setUserData() {
        ctrl.current_user = $localStorage.user.current_user;
        ctrl.main_projects = $localStorage.user.main_projects;
        ctrl.sessionMainProject = $localStorage.user.session_main_project;
      }
      setUserData();
      ctrl.setHeaderBtnActive = function (btnName, showSideMenu) {
        $localStorage.header.btnActive = btnName;
        ctrl.btnActive = btnName;
        if (showSideMenu) {
          $localStorage.adminSideMenu.visible = true;
          $rootScope.adminSideMenu.visible = true;
        } else {
          $localStorage.adminSideMenu = {
            visible: false,
            groupActive: {
              project: false,
              gateManagement: false,
              transports: false,
              statisticsReports: false
            },
            itemActive: 'administrate'
          };
          $rootScope.adminSideMenu = $localStorage.adminSideMenu;
        }
      };
      ctrl.setSessionMainProject = function (mainProject) {
        $localStorage.user.session_main_project = mainProject;
        ctrl.sessionMainProject = mainProject;
        languageFactory.changeLanguageByDivisionId(mainProject.division_id);
        $rootScope.$broadcast('updatedUserData');
      };
      ctrl.changeBaseLanguage = function (baseLang) {
        languageFactory.changeBaseLanguage(baseLang);
      };
      ctrl.logout = function () {
        authFactory.logout();
      };
      ctrl.settings = function () {
        var animationsEnabled = false;
        $uibModal.open({
          animation: animationsEnabled,
          backdrop: 'static',
          ariaLabelledBy: 'modal-title',
          ariaDescribedBy: 'modal-body',
          templateUrl: 'app/components/user/settings/settings_form.html',
          controller: 'SettingsController',
          size: 'md',
          windowClass: 'sp-modal-window',
          resolve: {
            isPasswordChangeRequired: function isPasswordChangeRequired() {
              return false;
            }
          }
        });
      };
      ctrl.openDirectDeliveryMobileForm = function () {
        ctrl.toggleMenu(null);
        orderFormModalService.openCreate(OrderTypeEnum.DIRECT_DELIVERY).then(function () {
          $rootScope.$broadcast('updateOrders');
        });
      };
      $scope.$on('updatedUserData', function () {
        setUserData();
      });
      $scope.$watch('$ctrl.mobileSearchString', function () {
        $rootScope.$broadcast('searchFromMobile', ctrl.mobileSearchString);
      });
      ctrl.callForFiltering = function () {
        $rootScope.$broadcast('filterVehicleDropLocationFromMobile', ctrl.selectedVehicleDropLocation.id);
      };
      $rootScope.$on('$translateChangeSuccess', function () {
        ctrl.sessionLanguage = $rootScope.lang_prefix;
      });
      ctrl.toggleMenu = function (menu) {
        if (ctrl.activeMenu === menu) {
          ctrl.activeMenu = null;
        } else {
          ctrl.activeMenu = menu;
        }
      };
    }]
  };
});
'use strict';

directives.directive('packageDetails', ['$uibModal', function ($uibModal) {
  return {
    restrict: 'A',
    scope: {
      packageDetails: "=",
      reloadPackages: "&"
    },
    link: function link(scope, element, attrs) {
      element.bind('click', function () {
        var modalInstance = $uibModal.open({
          templateUrl: "app/directives/packageDetails/packageDetails.html",
          resolve: {
            pkg: function pkg() {
              return scope.packageDetails;
            },
            reloadPackages: function reloadPackages() {
              return scope.reloadPackages;
            }
          },
          controller: ['$scope', 'pkg', 'reloadPackages', '$uibModalInstance', 'packageFactory', 'errorService', '$rootScope', 'roleService', function ($scope, pkg, reloadPackages, $uibModalInstance, packageFactory, errorService, $rootScope, roleService) {
            $scope.packageHistory = [];
            $scope.showHistory = false;
            var getPackage = function getPackage(update) {
              packageFactory.getPackage(pkg.package_id).then(function (response) {
                var data = response.data;
                $scope.package = packageFactory.repackageDTO(data);
                getPackageHistory();
                $scope.package.isDelivered = $scope.package.package_status_type == PackageStatusTypeEnum.DELIVERED;
                if (update && reloadPackages) {
                  reloadPackages();
                }
              }, function (error) {
                errorService.handleError(error);
              });
            };
            getPackage(false);
            function getPackageHistory() {
              packageFactory.getPackageHistory($scope.package.package_id).then(function (result) {
                $scope.packageHistory = result.data;
              });
            }
            $scope.deliverPackage = function () {
              packageFactory.deliverPackage(pkg.package_id).then(function () {
                getPackage(true);
              }, function (error) {
                errorService.handleError(error);
              });
            };
            $scope.cancel = function () {
              $uibModalInstance.close();
            };
            $scope.canDeliver = roleService.isAdmin() || roleService.isServicenter() || roleService.isProjectOwner() || roleService.isWarehousePlanner();
          }]
        });
      });
    }
  };
}]);
angular.module('sp.directives').directive('packageTimeTypeDropdown', function () {
  return {
    restrict: 'EA',
    scope: {
      timeValueTypes: '=',
      chosenTimeValueType: '='
    },
    templateUrl: 'app/directives/packageDropdown/packageTimeTypeDropdown.html',
    controller: ['$scope', function (scope) {
      scope.chooseTimeValueType = function (t) {
        scope.chosenTimeValueType = t;
      };
    }]
  };
});
'use strict';

angular.module('sp.controllers').controller('OrderMiniListController', ['$uibModal', '$scope', '$rootScope', '$translate', '$filter', 'orderFactory', 'generalHelperService', 'errorService', '$localStorage', 'roleService', 'orderFormModalService', function ($uibModal, $scope, $rootScope, $translate, $filter, orderFactory, generalHelperService, errorService, $localStorage, roleService, orderFormModalService) {
  var vm = this;
  function identifyRoles() {
    vm.isAdmin = roleService.isAdmin();
    vm.isInternal = roleService.isInternal();
  }
  identifyRoles();
  function reloadOrders() {
    if (vm.isAdmin) {
      vm.adminOrders = $filter('filter')(vm.miniListOrders, {
        task_status: '!' + TaskStatusTypeEnum.CANCELLED
      }, true);
    }
  }
  reloadOrders();

  //FUTURE Make sure this is not called multiple times in a row, also make this a service or similar...
  function loadMonthsFromLanguage() {
    var translations = $translate.instant(['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']);
    var months = [];
    months.push(translations['JAN']);
    months.push(translations['FEB']);
    months.push(translations['MAR']);
    months.push(translations['APR']);
    months.push(translations['MAY']);
    months.push(translations['JUN']);
    months.push(translations['JUL']);
    months.push(translations['AUG']);
    months.push(translations['SEP']);
    months.push(translations['OCT']);
    months.push(translations['NOV']);
    months.push(translations['DEC']);
    return months;
  }
  vm.displayDate = function (date) {
    var months = loadMonthsFromLanguage();
    var today = new Date().toISOString().split('T')[0];
    var pDate = new Date(date);
    return (today === date ? $translate.instant('TODAY') + ' ' : '') + pDate.getDate() + ' ' + months[pDate.getMonth()];
  };
  vm.displayHeader = function (order1, order2) {
    if (order2 === null || typeof order2 === 'undefined') {
      return true;
    }
    return order1.date_i !== order2.date_i;
  };
  vm.isDirectOrder = function (orderType) {
    return OrderTypeEnum.DIRECT_DELIVERY === orderType;
  };
  vm.displayOrderType = function (order_type) {
    var text = "";
    switch (order_type) {
      case OrderTypeEnum.DIRECT_DELIVERY:
        text = $translate.instant('DIRECT_DELIVERY');
        break;
      case OrderTypeEnum.STORING:
        text = $translate.instant('STORING');
        break;
      case OrderTypeEnum.TRANSSHIPMENT:
        text = $translate.instant('TRANSSHIPMENT');
        break;
      case OrderTypeEnum.MATERIAL:
        text = $translate.instant('MATERIAL');
        break;
      case OrderTypeEnum.RESOURCE_BOOKING:
        text = $translate.instant('RESOURCE_BOOKING');
        break;
      default:
        return;
    }
    return text;
  };

  // Color utility functions
  vm.generateFirstColorClass = function (id) {
    return generalHelperService.generateFirstColorClass(id);
  };
  vm.generateSecondColorClass = function (id) {
    return generalHelperService.generateSecondColorClass(id);
  };
  vm.viewOrderFromMini = function (order_type, id, copy) {
    if (id === -1) {
      return;
    }
    var orderFormPromise;
    if (vm.isAdmin) {
      orderFormPromise = orderFormModalService.openManage(id, order_type, copy);
    } else {
      orderFormPromise = orderFormModalService.openView(id, order_type, copy);
    }
    orderFormPromise.then(function (results) {
      if (results.copy) {
        vm.viewOrderFromMini(order_type, id, true);
      }
      if (results.success) {
        $rootScope.$broadcast('updateOrders');
      }
    });
  };
  $scope.$on('updatedOrders', function () {
    reloadOrders();
  });
  $scope.$watchCollection('miniListOrders', function () {
    reloadOrders();
  });
  $scope.$on('updatedUserData', function () {
    identifyRoles();
  });
}]);
angular.module('sp.directives').directive('orderMiniList', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'app/directives/orderMiniList/order_mini_list.html',
    controller: 'OrderMiniListController',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      miniListOrders: '=orders'
    }
  };
});
'use strict';

directives.directive("packageTable", function () {
  return {
    restrict: 'E',
    scope: {
      packages: "="
    },
    templateUrl: "app/directives/packageTable/packageTable.html"
  };
});
angular.module('sp.directives').directive('spPagination', function () {
  return {
    templateUrl: 'app/directives/spPagination/sp_pagination.html',
    restrict: 'E',
    controllerAs: '$ctrl',
    bindToController: true,
    scope: {
      currentPage: '=currentPage',
      itemsPerPage: '<itemsPerPage',
      totalItems: '<totalItems',
      onChange: '&onChange'
    },
    controller: [function () {
      var ctrl = this;
      ctrl.currentPage = ctrl.currentPage || 1;
      ctrl.updatePage = function () {
        var skip = (ctrl.currentPage - 1) * ctrl.itemsPerPage;
        if (ctrl.onChange) {
          ctrl.onChange({
            currentPage: ctrl.currentPage,
            skip: skip,
            take: ctrl.itemsPerPage
          });
        }
      };
      return ctrl;
    }]
  };
});
angular.module('sp.directives').directive('touchEnd', [function () {
  return function (scope, element, attr) {
    element.on('touchend ', function () {
      scope.$apply(function () {
        scope.$eval(attr.touchEnd);
      });
    });
  };
}]);
angular.module('sp.directives').directive('touchStart', [function () {
  return function (scope, element, attr) {
    element.on('touchstart', function () {
      scope.$apply(function () {
        scope.$eval(attr.touchStart);
      });
    });
  };
}]);
'use strict';

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
angular.module('serviplan').controller('MegaFilterController', ['$uibModalInstance', '$scope', '$localStorage', '$q', 'currentFilter', 'isArchive', '$filter', 'generalHelperService', 'workOrderFactory', 'projectFactory', 'subProjectFactory', 'locationFactory', 'companyFactory', 'megaFilterService', function ($uibModalInstance, $scope, $localStorage, $q, currentFilter, isArchive, $filter, generalHelperService, workOrderFactory, projectFactory, subProjectFactory, locationFactory, companyFactory, megaFilterService) {
  var vm = this;
  var $ = angular.element;
  vm.filter = {};
  vm.count = 0;
  vm.showDeliveriesAndStatusSection = true;
  vm.showDatesAndTimeSection = true;
  vm.showProjectsSection = true;
  vm.isArchive = isArchive;
  var limit = 8;
  vm.projectsLimit = limit;
  vm.subProjectsLimit = limit;
  vm.vehicleDropLocationsLimit = limit;
  vm.resourceLocationsLimit = limit;
  vm.companiesLimit = limit;
  vm.workOrdersLimit = limit;
  vm.mainProjectId = $localStorage.user.session_main_project.main_project_id;
  vm.projects = {
    ids: [],
    nameMap: {}
  };
  vm.subProjects = {
    ids: [],
    nameMap: {}
  };
  vm.vehicleDropLocations = {
    ids: [],
    nameMap: {}
  };
  vm.workOrders = {
    ids: [],
    nameMap: {}
  };
  vm.resourceLocations = {
    ids: [],
    nameMap: {}
  };
  vm.companies = {
    ids: [],
    nameMap: {}
  };
  function getFilterables() {
    var workorderPromise = workOrderFactory.getFilterableWorkorders(vm.mainProjectId, vm.isArchive, vm.isArchive).then(function (result) {
      var filterableWorkOrders = result.data;
      vm.workOrders.nameMap = generateNameMapFromFilterables(filterableWorkOrders);
      vm.workOrders.ids = generateIdListFromFilterables(filterableWorkOrders);
    });
    var projectPromise = projectFactory.getFilterableProjects(vm.mainProjectId, vm.isArchive, vm.isArchive).then(function (result) {
      var filterableProjects = result.data;
      vm.projects.nameMap = generateNameMapFromFilterables(filterableProjects);
      vm.projects.ids = generateIdListFromFilterables(filterableProjects);
    });
    var subprojectPromise = subProjectFactory.getFilterableSubProjects(vm.mainProjectId, vm.isArchive, vm.isArchive).then(function (result) {
      var filterableSubProjects = result.data;
      vm.subProjects.nameMap = generateNameMapFromFilterables(filterableSubProjects);
      vm.subProjects.ids = generateIdListFromFilterables(filterableSubProjects);
    });
    var vehicleDropLocationsPromise = locationFactory.getFilterableVehicleDropLocations(vm.mainProjectId, vm.isArchive, vm.isArchive).then(function (result) {
      var locations = result.data;
      vm.vehicleDropLocations.nameMap = generateNameMapFromFilterables(locations);
      vm.vehicleDropLocations.ids = generateIdListFromFilterables(locations);
    });
    var resourceLocationPromise = locationFactory.getFilterableResourceLocations(vm.mainProjectId, vm.isArchive, vm.isArchive).then(function (result) {
      var filterableResourceLocations = result.data;
      vm.resourceLocations.nameMap = generateNameMapFromFilterables(filterableResourceLocations);
      vm.resourceLocations.ids = generateIdListFromFilterables(filterableResourceLocations);
    });
    var companyPromise = companyFactory.getFilterableCompanies(vm.mainProjectId, vm.isArchive, vm.isArchive).then(function (result) {
      var filterableCompanies = result.data;
      vm.companies.nameMap = generateNameMapFromFilterables(filterableCompanies);
      vm.companies.ids = generateIdListFromFilterables(filterableCompanies);
    });
    $q.all([workorderPromise, projectPromise, subprojectPromise, vehicleDropLocationsPromise, resourceLocationPromise, companyPromise]).then(function () {
      $localStorage.megafilterCache = {
        mainProjectId: vm.mainProjectId,
        isArchive: vm.isArchive,
        expiretime: moment(new Date()).add(30, 'm').toDate(),
        workOrders: vm.workOrders,
        projects: vm.projects,
        subProjects: vm.subProjects,
        vehicleDropLocations: vm.vehicleDropLocations,
        resourceLocations: vm.resourceLocations,
        companies: vm.companies
      };
    });
  }
  function initFilterables() {
    if (isCacheValid()) {
      vm.workOrders.nameMap = $localStorage.megafilterCache.workOrders.nameMap;
      vm.workOrders.ids = $localStorage.megafilterCache.workOrders.ids;
      vm.projects.nameMap = $localStorage.megafilterCache.projects.nameMap;
      vm.projects.ids = $localStorage.megafilterCache.projects.ids;
      vm.subProjects.nameMap = $localStorage.megafilterCache.subProjects.nameMap;
      vm.subProjects.ids = $localStorage.megafilterCache.subProjects.ids;
      vm.vehicleDropLocations.nameMap = $localStorage.megafilterCache.vehicleDropLocations.nameMap;
      vm.vehicleDropLocations.ids = $localStorage.megafilterCache.vehicleDropLocations.ids;
      vm.resourceLocations.nameMap = $localStorage.megafilterCache.resourceLocations.nameMap;
      vm.resourceLocations.ids = $localStorage.megafilterCache.resourceLocations.ids;
      vm.companies.nameMap = $localStorage.megafilterCache.companies.nameMap;
      vm.companies.ids = $localStorage.megafilterCache.companies.ids;
    } else {
      getFilterables();
    }
  }
  initFilterables();
  function isCacheValid() {
    var now = new Date();
    return $localStorage.megafilterCache && $localStorage.megafilterCache.expiretime > now && $localStorage.megafilterCache.mainProjectId === vm.mainProjectId && $localStorage.megafilterCache.isArchive === vm.isArchive;
  }
  var orderTypes = generalHelperService.getEnumIds(OrderTypeEnum);
  vm.orderTypes = $filter('filter')(orderTypes, function (type) {
    return type !== OrderTypeEnum.GATE_BOOKING && type !== OrderTypeEnum.PACKAGE_COLLECTION;
  });
  vm.taskStatuses = generalHelperService.getEnumIds(TaskStatusTypeEnum);
  vm.orderTypeNameMap = generalHelperService.generateNameMapFromEnum(OrderTypeEnum);
  vm.deliveryStatusNameMap = generalHelperService.generateNameMapFromEnum(TaskStatusTypeEnum);
  vm.resetFilter = function () {
    vm.filter = megaFilterService.getEmptyFilter();
    vm.isEmpty = true;
    vm.updateDatePickersFromFilter();
  };
  function loadFilter(filter) {
    vm.filter = megaFilterService.copyFilter(filter);
    vm.updateDatePickersFromFilter();
    vm.updateIsEmpty();
  }
  vm.initFilter = function () {
    if (!currentFilter) {
      vm.resetFilter();
    } else {
      loadFilter(currentFilter);
    }
    vm.updateCount();
  };
  function generateNameMapFromFilterables(filterList) {
    var map = {};
    for (var i = 0; i < filterList.length; i++) {
      map[filterList[i].Id] = filterList[i].Name;
    }
    return map;
  }
  function generateIdListFromFilterables(filterList) {
    var array = [];
    for (var i = 0; i < filterList.length; i++) {
      array.push(filterList[i].Id);
    }
    return array;
  }
  vm.close = function () {
    $uibModalInstance.close(vm.filter);
  };
  vm.discard = function () {
    $uibModalInstance.dismiss();
  };
  vm.isSelected = function (id, filterList) {
    if (filterList) {
      return filterList.includes(id);
    }
    return false;
  };
  vm.toggleSelection = function (id, filterList) {
    if (vm.isSelected(id, filterList)) {
      var index = filterList.indexOf(id);
      if (index > -1) {
        filterList.splice(index, 1);
      }
    } else {
      filterList.push(id);
    }
    vm.update();
  };
  vm.updateIsEmpty = function () {
    vm.isEmpty = megaFilterService.isEmptyFilter(vm.filter);
  };
  vm.updateCount = function () {
    // FUTURE: This fits better in SPL256
    // filterCountFunction(vm.filter).then(
    //     function (count) {
    //         vm.count = count;
    //     });
  };
  vm.update = function () {
    vm.updateIsEmpty();
    vm.updateCount();
    if (!$scope.$$phase) {
      $scope.$apply();
    }
  };
  function onChangeDateTimePicker1Change(event) {
    if (event.date) {
      vm.filter.deliveryTimeFrom = moment.utc(event.date.format('YYYY-MM-DD')).startOf('day').toDate();
    } else {
      vm.filter.deliveryTimeFrom = null;
    }
    ;
    vm.update();
  }
  function onChangeDateTimePicker2Change(event) {
    if (event.date) {
      vm.filter.deliveryTimeTo = moment.utc(event.date.format('YYYY-MM-DD')).endOf('day').toDate();
    } else {
      vm.filter.deliveryTimeTo = null;
    }
    ;
    vm.update();
  }
  function initDateTimeEvents() {
    // Date time picker events
    vm.datepicker1.on('dp.change', onChangeDateTimePicker1Change);
    vm.datepicker2.on('dp.change', onChangeDateTimePicker2Change);
  }
  ;
  vm.updateDatePickersFromFilter = function () {
    vm.datepicker1.data().DateTimePicker.date(vm.filter.deliveryTimeFrom);
    var newDate = moment(vm.filter.deliveryTimeTo).clone().startOf('day');
    vm.datepicker2.data().DateTimePicker.date(newDate);
  };
  vm.initDateTimePickers = function () {
    vm.datepicker1 = $('#megafilter-datetimepicker1');
    vm.datepicker2 = $('#megafilter-datetimepicker2');
    vm.datepicker1.datetimepicker({
      format: 'YYYY-MM-DD',
      locale: 'sv'
    });
    vm.datepicker1.data().DateTimePicker.stepping(15);
    vm.datepicker2.datetimepicker({
      format: 'YYYY-MM-DD',
      locale: 'sv'
    });
    vm.datepicker2.data().DateTimePicker.stepping(15);
    initDateTimeEvents();
    vm.initFilter();
  };
  return vm;
}]);
angular.module('sp.services').service('megaFilterModalService', ['$uibModal', function ($uibModal) {
  this.openFilter = function (_currentFilter, _isArchive) {
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/modals/megafilter/mega_filter.html',
      controller: 'MegaFilterController as vm',
      size: 'lg',
      windowClass: 'sp-modal-window',
      resolve: {
        currentFilter: function currentFilter() {
          return _currentFilter;
        },
        isArchive: function isArchive() {
          return _isArchive;
        }
      }
    });
    return modalInstance.result;
  };
}]);
angular.module('sp.services').service('orderFormModalService', ['$uibModal', function ($uibModal) {
  function getViewInformation(orderType) {
    var viewInfo = {};
    switch (orderType) {
      case OrderTypeEnum.DIRECT_DELIVERY:
      case OrderTypeEnum.RECURRING_DIRECT_DELIVERY:
        viewInfo.templateUrl = 'app/modals/orderForm/direct_delivery/direct_delivery_form.html';
        viewInfo.controller = 'DirectDeliveryFormController';
        break;
      case OrderTypeEnum.STORING:
        viewInfo.templateUrl = 'app/modals/orderForm/storing/storing_form.html';
        viewInfo.controller = 'StoringFormController';
        break;
      case OrderTypeEnum.TRANSSHIPMENT:
        viewInfo.templateUrl = 'app/modals/orderForm/transshipment/transshipment_form.html';
        viewInfo.controller = 'TransshipmentFormController';
        break;
      case OrderTypeEnum.MATERIAL:
        viewInfo.templateUrl = 'app/modals/orderForm/material/material_form.html';
        viewInfo.controller = 'MaterialFormController';
        break;
      case OrderTypeEnum.RESOURCE_BOOKING:
        viewInfo.templateUrl = 'app/modals/orderForm/resource_booking/resource_booking_form.html';
        viewInfo.controller = 'ResourceBookingFormController';
        break;
      default:
        return;
    }
    return viewInfo;
  }
  function openModal(orderId, _orderType, _copy, formType, _parentOrderId) {
    var viewInfo = getViewInformation(_orderType);
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: viewInfo.templateUrl,
      controller: viewInfo.controller,
      controllerAs: 'vm',
      size: 'lg',
      windowClass: 'sp-modal-window',
      resolve: {
        form_type: function form_type() {
          return formType;
        },
        order_id: function order_id() {
          return orderId;
        },
        copy: function copy() {
          return _copy;
        },
        orderType: function orderType() {
          return _orderType;
        },
        parentOrderId: function parentOrderId() {
          return _parentOrderId;
        }
      }
    });
    return modalInstance.result;
  }
  this.openView = function (orderId, orderType, copy) {
    return openModal(orderId, orderType, copy, 'view_order', undefined);
  };
  this.openManage = function (orderId, orderType, copy) {
    return openModal(orderId, orderType, copy, 'manage_order', undefined);
  };
  this.openCreate = function (orderType) {
    return openModal(-1, orderType, false, 'create_order', undefined);
  };
  this.openCreateFromReference = function (orderType, parentOrderId) {
    return openModal(-1, orderType, false, 'create_order', parentOrderId);
  };
}]);
'use strict';

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
angular.module('serviplan').controller('WarehouseBalanceModalController', ['$uibModalInstance', '$scope', '$localStorage', 'roleService', 'materialFactory', function ($uibModalInstance, $scope, $localStorage, roleService, materialFactory) {
  var vm = this;
  vm.sessionMainProject = $localStorage.user.session_main_project;
  function loadMaterials() {
    materialFactory.getMaterials(vm.sessionMainProject.main_project_id).then(function (materials) {
      vm.articles = materials;
    });
  }
  loadMaterials();
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  vm.export = function () {
    materialFactory.getMaterialsExport(vm.sessionMainProject.main_project_id).then(function (blob) {
      // IE11: use the msSaveOrOpenBlob API
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'stock_quantity.xlsx');
      }
      // Firefox and Chrome: simulate download link click
      else {
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = 'stock_quantity.xlsx';
        a.click();
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }
    });
  };
  $scope.$on('updatedUserData', function () {
    identifyRoles();
  });
}]);
angular.module('sp.services').service('warehouseBalanceModalService', ['$uibModal', function ($uibModal) {
  this.open = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      backdrop: 'static',
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'app/modals/warehouseBalance/warehouse_balance.html',
      controller: 'WarehouseBalanceModalController',
      controllerAs: 'vm',
      size: 'lg',
      windowClass: 'sp-modal-window'
    });
    return modalInstance.result;
  };
}]);
'use strict';

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
angular.module('serviplan').controller('DirectDeliveryFormController', ['$uibModalInstance', 'form_type', 'order_id', 'copy', 'orderType', '$scope', '$filter', 'orderFactory', 'orderDirectDeliveryFactory', 'workOrderFactory', 'locationFactory', '$translate', '$localStorage', 'errorService', 'roleService', 'inputValidationService', 'taskStatusService', 'generalHelperService', 'orderFormModalService', 'dropdownService', 'ngToast', 'packageFactory', 'orderGateBookingFactory', '$log', '$q', 'ALLOWED_FILE_EXTENTIONS', function ($uibModalInstance, form_type, order_id, copy, orderType, $scope, $filter, orderFactory, orderDirectDeliveryFactory, workOrderFactory, locationFactory, $translate, $localStorage, errorService, roleService, inputValidationService, taskStatusService, generalHelperService, orderFormModalService, dropdownService, ngToast, packageFactory, orderGateBookingFactory, $log, $q, ALLOWED_FILE_EXTENTIONS) {
  var vm = this;
  vm.ALLOWED_FILE_EXTENTIONS = ALLOWED_FILE_EXTENTIONS;
  orderFactory.getGuid().then(function (response) {
    vm.formGuid = response.data;
  });
  initiateOrder();
  vm.sessionMainProject = $localStorage.user.session_main_project;
  vm.isSectionReceiversCompleted = false;
  vm.isSectionProjectCompleted = false;
  vm.isSectionDeliveryInformationCompleted = false;
  vm.isSectionBookingChoiceCompleted = false;
  vm.validated = false;
  vm.formValid = false;
  vm.order.order_type = orderType;
  vm.form_type = form_type;
  vm.canEdit = true;
  vm.canUpload = true;
  vm.order.pastConfirmed = false;
  vm.recurringWeekTemplate = [
  // Conform to backend: Sun = 0
  {
    day_name: 'MON',
    slots: [],
    week_day: 1,
    active: true
  }, {
    day_name: 'TUE',
    slots: [],
    week_day: 2
  }, {
    day_name: 'WED',
    slots: [],
    week_day: 3
  }, {
    day_name: 'THU',
    slots: [],
    week_day: 4
  }, {
    day_name: 'FRI',
    slots: [],
    week_day: 5
  }, {
    day_name: 'SAT',
    slots: [],
    week_day: 6
  }, {
    day_name: 'SUN',
    slots: [],
    week_day: 0
  }];

  // Additional setup START ---

  vm.isGateBookingOrder = orderType === OrderTypeEnum.GATE_BOOKING;
  function checkWorkOrderReferences() {
    var hasReference = false;
    if (vm.workOrderReferences) {
      angular.forEach(vm.workOrderReferences, function (data) {
        if (vm.order.proj.work_order_id === data.work_order_id) {
          hasReference = true;
        }
      });
    }
    return hasReference;
  }
  function identifyRoles() {
    vm.isAdmin = roleService.isAdmin();
    vm.isInternal = roleService.isInternal();
    vm.isCustomer = roleService.isCustomer();
    vm.isWarehouseOperator = roleService.isWarehouseOperator();
    vm.isWarehousePlanner = roleService.isWarehousePlanner();
  }
  identifyRoles();
  if (copy) vm.form_type = 'create_order';
  vm.hideWarnings = false;
  loadWorkOrders().then(function (response) {
    if (form_type === 'create_order') {
      fillCompanyOptions(vm.work_orders);
    } else if (form_type === 'view_order' || form_type === 'manage_order') {
      vm.workOrderReferences = vm.work_orders;
      loadOrder(order_id).then(function (response) {
        if (checkWorkOrderReferences()) {
          // Load work order data if we have access to it.
          vm.fillFormDataFromWorkOrder(vm.order.proj.work_order_id);
        } else {
          // User does not have permission to load work order data.
          // Hide warnings as we will not be able to edit the order.
          vm.hideWarnings = true;
          vm.loadDestinationLocationsForMainProject();
        }
      });
    }
  });

  // Additional setup END ---

  // Is editable if the orders WorkOrderId exists in the WorkOrderReferences.
  // WorkOrderReferences are the workorders which user are associated with. So when a user opens
  // an order in the list this is a way to check if the user can edit the form.
  function setCanEdit() {
    var canEdit = false;
    if (vm.form_type === 'create_order') {
      canEdit = true;
    }
    if (!canEdit && vm.isCustomer && taskStatusService.isNotified(vm.order.br.task_status)) {
      canEdit = checkWorkOrderReferences();
    }
    if (!canEdit && vm.isInternal && taskStatusService.isConfirmed(vm.order.br.task_status)) {
      canEdit = true;
    }
    if (!canEdit && vm.isAdmin && taskStatusService.isDelivered(vm.order.br.task_status)) {
      canEdit = true;
    }
    vm.canEdit = canEdit;
  }
  function setCanCancel() {
    var canCancel = false;
    if (vm.form_type !== "create_order") {
      if (vm.isCustomer && taskStatusService.isNotified(vm.order.br.task_status)) {
        canCancel = checkWorkOrderReferences();
      }
      if (!canCancel && vm.isInternal && taskStatusService.isNotified(vm.order.br.task_status)) {
        canCancel = true;
      }
      if (!canCancel && vm.isInternal && taskStatusService.isConfirmed(vm.order.br.task_status)) {
        canCancel = true;
      }
      if (!canCancel && vm.isAdmin && !taskStatusService.isCancelled(vm.order.br.task_status)) {
        canCancel = true;
      }
    }
    vm.canCancel = canCancel;
  }
  function setCanConfirm() {
    var canConfirm = false;
    if (vm.isInternal && taskStatusService.isNotified(vm.order.br.task_status)) {
      canConfirm = true;
    }
    vm.canConfirm = canConfirm;
  }
  function setCanRaiseStatus() {
    var canRaiseStatus = false;
    if (vm.isInternal && taskStatusService.isConfirmedOrLater(vm.order.br.task_status)) {
      canRaiseStatus = true;
    }
    vm.canRaiseStatus = canRaiseStatus;
  }
  function setCanCopy() {
    var canCopy = false;
    if (vm.isCustomer && taskStatusService.isNotified(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isNotified(vm.order.br.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isConfirmed(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isConfirmed(vm.order.br.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isCancelled(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isCancelled(vm.order.br.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isDelivered(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isDelivered(vm.order.br.task_status)) {
      canCopy = true;
    }
    vm.canCopy = canCopy;
  }
  function setCanRenotify() {
    var canRenotify = false;
    if (!canRenotify && vm.isInternal && taskStatusService.isConfirmed(vm.order.br.task_status)) {
      canRenotify = true;
    }
    vm.canRenotify = canRenotify;
  }
  function setCanUpload() {
    var canUpload = false;
    if (!taskStatusService.isCancelled(vm.order.br.task_status) && checkWorkOrderReferences() || vm.isAdmin) {
      canUpload = true;
    }
    vm.canUpload = canUpload;
  }
  function setPermissions() {
    setCanEdit();
    setCanCancel();
    setCanConfirm();
    setCanRaiseStatus();
    setCanCopy();
    setCanRenotify();
    setCanUpload();
  }
  function loadWorkOrders() {
    if (!vm.sessionMainProject) return $q.reject();
    return workOrderFactory.getWorkOrders(vm.sessionMainProject.main_project_id, false).then(function (response) {
      var data = response.data;
      var workOrders = workOrderFactory.repackageWorkOrderDTOArray(data);
      if (vm.isGateBookingOrder) {
        // Only include workorders with gateIntegration.
        workOrders = $filter('filter')(workOrders, {
          has_gate_integration: true
        }, true);
      }
      vm.work_orders = workOrders;
    }, function (error) {
      errorService.handleError(error);
    });
  }
  function fillCompanyOptions(workOrders) {
    vm.companies = workOrderFactory.extractUniqueCompaniesFromWorkOrders(workOrders);
    vm.order.proj.company_id = -1;
    if (!vm.companies || vm.companies.length === 0) {
      vm.order.proj.company_name = $translate.instant('NON_AVAILABLE') + '...';
    } else if (vm.companies.length === 1) {
      vm.order.proj.company_id = vm.companies[0].company_id;
      vm.order.proj.company_name = vm.companies[0].company_name;
    }
  }
  vm.loadDestinationLocationsForMainProject = function () {
    var mainProjectId = vm.sessionMainProject.main_project_id;
    locationFactory.getDestinationLocations(mainProjectId).then(function (response) {
      vm.destinationLocations = response.data;
      vm.destinationLocationPath = [];
      var depth = findTreeDepth(vm.destinationLocations);
      fillDestinationLocationPath(vm.destinationLocationPath, depth);
      buildPath(vm.order.bc.destination_location_id);
    });
  };
  vm.fillFormDataFromWorkOrder = function (workOrderId) {
    orderFactory.getDirectDeliveryFormBase(workOrderId).then(function (response) {
      var data = response.data;

      // Load from base if not from order
      if (form_type === 'create_order') {
        vm.order.proj.id_number = data.ErpSystemReference;
        vm.order.proj.contact_person = {
          "contact_name": data.OrderCreatorContactName,
          "phone_nr": data.OrderCreatorContactPhone,
          "email": data.OrderCreatorContactEmail,
          "sms_notif": data.OrderCreatorContactWantSms,
          "email_notif": data.OrderCreatorContactWantEmail
        };
      }
      vm.order.di.vehicle_types = data.VehicleTypes;
      vm.order.bc.hasGateIntegration = data.HasGateIntegration;
      vm.order.bc.extra_gates = data.MainProjectGates;
      vm.order.bc.gates = data.ProjectGates;
      vm.vehicleDropLocations = data.VehicleDropLocations;
      vm.destinationLocations = data.DestinationLocations;
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.onFormResetAction = function () {
    setDefaultOrderValues();
  };
  function initiateOrder() {
    vm.order = {};
    vm.order.proj = {};
    setDefaultOrderValues();
  }
  function setDefaultOrderValues() {
    delete vm.orderDTO;
    vm.order.dr = {};
    vm.order.di = {};
    vm.order.bc = {};
    vm.order.br = {};
    vm.order.ar = {};
    vm.order.packages = [];
    vm.validated = false;
  }

  // Load order
  function loadOrder(id) {
    return orderFactory.getOrder(id).then(function (response) {
      var data = response.data;
      vm.orderDTO = data;
      vm.order.dto = data;
      vm.order.order_id = id;
      vm.order.task_status = data.TaskStatus;
      vm.order.order_type = data.OrderType;

      // Section 1 - Project (proj)
      vm.order.proj.id_number = data.ErpSystemReference;
      vm.order.proj.work_order_name = data.WorkOrderName;
      vm.order.proj.work_order_id = data.WorkOrderId;
      vm.order.proj.company_name = data.WorkOrderCompanyName;
      vm.order.proj.company_id = data.WorkOrderCompanyId;
      vm.order.proj.order_number = data.OrderNumber;
      vm.order.proj.contact_person = {
        "contact_name": data.OrderCreatorContactName,
        "contact_id": data.OrderCreatorContactId,
        "phone_nr": data.OrderCreatorContactPhone,
        "email": data.OrderCreatorContactEmail,
        "sms_notif": data.OrderCreatorContactWantSms,
        "email_notif": data.OrderCreatorContactWantEmail
      };
      // Section 2 - Receivers (dr)
      vm.order.dr.receiver1 = {
        "contact_name": data.DeliveryReceiver1ContactName,
        "contact_id": data.DeliveryReceiver1ContactId,
        "phone_nr": data.DeliveryReceiver1ContactPhone,
        "email": data.DeliveryReceiver1ContactEmail,
        "sms_notif": data.DeliveryReceiver1ContactWantSms,
        "email_notif": data.DeliveryReceiver1ContactWantEmail
      };
      vm.order.dr.receiver2 = {
        "contact_name": data.DeliveryReceiver2ContactName,
        "contact_id": data.DeliveryReceiver2ContactId,
        "phone_nr": data.DeliveryReceiver2ContactPhone,
        "email": data.DeliveryReceiver2ContactEmail,
        "sms_notif": data.DeliveryReceiver2ContactWantSms,
        "email_notif": data.DeliveryReceiver2ContactWantEmail
      };
      vm.order.dr.receiver3 = {
        "contact_name": data.DeliveryReceiver3ContactName,
        "contact_id": data.DeliveryReceiver3ContactId,
        "phone_nr": data.DeliveryReceiver3ContactPhone,
        "email": data.DeliveryReceiver3ContactEmail,
        "sms_notif": data.DeliveryReceiver3ContactWantSms,
        "email_notif": data.DeliveryReceiver3ContactWantEmail
      };

      // Section 3 - Delivery information (di)
      vm.order.di = {
        "supplier": data.Supplier,
        "vehicle_type_id": data.VehicleTypeId,
        "vehicle_type_name": data.VehicleTypeCode,
        "material": data.Content,
        "n_materials": data.Quantity
      };
      // Section 4 - Booking choice (bc)
      vm.order.bc.vehicle_drop_location_name = data.VehicleDropLocationName;
      vm.order.bc.vehicle_drop_location_id = data.VehicleDropLocationId;
      vm.order.bc.gate_in_id = data.InGateId;
      vm.order.bc.gate_in_name = data.InGateName;
      vm.order.bc.gate_out_name = data.OutGateName;
      vm.order.bc.gate_out_id = data.OutGateId;
      vm.order.bc.extra_gate_in_id = data.ExtraInGateId;
      vm.order.bc.extra_gate_in_name = data.ExtraInGateName;
      vm.order.bc.extra_gate_out_id = data.ExtraOutGateId;
      vm.order.bc.extra_gate_out_name = data.ExtraOutGateName;
      vm.order.bc.n_transports = data.NumTransports;
      vm.order.bc.n_unbooked_transports = data.NumUnbookedTransports;
      vm.order.bc.allowed_passages = data.AllowedPassages;
      vm.order.bc.unloading_help = data.HasAdditionalServiceUnloadingHelp;
      vm.order.bc.guiding_help = data.HasAdditionalServiceGuiding;
      vm.order.bc.is_unannounced_goods = !!data.IsUnannouncedGoods;
      vm.order.bc.is_unreachable = !!data.IsUnreachable;
      vm.order.bc.is_unused_resource = !!data.IsUnusedResource;
      vm.order.bc.destination_location_id = data.DestinationLocationId;
      vm.order.bc.staircase_location_id = data.StaircaseLocationId;
      vm.order.bc.staircase_location_name = data.StaircaseLocationName;
      vm.order.bc.comments = data.Comments;
      vm.order.bc.file_attachments = data.Files;
      if (data.OrderType === OrderTypeEnum.RECURRING_DIRECT_DELIVERY) {
        vm.order.bc.timeslots = {
          "recurring_start": $filter('toDate')(data.RecurringStart),
          "recurring_end": $filter('toDate')(data.RecurringEnd),
          "week_frequency": data.WeekTypeId.toString(),
          "recurring_week": orderDirectDeliveryFactory.loadRecurringWeek(vm.recurringWeekTemplate, data.RecurringTimes),
          "allowed_passages": data.AllowedPassages
        };
        vm.isRecurringOrder = true;
      } else {
        vm.order.bc.timeslots = {
          "time_i": $filter('toDateTime')(data.SlotTimeMin),
          "time_f": $filter('toDateTime')(data.SlotTimeMax)
        };
      }
      if (data.OrderType === OrderTypeEnum.GATE_BOOKING) {
        vm.isGateBookingOrder = true;
        vm.order.proj.sms_notif = false;
        vm.order.proj.email_notif = false;
      }

      // Section 5 - Booking reference (br)
      vm.order.br.registered = $filter('toDateTime')(data.Created);
      vm.order.br.status = $translate.instant(data.TaskStatusTypeAlias);
      vm.order.br.task_status = data.TaskStatus;
      vm.order.br.gate_code = data.GatePassCode;
      vm.order.br.used_passages = data.UsedPassages;
      vm.order.br.order_number = data.OrderNumber;
      vm.order.br.gate_data_sent = data.LastPassCodeRequest ? $filter('toDateTime')(data.LastPassCodeRequest) : '';
      vm.order.br.last_notification_sent = data.LastNotificationSent ? $filter('toDateTime')(data.LastNotificationSent) : '';
      vm.order.br.gate_booking_failed = data.LastUnhandledPasscodeNotificationSent ? $filter('toDateTime')(data.LastUnhandledPasscodeNotificationSent) : '';
      vm.order.br.gate_booking_failed_code = data.WellSecErrorCode;
      vm.showPassCodeFailedError = !!vm.order.br.gate_booking_failed_code;

      // Packages
      vm.order.packages = [];
      for (var i = 0; i < data.Packages.length; i++) {
        vm.order.packages.push(packageFactory.repackageDTO(data.Packages[i]));
      }
      vm.order.pastConfirmed = taskStatusService.isConfirmedOrLater(vm.order.br.task_status);
      if (copy) {
        delete vm.order.order_id;
        vm.order.br = {};
        vm.order.bc.file_attachments = [];
        vm.order.bc.file_attachments_to_add = [];
        vm.order.packages = [];
        vm.order.proj.order_number = '';
      }
      getNextStatus();
      setPermissions();
    }, function (error) {
      errorService.handleError(error);
    });
  }

  // Status management
  vm.setNextStatus = function () {
    if (vm.order.task_status !== vm.order.nextTaskStatus) {
      orderFactory.setNextStatus(order_id).then(function () {
        ngToast.success("Status ändrat.");
        vm.order.br.status = vm.order.nextTaskStatusName;
        vm.order.br.task_status = vm.order.nextTaskStatus;
        vm.order.task_status = vm.order.nextTaskStatus;
        getNextStatus();
      }, function (error) {
        ngToast.danger("Det gick inte att ändra status.");
        $log.error(error);
      });
    }
  };
  function getNextStatus() {
    orderFactory.getNextStatus(vm.order.order_type, vm.order.task_status).then(function (result) {
      vm.order.nextTaskStatus = result.data;
      vm.order.nextTaskStatusName = $translate.instant(generalHelperService.getKeyByValue(TaskStatusTypeEnum, vm.order.nextTaskStatus));
    });
  }
  vm.createOrder = function (addBookings) {
    validateForm();
    if (!vm.formValid || vm.lockCall) {
      return;
    }
    vm.lockCall = true;
    var orderDTO;
    if (vm.isGateBookingOrder) orderDTO = orderGateBookingFactory.createOrderDTO(vm.order, TaskStatusTypeEnum.NOTIFIED);else if (vm.isRecurringOrder) orderDTO = orderDirectDeliveryFactory.createRecurringOrderDTO(vm.order, TaskStatusTypeEnum.NOTIFIED);else if (!vm.isRecurringOrder) orderDTO = orderDirectDeliveryFactory.createOrderDTO(vm.order, TaskStatusTypeEnum.NOTIFIED);
    orderFactory.createOrder(orderDTO, vm.order.bc.file_attachments_to_add, vm.formGuid).then(function (response) {
      var results = {
        success: true,
        copy: false
      };
      if (addBookings) {
        var parentOrderId = response.data;
        var resourceBookingResults = orderFormModalService.openCreateFromReference(OrderTypeEnum.RESOURCE_BOOKING, parentOrderId);
        results.success = resourceBookingResults.success;
      }
      vm.lockCall = false;
      $uibModalInstance.close(results);
    }, function (error) {
      vm.lockCall = false;
      if (error.status === 409) {
        ngToast.warning("Kunde inte spara formuläret, ordern finns redan.");
      } else {
        ngToast.danger("Det gick inte att spara formuläret.");
      }
      errorService.handleError(error);
    });
  };
  vm.updateOrder = function () {
    validateForm();
    if (!vm.formValid) {
      return;
    }
    var orderDTO;
    if (vm.isGateBookingOrder) orderDTO = orderGateBookingFactory.createOrderDTO(vm.order, '');else if (vm.isRecurringOrder) orderDTO = orderDirectDeliveryFactory.createRecurringOrderDTO(vm.order, '');else if (!vm.isRecurringOrder) orderDTO = orderDirectDeliveryFactory.createOrderDTO(vm.order, '');
    var options = {
      fileAttachments: vm.order.bc.file_attachments_to_add
    };
    orderFactory.updateOrder(vm.order.order_id, orderDTO, options).then(function () {
      var results = {
        success: true,
        copy: false
      };
      $uibModalInstance.close(results);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.confirmOrder = function () {
    validateForm();
    if (!vm.formValid) {
      return;
    }
    var orderDTO;
    if (vm.isGateBookingOrder) orderDTO = orderGateBookingFactory.createOrderDTO(vm.order, '');else if (vm.isRecurringOrder) orderDTO = orderDirectDeliveryFactory.createRecurringOrderDTO(vm.order, '');else if (!vm.isRecurringOrder) orderDTO = orderDirectDeliveryFactory.createOrderDTO(vm.order, '');
    var options = {
      fileAttachments: vm.order.bc.file_attachments_to_add
    };
    orderFactory.confirmOrder(vm.order.order_id, orderDTO, options).then(function () {
      var results = {
        success: true,
        copy: false
      };
      $uibModalInstance.close(results);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.copyOrder = function () {
    var results = {
      success: true,
      copy: true
    };
    $uibModalInstance.close(results);
  };
  vm.cancelOrder = function () {
    orderFactory.cancelOrder(vm.orderDTO.OrderId, vm.orderDTO).then(function () {
      var results = {
        success: true,
        copy: false
      };
      $uibModalInstance.close(results);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  // --- VALIDATION ---
  vm.handleValidationChange = function (source, value) {
    switch (source) {
      case "section_project":
        vm.isSectionProjectCompleted = value;
        break;
      case "section_receivers":
        vm.isSectionReceiversCompleted = value;
        break;
      case "section_delivery_information":
        vm.isSectionDeliveryInformationCompleted = value;
        break;
      case "section_booking_choice":
        vm.isSectionBookingChoiceCompleted = value;
        break;
      default:
        console.log(source + " is not a valid source");
        break;
    }
  };
  function checkAllSectionsDone() {
    if (vm.isSectionProjectCompleted && vm.isSectionReceiversCompleted && (vm.isSectionDeliveryInformationCompleted || vm.isGateBookingOrder) && vm.isSectionBookingChoiceCompleted) {
      vm.formValid = true;
    } else vm.formValid = false;
  }
  function validateForm() {
    vm.validated = true;
    checkAllSectionsDone();
    return vm.formValid;
  }
  vm.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  vm.isValidEmail = function (input) {
    return inputValidationService.isValidEmail(input);
  };
  vm.isConfirmedOrLater = function () {
    return taskStatusService.isConfirmedOrLater(vm.order.br.task_status);
  };
  vm.deleteKeyFromObject = function (object, key) {
    if (object[key]) delete object[key];
  };
  vm.renotify = function () {
    orderFactory.renotifyDirectDeliveryOrder(vm.orderDTO.OrderId);
    orderFactory.renotifyOrderStatus(vm.orderDTO.OrderId);
  };
  vm.passCodeTryAgain = function () {
    orderFactory.passCodeTryAgain(vm.order.order_id).then(function () {
      vm.showPassCodeFailedError = false;
    }, function () {
      vm.showPassCodeFailedError = true;
    });
  };
  vm.getFilePath = function (orderId, fileName) {
    return orderFactory.createFileLink(orderId, fileName);
  };
  vm.setIsRecurringOrder = function (isRecurringOrder) {
    vm.isRecurringOrder = isRecurringOrder;
  };
  vm.openDropdown = dropdownService.openDropdown;

  // EVENT MANAGEMENT

  // Watch for our custom `fileselect` event
  // FUTURE: This should be done using  a directive instead
  vm.initFileSelectEvent = function () {
    $(':file').on('fileselect', function (event, numFiles, label) {
      var input = $('#fileSelectedText');
      log = numFiles > 1 ? numFiles + ' filer valda' : label;
      if (input) {
        input.val(log);
      } else {
        if (log) alert(log);
      }
    });
  };
  $scope.$on('updatedUserData', function () {
    identifyRoles();
  });
}]);
'use strict';

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
angular.module('serviplan').controller('MaterialFormController', ['$uibModalInstance', 'form_type', 'order_id', 'copy', '$scope', '$filter', 'orderFactory', 'workOrderFactory', 'locationFactory', '$translate', '$localStorage', 'errorService', 'dropdownService', 'shippingFactory', 'orderMaterialFactory', 'printerFactory', 'roleService', 'inputValidationService', 'taskStatusService', 'generalHelperService', 'orderFormModalService', 'ngToast', 'packageFactory', '$log', '$q', 'ALLOWED_FILE_EXTENTIONS', function ($uibModalInstance, form_type, order_id, copy, $scope, $filter, orderFactory, workOrderFactory, locationFactory, $translate, $localStorage, errorService, dropdownService, shippingFactory, orderMaterialFactory, printerFactory, roleService, inputValidationService, taskStatusService, generalHelperService, orderFormModalService, ngToast, packageFactory, $log, $q, ALLOWED_FILE_EXTENTIONS) {
  var vm = this;
  vm.ALLOWED_FILE_EXTENTIONS = ALLOWED_FILE_EXTENTIONS;
  orderFactory.getGuid().then(function (responce) {
    vm.formGuid = responce.data;
  });
  initiateOrder();
  vm.sessionMainProject = $localStorage.user.session_main_project;
  vm.work_orders = [];
  vm.companies = [];
  vm.isSectionReceiversCompleted = false;
  vm.sectionTwoDone = false;
  vm.isSectionProjectCompleted = false;
  vm.isSectionBookingChoiceCompleted = false;
  vm.sectionFiveDone = false;
  vm.validated = false;
  vm.formValid = false;
  vm.timingSet = false;
  vm.order.ar.file_attachments = [];
  vm.order.order_type = OrderTypeEnum.MATERIAL;
  vm.form_type = form_type;
  vm.canEdit = true;
  vm.canUpload = true;
  vm.hideWarnings = false;
  vm.hideArticleBalance = false;

  //Roles
  function identifyRoles() {
    vm.isAdmin = roleService.isAdmin();
    vm.isInternal = roleService.isInternal();
    vm.isCustomer = roleService.isCustomer();
  }
  identifyRoles();

  // Additional setup Start ---

  if (copy) {
    vm.form_type = 'create_order';
  }
  loadWorkOrders().then(function (response) {
    if (form_type === 'create_order') {
      fillCompanyOptions(vm.work_orders);
    } else if (form_type === 'view_order' || form_type === 'manage_order') {
      vm.workOrderReferences = vm.work_orders;
      loadOrder(order_id).then(function (response) {
        if (checkWorkOrderReferences()) {
          // Load work order data if we have access to it.
          vm.fillFormDataFromWorkOrder(vm.order.proj.work_order_id);
        } else {
          // User does not have permission to load work order data.
          // Hide warnings as user will not be able to edit the order.
          vm.hideWarnings = true;
          // Hide article balance as user does not have access to the available articles.
          vm.hideArticleBalance = true;
          if (!vm.order.bc.specified_address) {
            vm.loadDestinationLocationsForMainProject();
            vm.evaluateProgress();
          }
        }
      });
    }
  });

  // Additional setup END ---

  function checkWorkOrderReferences() {
    var hasReference = false;
    if (vm.workOrderReferences) {
      angular.forEach(vm.workOrderReferences, function (data) {
        if (vm.order.proj.work_order_id === data.work_order_id) {
          hasReference = true;
        }
      });
    }
    return hasReference;
  }

  // Is editable if the orders WorkOrderId exists in the WorkOrderReferences.
  // WorkOrderReferences are the workorders which user are associated with. So when a user opens
  // an order in the list this is a way to check if the user can edit the form.
  function setCanEdit() {
    var canEdit = false;
    if (vm.form_type === 'create_order') {
      canEdit = true;
    }
    if (!canEdit && vm.isCustomer && taskStatusService.isNotified(vm.order.br.task_status)) {
      canEdit = checkWorkOrderReferences();
    }
    if (!canEdit && vm.isInternal && taskStatusService.isConfirmed(vm.order.br.task_status)) {
      canEdit = true;
    }
    if (!canEdit && vm.isInternal && taskStatusService.isPicked(vm.order.br.task_status)) {
      canEdit = true;
    }
    if (!canEdit && vm.isInternal && (taskStatusService.isAssignedToTransport(vm.order.br.task_status) || taskStatusService.isAssignedToRoute(vm.order.br.task_status))) {
      canEdit = true;
    }
    if (!canEdit && vm.isAdmin && taskStatusService.isDelivered(vm.order.br.task_status)) {
      canEdit = true;
    }
    vm.canEdit = canEdit;
  }
  function setCanCancel() {
    var canCancel = false;
    if (vm.form_type !== "create_order") {
      if (vm.isCustomer && taskStatusService.isNotified(vm.order.br.task_status)) {
        canCancel = checkWorkOrderReferences();
      }
      if (!canCancel && vm.isInternal && taskStatusService.isNotified(vm.order.br.task_status)) {
        canCancel = true;
      }
      if (!canCancel && vm.isInternal && taskStatusService.isConfirmed(vm.order.br.task_status)) {
        canCancel = true;
      }
      if (!canCancel && vm.isInternal && taskStatusService.isPicked(vm.order.br.task_status) && !vm.order.delivery_date && !vm.order.packages.length) {
        canCancel = true;
      }
      if (!canCancel && vm.isAdmin && !taskStatusService.isCancelled(vm.order.br.task_status)) {
        canCancel = true;
      }
    }
    vm.canCancel = canCancel;
  }
  function setCanConfirm() {
    var canConfirm = false;
    if (vm.isInternal && taskStatusService.isNotified(vm.order.br.task_status)) {
      canConfirm = true;
    }
    vm.canConfirm = canConfirm;
  }
  function setCanRaiseStatus() {
    var canRaiseStatus = false;
    if (vm.isInternal && taskStatusService.isConfirmedOrLater(vm.order.br.task_status)) {
      canRaiseStatus = true;
    }
    vm.canRaiseStatus = canRaiseStatus;
  }
  function setCanCopy() {
    var canCopy = false;
    if (vm.isCustomer && taskStatusService.isNotified(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isNotified(vm.order.br.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isConfirmed(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isConfirmed(vm.order.br.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isPicked(vm.order.br.task_status)) {
      //--
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isPicked(vm.order.br.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && (taskStatusService.isAssignedToTransport(vm.order.br.task_status) || taskStatusService.isAssignedToRoute(vm.order.br.task_status))) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && (taskStatusService.isAssignedToTransport(vm.order.br.task_status) || taskStatusService.isAssignedToRoute(vm.order.br.task_status))) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isCancelled(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isCancelled(vm.order.br.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isDelivered(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isDelivered(vm.order.br.task_status)) {
      canCopy = true;
    }
    vm.canCopy = canCopy;
  }
  function setCanPrint() {
    var canPrint = false;
    if (vm.isInternal && taskStatusService.isConfirmed(vm.order.br.task_status)) {
      canPrint = true;
    }
    if (!canPrint && vm.isInternal && taskStatusService.isPicked(vm.order.br.task_status)) {
      canPrint = true;
    }
    if (!canPrint && vm.isInternal && (taskStatusService.isAssignedToTransport(vm.order.br.task_status) || taskStatusService.isAssignedToRoute(vm.order.br.task_status))) {
      canPrint = true;
    }
    if (!canPrint && vm.isInternal && taskStatusService.isDelivered(vm.order.br.task_status)) {
      canPrint = true;
    }
    vm.canPrint = canPrint;
  }
  function setCanRenotify() {
    var canRenotify = false;
    if (!canRenotify && vm.isInternal && taskStatusService.isConfirmedOrLater(vm.order.br.task_status) && !taskStatusService.isDelivered(vm.order.br.task_status)) {
      canRenotify = true;
    }
    vm.canRenotify = canRenotify;
  }
  function setCanUpload() {
    var canUpload = false;
    if (!taskStatusService.isCancelled(vm.order.br.task_status) && checkWorkOrderReferences() || vm.isAdmin) {
      canUpload = true;
    }
    vm.canUpload = canUpload;
  }
  function setPermissions() {
    setCanEdit();
    setCanCancel();
    setCanConfirm();
    setCanRaiseStatus();
    setCanCopy();
    setCanPrint();
    setCanUpload();
    setCanRenotify();
  }
  function loadWorkOrders() {
    if (!vm.sessionMainProject) return $q.reject();
    return workOrderFactory.getWorkOrders(vm.sessionMainProject.main_project_id, false).then(function (response) {
      vm.work_orders = workOrderFactory.repackageWorkOrderDTOArray(response.data);
    }, function (error) {
      errorService.handleError(error);
    });
  }
  function fillCompanyOptions(workOrders) {
    vm.companies = workOrderFactory.extractUniqueCompaniesFromWorkOrders(workOrders);
    vm.order.proj.company_id = -1;
    if (!vm.companies || vm.companies.length === 0) {
      vm.order.proj.company_name = $translate.instant('NON_AVAILABLE') + '...';
    } else if (vm.companies.length === 1) {
      vm.order.proj.company_id = vm.companies[0].company_id;
      vm.order.proj.company_name = vm.companies[0].company_name;
    }
  }
  function loadPrinters() {
    if (!vm.sessionMainProject || !vm.isInternal) {
      return;
    }
    printerFactory.getPrintersByMainProjectId(vm.sessionMainProject.main_project_id).then(function (response) {
      var data = response.data;
      vm.printers = printerFactory.repackageDTOArray(data);
    }, function (error) {
      errorService.handleError(error);
    });
  }
  loadPrinters();
  function loadShippings() {
    if (!vm.sessionMainProject || !vm.isInternal) {
      return;
    }
    shippingFactory.getShippingsByMainProjectId(false, vm.sessionMainProject.main_project_id).then(function (response) {
      var data = response.data;
      vm.shippings = shippingFactory.repackageDTOArray(data);
    }, function (error) {
      errorService.handleError(error);
    });
  }
  loadShippings();
  function getUniqueStorageLocations(articles) {
    var out = [];
    for (var i = 0; i < articles.length; i++) {
      var isUnique = true;
      for (var j = 0; j < out.length; j++) {
        if (articles[i].StorageLocation === out[j].storage_location) {
          isUnique = false;
          break;
        }
      }
      if (isUnique) {
        out.push({
          storage_location: articles[i].StorageLocation
        });
      }
    }
    return out;
  }
  vm.loadDestinationLocationsForMainProject = function () {
    var mainProjectId = vm.sessionMainProject.main_project_id;
    locationFactory.getDestinationLocations(mainProjectId).then(function (response) {
      vm.destinationLocations = response.data;
    });
  };
  vm.fillFormDataFromWorkOrder = function (workOrderId) {
    // FUTURE: Unnecessary to ask for articles in stock if order is confirmed!
    orderFactory.getMaterialFormBase(workOrderId).then(function (response) {
      // MaterialOrderFormBaseDTO
      var data = response.data;

      // Load from base if not from order
      if (form_type === 'create_order') {
        vm.order.proj.id_number = data.ErpSystemReference;
        vm.order.proj.contact_person = {
          "contact_name": data.OrderCreatorContactName,
          "phone_nr": data.OrderCreatorContactPhone,
          "email": data.OrderCreatorContactEmail,
          "sms_notif": data.OrderCreatorContactWantSms,
          "email_notif": data.OrderCreatorContactWantEmail
        };
      }
      vm.order.minOrderDate = data.MinOrderDate ? $filter('toDateTime')(data.MinOrderDate) : null;
      vm.order.wb.articles = vm.isConfirmedOrLater() ? orderMaterialFactory.repackageArticleOrderLineDTOArray(vm.order.dto.ArticleOrderLines) : orderMaterialFactory.repackageArticleDTOsAsArticleOrderLineArray(data.Articles, vm.order.wb.ordered_articles);

      // Update Epix owner number from the Epix article query. Will update workorder in db when the order is saved.
      if (data.Articles && data.Articles.length > 0) {
        vm.order.proj.epix_owner_number = data.Articles[0].ProductOwnerNumber;
      }
      vm.order.wb.storage_locations = getUniqueStorageLocations(data.Articles);
      vm.order.wb.storage_location = "";
      if (vm.order.wb.ordered_articles && vm.order.wb.ordered_articles.length > 0) {
        vm.order.wb.storage_location = vm.order.wb.ordered_articles[0].storage_location;
      } else if (vm.order.wb.storage_locations.length > 0) {
        vm.order.wb.storage_location = vm.order.wb.storage_locations[0].storage_location;
      }
      vm.vehicleDropLocations = data.VehicleDropLocations;
      vm.destinationLocations = data.DestinationLocations;
      vm.evaluateProgress();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.onFormResetAction = function () {
    setDefaultOrderValues();
    vm.evaluateProgress();
  };
  function initiateOrder() {
    vm.order = {};
    vm.order.proj = {};
    setDefaultOrderValues();
  }
  function setDefaultOrderValues() {
    vm.order.wb = {};
    vm.order.dr = {};
    vm.order.bc = {};
    vm.order.br = {};
    vm.order.si = {};
    vm.order.ar = {};
    vm.order.packages = [];
    vm.validated = false;
  }
  vm.getFilePath = function (orderId, fileName) {
    return orderFactory.createFileLink(orderId, fileName);
  };
  function loadOrder(id) {
    return orderFactory.getOrder(id).then(function (response) {
      // MaterialOrderDTO (:OrderDTO)
      var data = response.data;
      vm.orderDTO = data;
      vm.order.dto = data;
      vm.order.order_id = id;
      vm.order.task_status = data.TaskStatus;
      vm.order.delivery_date = data.DeliveryDate;
      vm.order.order_type = data.OrderType;

      // Section 1 - Project (proj)
      vm.order.proj.id_number = data.ErpSystemReference;
      vm.order.proj.work_order_name = data.WorkOrderName;
      vm.order.proj.work_order_id = data.WorkOrderId;
      vm.order.proj.epix_owner_number = null; // Only used to send updated data from epix to backend
      vm.order.proj.company_name = data.WorkOrderCompanyName;
      vm.order.proj.company_id = data.WorkOrderCompanyId;
      vm.order.proj.order_number = data.OrderNumber;
      vm.order.proj.contact_person = {
        "contact_name": data.OrderCreatorContactName,
        "contact_id": data.OrderCreatorContactId,
        "phone_nr": data.OrderCreatorContactPhone,
        "email": data.OrderCreatorContactEmail,
        "sms_notif": data.OrderCreatorContactWantSms,
        "email_notif": data.OrderCreatorContactWantEmail
      };
      // Section 2 - Warehouse balance (wb)

      vm.order.wb.articles = orderMaterialFactory.repackageArticleOrderLineDTOArray(data.ArticleOrderLines);
      vm.order.wb.ordered_articles = orderMaterialFactory.repackageArticleOrderLineDTOArray(data.ArticleOrderLines);
      vm.order.wb.storage_location = "";
      if (vm.order.wb.ordered_articles && vm.order.wb.ordered_articles.length > 0) {
        vm.order.wb.storage_location = vm.order.wb.ordered_articles[0].storage_location;
      }

      // Section 3 - Receivers (dr)
      vm.order.dr.receiver1 = {
        "contact_name": data.DeliveryReceiver1ContactName,
        "contact_id": data.DeliveryReceiver1ContactId,
        "phone_nr": data.DeliveryReceiver1ContactPhone,
        "email": data.DeliveryReceiver1ContactEmail,
        "sms_notif": data.DeliveryReceiver1ContactWantSms,
        "email_notif": data.DeliveryReceiver1ContactWantEmail
      };
      vm.order.dr.receiver2 = {
        "contact_name": data.DeliveryReceiver2ContactName,
        "contact_id": data.DeliveryReceiver2ContactId,
        "phone_nr": data.DeliveryReceiver2ContactPhone,
        "email": data.DeliveryReceiver2ContactEmail,
        "sms_notif": data.DeliveryReceiver2ContactWantSms,
        "email_notif": data.DeliveryReceiver2ContactWantEmail
      };
      vm.order.dr.receiver3 = {
        "contact_name": data.DeliveryReceiver3ContactName,
        "contact_id": data.DeliveryReceiver3ContactId,
        "phone_nr": data.DeliveryReceiver3ContactPhone,
        "email": data.DeliveryReceiver3ContactEmail,
        "sms_notif": data.DeliveryReceiver3ContactWantSms,
        "email_notif": data.DeliveryReceiver3ContactWantEmail
      };
      // Section 4 - Booking choice (bc)
      vm.order.bc.specified_address = data.DestinationAddress ? true : false;
      vm.order.bc.address = data.DestinationAddress;
      vm.order.bc.city = data.DestinationCity;
      vm.order.bc.zip_code = data.DestinationZipCode;
      vm.order.bc.arrival_time = $filter('toDateTime')(data.WishedDeliveryDate);
      vm.order.bc.vehicle_drop_location_name = data.VehicleDropLocationName;
      vm.order.bc.vehicle_drop_location_id = data.VehicleDropLocationId;
      vm.order.bc.destination_location_id = data.DestinationLocationId;
      vm.order.bc.staircase_location_id = data.StaircaseLocationId;
      vm.order.bc.staircase_location_name = data.StaircaseLocationName;
      vm.order.bc.comments = data.Comments;
      vm.order.bc.file_attachments = data.Files;
      vm.order.bc.is_unannounced_goods = !!data.IsUnannouncedGoods;
      vm.order.bc.is_unreachable = !!data.IsUnreachable;
      vm.order.bc.is_unused_resource = !!data.IsUnusedResource;
      // Section 5 - Shipping information
      vm.order.si.package_count = data.SpecifiedPackageCount;
      vm.order.si.package_weight = data.SpecifiedPackageWeight;
      vm.order.si.pallet_count = data.SpecifiedPalletCount;
      vm.order.si.pallet_weight = data.SpecifiedPalletWeight;
      vm.order.si.other_count = data.SpecifiedOtherCount;
      vm.order.si.other_weight = data.SpecifiedOtherWeight;
      vm.order.si.has_timing = data.HasAdditionalServiceTiming;
      if (vm.order.si.has_timing) {
        vm.order.si.timing = $filter("toDateTime")(data.AdditionalServiceTimingDueDate);
      }
      vm.order.si.shipping_id = data.ShippingId;
      vm.order.si.shipping_name = data.ShippingName;
      vm.order.si.has_express = data.HasAdditionalServiceExpressDelivery;
      // Section 6 - Arrival contol
      vm.order.ar.is_return = data.IsReturn;
      // Section 7 - Booking reference (br)
      vm.order.br.registered = $filter('toDateTime')(data.Created);
      vm.order.br.status = $translate.instant(data.TaskStatusTypeAlias);
      vm.order.br.task_status = data.TaskStatus;
      vm.order.br.order_number = data.OrderNumber;

      // Packages
      vm.order.packages = [];
      for (var i = 0; i < data.Packages.length; i++) {
        vm.order.packages.push(packageFactory.repackageDTO(data.Packages[i]));
      }
      if (copy) {
        delete vm.order.order_id;
        delete vm.order.delivery_date;
        vm.order.br = {};
        vm.order.bc.file_attachments = [];
        vm.order.bc.file_attachments_to_add = [];
        vm.order.packages = [];
        vm.order.proj.order_number = '';
      }
      vm.evaluateProgress();
      getNextStatus();
      setPermissions();
    }, function (error) {
      errorService.handleError(error);
    });
  }
  vm.setNextStatus = function () {
    if (vm.order.task_status !== vm.order.nextTaskStatus) {
      orderFactory.setNextStatus(order_id).then(function () {
        ngToast.success("Status ändrat.");
        vm.order.br.status = vm.order.nextTaskStatusName;
        vm.order.br.task_status = vm.order.nextTaskStatus;
        vm.order.task_status = vm.order.nextTaskStatus;
        getNextStatus();
      }, function (error) {
        ngToast.danger("Det gick inte att ändra status.");
        $log.error(error);
      });
    }
  };
  function getNextStatus() {
    orderFactory.getNextStatus(vm.order.order_type, vm.order.task_status).then(function (result) {
      vm.order.nextTaskStatus = result.data;
      vm.order.nextTaskStatusName = $translate.instant(generalHelperService.getKeyByValue(TaskStatusTypeEnum, vm.order.nextTaskStatus));
    });
  }
  vm.createOrder = function (addBookings) {
    validateForm();
    if (!vm.formValid || vm.lockCall) {
      return;
    }
    vm.lockCall = true;
    var orderDTO = orderMaterialFactory.createOrderDTO(vm.order, TaskStatusTypeEnum.NOTIFIED);
    orderFactory.createOrder(orderDTO, vm.order.bc.file_attachments_to_add, vm.formGuid).then(function (response) {
      var results = {
        success: true,
        copy: false
      };
      if (addBookings) {
        var parentOrderId = response.data;
        var resourceBookingResults = orderFormModalService.openCreateFromReference(OrderTypeEnum.RESOURCE_BOOKING, parentOrderId);
        results.success = resourceBookingResults.success;
      }
      vm.lockCall = false;
      $uibModalInstance.close(results);
    }, function (error) {
      vm.lockCall = false;
      if (error.status === 409) {
        ngToast.warning("Kunde inte spara formuläret, ordern finns redan.");
      } else {
        ngToast.danger("Det gick inte att spara formuläret.");
      }
      errorService.handleError(error);
    });
  };
  vm.updateOrder = function (printerId) {
    validateForm();
    if (!vm.formValid) {
      return;
    }
    var orderDTO = orderMaterialFactory.createOrderDTO(vm.order, ""),
      options = {
        fileAttachments: vm.order.bc.file_attachments_to_add
      };
    orderFactory.updateOrder(vm.orderDTO.OrderId, orderDTO, options).then(function () {
      if (printerId) {
        printShippingsNote(printerId);
      } else {
        $uibModalInstance.close({
          success: true,
          copy: false
        });
      }
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.confirmOrder = function () {
    validateForm();
    if (!vm.formValid) {
      return;
    }
    var orderDTO = orderMaterialFactory.createOrderDTO(vm.order, TaskStatusTypeEnum.CONFIRMED),
      options = {
        fileAttachments: vm.order.bc.file_attachments_to_add
      };
    orderFactory.confirmOrder(orderDTO.OrderId, orderDTO, options).then(function () {
      var results = {
        success: true,
        copy: false
      };
      $uibModalInstance.close(results);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  vm.copyOrder = function () {
    var results = {};
    results.success = true;
    results.copy = true;
    $uibModalInstance.close(results);
  };
  vm.cancelOrder = function () {
    var results = {};
    orderFactory.cancelOrder(vm.orderDTO.OrderId, vm.orderDTO).then(function () {
      results.success = true;
      results.copy = false;
      $uibModalInstance.close(results);
    }, function (error) {
      errorService.handleError(error);
    });
  };

  // --- VALIDATION ---
  vm.handleValidationChange = function (source, value) {
    switch (source) {
      case "section_project":
        vm.isSectionProjectCompleted = value;
        break;
      case "section_receivers":
        vm.isSectionReceiversCompleted = value;
        break;
      case "section_booking_choice":
        vm.isSectionBookingChoiceCompleted = value;
        break;
      default:
        console.log(source + " is not a valid source");
        break;
    }
    vm.evaluateProgress();
  };
  vm.evaluateProgress = function () {
    // -- 1, 3 & 4: Validation is handled by component

    // -- 2
    vm.sectionTwoDone = vm.isOrderInProgress(vm.order.wb.articles);

    // -- 5

    if (vm.order.si.has_timing) {
      var evaluation = inputValidationService.isValidDateTime(vm.order.si.timing);
      vm.sectionFiveDone = evaluation;
      vm.timingSet = evaluation;
    } else vm.sectionFiveDone = true;

    // --

    if (!vm.isSectionProjectCompleted) {
      vm.sectionTwoDone = false;
      vm.sectionFiveDone = false;
    }
    if (!vm.sectionTwoDone) {
      vm.isSectionReceiversCompleted = false;
      vm.sectionFiveDone = false;
    }
    if (!vm.isSectionReceiversCompleted) {
      vm.sectionFiveDone = false;
    }
    if (!vm.isSectionBookingChoiceCompleted) {
      vm.sectionFiveDone = false;
    }
  };
  function checkAllSectionsDone() {
    if (vm.isSectionProjectCompleted && vm.sectionTwoDone && vm.isSectionReceiversCompleted && vm.isSectionBookingChoiceCompleted && vm.sectionFiveDone) {
      vm.formValid = true;
    } else vm.formValid = false;
  }
  function validateForm() {
    vm.validated = true;
    vm.evaluateProgress();
    checkAllSectionsDone();
    return vm.formValid;
  }
  vm.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  vm.isValidEmail = function (input) {
    return inputValidationService.isValidEmail(input);
  };
  vm.isConfirmedOrLater = function () {
    return taskStatusService.isConfirmedOrLater(vm.order.br.task_status);
  };
  vm.isOrderInProgress = function (articles) {
    var inProgress = false;
    angular.forEach(articles, function (article) {
      if (article.article_quantity > 0) {
        inProgress = true;
      }
    });
    return inProgress;
  };
  vm.totalWeight = function (articles) {
    var total = 0;
    if (!articles) return 0;
    for (var i = 0; i < articles.length; i++) {
      var article = articles[i];
      if (article.article_quantity && article.weight) {
        total += article.article_quantity * article.weight;
      } else if (article.article_quantity === undefined && article.original_article_quantity && article.weight) {
        // Handle that article_quantity is mangled by UI-binding if larger than availability
        total += article.original_article_quantity * article.weight;
      }
    }
    return total;
  };
  function hasSpecialPackageInformation() {
    return !!vm.order.si.package_count || !!vm.order.si.pallet_count || !!vm.order.si.other_count;
  }
  vm.isReadyForPrint = function () {
    return inputValidationService.isValidInput(vm.order.si.shipping_name) && (vm.order.si.print_notice || vm.order.si.print_label) && (vm.order.packages.length || hasSpecialPackageInformation());
  };
  function printShippingsNote(printerId) {
    orderFactory.printShippingsNote(order_id, printerId, vm.order.si.print_label, vm.order.si.print_notice).then(function () {}, function (error) {
      errorService.handleError(error);
    });
  }
  vm.deleteKeyFromObject = function (object, key) {
    if (object[key]) delete object[key];
  };
  vm.clearFinalDestination = function () {
    clearDestinations();
    clearChildNodes(0);
    vm.evaluateProgress();
  };
  vm.renotify = function () {
    orderFactory.renotifyOrderStatus(vm.orderDTO.OrderId);
  };
  vm.copyContactInfo = function () {
    vm.order.dr.receiver1 = {
      "contact_id": vm.order.dr.receiver1.contact_id,
      "contact_name": vm.order.proj.contact_person.contact_name,
      "phone_nr": vm.order.proj.contact_person.phone_nr,
      "email": vm.order.proj.contact_person.email,
      "sms_notif": vm.order.dr.receiver1.sms_notif,
      "email_notif": vm.order.dr.receiver1.email_notif
    };
    vm.order.proj.contact_person.sms_notif = false;
    vm.order.proj.contact_person.email_notif = false;
    vm.evaluateProgress();
  };

  // Watch for our custom `fileselect` event
  // FUTURE: This should be done using  a directive instead
  vm.initFileSelectEvent = function () {
    $(':file').on('fileselect', function (event, numFiles, label) {
      var input = $('#fileSelectedText');
      log = numFiles > 1 ? numFiles + ' filer valda' : label;
      if (input) {
        input.val(log);
      } else {
        if (log) alert(log);
      }
      vm.evaluateProgress();
    });
  };
  vm.initDateTimeEvents = function () {
    // Init date time pickers
    $('#material-datetimepicker2').datetimepicker({
      format: 'YYYY-MM-DD HH:mm',
      locale: 'sv'
    });
    $('#material-datetimepicker2').data().DateTimePicker.stepping(15);

    // Date time picker events
    $('#material-datetimepicker2').on('dp.change', function () {
      vm.order.si.timing = $('#material-timing').val();
      vm.evaluateProgress();
      if (!$scope.$$phase) {
        //$digest or $apply
        $scope.$apply();
      }
    });
  };
  vm.openDropdown = dropdownService.openDropdown;
  $scope.$on('updatedUserData', function () {
    identifyRoles();
  });
}]);
'use strict';

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
angular.module('serviplan').controller('ResourceBookingFormController', ['$uibModalInstance', 'form_type', 'order_id', 'copy', 'parentOrderId', '$scope', '$filter', 'orderFactory', 'workOrderFactory', 'locationFactory', '$translate', '$localStorage', 'packageFactory', 'errorService', 'roleService', 'inputValidationService', 'dropdownService', 'shippingFactory', 'orderResourceBookingFactory', 'printerFactory', 'taskStatusService', 'additionalServiceStatusService', 'generalHelperService', 'ngToast', '$log', '$q', 'ALLOWED_FILE_EXTENTIONS', function ($uibModalInstance, form_type, order_id, copy, parentOrderId, $scope, $filter, orderFactory, workOrderFactory, locationFactory, $translate, $localStorage, packageFactory, errorService, roleService, inputValidationService, dropdownService, shippingFactory, orderResourceBookingFactory, printerFactory, taskStatusService, additionalServiceStatusService, generalHelperService, ngToast, $log, $q, ALLOWED_FILE_EXTENTIONS) {
  var vm = this;
  vm.ALLOWED_FILE_EXTENTIONS = ALLOWED_FILE_EXTENTIONS;
  orderFactory.getGuid().then(function (response) {
    vm.formGuid = response.data;
  });
  initiateOrder();
  vm.sessionMainProject = $localStorage.user.session_main_project;
  vm.work_orders = [];
  vm.companies = [];
  vm.isSectionReceiversCompleted = false;
  vm.isSectionProjectCompleted = false;
  vm.isSectionBookingChoiceCompleted = false;
  vm.validated = false;
  vm.formValid = false;
  vm.hideWarnings = false;
  vm.order.order_type = OrderTypeEnum.RESOURCE_BOOKING;
  vm.form_type = form_type;
  vm.isCopy = copy;
  vm.isChildOrder = !!parentOrderId;
  vm.canEdit = false;
  vm.canCancel = false;
  vm.canConfirm = false;
  vm.canRaiseStatus = false;
  vm.canCopy = false;
  vm.canRenotify = false;
  vm.canUpload = false;
  function identifyRoles() {
    vm.isAdmin = roleService.isAdmin();
    vm.isInternal = roleService.isInternal();
    vm.isCustomer = roleService.isCustomer();
  }
  identifyRoles();
  if (vm.isCopy) {
    vm.form_type = 'create_order';
  }
  loadWorkOrders().then(function (response) {
    if (form_type === 'view_order' || form_type === 'manage_order' || vm.isChildOrder) {
      var orderToLoadId = vm.isChildOrder ? parentOrderId : order_id;
      loadOrder(orderToLoadId).then(function (response) {
        if (checkWorkOrderReferences()) {
          // Load work order data if we have access to it.
          vm.fillFormDataFromWorkOrder(vm.order.proj.work_order_id);
        } else {
          // User does not have permission to load work order data.
          // Hide warnings as user will not be able to edit the order.
          vm.hideWarnings = true;
          vm.loadDestinationLocationsForMainProject();
        }
      });
    } else if (form_type === 'create_order') {
      fillCompanyOptions(vm.work_orders);
    }
  });
  function checkWorkOrderReferences() {
    var hasReference = false;
    if (vm.work_orders) {
      angular.forEach(vm.work_orders, function (data) {
        if (vm.order.proj.work_order_id === data.work_order_id) {
          hasReference = true;
        }
      });
    }
    return hasReference;
  }
  var checkWorkOrderReferencesCallbacks = [];
  function subscribeToCheckWorkOrderReferencesChanges(callback) {
    checkWorkOrderReferencesCallbacks.push(callback);
  }
  function notifyCheckWorkOrdersReferencesChanged() {
    checkWorkOrderReferencesCallbacks.forEach(function (callback) {
      return callback();
    });
  }
  $scope.$watch('vm.work_orders', function () {
    notifyCheckWorkOrdersReferencesChanged();
  });
  $scope.$watch('vm.order.proj.work_order_id', function () {
    notifyCheckWorkOrdersReferencesChanged();
  });
  var taskStatusChangedCallbacks = [];
  function subscribeToTaskStatusChanges(callback) {
    taskStatusChangedCallbacks.push(callback);
  }
  function notifyTaskStatusChangesChanged() {
    taskStatusChangedCallbacks.forEach(function (callback) {
      return callback();
    });
  }
  $scope.$watch('vm.order.task_status', function () {
    notifyTaskStatusChangesChanged();
  });

  // Is editable if the orders WorkOrderId exists in the WorkOrderReferences.
  // WorkOrderReferences are the workorders which user are associated with. So when a user opens
  // an order in the list this is a way to check if the user can edit the form.
  function setCanEdit() {
    var canEdit = false;
    if (vm.form_type === 'create_order') {
      canEdit = true;
    }
    if (!canEdit && vm.isCustomer && taskStatusService.isNotified(vm.order.task_status)) {
      canEdit = checkWorkOrderReferences();
    }
    if (!canEdit && vm.isInternal && taskStatusService.isConfirmed(vm.order.task_status)) {
      canEdit = true;
    }
    if (!canEdit && vm.isAdmin && taskStatusService.isDelivered(vm.order.task_status)) {
      canEdit = true;
    }
    vm.canEdit = canEdit;
  }
  subscribeToCheckWorkOrderReferencesChanges(function () {
    return setCanEdit();
  });
  subscribeToTaskStatusChanges(function () {
    return setCanEdit();
  });
  function setCanCancel() {
    var canCancel = false;
    if (vm.form_type !== "create_order") {
      if (vm.isCustomer && taskStatusService.isNotified(vm.order.task_status)) {
        canCancel = checkWorkOrderReferences();
      }
      if (!canCancel && vm.isInternal && taskStatusService.isNotified(vm.order.task_status)) {
        canCancel = true;
      }
      if (!canCancel && vm.isInternal && taskStatusService.isConfirmed(vm.order.task_status)) {
        canCancel = true;
      }
      if (!canCancel && vm.isAdmin && !taskStatusService.isCancelled(vm.order.task_status)) {
        canCancel = true;
      }
    }
    vm.canCancel = canCancel;
  }
  subscribeToCheckWorkOrderReferencesChanges(function () {
    return setCanCancel();
  });
  subscribeToTaskStatusChanges(function () {
    return setCanCancel();
  });
  function setCanConfirm() {
    var canConfirm = false;
    if (vm.isInternal && taskStatusService.isNotified(vm.order.task_status)) {
      canConfirm = true;
    }
    vm.canConfirm = canConfirm;
  }
  subscribeToTaskStatusChanges(function () {
    return setCanConfirm();
  });
  function setCanRaiseStatus() {
    var canRaiseStatus = false;
    if (vm.isInternal && taskStatusService.isConfirmedOrLater(vm.order.task_status)) {
      canRaiseStatus = true;
    }
    vm.canRaiseStatus = canRaiseStatus;
  }
  subscribeToTaskStatusChanges(function () {
    return setCanRaiseStatus();
  });
  function setCanCopy() {
    var canCopy = false;
    if (vm.isCustomer && taskStatusService.isNotified(vm.order.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isNotified(vm.order.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isConfirmed(vm.order.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isConfirmed(vm.order.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isCancelled(vm.order.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isCancelled(vm.order.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isCompleted(vm.order.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isCompleted(vm.order.task_status)) {
      canCopy = true;
    }
    vm.canCopy = canCopy;
  }
  subscribeToCheckWorkOrderReferencesChanges(function () {
    return setCanCopy();
  });
  subscribeToTaskStatusChanges(function () {
    return setCanCopy();
  });
  function setCanRenotify() {
    var canRenotify = false;
    if (!canRenotify && vm.isInternal && taskStatusService.isConfirmed(vm.order.task_status)) {
      canRenotify = true;
    }
    vm.canRenotify = canRenotify;
  }
  subscribeToTaskStatusChanges(function () {
    return setCanRenotify();
  });
  function setCanUpload() {
    var canUpload = false;
    if (!taskStatusService.isCancelled(vm.order.task_status) && checkWorkOrderReferences() || vm.isAdmin) {
      canUpload = true;
    }
    vm.canUpload = canUpload;
  }
  subscribeToCheckWorkOrderReferencesChanges(function () {
    return setCanUpload();
  });
  subscribeToTaskStatusChanges(function () {
    return setCanUpload();
  });
  function loadWorkOrders() {
    if (!vm.sessionMainProject) return $q.reject();
    return workOrderFactory.getWorkOrders(vm.sessionMainProject.main_project_id, false).then(function (response) {
      vm.work_orders = workOrderFactory.repackageWorkOrderDTOArray(response.data);
    }, function (error) {
      errorService.handleError(error);
    });
  }
  function fillCompanyOptions(workOrders) {
    vm.companies = workOrderFactory.extractUniqueCompaniesFromWorkOrders(workOrders);
    vm.order.proj.company_id = -1;
    if (!vm.companies || vm.companies.length === 0) {
      vm.order.proj.company_name = $translate.instant('NON_AVAILABLE') + '...';
    } else if (vm.companies.length === 1) {
      vm.order.proj.company_id = vm.companies[0].company_id;
      vm.order.proj.company_name = vm.companies[0].company_name;
    }
  }
  vm.loadDestinationLocationsForMainProject = function () {
    var mainProjectId = vm.sessionMainProject.main_project_id;
    locationFactory.getDestinationLocations(mainProjectId).then(function (response) {
      vm.destinationLocations = response.data;
    });
  };
  vm.fillFormDataFromWorkOrder = function (workOrderId) {
    orderFactory.getResourceBookingOrderBase(workOrderId).then(function (response) {
      var data = response.data;

      // Load from base if not from order
      if (form_type === 'create_order' && !vm.isChildOrder) {
        vm.order.proj.id_number = data.ErpSystemReference;
        vm.order.proj.contact_person = {
          "contact_name": data.OrderCreatorContactName,
          "phone_nr": data.OrderCreatorContactPhone,
          "email": data.OrderCreatorContactEmail,
          "sms_notif": data.OrderCreatorContactWantSms,
          "email_notif": data.OrderCreatorContactWantEmail
        };
      }
      vm.resourceLocations = data.ResourceLocations;
      vm.vehicleDropLocations = data.VehicleDropLocations;
      vm.destinationLocations = data.DestinationLocations;
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.onFormResetAction = function () {
    setDefaultOrderValues();
  };
  function initiateOrder() {
    vm.order = {};
    vm.order.proj = {};
    setDefaultOrderValues();
  }
  function setDefaultOrderValues() {
    vm.order.dr = {};
    vm.order.di = {};
    vm.order.bc = {};
    vm.order.br = {};
    vm.order.si = {};
    vm.order.ar = {};
    vm.order.packages = [];
    vm.validated = false;
  }
  function loadOrder(id) {
    var isLoadingReference = vm.isCopy || vm.isChildOrder;
    return orderFactory.getOrder(id).then(function (response) {
      var data = response.data;
      if (!isLoadingReference) {
        vm.orderDTO = data;
        vm.order.dto = data;
        vm.order.order_id = id;
        vm.order.task_status = data.TaskStatus;
        vm.order.delivery_date = data.DeliveryDate;
        vm.order.order_type = data.OrderType;
      }

      // Section Project (proj)
      vm.order.proj.id_number = data.ErpSystemReference;
      vm.order.proj.work_order_name = data.WorkOrderName;
      vm.order.proj.work_order_id = data.WorkOrderId;
      vm.order.proj.company_name = data.WorkOrderCompanyName;
      vm.order.proj.company_id = data.WorkOrderCompanyId;
      vm.order.proj.order_number = data.OrderNumber;
      vm.order.proj.contact_person = {
        "contact_name": data.OrderCreatorContactName,
        "contact_id": data.OrderCreatorContactId,
        "phone_nr": data.OrderCreatorContactPhone,
        "email": data.OrderCreatorContactEmail,
        "sms_notif": data.OrderCreatorContactWantSms,
        "email_notif": data.OrderCreatorContactWantEmail
      };
      // Section Receivers
      vm.order.dr.receiver1 = {
        "contact_name": data.DeliveryReceiver1ContactName,
        "contact_id": data.DeliveryReceiver1ContactId,
        "phone_nr": data.DeliveryReceiver1ContactPhone,
        "email": data.DeliveryReceiver1ContactEmail,
        "sms_notif": data.DeliveryReceiver1ContactWantSms,
        "email_notif": data.DeliveryReceiver1ContactWantEmail
      };
      vm.order.dr.receiver2 = {
        "contact_name": data.DeliveryReceiver2ContactName,
        "contact_id": data.DeliveryReceiver2ContactId,
        "phone_nr": data.DeliveryReceiver2ContactPhone,
        "email": data.DeliveryReceiver2ContactEmail,
        "sms_notif": data.DeliveryReceiver2ContactWantSms,
        "email_notif": data.DeliveryReceiver2ContactWantEmail
      };
      vm.order.dr.receiver3 = {
        "contact_name": data.DeliveryReceiver3ContactName,
        "contact_id": data.DeliveryReceiver3ContactId,
        "phone_nr": data.DeliveryReceiver3ContactPhone,
        "email": data.DeliveryReceiver3ContactEmail,
        "sms_notif": data.DeliveryReceiver3ContactWantSms,
        "email_notif": data.DeliveryReceiver3ContactWantEmail
      };

      // SectionBooking choice (bc)
      vm.order.bc.resource_bookings = isLoadingReference ? [] : orderFactory.repackageResourceBookingDTOArray(data.ResourceBookings);
      vm.order.bc.vehicle_drop_location_name = data.VehicleDropLocationName;
      vm.order.bc.vehicle_drop_location_id = data.VehicleDropLocationId;
      vm.order.bc.destination_location_id = data.DestinationLocationId;
      vm.order.bc.staircase_location_id = data.StaircaseLocationId;
      vm.order.bc.staircase_location_name = data.StaircaseLocationName;
      vm.order.bc.comments = data.Comments;
      vm.order.bc.file_attachments = isLoadingReference ? [] : $filter('filter')(data.Files, {
        OrderFileAttachmentTypeId: FileAttachmentTypeEnum.DOCUMENT
      }, true);

      // Section Booking reference (br)
      if (!isLoadingReference) {
        vm.order.br.registered = $filter('toDateTime')(data.Created);
        vm.order.br.status = $translate.instant(data.TaskStatusTypeAlias);
        vm.order.br.order_number = data.OrderNumber;
        vm.order.br.parent_order_id = data.ParentOrderId;
        vm.order.br.parent_order_number = data.ParentOrderNumber;
        getNextStatus();
      } else if (vm.isChildOrder) {
        vm.order.br.parent_order_id = data.OrderId;
        vm.order.br.parent_order_number = data.OrderNumber;
      }
    }, function (error) {
      errorService.handleError(error);
    });
  }
  vm.setNextStatus = function () {
    if (vm.order.task_status !== vm.order.nextTaskStatus) {
      orderFactory.setNextStatus(order_id).then(function () {
        ngToast.success("Status ändrat.");
        vm.order.br.status = vm.order.nextTaskStatusName;
        vm.order.task_status = vm.order.nextTaskStatus;
        vm.order.task_status = vm.order.nextTaskStatus;
        getNextStatus();
      }, function (error) {
        ngToast.danger("Det gick inte att ändra status.");
        $log.error(error);
      });
    }
  };
  function getNextStatus() {
    orderFactory.getNextStatus(vm.order.order_type, vm.order.task_status).then(function (result) {
      vm.order.nextTaskStatus = result.data;
      vm.order.nextTaskStatusName = $translate.instant(generalHelperService.getKeyByValue(TaskStatusTypeEnum, vm.order.nextTaskStatus));
    });
  }
  vm.createOrder = function () {
    vm.validateForm();
    if (!vm.formValid || vm.lockCall) {
      return;
    }
    vm.lockCall = true;
    var orderDTO = orderResourceBookingFactory.createOrderDTO(vm.order, TaskStatusTypeEnum.NOTIFIED);
    orderFactory.createOrder(orderDTO, vm.order.bc.file_attachments_to_add, vm.formGuid).then(function () {
      var results = {
        success: true,
        copy: false
      };
      vm.lockCall = false;
      $uibModalInstance.close(results);
    }, function (error) {
      vm.lockCall = false;
      if (error.status === 409) {
        ngToast.warning("Kunde inte spara formuläret, ordern finns redan.");
      } else {
        ngToast.danger("Det gick inte att spara formuläret.");
      }
      errorService.handleError(error);
    });
  };
  vm.updateOrder = function () {
    vm.validateForm();
    if (!vm.formValid) {
      return;
    }
    var orderDTO = orderResourceBookingFactory.createOrderDTO(vm.order, "");
    var options = {
      fileAttachments: vm.order.bc.file_attachments_to_add
    };
    orderFactory.updateOrder(vm.order.order_id, orderDTO, options).then(function () {
      var results = {
        success: true,
        copy: false
      };
      $uibModalInstance.close(results);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.confirmOrder = function () {
    vm.validateForm();
    if (!vm.formValid) {
      return;
    }
    var orderDTO = orderResourceBookingFactory.createOrderDTO(vm.order, TaskStatusTypeEnum.CONFIRMED);
    var options = {
      fileAttachments: vm.order.bc.file_attachments_to_add
    };
    orderFactory.confirmOrder(vm.orderDTO.OrderId, orderDTO, options).then(function () {
      var results = {};
      results.success = true;
      results.copy = false;
      $uibModalInstance.close(results);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  vm.copyOrder = function () {
    var results = {};
    results.success = true;
    results.copy = true;
    $uibModalInstance.close(results);
  };
  vm.cancelOrder = function () {
    var results = {};
    orderFactory.cancelOrder(vm.orderDTO.OrderId, vm.orderDTO).then(function () {
      results.success = true;
      results.copy = false;
      $uibModalInstance.close(results);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.renotify = function () {
    orderFactory.renotifyOrderStatus(vm.orderDTO.OrderId);
  };

  // --- VALIDATION ---
  vm.handleValidationChange = function (source, value) {
    switch (source) {
      case "section_project":
        vm.isSectionProjectCompleted = value;
        break;
      case "section_receivers":
        vm.isSectionReceiversCompleted = value;
        break;
      case "section_booking_choice":
        vm.isSectionBookingChoiceCompleted = value;
        break;
      default:
        console.log(source + " is not a valid source");
        break;
    }
  };
  function checkAllSectionsDone() {
    vm.formValid = vm.isSectionProjectCompleted && vm.isSectionReceiversCompleted && vm.isSectionBookingChoiceCompleted;
    return vm.formValid;
  }
  vm.validateForm = function () {
    checkAllSectionsDone();
    vm.validated = true;
    return vm.formValid;
  };

  // -- OTHER --

  vm.setFinalDestinationLocation = function (location) {
    vm.order.bc.destination_location_id = location.location_id;
    vm.order.bc.destination_location_name = location.location_name;
  };
  $scope.$on('updatedUserData', function () {
    identifyRoles();
  });
}]);
'use strict';

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
angular.module('serviplan').controller('StoringFormController', ['$uibModalInstance', 'form_type', 'order_id', 'copy', '$scope', '$filter', 'orderFactory', 'workOrderFactory', '$translate', '$localStorage', 'errorService', 'roleService', 'dropdownService', 'orderStoringFactory', 'taskStatusService', 'additionalServiceStatusService', 'inputValidationService', 'generalHelperService', 'ngToast', 'packageFactory', '$log', 'ALLOWED_FILE_EXTENTIONS', function ($uibModalInstance, form_type, order_id, copy, $scope, $filter, orderFactory, workOrderFactory, $translate, $localStorage, errorService, roleService, dropdownService, orderStoringFactory, taskStatusService, additionalServiceStatusService, inputValidationService, generalHelperService, ngToast, packageFactory, $log, ALLOWED_FILE_EXTENTIONS) {
  var vm = this;
  vm.ALLOWED_FILE_EXTENTIONS = ALLOWED_FILE_EXTENTIONS;
  orderFactory.getGuid().then(function (responce) {
    vm.formGuid = responce.data;
  });
  initiateOrder();
  vm.sessionMainProject = $localStorage.user.session_main_project;
  vm.isSectionProjectCompleted = false;
  vm.isSectionDeliveryInformationCompleted = false;
  vm.isSectionBookingChoiceCompleted = false;
  vm.validated = false;
  vm.formValid = false;
  vm.arrivalSet = false;
  vm.order.ar.file_attachments = [];
  vm.order.order_type = OrderTypeEnum.STORING;
  vm.form_type = form_type;
  vm.canEdit = true;
  vm.canUpload = true;
  vm.hideWarnings = false;
  function identifyRoles() {
    vm.isAdmin = roleService.isAdmin();
    vm.isInternal = roleService.isInternal();
    vm.isCustomer = roleService.isCustomer();
  }
  identifyRoles();
  if (copy) {
    vm.form_type = 'create_order';
  }
  loadWorkOrders().then(function (response) {
    if (form_type === 'create_order') {
      fillCompanyOptions(vm.work_orders);
    } else if (form_type === 'view_order' || form_type === 'manage_order') {
      vm.workOrderReferences = vm.work_orders;
      loadOrder(order_id).then(function (response) {
        if (checkWorkOrderReferences()) {
          // Load work order data if we have access to it.
          vm.fillFormDataFromWorkOrder(vm.order.proj.work_order_id);
        } else {
          // User does not have permission to load work order data.
          // Hide warnings as user will not be able to edit the order.
          vm.hideWarnings = true;
        }
      });
    }
  });

  // Additional setup END ---

  function checkWorkOrderReferences() {
    var hasReference = false;
    if (vm.workOrderReferences) {
      angular.forEach(vm.workOrderReferences, function (data) {
        if (vm.order.proj.work_order_id === data.work_order_id) {
          hasReference = true;
        }
      });
    }
    return hasReference;
  }

  // Is editable if the orders WorkOrderId exists in the WorkOrderReferences.
  // WorkOrderReferences are the workorders which user are associated with. So when a user opens
  // an order in the list this is a way to check if the user can edit the form.
  function setCanEdit() {
    var canEdit = false;
    if (vm.form_type === 'create_order') {
      canEdit = true;
    }
    if (!canEdit && vm.isCustomer && taskStatusService.isNotified(vm.order.br.task_status)) {
      canEdit = checkWorkOrderReferences();
    }
    if (!canEdit && vm.isInternal && taskStatusService.isConfirmed(vm.order.br.task_status)) {
      canEdit = true;
    }
    if (!canEdit && vm.isInternal && taskStatusService.isArrived(vm.order.br.task_status)) {
      canEdit = true;
    }
    if (!canEdit && vm.isAdmin && taskStatusService.isStored(vm.order.br.task_status)) {
      canEdit = true;
    }
    vm.canEdit = canEdit;
  }
  function setCanCancel() {
    var canCancel = false;
    if (vm.form_type !== "create_order") {
      if (vm.isCustomer && taskStatusService.isNotified(vm.order.br.task_status)) {
        canCancel = checkWorkOrderReferences();
      }
      if (!canCancel && vm.isInternal && taskStatusService.isNotified(vm.order.br.task_status)) {
        canCancel = true;
      }
      if (!canCancel && vm.isInternal && taskStatusService.isConfirmed(vm.order.br.task_status)) {
        canCancel = true;
      }
      if (!canCancel && vm.isInternal && taskStatusService.isArrived(vm.order.br.task_status)) {
        canCancel = true;
      }
      if (!canCancel && vm.isAdmin && !taskStatusService.isCancelled(vm.order.br.task_status)) {
        canCancel = true;
      }
    }
    vm.canCancel = canCancel;
  }
  function setCanConfirm() {
    var canConfirm = false;
    if (vm.isInternal && taskStatusService.isNotified(vm.order.br.task_status)) {
      canConfirm = true;
    }
    vm.canConfirm = canConfirm;
  }
  function setCanRaiseStatus() {
    var canRaiseStatus = false;
    if (vm.isInternal && taskStatusService.isConfirmedOrLater(vm.order.br.task_status)) {
      canRaiseStatus = true;
    }
    vm.canRaiseStatus = canRaiseStatus;
  }
  function setCanCopy() {
    var canCopy = false;
    if (vm.isCustomer && taskStatusService.isNotified(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isNotified(vm.order.br.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isConfirmed(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isConfirmed(vm.order.br.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isArrived(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isArrived(vm.order.br.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isCancelled(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isCancelled(vm.order.br.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isStored(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isStored(vm.order.br.task_status)) {
      canCopy = true;
    }
    vm.canCopy = canCopy;
  }
  function setCanRenotify() {
    var canRenotify = false;
    if (vm.isInternal && taskStatusService.isConfirmedOrLater(vm.order.br.task_status) && !taskStatusService.isStored(vm.order.br.task_status)) {
      canRenotify = true;
    }
    vm.canRenotify = canRenotify;
  }
  function setCanUpload() {
    var canUpload = false;
    if (!taskStatusService.isCancelled(vm.order.br.task_status) && checkWorkOrderReferences() || vm.isAdmin) {
      canUpload = true;
    }
    vm.canUpload = canUpload;
  }
  function setPermissions() {
    setCanEdit();
    setCanCancel();
    setCanConfirm();
    setCanRaiseStatus();
    setCanCopy();
    setCanUpload();
    setCanRenotify();
  }
  function loadWorkOrders() {
    if (!vm.sessionMainProject) return $q.reject();
    return workOrderFactory.getWorkOrders(vm.sessionMainProject.main_project_id, false).then(function (response) {
      vm.work_orders = workOrderFactory.repackageWorkOrderDTOArray(response.data);
    }, function (error) {
      errorService.handleError(error);
    });
  }
  function fillCompanyOptions(workOrders) {
    vm.companies = workOrderFactory.extractUniqueCompaniesFromWorkOrders(workOrders);
    vm.order.proj.company_id = -1;
    if (!vm.companies || vm.companies.length === 0) {
      vm.order.proj.company_name = $translate.instant('NON_AVAILABLE') + '...';
    } else if (vm.companies.length === 1) {
      vm.order.proj.company_id = vm.companies[0].company_id;
      vm.order.proj.company_name = vm.companies[0].company_name;
    }
  }
  vm.fillFormDataFromWorkOrder = function (workOrderId) {
    orderFactory.getStoringFormBase(workOrderId).then(
    //getOrderBy Work order
    function (response) {
      var data = response.data;

      // Load from base if not from order
      if (form_type === 'create_order') {
        vm.order.proj.id_number = data.ErpSystemReference;
        vm.order.proj.contact_person = {
          "contact_name": data.OrderCreatorContactName,
          "phone_nr": data.OrderCreatorContactPhone,
          "email": data.OrderCreatorContactEmail,
          "sms_notif": data.OrderCreatorContactWantSms,
          "email_notif": data.OrderCreatorContactWantEmail
        };
      }
      vm.order.di.vehicle_types = data.VehicleTypes;
      vm.evaluateProgress();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.onFormResetAction = function () {
    setDefaultOrderValues();
    vm.evaluateProgress();
  };
  function initiateOrder() {
    vm.order = {};
    vm.order.proj = {};
    setDefaultOrderValues();
  }
  function setDefaultOrderValues() {
    delete vm.orderDTO;
    vm.order.di = {};
    vm.order.bc = {};
    vm.order.br = {};
    vm.order.ar = {};
    vm.order.packages = [];
    vm.validated = false;
  }
  function loadOrder(id) {
    return orderFactory.getOrder(id).then(function (response) {
      var data = response.data;
      vm.orderDTO = data;
      vm.order.dto = data;
      vm.order.order_id = id;
      vm.order.task_status = data.TaskStatus;
      vm.order.order_type = data.OrderType;

      // Section 1 - Project (proj)
      vm.order.proj.id_number = data.ErpSystemReference;
      vm.order.proj.work_order_name = data.WorkOrderName;
      vm.order.proj.work_order_id = data.WorkOrderId;
      vm.order.proj.company_name = data.WorkOrderCompanyName;
      vm.order.proj.company_id = data.WorkOrderCompanyId;
      vm.order.proj.order_number = data.OrderNumber;
      vm.order.proj.contact_person = {
        "contact_name": data.OrderCreatorContactName,
        "contact_id": data.OrderCreatorContactId,
        "phone_nr": data.OrderCreatorContactPhone,
        "email": data.OrderCreatorContactEmail,
        "sms_notif": data.OrderCreatorContactWantSms,
        "email_notif": data.OrderCreatorContactWantEmail
      };
      // Section 3 - Delivery information (di)
      vm.order.di.supplier = data.Supplier;
      vm.order.di.vehicle_type_id = data.VehicleTypeId;
      vm.order.di.vehicle_type_name = data.VehicleTypeCode;
      vm.order.di.material = data.Content;
      vm.order.di.n_materials = data.Quantity;
      // Section 4 - Booking choice (bc)
      vm.order.bc.arrival_time = formatDate(data.Arrival);
      vm.order.bc.n_transports = data.NumTransports;
      vm.order.bc.ext_order_reference = data.ExternalOrderReference;
      vm.order.bc.comments = data.Comments;
      vm.order.bc.file_attachments = $filter('filter')(data.Files, {
        OrderFileAttachmentTypeId: FileAttachmentTypeEnum.DOCUMENT
      }, true);
      vm.order.bc.is_unannounced_goods = !!data.IsUnannouncedGoods;
      vm.order.bc.is_unreachable = !!data.IsUnreachable;
      vm.order.bc.is_unused_resource = !!data.IsUnusedResource;

      // Section 5 - Arrival registration
      vm.order.ar.has_inadequate_labeling = data.HasInadequateLabeling;
      vm.order.ar.other_reference = data.OtherReference;
      vm.order.ar.arrival_control_status_id = data.AdditionalServiceArrivalControlStatusTypeId;
      vm.order.ar.file_attachments = $filter('filter')(data.Files, {
        OrderFileAttachmentTypeId: FileAttachmentTypeEnum.ARRIVAL_CONTROL
      }, true);
      var arrivelControllCompleted = isAdditionalServiceCompleted(vm.order.ar.arrival_control_status_id);
      vm.lockArrivalControlled = arrivelControllCompleted; // Lock if controlled
      vm.order.ar.is_arrival_controlled = arrivelControllCompleted;

      // Section 6 - Booking reference (br)
      vm.order.br.registered = $filter('toDateTime')(data.Created);
      vm.order.br.status = $translate.instant(data.TaskStatusTypeAlias);
      vm.order.br.task_status = data.TaskStatus;
      vm.order.br.order_number = data.OrderNumber;

      // Packages
      vm.order.packages = [];
      for (var i = 0; i < data.Packages.length; i++) {
        vm.order.packages.push(packageFactory.repackageDTO(data.Packages[i]));
      }
      if (copy) {
        delete vm.order.order_id;
        vm.order.br = {};
        vm.order.ar.file_attachments = [];
        delete vm.order.ar.file_attachment_to_add;
        vm.order.bc.file_attachments = [];
        vm.order.bc.file_attachments_to_add = [];
        vm.order.packages = [];
        vm.order.proj.order_number = '';
      }
      vm.evaluateProgress();
      getNextStatus();
      setPermissions();
    }, function (error) {
      errorService.handleError(error);
    });
  }
  vm.setNextStatus = function () {
    if (vm.order.task_status !== vm.order.nextTaskStatus) {
      orderFactory.setNextStatus(order_id).then(function () {
        ngToast.success("Status ändrat.");
        vm.order.br.status = vm.order.nextTaskStatusName;
        vm.order.br.task_status = vm.order.nextTaskStatus;
        vm.order.task_status = vm.order.nextTaskStatus;
        getNextStatus();
      }, function (error) {
        ngToast.danger("Det gick inte att ändra status.");
        $log.error(error);
      });
    }
  };
  function getNextStatus() {
    orderFactory.getNextStatus(vm.order.order_type, vm.order.task_status).then(function (result) {
      vm.order.nextTaskStatus = result.data;
      vm.order.nextTaskStatusName = $translate.instant(generalHelperService.getKeyByValue(TaskStatusTypeEnum, vm.order.nextTaskStatus));
    });
  }
  vm.isConfirmedOrLater = function () {
    return taskStatusService.isConfirmedOrLater(vm.order.br.task_status);
  };
  vm.renotify = function () {
    orderFactory.renotifyOrderStatus(vm.orderDTO.OrderId);
  };
  function formatDate(date) {
    var split = date.slice(0, -3).split('T');
    return split[0] + ' ' + split[1];
  }
  vm.send = function () {
    validateForm();
    if (!vm.formValid || vm.lockCall) {
      return;
    }
    vm.lockCall = true;
    var orderDTO = orderStoringFactory.createOrderDTO(vm.order, TaskStatusTypeEnum.NOTIFIED);
    orderFactory.createOrder(orderDTO, vm.order.bc.file_attachments_to_add, vm.formGuid).then(function () {
      var results = {
        success: true,
        copy: false
      };
      vm.lockCall = false;
      $uibModalInstance.close(results);
    }, function (error) {
      vm.lockCall = false;
      if (error.status === 409) {
        ngToast.warning("Kunde inte spara formuläret, ordern finns redan.");
      } else {
        ngToast.danger("Det gick inte att spara formuläret.");
      }
      errorService.handleError(error);
    });
  };
  vm.updateOrder = function () {
    validateForm();
    if (!vm.formValid) {
      return;
    }
    var orderDTO = orderStoringFactory.createOrderDTO(vm.order, vm.orderDTO.DestinationLocationId, vm.orderDTO.DestinationLocationName, ""),
      options = {
        fileAttachments: vm.order.bc.file_attachments_to_add
      };
    orderFactory.updateOrder(vm.order.order_id, orderDTO, options).then(function () {
      // The status of an additional service is not updated in mapping, since it typically set via SST and not in UI.
      // Setting arrival status to COMPLETE is an exception. Therefore a separate call to update status must be done.
      if (vm.order.ar.is_arrival_controlled) {
        orderFactory.updateAdditionalService(vm.orderDTO.OrderId, AdditionalServiceTypeEnum.ARRIVAL_CONTROL, AdditionalServiceStatusTypeEnum.COMPLETED);
      }
      var results = {
        success: true,
        copy: false
      };
      $uibModalInstance.close(results);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.confirmOrder = function () {
    validateForm();
    if (!vm.formValid) {
      return;
    }
    var orderDTO = orderStoringFactory.createOrderDTO(vm.order, TaskStatusTypeEnum.CONFIRMED),
      options = {
        fileAttachments: vm.order.bc.file_attachments_to_add
      };
    orderFactory.confirmOrder(vm.orderDTO.OrderId, orderDTO, options).then(function () {
      var results = {
        success: true,
        copy: false
      };
      $uibModalInstance.close(results);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  vm.copyOrder = function () {
    var results = {
      success: true,
      copy: true
    };
    $uibModalInstance.close(results);
  };
  vm.cancelOrder = function () {
    var results = {};
    orderFactory.cancelOrder(vm.orderDTO.OrderId, vm.orderDTO).then(function () {
      results.success = true;
      results.copy = false;
      $uibModalInstance.close(results);
    }, function (error) {
      errorService.handleError(error);
    });
  };

  // --- VALIDATION ---
  vm.handleValidationChange = function (source, value) {
    switch (source) {
      case "section_project":
        vm.isSectionProjectCompleted = value;
        break;
      case "section_delivery_information":
        vm.isSectionDeliveryInformationCompleted = value;
        break;
      case "section_booking_choice":
        vm.isSectionBookingChoiceCompleted = value;
        break;
      default:
        console.log(source + " is not a valid source");
        break;
    }
    vm.evaluateProgress();
  };
  vm.evaluateProgress = function () {
    // -- 1-3: Validation is handled by component

    vm.sectionFourDone = vm.isSectionBookingChoiceCompleted; // Does not have any input that shall be validated
  };

  vm.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  vm.isValidEmail = function (input) {
    return inputValidationService.isValidEmail(input);
  };
  function isAdditionalServiceCompleted(statusTypeId) {
    return additionalServiceStatusService.isCompleted(statusTypeId);
  }
  function validateForm() {
    vm.validated = true;
    vm.evaluateProgress();
    checkAllSectionsDone();
    return vm.formValid;
  }
  function checkAllSectionsDone() {
    if (vm.isSectionProjectCompleted && vm.isSectionDeliveryInformationCompleted && vm.isSectionBookingChoiceCompleted && vm.sectionFourDone) {
      vm.formValid = true;
    } else vm.formValid = false;
  }

  // Watch for our custom `fileselect` event
  // FUTURE: This should be done using  a directive instead
  vm.initFileSelectEvent = function (fileInputId, fileSelectedTextId) {
    $(fileInputId).on('fileselect', function (event, numFiles, label) {
      var input = $(fileSelectedTextId);
      log = numFiles > 1 ? numFiles + ' filer valda' : label;
      if (input) {
        input.val(log);
      } else {
        if (log) alert(log);
      }
      vm.evaluateProgress();
    });
  };
  vm.getFilePath = function (orderId, fileName) {
    return orderFactory.createFileLink(orderId, fileName);
  };
  vm.addArrivalControlFileToOrder = function () {
    var orderId = vm.order.order_id;
    var file = vm.order.ar.file_attachment_to_add;
    if (!file) return;
    orderFactory.saveFile(orderId, file, FileAttachmentTypeEnum.ARRIVAL_CONTROL).then(function (response) {
      var data = response.data;
      angular.forEach(data, function (file) {
        vm.order.ar.file_attachments.push(file);
      });
      delete vm.order.ar.file_attachment_to_add;
      $('#ar-fileattachment').val('');
    });
  };
  $scope.openDropdown = dropdownService.openDropdown;
  $scope.$on('updatedUserData', function () {
    identifyRoles();
  });
}]);
'use strict';

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
angular.module('serviplan').controller('TransshipmentFormController', ['$uibModalInstance', 'form_type', 'order_id', 'copy', '$scope', '$filter', 'orderFactory', 'workOrderFactory', 'locationFactory', '$translate', '$localStorage', 'packageFactory', 'errorService', 'roleService', 'inputValidationService', 'dropdownService', 'shippingFactory', 'orderTransshipmentFactory', 'printerFactory', 'taskStatusService', 'additionalServiceStatusService', 'generalHelperService', 'orderFormModalService', 'ngToast', '$log', '$q', 'ALLOWED_FILE_EXTENTIONS', function ($uibModalInstance, form_type, order_id, copy, $scope, $filter, orderFactory, workOrderFactory, locationFactory, $translate, $localStorage, packageFactory, errorService, roleService, inputValidationService, dropdownService, shippingFactory, orderTransshipmentFactory, printerFactory, taskStatusService, additionalServiceStatusService, generalHelperService, orderFormModalService, ngToast, $log, $q, ALLOWED_FILE_EXTENTIONS) {
  var vm = this;
  vm.ALLOWED_FILE_EXTENTIONS = ALLOWED_FILE_EXTENTIONS;
  orderFactory.getGuid().then(function (responce) {
    vm.formGuid = responce.data;
  });
  initiateOrder();
  vm.sessionMainProject = $localStorage.user.session_main_project;
  vm.work_orders = [];
  vm.companies = [];
  vm.isSectionReceiversCompleted = false;
  vm.isSectionProjectCompleted = false;
  vm.isSectionDeliveryInformationCompleted = false;
  vm.isSectionBookingChoiceCompleted = false;
  vm.sectionFiveDone = false;
  vm.sectionSixDone = false;
  vm.validated = false;
  vm.formValid = false;
  vm.order.ar.file_attachments = [];
  vm.order.order_type = OrderTypeEnum.TRANSSHIPMENT;
  vm.form_type = form_type;
  vm.canEdit = true;
  vm.canUpload = true;
  function identifyRoles() {
    vm.isAdmin = roleService.isAdmin();
    vm.isInternal = roleService.isInternal();
    vm.isCustomer = roleService.isCustomer();
  }
  identifyRoles();
  if (copy) {
    vm.form_type = 'create_order';
  }
  vm.hideWarnings = false;
  loadWorkOrders().then(function (response) {
    if (form_type === 'create_order') {
      fillCompanyOptions(vm.work_orders);
    } else if (form_type === 'view_order' || form_type === 'manage_order') {
      vm.workOrderReferences = vm.work_orders;
      loadOrder(order_id).then(function (response) {
        if (checkWorkOrderReferences()) {
          // Load work order data if we have access to it.
          vm.fillFormDataFromWorkOrder(vm.order.proj.work_order_id);
        } else {
          // User does not have permission to load work order data.
          // Hide warnings as user will not be able to edit the order.
          vm.hideWarnings = true;
          vm.loadDestinationLocationsForMainProject();
          vm.evaluateProgress();
        }
      });
    }
  });
  function checkWorkOrderReferences() {
    var hasReference = false;
    if (vm.workOrderReferences) {
      angular.forEach(vm.workOrderReferences, function (data) {
        if (vm.order.proj.work_order_id === data.work_order_id) {
          hasReference = true;
        }
      });
    }
    return hasReference;
  }

  // Is editable if the orders WorkOrderId exists in the WorkOrderReferences.
  // WorkOrderReferences are the workorders which user are associated with. So when a user opens
  // an order in the list this is a way to check if the user can edit the form.
  function setCanEdit() {
    var canEdit = false;
    if (vm.form_type === 'create_order') {
      canEdit = true;
    }
    if (!canEdit && vm.isCustomer && taskStatusService.isNotified(vm.order.br.task_status)) {
      canEdit = checkWorkOrderReferences();
    }
    if (!canEdit && vm.isInternal && taskStatusService.isConfirmed(vm.order.br.task_status)) {
      canEdit = true;
    }
    if (!canEdit && vm.isInternal && taskStatusService.isArrived(vm.order.br.task_status)) {
      canEdit = true;
    }
    if (!canEdit && vm.isInternal && (taskStatusService.isAssignedToTransport(vm.order.br.task_status) || taskStatusService.isAssignedToRoute(vm.order.br.task_status))) {
      canEdit = true;
    }
    if (!canEdit && vm.isAdmin && taskStatusService.isDelivered(vm.order.br.task_status)) {
      canEdit = true;
    }
    vm.canEdit = canEdit;
  }
  function setCanCancel() {
    var canCancel = false;
    if (vm.form_type !== "create_order") {
      if (vm.isCustomer && taskStatusService.isNotified(vm.order.br.task_status)) {
        canCancel = checkWorkOrderReferences();
      }
      if (!canCancel && vm.isInternal && taskStatusService.isNotified(vm.order.br.task_status)) {
        canCancel = true;
      }
      if (!canCancel && vm.isInternal && taskStatusService.isConfirmed(vm.order.br.task_status)) {
        canCancel = true;
      }
      if (!canCancel && vm.isInternal && taskStatusService.isArrived(vm.order.br.task_status) && !vm.order.delivery_date && !vm.order.packages.length) {
        canCancel = true;
      }
      if (!canCancel && vm.isAdmin && !taskStatusService.isCancelled(vm.order.br.task_status)) {
        canCancel = true;
      }
    }
    vm.canCancel = canCancel;
  }
  function setCanConfirm() {
    var canConfirm = false;
    if (vm.isInternal && taskStatusService.isNotified(vm.order.br.task_status)) {
      canConfirm = true;
    }
    vm.canConfirm = canConfirm;
  }
  function setCanRaiseStatus() {
    var canRaiseStatus = false;
    if (!canRaiseStatus && vm.isInternal && taskStatusService.isConfirmedOrLater(vm.order.br.task_status)) {
      canRaiseStatus = true;
    }
    vm.canRaiseStatus = canRaiseStatus;
  }
  function setCanCopy() {
    var canCopy = false;
    if (vm.isCustomer && taskStatusService.isNotified(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isNotified(vm.order.br.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isConfirmed(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isConfirmed(vm.order.br.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isArrived(vm.order.br.task_status)) {
      //--
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isArrived(vm.order.br.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && (taskStatusService.isAssignedToTransport(vm.order.br.task_status) || taskStatusService.isAssignedToRoute(vm.order.br.task_status))) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && (taskStatusService.isAssignedToTransport(vm.order.br.task_status) || taskStatusService.isAssignedToRoute(vm.order.br.task_status))) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isCancelled(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isCancelled(vm.order.br.task_status)) {
      canCopy = true;
    }
    if (!canCopy && vm.isCustomer && taskStatusService.isDelivered(vm.order.br.task_status)) {
      canCopy = checkWorkOrderReferences();
    }
    if (!canCopy && vm.isInternal && taskStatusService.isDelivered(vm.order.br.task_status)) {
      canCopy = true;
    }
    vm.canCopy = canCopy;
  }
  function setCanPrint() {
    var canPrint = false;
    if (vm.isInternal && taskStatusService.isConfirmed(vm.order.br.task_status)) {
      canPrint = true;
    }
    if (!canPrint && vm.isInternal && taskStatusService.isArrived(vm.order.br.task_status)) {
      canPrint = true;
    }
    if (!canPrint && vm.isInternal && (taskStatusService.isAssignedToTransport(vm.order.br.task_status) || taskStatusService.isAssignedToRoute(vm.order.br.task_status))) {
      canPrint = true;
    }
    if (!canPrint && vm.isInternal && taskStatusService.isDelivered(vm.order.br.task_status)) {
      canPrint = true;
    }
    vm.canPrint = canPrint;
  }
  function setCanRenotify() {
    var canRenotify = false;
    if (vm.isInternal && taskStatusService.isConfirmedOrLater(vm.order.br.task_status) && !taskStatusService.isDelivered(vm.order.br.task_status)) {
      canRenotify = true;
    }
    vm.canRenotify = canRenotify;
  }
  function setCanUpload() {
    var canUpload = false;
    if (!taskStatusService.isCancelled(vm.order.br.task_status) && checkWorkOrderReferences() || vm.isAdmin) {
      canUpload = true;
    }
    vm.canUpload = canUpload;
  }
  function setPermissions() {
    setCanEdit();
    setCanCancel();
    setCanConfirm();
    setCanRaiseStatus();
    setCanCopy();
    setCanPrint();
    setCanUpload();
    setCanRenotify();
  }
  function loadWorkOrders() {
    if (!vm.sessionMainProject) return $q.reject();
    return workOrderFactory.getWorkOrders(vm.sessionMainProject.main_project_id, false).then(function (response) {
      vm.work_orders = workOrderFactory.repackageWorkOrderDTOArray(response.data);
    }, function (error) {
      errorService.handleError(error);
    });
  }
  function fillCompanyOptions(workOrders) {
    vm.companies = workOrderFactory.extractUniqueCompaniesFromWorkOrders(workOrders);
    vm.order.proj.company_id = -1;
    if (!vm.companies || vm.companies.length === 0) {
      vm.order.proj.company_name = $translate.instant('NON_AVAILABLE') + '...';
    } else if (vm.companies.length === 1) {
      vm.order.proj.company_id = vm.companies[0].company_id;
      vm.order.proj.company_name = vm.companies[0].company_name;
    }
  }
  function loadShippings() {
    if (!vm.sessionMainProject || !vm.isInternal) {
      vm.shippings = [];
      return;
    }
    shippingFactory.getShippingsByMainProjectId(false, vm.sessionMainProject.main_project_id).then(function (response) {
      var data = response.data;
      vm.shippings = shippingFactory.repackageDTOArray(data);
    }, function (error) {
      errorService.handleError(error);
    });
  }
  loadShippings();
  function loadPrinters() {
    if (!vm.sessionMainProject || !vm.isInternal) {
      vm.printers = [];
      return;
    }
    printerFactory.getPrintersByMainProjectId(vm.sessionMainProject.main_project_id).then(function (response) {
      var data = response.data;
      vm.printers = printerFactory.repackageDTOArray(data);
    }, function (error) {
      errorService.handleError(error);
    });
  }
  loadPrinters();
  vm.loadDestinationLocationsForMainProject = function () {
    var mainProjectId = vm.sessionMainProject.main_project_id;
    locationFactory.getDestinationLocations(mainProjectId).then(function (response) {
      vm.destinationLocations = response.data;
    });
  };
  vm.fillFormDataFromWorkOrder = function (workOrderId) {
    orderFactory.getTransshipmentFormBase(workOrderId).then(function (response) {
      var data = response.data;

      // Load from base if not from order
      if (form_type === 'create_order') {
        vm.order.proj.id_number = data.ErpSystemReference;
        vm.order.proj.contact_person = {
          "contact_name": data.OrderCreatorContactName,
          "phone_nr": data.OrderCreatorContactPhone,
          "email": data.OrderCreatorContactEmail,
          "sms_notif": data.OrderCreatorContactWantSms,
          "email_notif": data.OrderCreatorContactWantEmail
        };
      }
      vm.vehicleDropLocations = data.VehicleDropLocations;
      vm.destinationLocations = data.DestinationLocations;
      vm.evaluateProgress();
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.onFormResetAction = function () {
    setDefaultOrderValues();
    vm.evaluateProgress();
  };
  function initiateOrder() {
    vm.order = {};
    vm.order.proj = {};
    setDefaultOrderValues();
  }
  function setDefaultOrderValues() {
    vm.order.dr = {};
    vm.order.di = {};
    vm.order.bc = {};
    vm.order.br = {};
    vm.order.si = {};
    vm.order.ar = {};
    vm.order.packages = [];
    vm.validated = false;
  }
  function loadOrder(id) {
    return orderFactory.getOrder(id).then(function (response) {
      var data = response.data;
      vm.orderDTO = data;
      vm.order.dto = data;
      vm.order.order_id = id;
      vm.order.task_status = data.TaskStatus;
      vm.order.delivery_date = data.DeliveryDate;
      vm.order.order_type = data.OrderType;

      // Section 1 - Project (proj)
      vm.order.proj.id_number = data.ErpSystemReference;
      vm.order.proj.work_order_name = data.WorkOrderName;
      vm.order.proj.work_order_id = data.WorkOrderId;
      vm.order.proj.company_name = data.WorkOrderCompanyName;
      vm.order.proj.company_id = data.WorkOrderCompanyId;
      vm.order.proj.order_number = data.OrderNumber;
      vm.order.proj.contact_person = {
        "contact_name": data.OrderCreatorContactName,
        "contact_id": data.OrderCreatorContactId,
        "phone_nr": data.OrderCreatorContactPhone,
        "email": data.OrderCreatorContactEmail,
        "sms_notif": data.OrderCreatorContactWantSms,
        "email_notif": data.OrderCreatorContactWantEmail
      };
      // Section 2 - Receivers
      vm.order.dr.receiver1 = {
        "contact_name": data.DeliveryReceiver1ContactName,
        "contact_id": data.DeliveryReceiver1ContactId,
        "phone_nr": data.DeliveryReceiver1ContactPhone,
        "email": data.DeliveryReceiver1ContactEmail,
        "sms_notif": data.DeliveryReceiver1ContactWantSms,
        "email_notif": data.DeliveryReceiver1ContactWantEmail
      };
      vm.order.dr.receiver2 = {
        "contact_name": data.DeliveryReceiver2ContactName,
        "contact_id": data.DeliveryReceiver2ContactId,
        "phone_nr": data.DeliveryReceiver2ContactPhone,
        "email": data.DeliveryReceiver2ContactEmail,
        "sms_notif": data.DeliveryReceiver2ContactWantSms,
        "email_notif": data.DeliveryReceiver2ContactWantEmail
      };
      vm.order.dr.receiver3 = {
        "contact_name": data.DeliveryReceiver3ContactName,
        "contact_id": data.DeliveryReceiver3ContactId,
        "phone_nr": data.DeliveryReceiver3ContactPhone,
        "email": data.DeliveryReceiver3ContactEmail,
        "sms_notif": data.DeliveryReceiver3ContactWantSms,
        "email_notif": data.DeliveryReceiver3ContactWantEmail
      };

      // Section 3 - Delivery information (di)
      vm.order.di.supplier = data.Supplier;
      vm.order.di.material = data.Content;
      vm.order.di.n_materials = data.Quantity;
      // Section 4 - Booking choice (bc)
      vm.order.bc.arrival_time = formatDate(data.ArrivalAtWarehouse);
      vm.order.bc.vehicle_drop_location_name = data.VehicleDropLocationName;
      vm.order.bc.vehicle_drop_location_id = data.VehicleDropLocationId;
      vm.order.bc.destination_location_id = data.DestinationLocationId;
      vm.order.bc.staircase_location_id = data.StaircaseLocationId;
      vm.order.bc.staircase_location_name = data.StaircaseLocationName;
      vm.order.bc.arrival_control_status_id = data.AdditionalServiceArrivalControlStatusTypeId;
      var arrivelControllCompleted = isAdditionalServiceCompleted(vm.order.bc.arrival_control_status_id);
      vm.lockArrivalControlled = arrivelControllCompleted; // Lock if controlled
      vm.order.ar.is_arrival_controlled = arrivelControllCompleted; // Set true if controlled

      vm.order.bc.comments = data.Comments;
      vm.order.bc.file_attachments = $filter('filter')(data.Files, {
        OrderFileAttachmentTypeId: FileAttachmentTypeEnum.DOCUMENT
      }, true);
      vm.order.bc.is_unannounced_goods = !!data.IsUnannouncedGoods;
      vm.order.bc.is_unreachable = !!data.IsUnreachable;
      vm.order.bc.is_unused_resource = !!data.IsUnusedResource;

      // Section 5 - Arrival registration
      vm.order.ar.has_inadequate_labeling = data.HasInadequateLabeling;
      vm.order.ar.is_return = data.IsReturn;
      vm.order.ar.other_reference = data.OtherReference;
      vm.order.ar.file_attachments = $filter('filter')(data.Files, {
        OrderFileAttachmentTypeId: FileAttachmentTypeEnum.ARRIVAL_CONTROL
      }, true);
      // Section 6 - Shipping information
      vm.order.si.package_count = data.SpecifiedPackageCount;
      vm.order.si.package_weight = data.SpecifiedPackageWeight;
      vm.order.si.pallet_count = data.SpecifiedPalletCount;
      vm.order.si.pallet_weight = data.SpecifiedPalletWeight;
      vm.order.si.other_count = data.SpecifiedOtherCount;
      vm.order.si.other_weight = data.SpecifiedOtherWeight;
      vm.order.si.has_timing = data.HasAdditionalServiceTiming;
      if (vm.order.si.has_timing) {
        vm.order.si.timing = $filter("toDateTime")(data.AdditionalServiceTimingDueDate);
      }
      vm.order.si.shipping_id = data.ShippingId;
      vm.order.si.shipping_name = data.ShippingName;
      vm.order.si.has_express = data.HasAdditionalServiceExpressDelivery;
      // Section 7 - Booking reference (br)
      vm.order.br.registered = $filter('toDateTime')(data.Created);
      vm.order.br.status = $translate.instant(data.TaskStatusTypeAlias);
      vm.order.br.task_status = data.TaskStatus;
      vm.order.br.order_number = data.OrderNumber;
      // Packages
      vm.order.packages = [];
      for (var i = 0; i < data.Packages.length; i++) {
        vm.order.packages.push(packageFactory.repackageDTO(data.Packages[i]));
      }
      if (copy) {
        delete vm.order.order_id;
        delete vm.order.delivery_date;
        vm.order.br = {};
        vm.order.ar.file_attachments = [];
        delete vm.order.ar.file_attachment_to_add;
        vm.order.bc.file_attachments = [];
        vm.order.bc.file_attachments_to_add = [];
        vm.order.packages = [];
        vm.order.proj.order_number = '';
      }
      vm.evaluateProgress();
      getNextStatus();
      setPermissions();
    }, function (error) {
      errorService.handleError(error);
    });
  }
  vm.setNextStatus = function () {
    if (vm.order.task_status !== vm.order.nextTaskStatus) {
      orderFactory.setNextStatus(order_id).then(function () {
        ngToast.success("Status ändrat.");
        vm.order.br.status = vm.order.nextTaskStatusName;
        vm.order.br.task_status = vm.order.nextTaskStatus;
        vm.order.task_status = vm.order.nextTaskStatus;
        getNextStatus();
      }, function (error) {
        ngToast.danger("Det gick inte att ändra status.");
        $log.error(error);
      });
    }
  };
  function getNextStatus() {
    orderFactory.getNextStatus(vm.order.order_type, vm.order.task_status).then(function (result) {
      vm.order.nextTaskStatus = result.data;
      vm.order.nextTaskStatusName = $translate.instant(generalHelperService.getKeyByValue(TaskStatusTypeEnum, vm.order.nextTaskStatus));
    });
  }
  function formatDate(date) {
    var split = date.slice(0, -3).split('T');
    return split[0] + ' ' + split[1];
  }
  vm.createOrder = function (addBookings) {
    vm.validateForm();
    if (!vm.formValid || vm.lockCall) {
      return;
    }
    vm.lockCall = true;
    var orderDTO = orderTransshipmentFactory.createOrderDTO(vm.order, TaskStatusTypeEnum.NOTIFIED);
    orderFactory.createOrder(orderDTO, vm.order.bc.file_attachments_to_add, vm.formGuid).then(function (response) {
      var results = {
        success: true,
        copy: false
      };
      if (addBookings) {
        var parentOrderId = response.data;
        var resourceBookingResults = orderFormModalService.openCreateFromReference(OrderTypeEnum.RESOURCE_BOOKING, parentOrderId);
        results.success = resourceBookingResults.success;
      }
      vm.lockCall = false;
      $uibModalInstance.close(results);
    }, function (error) {
      vm.lockCall = false;
      if (error.status === 409) {
        ngToast.warning("Kunde inte spara formuläret, ordern finns redan.");
      } else {
        ngToast.danger("Det gick inte att spara formuläret.");
      }
      errorService.handleError(error);
    });
  };
  vm.updateOrder = function (printerId) {
    vm.validateForm();
    if (!vm.formValid) {
      return;
    }
    var orderDTO = orderTransshipmentFactory.createOrderDTO(vm.order, ""),
      options = {
        fileAttachments: vm.order.bc.file_attachments_to_add
      };
    orderFactory.updateOrder(vm.orderDTO.OrderId, orderDTO, options).then(function () {
      // The status of an additional service is not updated in mapping, since it typically set via SST and not in UI.
      // Setting arrival status to COMPLETE is an exception. Therefore a separate call to update status must be done.
      if (vm.order.ar.is_arrival_controlled) {
        orderFactory.updateAdditionalService(vm.orderDTO.OrderId, AdditionalServiceTypeEnum.ARRIVAL_CONTROL, AdditionalServiceStatusTypeEnum.COMPLETED);
      }
      if (printerId) {
        printShippingsNote(printerId);
      } else {
        $uibModalInstance.close({
          success: true,
          copy: false
        });
      }
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.confirmOrder = function () {
    vm.validateForm();
    if (!vm.formValid) {
      return;
    }
    var orderDTO = orderTransshipmentFactory.createOrderDTO(vm.order, TaskStatusTypeEnum.CONFIRMED),
      options = {
        fileAttachments: vm.order.bc.file_attachments_to_add
      };
    orderFactory.confirmOrder(vm.orderDTO.OrderId, orderDTO, options).then(function () {
      var results = {};
      results.success = true;
      results.copy = false;
      $uibModalInstance.close(results);
    }, function (error) {
      errorService.handleError(error);
    });
  };
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  vm.copyOrder = function () {
    var results = {};
    results.success = true;
    results.copy = true;
    $uibModalInstance.close(results);
  };
  vm.cancelOrder = function () {
    var results = {};
    orderFactory.cancelOrder(vm.orderDTO.OrderId, vm.orderDTO).then(function () {
      results.success = true;
      results.copy = false;
      $uibModalInstance.close(results);
    }, function (error) {
      errorService.handleError(error);
    });
  };

  // --- VALIDATION ---
  vm.handleValidationChange = function (source, value) {
    switch (source) {
      case "section_project":
        vm.isSectionProjectCompleted = value;
        break;
      case "section_receivers":
        vm.isSectionReceiversCompleted = value;
        break;
      case "section_delivery_information":
        vm.isSectionDeliveryInformationCompleted = value;
        break;
      case "section_booking_choice":
        vm.isSectionBookingChoiceCompleted = value;
        break;
      default:
        console.log(source + " is not a valid source");
        break;
    }
    vm.evaluateProgress();
  };
  vm.evaluateProgress = function () {
    // -- 1-4: Validation is handled by component

    // -- 5
    vm.sectionFiveDone = vm.isSectionBookingChoiceCompleted;

    // -- 6

    if (vm.order.si.has_timing) {
      var evaluation = inputValidationService.isValidDateTime(vm.order.si.timing);
      vm.sectionSixDone = evaluation;
      vm.timingSet = evaluation;
    } else vm.sectionSixDone = true;

    // --

    if (!vm.isSectionProjectCompleted) {
      vm.sectionFiveDone = false;
      vm.sectionSixDone = false;
    }
    if (!vm.isSectionReceiversCompleted) {
      vm.sectionFiveDone = false;
      vm.sectionSixDone = false;
    }
    if (!vm.isSectionDeliveryInformationCompleted) {
      vm.sectionFiveDone = false;
      vm.sectionSixDone = false;
    }
    if (!vm.isSectionBookingChoiceCompleted) {
      vm.sectionFiveDone = false;
      vm.sectionSixDone = false;
    }
    if (!vm.sectionFiveDone) {
      vm.sectionSixDone = false;
    }
  };
  function checkAllSectionsDone() {
    if (vm.isSectionProjectCompleted && vm.isSectionReceiversCompleted && vm.isSectionDeliveryInformationCompleted && vm.isSectionBookingChoiceCompleted && vm.sectionFiveDone && vm.sectionSixDone) {
      vm.formValid = true;
    } else vm.formValid = false;
  }
  vm.validateForm = function () {
    vm.validated = true;
    vm.evaluateProgress();
    checkAllSectionsDone();
    return vm.formValid;
  };
  vm.isValidInput = function (input) {
    return inputValidationService.isValidInput(input);
  };
  vm.isValidEmail = function (input) {
    return inputValidationService.isValidEmail(input);
  };
  function isAdditionalServiceCompleted(statusTypeId) {
    return additionalServiceStatusService.isCompleted(statusTypeId);
  }
  ;
  vm.isConfirmedOrLater = function () {
    return taskStatusService.isConfirmedOrLater(vm.order.br.task_status);
  };
  vm.renotify = function () {
    orderFactory.renotifyOrderStatus(vm.orderDTO.OrderId);
  };

  // -- OTHER --
  function hasSpecialPackageInformation() {
    return !!vm.order.si.package_count || !!vm.order.si.pallet_count || !!vm.order.si.other_count;
  }
  vm.isReadyForPrint = function () {
    return inputValidationService.isValidInput(vm.order.si.shipping_name) && (vm.order.si.print_notice || vm.order.si.print_label) && (vm.order.packages.length || hasSpecialPackageInformation());
  };
  function printShippingsNote(printerId) {
    orderFactory.printShippingsNote(order_id, printerId, vm.order.si.print_label, vm.order.si.print_notice).then(function () {}, function (error) {
      errorService.handleError(error);
    });
  }
  vm.deleteKeyFromObject = function (object, key) {
    if (object[key]) delete object[key];
  };
  vm.getFilePath = function (orderId, fileName) {
    return orderFactory.createFileLink(orderId, fileName);
  };
  vm.addArrivalControlFileToOrder = function () {
    var orderId = vm.order.order_id;
    var file = vm.order.ar.file_attachment_to_add;
    if (!file) return;
    orderFactory.saveFile(orderId, file, FileAttachmentTypeEnum.ARRIVAL_CONTROL).then(function (response) {
      var data = response.data;
      angular.forEach(data, function (file) {
        vm.order.ar.file_attachments.push(file);
      });
      delete vm.order.ar.file_attachment_to_add;
      $('#ar-fileattachment').val('');
    });
  };
  vm.openDropdown = dropdownService.openDropdown;

  // --- EVENTS --

  // Watch for our custom `fileselect` event
  // FUTURE: This should be done using a directive instead
  vm.initFileSelectEvent = function (fileInputId, fileSelectedTextId) {
    $(fileInputId).on('fileselect', function (event, numFiles, label) {
      var input = $(fileSelectedTextId);
      log = numFiles > 1 ? numFiles + ' filer valda' : label;
      if (input) {
        input.val(log);
      } else {
        if (log) alert(log);
      }
      vm.evaluateProgress();
    });
  };
  vm.initDateTimeEvents = function () {
    // #transshipment-datetimepicker2 is not in the DOM for external Users
    if (vm.isInternal) {
      $('#transshipment-datetimepicker2').datetimepicker({
        format: 'YYYY-MM-DD HH:mm',
        locale: 'sv'
      });
      $('#transshipment-datetimepicker2').data().DateTimePicker.stepping(15);
      $('#transshipment-datetimepicker2').on('dp.change', function () {
        vm.order.si.timing = $('#transshipment-timing').val();
        vm.evaluateProgress();
        if (!$scope.$$phase) {
          //$digest or $apply
          $scope.$apply();
        }
      });
    }
  };
  $scope.$on('updatedUserData', function () {
    identifyRoles();
  });
}]);
//# sourceMappingURL=../../sourcemaps/assets/js/bundle.js.map
